import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: any;
};



/** Purpose for using the application */
export enum AppUse {
  Corporate = 'CORPORATE',
  Investment = 'INVESTMENT'
}

export type ApproveMasterBondInput = {
  id: Scalars['String'];
};

/** Input for approving a commercial paper */
export type ApproveNoteInput = {
  /** ID of the commercial paper */
  id?: Maybe<Scalars['ID']>;
  /** Date of signing */
  signedAt?: Maybe<Scalars['DateTime']>;
  /** Signature of the commercial paper */
  signature?: Maybe<Scalars['String']>;
};

export type ApproveRealEstateAssetInput = {
  id: Scalars['String'];
};

export type AssociatedNotePayload = {
  __typename?: 'AssociatedNotePayload';
  /** ID of the note */
  id?: Maybe<Scalars['ID']>;
  /** Title of the note */
  title?: Maybe<Scalars['String']>;
  /** Amount of the note */
  amount?: Maybe<Scalars['Long']>;
  /** Face value of the note */
  faceValue?: Maybe<Scalars['Long']>;
  /** Proposed date of issue */
  dateFunded?: Maybe<Scalars['String']>;
  /** Purchase price of the note */
  purchasePrice?: Maybe<Scalars['Float']>;
  /** Status of the note */
  status?: Maybe<Enum_Note_Notestatus>;
};

/** Input for querying available bonds for investors */
export type AvailableBondsInput = {
  /** Search by bond or master bond title */
  search?: Maybe<Scalars['String']>;
  /** Filter by bond type (Sophisticated / Ordinary) */
  bondType?: Maybe<Scalars['String']>;
  /** Sort option for available bonds */
  sortBy?: Maybe<InvestorSortBy>;
  /** Page number (default 1) */
  page?: Maybe<Scalars['Int']>;
  /** Items per page (default 10) */
  limit?: Maybe<Scalars['Int']>;
};

/** Input for available notes */
export type AvailableNotesInput = {
  /** Search term for filtering available notes */
  search?: Maybe<Scalars['String']>;
  /** Sort option for available notes */
  sortBy?: Maybe<InvestorSortBy>;
  /** Page number for pagination */
  page?: Maybe<Scalars['Int']>;
  /** Number of items per page */
  limit?: Maybe<Scalars['Int']>;
  /** List of industry types */
  industryTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Minimum investment amount */
  minInvestment?: Maybe<Scalars['Int']>;
  /** Currency type for filtering */
  currency?: Maybe<Enum_Note_Currency>;
};

/** Input for available real estate assets */
export type AvailableRealEstateAssetsInput = {
  /** Search term for filtering available real estate assets */
  search?: Maybe<Scalars['String']>;
  /** Sort option for available real estate assets */
  sortBy?: Maybe<InvestorSortBy>;
  /** Page number for pagination */
  page?: Maybe<Scalars['Int']>;
  /** Number of items per page */
  limit?: Maybe<Scalars['Int']>;
  /** List of property types */
  propertyTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Currency type for filtering */
  currency?: Maybe<Enum_Note_Currency>;
  /** Price range filter */
  priceRange?: Maybe<PriceRangeInput>;
};

export type BankWithdrawRequest = {
  __typename?: 'BankWithdrawRequest';
  documentId: Scalars['ID'];
  bankName?: Maybe<Scalars['String']>;
  transaction?: Maybe<Transaction>;
  user?: Maybe<UsersPermissionsUser>;
  mpesaNumber?: Maybe<Scalars['String']>;
  withdrawType?: Maybe<Enum_Bankwithdrawrequest_Withdrawtype>;
  currency?: Maybe<Enum_Bankwithdrawrequest_Currency>;
  amount?: Maybe<Scalars['Float']>;
  bankWithdrawStatus?: Maybe<Enum_Bankwithdrawrequest_Bankwithdrawstatus>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BankWithdrawRequestEntityResponseCollection = {
  __typename?: 'BankWithdrawRequestEntityResponseCollection';
  nodes: Array<BankWithdrawRequest>;
  pageInfo: Pagination;
};

export type BankWithdrawRequestFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  bankName?: Maybe<StringFilterInput>;
  transaction?: Maybe<TransactionFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  mpesaNumber?: Maybe<StringFilterInput>;
  withdrawType?: Maybe<StringFilterInput>;
  currency?: Maybe<StringFilterInput>;
  amount?: Maybe<FloatFilterInput>;
  bankWithdrawStatus?: Maybe<StringFilterInput>;
  accountName?: Maybe<StringFilterInput>;
  accountNumber?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<BankWithdrawRequestFiltersInput>>>;
  or?: Maybe<Array<Maybe<BankWithdrawRequestFiltersInput>>>;
  not?: Maybe<BankWithdrawRequestFiltersInput>;
};

export type BankWithdrawRequestInput = {
  bankName?: Maybe<Scalars['String']>;
  transaction?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  mpesaNumber?: Maybe<Scalars['String']>;
  withdrawType?: Maybe<Enum_Bankwithdrawrequest_Withdrawtype>;
  currency?: Maybe<Enum_Bankwithdrawrequest_Currency>;
  amount?: Maybe<Scalars['Float']>;
  bankWithdrawStatus?: Maybe<Enum_Bankwithdrawrequest_Bankwithdrawstatus>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BankWithdrawRequestRelationResponseCollection = {
  __typename?: 'BankWithdrawRequestRelationResponseCollection';
  nodes: Array<BankWithdrawRequest>;
};

export type BankingInformation = {
  __typename?: 'BankingInformation';
  documentId: Scalars['ID'];
  bankName?: Maybe<Scalars['String']>;
  accountHolder?: Maybe<Scalars['String']>;
  typeOfAccount?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BankingInformationEntityResponseCollection = {
  __typename?: 'BankingInformationEntityResponseCollection';
  nodes: Array<BankingInformation>;
  pageInfo: Pagination;
};

export type BankingInformationFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  bankName?: Maybe<StringFilterInput>;
  accountHolder?: Maybe<StringFilterInput>;
  typeOfAccount?: Maybe<StringFilterInput>;
  accountNumber?: Maybe<StringFilterInput>;
  company?: Maybe<CompanyFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<BankingInformationFiltersInput>>>;
  or?: Maybe<Array<Maybe<BankingInformationFiltersInput>>>;
  not?: Maybe<BankingInformationFiltersInput>;
};

export type BankingInformationInput = {
  bankName?: Maybe<Scalars['String']>;
  accountHolder?: Maybe<Scalars['String']>;
  typeOfAccount?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type Bond = {
  __typename?: 'Bond';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  masterBond?: Maybe<MasterBond>;
  numberOfTokens?: Maybe<Scalars['Int']>;
  interestRate?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  yieldToMaturity?: Maybe<Scalars['Float']>;
  bondType?: Maybe<Enum_Bond_Bondtype>;
  bondStatus?: Maybe<Enum_Bond_Bondstatus>;
  proposedDateOfIssue?: Maybe<Scalars['Date']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  managementFee?: Maybe<Scalars['Float']>;
  contractAddress?: Maybe<Scalars['String']>;
  estimatedYTM?: Maybe<Scalars['Float']>;
  shortHoldDuration?: Maybe<Scalars['Int']>;
  investedTokens?: Maybe<Scalars['Int']>;
  holdings_connection?: Maybe<BondHoldingRelationResponseCollection>;
  holdings: Array<Maybe<BondHolding>>;
  datePending?: Maybe<Scalars['Date']>;
  amountNeeded?: Maybe<Scalars['Float']>;
  bondSellRequests_connection?: Maybe<BondSellRequestRelationResponseCollection>;
  bondSellRequests: Array<Maybe<BondSellRequest>>;
  dateApproved?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type BondHoldings_ConnectionArgs = {
  filters?: Maybe<BondHoldingFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type BondHoldingsArgs = {
  filters?: Maybe<BondHoldingFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type BondBondSellRequests_ConnectionArgs = {
  filters?: Maybe<BondSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type BondBondSellRequestsArgs = {
  filters?: Maybe<BondSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BondCountsPayload = {
  __typename?: 'BondCountsPayload';
  listedCount?: Maybe<Scalars['Int']>;
  submittedCount?: Maybe<Scalars['Int']>;
  approvedCount?: Maybe<Scalars['Int']>;
};

export type BondEntityResponseCollection = {
  __typename?: 'BondEntityResponseCollection';
  nodes: Array<Bond>;
  pageInfo: Pagination;
};

export type BondFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  masterBond?: Maybe<MasterBondFiltersInput>;
  numberOfTokens?: Maybe<IntFilterInput>;
  interestRate?: Maybe<FloatFilterInput>;
  purchasePrice?: Maybe<FloatFilterInput>;
  yieldToMaturity?: Maybe<FloatFilterInput>;
  bondType?: Maybe<StringFilterInput>;
  bondStatus?: Maybe<StringFilterInput>;
  proposedDateOfIssue?: Maybe<DateFilterInput>;
  purchaseFee?: Maybe<FloatFilterInput>;
  sellFee?: Maybe<FloatFilterInput>;
  shortHoldFee?: Maybe<FloatFilterInput>;
  managementFee?: Maybe<FloatFilterInput>;
  contractAddress?: Maybe<StringFilterInput>;
  estimatedYTM?: Maybe<FloatFilterInput>;
  shortHoldDuration?: Maybe<IntFilterInput>;
  investedTokens?: Maybe<IntFilterInput>;
  holdings?: Maybe<BondHoldingFiltersInput>;
  datePending?: Maybe<DateFilterInput>;
  amountNeeded?: Maybe<FloatFilterInput>;
  bondSellRequests?: Maybe<BondSellRequestFiltersInput>;
  dateApproved?: Maybe<DateFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<BondFiltersInput>>>;
  or?: Maybe<Array<Maybe<BondFiltersInput>>>;
  not?: Maybe<BondFiltersInput>;
};

/** A bond with computed tokenPrice for investor views */
export type BondForInvestorPayload = {
  __typename?: 'BondForInvestorPayload';
  documentId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  numberOfTokens?: Maybe<Scalars['Int']>;
  investedTokens?: Maybe<Scalars['Int']>;
  interestRate?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  yieldToMaturity?: Maybe<Scalars['Float']>;
  estimatedYTM?: Maybe<Scalars['Float']>;
  bondType?: Maybe<Scalars['String']>;
  bondStatus?: Maybe<Scalars['String']>;
  proposedDateOfIssue?: Maybe<Scalars['String']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  managementFee?: Maybe<Scalars['Float']>;
  shortHoldDuration?: Maybe<Scalars['Int']>;
  contractAddress?: Maybe<Scalars['String']>;
  masterBond?: Maybe<MasterBond>;
  /** (faceValuePerToken × purchasePrice) / 100 */
  tokenPrice?: Maybe<Scalars['Float']>;
  bondTokenPrice?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type BondHolding = {
  __typename?: 'BondHolding';
  documentId: Scalars['ID'];
  bond?: Maybe<Bond>;
  user?: Maybe<UsersPermissionsUser>;
  quantity: Scalars['Int'];
  avgCostBasis?: Maybe<Scalars['Float']>;
  currency: Enum_Bondholding_Currency;
  holdingStatus?: Maybe<Enum_Bondholding_Holdingstatus>;
  transactions_connection?: Maybe<TransactionRelationResponseCollection>;
  transactions: Array<Maybe<Transaction>>;
  bondSellRequests_connection?: Maybe<BondSellRequestRelationResponseCollection>;
  bondSellRequests: Array<Maybe<BondSellRequest>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type BondHoldingTransactions_ConnectionArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type BondHoldingTransactionsArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type BondHoldingBondSellRequests_ConnectionArgs = {
  filters?: Maybe<BondSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type BondHoldingBondSellRequestsArgs = {
  filters?: Maybe<BondSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BondHoldingEntityResponseCollection = {
  __typename?: 'BondHoldingEntityResponseCollection';
  nodes: Array<BondHolding>;
  pageInfo: Pagination;
};

export type BondHoldingFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  bond?: Maybe<BondFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  quantity?: Maybe<IntFilterInput>;
  avgCostBasis?: Maybe<FloatFilterInput>;
  currency?: Maybe<StringFilterInput>;
  holdingStatus?: Maybe<StringFilterInput>;
  transactions?: Maybe<TransactionFiltersInput>;
  bondSellRequests?: Maybe<BondSellRequestFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<BondHoldingFiltersInput>>>;
  or?: Maybe<Array<Maybe<BondHoldingFiltersInput>>>;
  not?: Maybe<BondHoldingFiltersInput>;
};

export type BondHoldingInput = {
  bond?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
  avgCostBasis?: Maybe<Scalars['Float']>;
  currency?: Maybe<Enum_Bondholding_Currency>;
  holdingStatus?: Maybe<Enum_Bondholding_Holdingstatus>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bondSellRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

/** An investor bond holding */
export type BondHoldingPayload = {
  __typename?: 'BondHoldingPayload';
  documentId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
  avgCostBasis?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  holdingStatus?: Maybe<Scalars['String']>;
  bond?: Maybe<BondForInvestorPayload>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type BondHoldingRelationResponseCollection = {
  __typename?: 'BondHoldingRelationResponseCollection';
  nodes: Array<BondHolding>;
};

export type BondInput = {
  title?: Maybe<Scalars['String']>;
  masterBond?: Maybe<Scalars['ID']>;
  numberOfTokens?: Maybe<Scalars['Int']>;
  interestRate?: Maybe<Scalars['Float']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  yieldToMaturity?: Maybe<Scalars['Float']>;
  bondType?: Maybe<Enum_Bond_Bondtype>;
  bondStatus?: Maybe<Enum_Bond_Bondstatus>;
  proposedDateOfIssue?: Maybe<Scalars['Date']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  managementFee?: Maybe<Scalars['Float']>;
  contractAddress?: Maybe<Scalars['String']>;
  estimatedYTM?: Maybe<Scalars['Float']>;
  shortHoldDuration?: Maybe<Scalars['Int']>;
  investedTokens?: Maybe<Scalars['Int']>;
  holdings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  datePending?: Maybe<Scalars['Date']>;
  amountNeeded?: Maybe<Scalars['Float']>;
  bondSellRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  dateApproved?: Maybe<Scalars['Date']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BondPayout = {
  __typename?: 'BondPayout';
  documentId: Scalars['ID'];
  masterBond?: Maybe<MasterBond>;
  isInterest?: Maybe<Scalars['Boolean']>;
  amountPerToken?: Maybe<Scalars['Float']>;
  payoutStatus?: Maybe<Enum_Bondpayout_Payoutstatus>;
  payoutPercentage?: Maybe<Scalars['Float']>;
  currency?: Maybe<Enum_Bondpayout_Currency>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BondPayoutEntityResponseCollection = {
  __typename?: 'BondPayoutEntityResponseCollection';
  nodes: Array<BondPayout>;
  pageInfo: Pagination;
};

export type BondPayoutFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  masterBond?: Maybe<MasterBondFiltersInput>;
  isInterest?: Maybe<BooleanFilterInput>;
  amountPerToken?: Maybe<FloatFilterInput>;
  payoutStatus?: Maybe<StringFilterInput>;
  payoutPercentage?: Maybe<FloatFilterInput>;
  currency?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<BondPayoutFiltersInput>>>;
  or?: Maybe<Array<Maybe<BondPayoutFiltersInput>>>;
  not?: Maybe<BondPayoutFiltersInput>;
};

export type BondPayoutInput = {
  masterBond?: Maybe<Scalars['ID']>;
  isInterest?: Maybe<Scalars['Boolean']>;
  amountPerToken?: Maybe<Scalars['Float']>;
  payoutStatus?: Maybe<Enum_Bondpayout_Payoutstatus>;
  payoutPercentage?: Maybe<Scalars['Float']>;
  currency?: Maybe<Enum_Bondpayout_Currency>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BondPayoutRelationResponseCollection = {
  __typename?: 'BondPayoutRelationResponseCollection';
  nodes: Array<BondPayout>;
};

export type BondPriceLog = {
  __typename?: 'BondPriceLog';
  documentId: Scalars['ID'];
  newPrice: Scalars['Float'];
  previousPrice: Scalars['Float'];
  logStatus: Enum_Bondpricelog_Logstatus;
  approvedAt?: Maybe<Scalars['DateTime']>;
  declinedAt?: Maybe<Scalars['DateTime']>;
  reviewNote?: Maybe<Scalars['String']>;
  submittedBy?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<Scalars['String']>;
  masterBond?: Maybe<MasterBond>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BondPriceLogEntityResponseCollection = {
  __typename?: 'BondPriceLogEntityResponseCollection';
  nodes: Array<BondPriceLog>;
  pageInfo: Pagination;
};

/** A single bond price log entry */
export type BondPriceLogEntry = {
  __typename?: 'BondPriceLogEntry';
  documentId: Scalars['String'];
  newPrice: Scalars['Float'];
  previousPrice: Scalars['Float'];
  logStatus: Scalars['String'];
  approvedAt?: Maybe<Scalars['String']>;
  declinedAt?: Maybe<Scalars['String']>;
  submittedBy?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<Scalars['String']>;
  reviewNote?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
};

export type BondPriceLogFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  newPrice?: Maybe<FloatFilterInput>;
  previousPrice?: Maybe<FloatFilterInput>;
  logStatus?: Maybe<StringFilterInput>;
  approvedAt?: Maybe<DateTimeFilterInput>;
  declinedAt?: Maybe<DateTimeFilterInput>;
  reviewNote?: Maybe<StringFilterInput>;
  submittedBy?: Maybe<StringFilterInput>;
  reviewedBy?: Maybe<StringFilterInput>;
  masterBond?: Maybe<MasterBondFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<BondPriceLogFiltersInput>>>;
  or?: Maybe<Array<Maybe<BondPriceLogFiltersInput>>>;
  not?: Maybe<BondPriceLogFiltersInput>;
};

export type BondPriceLogInput = {
  newPrice?: Maybe<Scalars['Float']>;
  previousPrice?: Maybe<Scalars['Float']>;
  logStatus?: Maybe<Enum_Bondpricelog_Logstatus>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  declinedAt?: Maybe<Scalars['DateTime']>;
  reviewNote?: Maybe<Scalars['String']>;
  submittedBy?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<Scalars['String']>;
  masterBond?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BondPriceLogRelationResponseCollection = {
  __typename?: 'BondPriceLogRelationResponseCollection';
  nodes: Array<BondPriceLog>;
};

/** Paginated bond price log response */
export type BondPriceLogsPayload = {
  __typename?: 'BondPriceLogsPayload';
  logs: Array<Maybe<BondPriceLogEntry>>;
  page: Scalars['Int'];
  pages: Scalars['Int'];
  total: Scalars['Int'];
};

export type BondRelationResponseCollection = {
  __typename?: 'BondRelationResponseCollection';
  nodes: Array<Bond>;
};

export type BondSellRequest = {
  __typename?: 'BondSellRequest';
  documentId: Scalars['ID'];
  customerValue?: Maybe<Scalars['Float']>;
  sellAmount?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  bond?: Maybe<Bond>;
  user?: Maybe<UsersPermissionsUser>;
  bondHolding?: Maybe<BondHolding>;
  sellStatus?: Maybe<Enum_Bondsellrequest_Sellstatus>;
  shortHoldFeeAmount?: Maybe<Scalars['Float']>;
  sellFeeAmount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Enum_Bondsellrequest_Currency>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BondSellRequestEntityResponseCollection = {
  __typename?: 'BondSellRequestEntityResponseCollection';
  nodes: Array<BondSellRequest>;
  pageInfo: Pagination;
};

export type BondSellRequestFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  customerValue?: Maybe<FloatFilterInput>;
  sellAmount?: Maybe<FloatFilterInput>;
  quantity?: Maybe<IntFilterInput>;
  bond?: Maybe<BondFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  bondHolding?: Maybe<BondHoldingFiltersInput>;
  sellStatus?: Maybe<StringFilterInput>;
  shortHoldFeeAmount?: Maybe<FloatFilterInput>;
  sellFeeAmount?: Maybe<FloatFilterInput>;
  currency?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<BondSellRequestFiltersInput>>>;
  or?: Maybe<Array<Maybe<BondSellRequestFiltersInput>>>;
  not?: Maybe<BondSellRequestFiltersInput>;
};

export type BondSellRequestInput = {
  customerValue?: Maybe<Scalars['Float']>;
  sellAmount?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  bond?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  bondHolding?: Maybe<Scalars['ID']>;
  sellStatus?: Maybe<Enum_Bondsellrequest_Sellstatus>;
  shortHoldFeeAmount?: Maybe<Scalars['Float']>;
  sellFeeAmount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Enum_Bondsellrequest_Currency>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BondSellRequestRelationResponseCollection = {
  __typename?: 'BondSellRequestRelationResponseCollection';
  nodes: Array<BondSellRequest>;
};

export type BooleanFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  or?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  not?: Maybe<BooleanFilterInput>;
  eq?: Maybe<Scalars['Boolean']>;
  eqi?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
  nei?: Maybe<Scalars['Boolean']>;
  startsWith?: Maybe<Scalars['Boolean']>;
  endsWith?: Maybe<Scalars['Boolean']>;
  contains?: Maybe<Scalars['Boolean']>;
  notContains?: Maybe<Scalars['Boolean']>;
  containsi?: Maybe<Scalars['Boolean']>;
  notContainsi?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['Boolean']>;
  gte?: Maybe<Scalars['Boolean']>;
  lt?: Maybe<Scalars['Boolean']>;
  lte?: Maybe<Scalars['Boolean']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  between?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type BuyInvestmentInput = {
  /** Amount to invest */
  amount: Scalars['Int'];
  /** ID of the note */
  noteId: Scalars['ID'];
  /** Currency code */
  currency: Scalars['String'];
};

/** Sort options for CP */
export enum Cp_Sort_By {
  SortByNewest = 'SORT_BY_NEWEST',
  SortByOldest = 'SORT_BY_OLDEST'
}

export type CalculateInvestmentInput = {
  /** ID of the note */
  id: Scalars['ID'];
  /** Date of the investment */
  investmentDate?: Maybe<Scalars['Date']>;
  /** Amount to invest */
  buyinAmount: Scalars['Float'];
  /** Number of years for the investment */
  numberOfYears?: Maybe<Scalars['Int']>;
};

export type CalculateInvestmentPayload = {
  __typename?: 'CalculateInvestmentPayload';
  /** Interest rate for the investment */
  interestRate?: Maybe<Scalars['Float']>;
  /** Term of the investment in years */
  investmentTerm?: Maybe<Scalars['Int']>;
  /** Date of the investment */
  investmentDate?: Maybe<Scalars['Date']>;
  /** Due date for the investment */
  dueDate?: Maybe<Scalars['Date']>;
  /** Purchase price of the investment */
  purchasePrice?: Maybe<Scalars['Int']>;
  /** Total return for the investor */
  investorTotalReturn?: Maybe<Scalars['Float']>;
};

export type CalculateSellInput = {
  /** Amount to sell */
  amount: Scalars['Float'];
  /** ID of the investment */
  investmentId: Scalars['ID'];
};

export type CalculateSellPayload = {
  __typename?: 'CalculateSellPayload';
  /** Amount to sell */
  sellAmount?: Maybe<Scalars['Float']>;
  /** Deadline for the sell */
  deadline?: Maybe<Scalars['Date']>;
  /** Amount the customer receives */
  customerAmount?: Maybe<Scalars['Float']>;
  /** Fee amount for the sell */
  sellFeeAmount?: Maybe<Scalars['Float']>;
  /** Short hold fee amount */
  shortHoldFeeAmount?: Maybe<Scalars['Float']>;
};

/** Input for changing the application usage purpose */
export type ChangeAppUseInput = {
  /** Type of app usage (CORPORATE, INVESTMENT, etc.) */
  userType: AppUse;
};

/** Input for changing user currency */
export type ChangeCurrencyInput = {
  /** New currency for the user */
  currency: Scalars['String'];
};

/** Input for changing user password */
export type ChangePasswordInput = {
  /** Current password for verification */
  currentPassword: Scalars['String'];
};

/** Input for changing the status of a note */
export type ChangeStatusInput = {
  /** ID of the note */
  id?: Maybe<Scalars['ID']>;
  /** New status of the note */
  noteStatus?: Maybe<Enum_Note_Notestatus>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  documentId: Scalars['ID'];
  role: Enum_Chatmessage_Role;
  content: Scalars['String'];
  tickers?: Maybe<Scalars['JSON']>;
  companies?: Maybe<Scalars['JSON']>;
  summary?: Maybe<Scalars['String']>;
  webSearchPerformed?: Maybe<Scalars['Boolean']>;
  searchMethod?: Maybe<Scalars['String']>;
  conversation?: Maybe<Conversation>;
  user?: Maybe<UsersPermissionsUser>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ChatMessageEntityResponseCollection = {
  __typename?: 'ChatMessageEntityResponseCollection';
  nodes: Array<ChatMessage>;
  pageInfo: Pagination;
};

export type ChatMessageFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  role?: Maybe<StringFilterInput>;
  content?: Maybe<StringFilterInput>;
  tickers?: Maybe<JsonFilterInput>;
  companies?: Maybe<JsonFilterInput>;
  summary?: Maybe<StringFilterInput>;
  webSearchPerformed?: Maybe<BooleanFilterInput>;
  searchMethod?: Maybe<StringFilterInput>;
  conversation?: Maybe<ConversationFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ChatMessageFiltersInput>>>;
  or?: Maybe<Array<Maybe<ChatMessageFiltersInput>>>;
  not?: Maybe<ChatMessageFiltersInput>;
};

export type ChatMessageInput = {
  role?: Maybe<Enum_Chatmessage_Role>;
  content?: Maybe<Scalars['String']>;
  tickers?: Maybe<Scalars['JSON']>;
  companies?: Maybe<Scalars['JSON']>;
  summary?: Maybe<Scalars['String']>;
  webSearchPerformed?: Maybe<Scalars['Boolean']>;
  searchMethod?: Maybe<Scalars['String']>;
  conversation?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ChatMessageRelationResponseCollection = {
  __typename?: 'ChatMessageRelationResponseCollection';
  nodes: Array<ChatMessage>;
};

export type Comment = {
  __typename?: 'Comment';
  documentId: Scalars['ID'];
  user?: Maybe<UsersPermissionsUser>;
  message?: Maybe<Scalars['String']>;
  noteType?: Maybe<Enum_Comment_Notetype>;
  note?: Maybe<Note>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type CommentEntityResponseCollection = {
  __typename?: 'CommentEntityResponseCollection';
  nodes: Array<Comment>;
  pageInfo: Pagination;
};

export type CommentFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  message?: Maybe<StringFilterInput>;
  noteType?: Maybe<StringFilterInput>;
  note?: Maybe<NoteFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CommentFiltersInput>>>;
  or?: Maybe<Array<Maybe<CommentFiltersInput>>>;
  not?: Maybe<CommentFiltersInput>;
};

export type CommentInput = {
  user?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  noteType?: Maybe<Enum_Comment_Notetype>;
  note?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type CommentRelationResponseCollection = {
  __typename?: 'CommentRelationResponseCollection';
  nodes: Array<Comment>;
};

export type Company = {
  __typename?: 'Company';
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  companyType?: Maybe<Enum_Company_Companytype>;
  industryType?: Maybe<Enum_Company_Industrytype>;
  briefDescription?: Maybe<Scalars['String']>;
  platformUseReason?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  registeredAt?: Maybe<Scalars['DateTime']>;
  countryOfRegistration?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  registrationStatus?: Maybe<Enum_Company_Registrationstatus>;
  formattedAddress?: Maybe<Scalars['String']>;
  netWorth?: Maybe<Scalars['Int']>;
  grossIncome?: Maybe<Scalars['Int']>;
  totalDebt?: Maybe<Scalars['Int']>;
  logo?: Maybe<UploadFile>;
  certificateOfIncorporation_connection?: Maybe<UploadFileRelationResponseCollection>;
  certificateOfIncorporation: Array<Maybe<UploadFile>>;
  memorandumAndArticlesOfAssociation_connection?: Maybe<UploadFileRelationResponseCollection>;
  memorandumAndArticlesOfAssociation: Array<Maybe<UploadFile>>;
  boardOfDirectorsApproval_connection?: Maybe<UploadFileRelationResponseCollection>;
  boardOfDirectorsApproval: Array<Maybe<UploadFile>>;
  reportingAccountsReport_connection?: Maybe<UploadFileRelationResponseCollection>;
  reportingAccountsReport: Array<Maybe<UploadFile>>;
  financialStatements_connection?: Maybe<UploadFileRelationResponseCollection>;
  financialStatements: Array<Maybe<UploadFile>>;
  companyTAXCertificate_connection?: Maybe<UploadFileRelationResponseCollection>;
  companyTAXCertificate: Array<Maybe<UploadFile>>;
  relevantCompanyDocuments_connection?: Maybe<UploadFileRelationResponseCollection>;
  relevantCompanyDocuments: Array<Maybe<UploadFile>>;
  companyConsent_connection?: Maybe<UploadFileRelationResponseCollection>;
  companyConsent: Array<Maybe<UploadFile>>;
  informationMemorandum_connection?: Maybe<UploadFileRelationResponseCollection>;
  informationMemorandum: Array<Maybe<UploadFile>>;
  investments_connection?: Maybe<InvestmentRelationResponseCollection>;
  investments: Array<Maybe<Investment>>;
  notes_connection?: Maybe<NoteRelationResponseCollection>;
  notes: Array<Maybe<Note>>;
  realEstateAssets_connection?: Maybe<RealEstateAssetRelationResponseCollection>;
  realEstateAssets: Array<Maybe<RealEstateAsset>>;
  bankingInformation?: Maybe<BankingInformation>;
  activeSince?: Maybe<Scalars['Date']>;
  financialSummary?: Maybe<FinancialSummary>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type CompanyCertificateOfIncorporation_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyCertificateOfIncorporationArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyMemorandumAndArticlesOfAssociation_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyMemorandumAndArticlesOfAssociationArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyBoardOfDirectorsApproval_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyBoardOfDirectorsApprovalArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyReportingAccountsReport_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyReportingAccountsReportArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyFinancialStatements_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyFinancialStatementsArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyCompanyTaxCertificate_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyCompanyTaxCertificateArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyRelevantCompanyDocuments_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyRelevantCompanyDocumentsArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyCompanyConsent_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyCompanyConsentArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyInformationMemorandum_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyInformationMemorandumArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyInvestments_ConnectionArgs = {
  filters?: Maybe<InvestmentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyInvestmentsArgs = {
  filters?: Maybe<InvestmentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyNotes_ConnectionArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyNotesArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyRealEstateAssets_ConnectionArgs = {
  filters?: Maybe<RealEstateAssetFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyRealEstateAssetsArgs = {
  filters?: Maybe<RealEstateAssetFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Input for company documents */
export type CompanyDocumentsInput = {
  /** ID of the information memorandum document */
  informationMemorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** ID of the certificate of incorporation document */
  certificateOfIncorporation?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** ID of the memorandum and articles of association document */
  memorandumAndArticlesOfAssociation?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** ID of the board of directors approval document */
  boardOfDirectorsApproval?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** ID of the reporting accounts report document */
  reportingAccountsReport?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** ID of the financial statements document */
  financialStatements?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** ID of the company tax certificate document */
  companyTAXCertificate?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** ID of the relevant company documents */
  relevantCompanyDocuments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** ID of the company consent document */
  companyConsent?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type CompanyEntityResponseCollection = {
  __typename?: 'CompanyEntityResponseCollection';
  nodes: Array<Company>;
  pageInfo: Pagination;
};

export type CompanyFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  companyType?: Maybe<StringFilterInput>;
  industryType?: Maybe<StringFilterInput>;
  briefDescription?: Maybe<StringFilterInput>;
  platformUseReason?: Maybe<StringFilterInput>;
  registrationNumber?: Maybe<StringFilterInput>;
  registeredAt?: Maybe<DateTimeFilterInput>;
  countryOfRegistration?: Maybe<StringFilterInput>;
  vatNumber?: Maybe<StringFilterInput>;
  taxNumber?: Maybe<StringFilterInput>;
  registrationStatus?: Maybe<StringFilterInput>;
  formattedAddress?: Maybe<StringFilterInput>;
  netWorth?: Maybe<IntFilterInput>;
  grossIncome?: Maybe<IntFilterInput>;
  totalDebt?: Maybe<IntFilterInput>;
  investments?: Maybe<InvestmentFiltersInput>;
  notes?: Maybe<NoteFiltersInput>;
  realEstateAssets?: Maybe<RealEstateAssetFiltersInput>;
  bankingInformation?: Maybe<BankingInformationFiltersInput>;
  activeSince?: Maybe<DateFilterInput>;
  financialSummary?: Maybe<FinancialSummaryFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CompanyFiltersInput>>>;
  or?: Maybe<Array<Maybe<CompanyFiltersInput>>>;
  not?: Maybe<CompanyFiltersInput>;
};

export type CompanyInput = {
  name?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  companyType?: Maybe<Enum_Company_Companytype>;
  industryType?: Maybe<Enum_Company_Industrytype>;
  briefDescription?: Maybe<Scalars['String']>;
  platformUseReason?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  registeredAt?: Maybe<Scalars['DateTime']>;
  countryOfRegistration?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  registrationStatus?: Maybe<Enum_Company_Registrationstatus>;
  formattedAddress?: Maybe<Scalars['String']>;
  netWorth?: Maybe<Scalars['Int']>;
  grossIncome?: Maybe<Scalars['Int']>;
  totalDebt?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['ID']>;
  certificateOfIncorporation?: Maybe<Array<Maybe<Scalars['ID']>>>;
  memorandumAndArticlesOfAssociation?: Maybe<Array<Maybe<Scalars['ID']>>>;
  boardOfDirectorsApproval?: Maybe<Array<Maybe<Scalars['ID']>>>;
  reportingAccountsReport?: Maybe<Array<Maybe<Scalars['ID']>>>;
  financialStatements?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companyTAXCertificate?: Maybe<Array<Maybe<Scalars['ID']>>>;
  relevantCompanyDocuments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companyConsent?: Maybe<Array<Maybe<Scalars['ID']>>>;
  informationMemorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  investments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  realEstateAssets?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bankingInformation?: Maybe<Scalars['ID']>;
  activeSince?: Maybe<Scalars['Date']>;
  financialSummary?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ComponentSharedMedia = {
  __typename?: 'ComponentSharedMedia';
  id: Scalars['ID'];
  file?: Maybe<UploadFile>;
};

export type ComponentSharedQuote = {
  __typename?: 'ComponentSharedQuote';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
};

export type ComponentSharedRichText = {
  __typename?: 'ComponentSharedRichText';
  id: Scalars['ID'];
  body?: Maybe<Scalars['String']>;
};

export type ComponentSharedSeo = {
  __typename?: 'ComponentSharedSeo';
  id: Scalars['ID'];
  metaTitle: Scalars['String'];
  metaDescription: Scalars['String'];
  shareImage?: Maybe<UploadFile>;
};

export type ComponentSharedSlider = {
  __typename?: 'ComponentSharedSlider';
  id: Scalars['ID'];
  files_connection?: Maybe<UploadFileRelationResponseCollection>;
  files: Array<Maybe<UploadFile>>;
};


export type ComponentSharedSliderFiles_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ComponentSharedSliderFilesArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentSharedWelcomeSlides = {
  __typename?: 'ComponentSharedWelcomeSlides';
  id: Scalars['ID'];
};

export type ComponentSharedWelcomeSlidesFiltersInput = {
  and?: Maybe<Array<Maybe<ComponentSharedWelcomeSlidesFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentSharedWelcomeSlidesFiltersInput>>>;
  not?: Maybe<ComponentSharedWelcomeSlidesFiltersInput>;
};

export type ComponentSharedWelcomeSlidesInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  documentId: Scalars['ID'];
  title: Scalars['String'];
  knowledgeLevel: Enum_Conversation_Knowledgelevel;
  user?: Maybe<UsersPermissionsUser>;
  chatMessages_connection?: Maybe<ChatMessageRelationResponseCollection>;
  chatMessages: Array<Maybe<ChatMessage>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type ConversationChatMessages_ConnectionArgs = {
  filters?: Maybe<ChatMessageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ConversationChatMessagesArgs = {
  filters?: Maybe<ChatMessageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ConversationEntityResponseCollection = {
  __typename?: 'ConversationEntityResponseCollection';
  nodes: Array<Conversation>;
  pageInfo: Pagination;
};

export type ConversationFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  knowledgeLevel?: Maybe<StringFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  chatMessages?: Maybe<ChatMessageFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ConversationFiltersInput>>>;
  or?: Maybe<Array<Maybe<ConversationFiltersInput>>>;
  not?: Maybe<ConversationFiltersInput>;
};

export type ConversationInput = {
  title?: Maybe<Scalars['String']>;
  knowledgeLevel?: Maybe<Enum_Conversation_Knowledgelevel>;
  user?: Maybe<Scalars['ID']>;
  chatMessages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ConversationRelationResponseCollection = {
  __typename?: 'ConversationRelationResponseCollection';
  nodes: Array<Conversation>;
};

export type CreateBaseMasterBondInput = {
  documentId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  currency: Scalars['String'];
  interestRate: Scalars['Float'];
  interestFrequency: Scalars['String'];
  maturityDate: Scalars['String'];
  bondPrice: Scalars['Float'];
  faceValuePerToken: Scalars['Int'];
  nextInterestPayment: Scalars['String'];
};

export type CreateBondInput = {
  masterBondId: Scalars['String'];
  purchasePrice: Scalars['Float'];
  numberOfTokens: Scalars['Int'];
  bondType: Scalars['String'];
  proposedDateOfIssue: Scalars['String'];
  purchaseFee?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  shortHoldDuration?: Maybe<Scalars['Int']>;
  managementFee?: Maybe<Scalars['Float']>;
};

export type CreateBondMaturityPayoutRequestInput = {
  /** Document ID of the master bond */
  masterBondId: Scalars['String'];
  /** Percentage of remaining face value to pay out (1-100) */
  percentage: Scalars['Float'];
};

export type CreateBondPayoutRequestInput = {
  /** Document ID of the master bond */
  masterBondId: Scalars['String'];
};

export type CreateBondSellRequestInput = {
  /** Document ID of the bond to sell */
  bondId: Scalars['String'];
  /** Number of tokens to sell */
  quantity: Scalars['Int'];
};

/** Input for creating an internal note */
export type CreateInternalCommentInput = {
  /** ID of the internal note */
  id?: Maybe<Scalars['ID']>;
  /** Message of the internal note */
  message?: Maybe<Scalars['String']>;
};

/** Input for creating a master note by a user */
export type CreateMasterNoteByUserInput = {
  /** Title of the master note */
  title?: Maybe<Scalars['String']>;
  /** Current step in the master note creation process */
  currentStep?: Maybe<Enum_Masternote_Currentstep>;
  /** ID of the master note (for updates) */
  id?: Maybe<Scalars['ID']>;
  /** Type of the master note (e.g. Bond, Fund) */
  type?: Maybe<Scalars['String']>;
  /** Interest rate for the master note */
  interestRate?: Maybe<Scalars['Float']>;
  /** Frequency of interest payments (e.g. Monthly, Quarterly) */
  interestFrequency?: Maybe<Scalars['String']>;
  /** Frequency of interest compounding */
  compoundingFrequency?: Maybe<Scalars['String']>;
  /** Maturity date of the master note */
  maturityDate?: Maybe<Scalars['DateTime']>;
  /** Market value of the master note */
  marketValue?: Maybe<Scalars['Float']>;
  /** Currency code for the master note */
  currency?: Maybe<Scalars['String']>;
  /** IDs of memorandum documents */
  memorandum?: Maybe<Array<Scalars['ID']>>;
  /** Type of asset */
  assetType?: Maybe<Scalars['String']>;
  /** Fund manager name */
  fundManager?: Maybe<Scalars['String']>;
  /** Description of the master note */
  description?: Maybe<Scalars['String']>;
  /** Description of potential risks */
  potentialRisks?: Maybe<Scalars['String']>;
};

/** Input for creating a note */
export type CreateMyNoteInput = {
  /** ID of the note */
  id?: Maybe<Scalars['ID']>;
  /** Current step of the note */
  currentStep?: Maybe<Enum_Note_Currentstep>;
  /** Amount of the note */
  amount?: Maybe<Scalars['Long']>;
  /** Currency of the note */
  currency?: Maybe<Scalars['String']>;
  /** Amount needed for the note */
  amountNeeded?: Maybe<Scalars['Long']>;
  /** Minimum investment for the note */
  minimumInvestment?: Maybe<Scalars['Int']>;
  /** Maturity date of the note */
  maturityDate?: Maybe<Scalars['DateTime']>;
  /** Next interest payment date of the note */
  nextInterestPayment?: Maybe<Scalars['DateTime']>;
  /** Follow-up date of the note */
  followup?: Maybe<Scalars['Int']>;
  /** Length of the commercial paper */
  lengthOfCP?: Maybe<Scalars['Int']>;
  /** Master note of the commercial paper */
  masterNote?: Maybe<Scalars['String']>;
  /** Interest rate of the note */
  interestRate?: Maybe<Scalars['Float']>;
  /** Service interest rate of the note */
  serviceInterestRate?: Maybe<Scalars['Float']>;
  /** ID of the memorandum document */
  memorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Sell fee of the note */
  sellFee?: Maybe<Scalars['Float']>;
  /** Purchase fee of the note */
  purchaseFee?: Maybe<Scalars['Float']>;
  /** management fee of the note */
  managementFee?: Maybe<Scalars['Float']>;
  /** Minimum investment of the note */
  minInvestment?: Maybe<Scalars['Int']>;
  /** Type of the note */
  type?: Maybe<Enum_Note_Type>;
  /** short hold fee of the note */
  shortHoldFee?: Maybe<Scalars['Float']>;
  /** Proposed date of issue of the note */
  proposedDateOfIssue?: Maybe<Scalars['DateTime']>;
  /** Purchase price of the note */
  purchasePrice?: Maybe<Scalars['Float']>;
  /** Market value of the master note */
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  /** Lock down period of the note */
  lockDown?: Maybe<Scalars['Int']>;
  /** Title of the note */
  title?: Maybe<Scalars['String']>;
  /** Description of the note */
  description?: Maybe<Scalars['String']>;
  /** potential Risks of the note */
  potentialRisks?: Maybe<Scalars['String']>;
  /** short hold Description of the note */
  shortHoldDescription?: Maybe<Scalars['String']>;
  /** Interest frequency of the note */
  interestFrequency?: Maybe<Scalars['String']>;
  /** Type of the commercial paper */
  noteType?: Maybe<Enum_Note_Notetype>;
  /** Payout date of the note */
  payoutDate?: Maybe<Scalars['DateTime']>;
  /** Short hold fee duration of the note */
  shortHoldFeeDuration?: Maybe<Scalars['Int']>;
};

export type CreatePayoutRequestInput = {
  /** ID of the real estate asset */
  realEstateAssetId: Scalars['ID'];
  /** Amount for the payout */
  amount: Scalars['Float'];
  /** Whether this is a yield payout (true) or payout all (false) */
  isYield: Scalars['Boolean'];
};

export type CreateRealEstateAssetBaseInput = {
  title: Scalars['String'];
  currency: Scalars['String'];
  symbol?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  lockDownMonths?: Maybe<Scalars['Int']>;
  expectedYield?: Maybe<Scalars['Int']>;
  totalSupply?: Maybe<Scalars['Int']>;
  tokenPrice?: Maybe<Scalars['Float']>;
  expectedRent?: Maybe<Scalars['Int']>;
  expectedExpenses?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
  expensesInfo?: Maybe<Scalars['String']>;
};

export type CreateRealEstatePriceLogInput = {
  /** ID of the real estate asset to update price for */
  realEstateAssetId: Scalars['String'];
  /** New value for the real estate asset */
  value: Scalars['Float'];
};

export type CreateRealEstateSellInput = {
  /** Document ID of the real estate asset to sell */
  realEstateAssetId: Scalars['String'];
  /** Number of tokens to sell */
  quantity: Scalars['Float'];
};

export type CreateSellInput = {
  /** ID of the note */
  noteId: Scalars['ID'];
  /** ID of the investment */
  investmentId: Scalars['ID'];
  /** Amount the customer receives */
  customerAmount: Scalars['Float'];
  /** Currency code */
  currency: Scalars['String'];
  /** Amount to sell */
  sellAmount: Scalars['Float'];
  /** Fee amount for the sell */
  sellFeeAmount: Scalars['Float'];
  /** Short hold fee amount */
  shortHoldFeeAmount: Scalars['Float'];
};


export type DateFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Date']>>>;
  or?: Maybe<Array<Maybe<Scalars['Date']>>>;
  not?: Maybe<DateFilterInput>;
  eq?: Maybe<Scalars['Date']>;
  eqi?: Maybe<Scalars['Date']>;
  ne?: Maybe<Scalars['Date']>;
  nei?: Maybe<Scalars['Date']>;
  startsWith?: Maybe<Scalars['Date']>;
  endsWith?: Maybe<Scalars['Date']>;
  contains?: Maybe<Scalars['Date']>;
  notContains?: Maybe<Scalars['Date']>;
  containsi?: Maybe<Scalars['Date']>;
  notContainsi?: Maybe<Scalars['Date']>;
  gt?: Maybe<Scalars['Date']>;
  gte?: Maybe<Scalars['Date']>;
  lt?: Maybe<Scalars['Date']>;
  lte?: Maybe<Scalars['Date']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Date']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Date']>>>;
  between?: Maybe<Array<Maybe<Scalars['Date']>>>;
};


export type DateTimeFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  or?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  not?: Maybe<DateTimeFilterInput>;
  eq?: Maybe<Scalars['DateTime']>;
  eqi?: Maybe<Scalars['DateTime']>;
  ne?: Maybe<Scalars['DateTime']>;
  nei?: Maybe<Scalars['DateTime']>;
  startsWith?: Maybe<Scalars['DateTime']>;
  endsWith?: Maybe<Scalars['DateTime']>;
  contains?: Maybe<Scalars['DateTime']>;
  notContains?: Maybe<Scalars['DateTime']>;
  containsi?: Maybe<Scalars['DateTime']>;
  notContainsi?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  between?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
};

/** Input for declining a note */
export type DeclineNoteInput = {
  /** ID of the note */
  id?: Maybe<Scalars['ID']>;
  /** Message for declining the note */
  message?: Maybe<Scalars['String']>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID'];
};

export type DownloadNoteSummaryPayload = {
  __typename?: 'DownloadNoteSummaryPayload';
  /** URL of the downloaded commercial paper summary */
  url?: Maybe<Scalars['String']>;
};

export type DownloadTransactionReceiptPayload = {
  __typename?: 'DownloadTransactionReceiptPayload';
  /** URL of the downloaded transaction receipt */
  url?: Maybe<Scalars['String']>;
};

export enum Enum_Bankwithdrawrequest_Bankwithdrawstatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum Enum_Bankwithdrawrequest_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export enum Enum_Bankwithdrawrequest_Withdrawtype {
  Bank = 'BANK',
  Mpesa = 'MPESA'
}

export enum Enum_Bondholding_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export enum Enum_Bondholding_Holdingstatus {
  Pending = 'PENDING',
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export enum Enum_Bondpayout_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export enum Enum_Bondpayout_Payoutstatus {
  Pending = 'PENDING',
  Declined = 'DECLINED',
  Approved = 'APPROVED',
  Completed = 'COMPLETED'
}

export enum Enum_Bondpricelog_Logstatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum Enum_Bondsellrequest_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export enum Enum_Bondsellrequest_Sellstatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Declined = 'DECLINED',
  Success = 'SUCCESS'
}

export enum Enum_Bond_Bondstatus {
  Delisted = 'DELISTED',
  Listed = 'LISTED',
  Submitted = 'SUBMITTED',
  Draft = 'DRAFT',
  Funded = 'FUNDED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum Enum_Bond_Bondtype {
  Sophisticated = 'Sophisticated',
  Ordinary = 'Ordinary'
}

export enum Enum_Chatmessage_Role {
  User = 'user',
  Assistant = 'assistant'
}

export enum Enum_Comment_Notetype {
  Internal = 'INTERNAL',
  InfoRequired = 'INFO_REQUIRED',
  Declined = 'DECLINED'
}

export enum Enum_Company_Companytype {
  PubliclyListedCompany = 'PUBLICLY_LISTED_COMPANY',
  PrivateCompany = 'PRIVATE_COMPANY',
  Government = 'GOVERNMENT'
}

export enum Enum_Company_Industrytype {
  Agriculture = 'AGRICULTURE',
  Construction = 'CONSTRUCTION',
  ConsumerGoods = 'CONSUMER_GOODS',
  Energy = 'ENERGY',
  Entertainment = 'ENTERTAINMENT',
  FinancialServices = 'FINANCIAL_SERVICES',
  Government = 'GOVERNMENT',
  Healthcare = 'HEALTHCARE',
  Hospitality = 'HOSPITALITY',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  Infrastructure = 'INFRASTRUCTURE',
  Manufacturing = 'MANUFACTURING',
  Mining = 'MINING',
  Pharmaceuticals = 'PHARMACEUTICALS',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  RealEstate = 'REAL_ESTATE',
  Retail = 'RETAIL',
  Telecommunication = 'TELECOMMUNICATION',
  Tourism = 'TOURISM',
  Transport = 'TRANSPORT',
  Other = 'OTHER'
}

export enum Enum_Company_Registrationstatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export enum Enum_Conversation_Knowledgelevel {
  Beginner = 'beginner',
  Intermediate = 'intermediate',
  Advanced = 'advanced'
}

export enum Enum_Fundinterest_Fundintereststatus {
  Pending = 'PENDING',
  Declined = 'DECLINED',
  Approved = 'APPROVED'
}

export enum Enum_Investment_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export enum Enum_Investment_Investmentstatus {
  PaidOut = 'PAID_OUT',
  Invested = 'INVESTED',
  Pending = 'PENDING',
  Declined = 'DECLINED'
}

export enum Enum_Marketvaluelog_Logstatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum Enum_Marketvaluelog_Type {
  Bond = 'Bond',
  Fund = 'Fund'
}

export enum Enum_Masterbond_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export enum Enum_Masterbond_Interestfrequency {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Annually = 'ANNUALLY'
}

export enum Enum_Masterbond_Masterbondstatus {
  Submitted = 'SUBMITTED',
  Approved = 'APPROVED',
  Listed = 'LISTED',
  Delisted = 'DELISTED',
  Declined = 'DECLINED'
}

export enum Enum_Masternote_Compoundingfrequency {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Annually = 'ANNUALLY',
  Weekly = 'WEEKLY',
  Daily = 'DAILY'
}

export enum Enum_Masternote_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export enum Enum_Masternote_Currentstep {
  GeneralInformation = 'GENERAL_INFORMATION',
  AdditionalInformation = 'ADDITIONAL_INFORMATION'
}

export enum Enum_Masternote_Interestfrequency {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Annually = 'ANNUALLY'
}

export enum Enum_Masternote_Masternotestatus {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum Enum_Masternote_Type {
  Bond = 'Bond',
  Fund = 'Fund'
}

export enum Enum_Note_Compoundingfrequency {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Annually = 'ANNUALLY',
  Weekly = 'WEEKLY',
  Daily = 'DAILY'
}

export enum Enum_Note_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export enum Enum_Note_Currentstep {
  BasicInformation = 'BASIC_INFORMATION',
  AdditionalInformation = 'ADDITIONAL_INFORMATION'
}

export enum Enum_Note_Interestfrequency {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Annually = 'ANNUALLY'
}

export enum Enum_Note_Notestatus {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
  InfoRequired = 'INFO_REQUIRED',
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Funding = 'FUNDING',
  PaymentDue = 'PAYMENT_DUE',
  InfoProvided = 'INFO_PROVIDED',
  Funded = 'FUNDED',
  Closed = 'CLOSED'
}

export enum Enum_Note_Notetype {
  Ordinary = 'Ordinary',
  Sophisticated = 'Sophisticated'
}

export enum Enum_Note_Type {
  Bond = 'Bond',
  Fund = 'Fund'
}

export enum Enum_Notification_Category {
  CpApproved = 'CP_APPROVED',
  RolloverAccepted = 'ROLLOVER_ACCEPTED',
  RolloverDeclined = 'ROLLOVER_DECLINED',
  RolloverRequested = 'ROLLOVER_REQUESTED',
  InfoRequired = 'INFO_REQUIRED',
  Funded = 'FUNDED',
  Investment = 'INVESTMENT',
  Submitted = 'SUBMITTED',
  Declined = 'DECLINED',
  NoteAdded = 'NOTE_ADDED',
  PayoutRequest = 'PAYOUT_REQUEST',
  UpdateRequest = 'UPDATE_REQUEST',
  Interest = 'INTEREST',
  Topup = 'TOPUP',
  SellRequest = 'SELL_REQUEST',
  WithdrawRequest = 'WITHDRAW_REQUEST',
  BondPayout = 'BOND_PAYOUT'
}

export enum Enum_Payoutrequest_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export enum Enum_Payoutrequest_Payoutstatus {
  Approved = 'APPROVED',
  Pending = 'PENDING'
}

export enum Enum_Payoutrequest_Type {
  Interest = 'INTEREST',
  Principal = 'PRINCIPAL'
}

export enum Enum_Purchaserequest_Investmenttermtype {
  Days = 'DAYS',
  Weeks = 'WEEKS',
  Months = 'MONTHS'
}

export enum Enum_Purchaserequest_Purchasestatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum Enum_Realestateasset_Assetstatus {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Listed = 'LISTED',
  Suspended = 'SUSPENDED',
  Delisted = 'DELISTED'
}

export enum Enum_Realestateasset_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export enum Enum_Realestateholding_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export enum Enum_Realestateholding_Holdingstatus {
  Pending = 'PENDING',
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export enum Enum_Realestatepayout_Payoutstatus {
  Pending = 'PENDING',
  Declined = 'DECLINED',
  Approved = 'APPROVED',
  Completed = 'COMPLETED'
}

export enum Enum_Realestatepricelog_Logstatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum Enum_Realestatesellrequest_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export enum Enum_Realestatesellrequest_Sellstatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Success = 'SUCCESS'
}

export enum Enum_Rolloverresponse_Rolloverstatus {
  Accepted = 'ACCEPTED',
  Declinded = 'DECLINDED'
}

export enum Enum_Sellrequest_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export enum Enum_Sellrequest_Sellstatus {
  Declined = 'DECLINED',
  Approved = 'APPROVED',
  Pending = 'PENDING'
}

export enum Enum_Topuprequest_Currency {
  Kes = 'KES',
  Usd = 'USD'
}

export enum Enum_Topuprequest_Topupstatus {
  Pending = 'PENDING',
  Completed = 'COMPLETED'
}

export enum Enum_Transaction_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export enum Enum_Transaction_Source {
  SalaryOrEmploymentIncome = 'SALARY_OR_EMPLOYMENT_INCOME',
  PersonalSavings = 'PERSONAL_SAVINGS',
  PensionIncome = 'PENSION_INCOME',
  InvestmentEarning = 'INVESTMENT_EARNING',
  PropertySale = 'PROPERTY_SALE',
  Inheritance = 'INHERITANCE',
  Gifts = 'GIFTS',
  BusinessIncomeOrDividends = 'BUSINESS_INCOME_OR_DIVIDENDS'
}

export enum Enum_Transaction_Transactionstatus {
  Success = 'SUCCESS',
  Error = 'ERROR',
  Pending = 'PENDING',
  Declined = 'DECLINED'
}

export enum Enum_Transaction_Transactiontype {
  Investment = 'INVESTMENT',
  Topup = 'TOPUP',
  Withdraw = 'WITHDRAW',
  Payout = 'PAYOUT',
  Sell = 'SELL',
  SellGross = 'SELL_GROSS',
  PayoutGross = 'PAYOUT_GROSS',
  Interest = 'INTEREST',
  PurchaseFee = 'PURCHASE_FEE',
  ManagementFee = 'MANAGEMENT_FEE',
  RealEstateSell = 'REAL_ESTATE_SELL',
  RealEstateSellFee = 'REAL_ESTATE_SELL_FEE',
  RealEstateSellGross = 'REAL_ESTATE_SELL_GROSS',
  CapitalGain = 'CAPITAL_GAIN',
  ShortHoldFee = 'SHORT_HOLD_FEE',
  SellFee = 'SELL_FEE',
  RealEstatePurchase = 'REAL_ESTATE_PURCHASE',
  RealEstatePurchaseFee = 'REAL_ESTATE_PURCHASE_FEE',
  WalletDebit = 'WALLET_DEBIT',
  Mint = 'MINT',
  RealEstatePayout = 'REAL_ESTATE_PAYOUT',
  RealEstatePayoutYield = 'REAL_ESTATE_PAYOUT_YIELD',
  BondPurchase = 'BOND_PURCHASE',
  BondPurchaseFee = 'BOND_PURCHASE_FEE',
  BondSell = 'BOND_SELL',
  BondSellFee = 'BOND_SELL_FEE',
  BondInterestPayout = 'BOND_INTEREST_PAYOUT',
  BondMaturityPayout = 'BOND_MATURITY_PAYOUT'
}

export enum Enum_Updaterequest_Updatestatus {
  PendingReview = 'PENDING_REVIEW',
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum Enum_Updaterequest_Updatetype {
  PersonalInformation = 'PERSONAL_INFORMATION',
  CompanyInformation = 'COMPANY_INFORMATION',
  MasterGeneral = 'MASTER_GENERAL',
  MasterAdditional = 'MASTER_ADDITIONAL'
}

export enum Enum_Userspermissionsuser_Annualnetincome {
  Less_0_5 = 'Less_0_5',
  B_0_5_1 = 'B_0_5_1',
  B_1_3 = 'B_1_3',
  B_3_6 = 'B_3_6',
  More_6 = 'More_6'
}

export enum Enum_Userspermissionsuser_Currency {
  Usd = 'USD',
  Kes = 'KES'
}

export enum Enum_Userspermissionsuser_Employmentstatus {
  Employed = 'EMPLOYED',
  SelfEmployed = 'SELF_EMPLOYED'
}

export enum Enum_Userspermissionsuser_Expectedfundingfrequency {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Annually = 'ANNUALLY'
}

export enum Enum_Userspermissionsuser_Investmenthorizon {
  ShortTerm = 'SHORT_TERM',
  MediumTerm = 'MEDIUM_TERM',
  LongTerm = 'LONG_TERM'
}

export enum Enum_Userspermissionsuser_Investmentknowledge {
  Low = 'LOW',
  Moderate = 'MODERATE',
  Extensive = 'EXTENSIVE'
}

export enum Enum_Userspermissionsuser_Investmentreaction {
  ExtremelyConcernedSell = 'EXTREMELY_CONCERNED_SELL',
  ConcernedSell = 'CONCERNED_SELL',
  ConcernedNotSell = 'CONCERNED_NOT_SELL',
  NotOverlyConcerned = 'NOT_OVERLY_CONCERNED'
}

export enum Enum_Userspermissionsuser_Investoronboardingsteps {
  BasicInformation = 'BASIC_INFORMATION',
  BusinessInformation = 'BUSINESS_INFORMATION',
  Banking = 'BANKING',
  DocumentUpload = 'DOCUMENT_UPLOAD',
  ReasonForInvesting = 'REASON_FOR_INVESTING',
  Agreement = 'AGREEMENT',
  PendingApproval = 'PENDING_APPROVAL',
  Completed = 'COMPLETED'
}

export enum Enum_Userspermissionsuser_Onboardingstatus {
  SelectRole = 'SELECT_ROLE',
  BasicInformation = 'BASIC_INFORMATION',
  DocumentUpload = 'DOCUMENT_UPLOAD',
  CompanyInformation = 'COMPANY_INFORMATION',
  ReasonForInvesting = 'REASON_FOR_INVESTING',
  CompanyDetails = 'COMPANY_DETAILS',
  Agreement = 'AGREEMENT',
  PendingApproval = 'PENDING_APPROVAL',
  Completed = 'COMPLETED'
}

export enum Enum_Userspermissionsuser_Platformaccess {
  Pending = 'PENDING',
  Granted = 'GRANTED',
  Declined = 'DECLINED'
}

export enum Enum_Userspermissionsuser_Residencystatus {
  Owner = 'Owner',
  Tenant = 'Tenant',
  Resident = 'Resident'
}

export enum Enum_Userspermissionsuser_Smileverificationstatus {
  Pending = 'PENDING',
  ProvisionallyApproved = 'PROVISIONALLY_APPROVED',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export enum Enum_Userspermissionsuser_Type {
  Sophisticated = 'Sophisticated',
  Ordinary = 'Ordinary'
}

export type ExportFilePayload = {
  __typename?: 'ExportFilePayload';
  /** Public URL to download the exported file */
  url: Scalars['String'];
  /** Upload file ID */
  fileId: Scalars['ID'];
  /** Original file name */
  fileName: Scalars['String'];
};

export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type FinancialSummary = {
  __typename?: 'FinancialSummary';
  documentId: Scalars['ID'];
  netWorth?: Maybe<Scalars['Long']>;
  company?: Maybe<Company>;
  totalDeptOutstanding?: Maybe<Scalars['Long']>;
  totalDeptOutstandingOther?: Maybe<Scalars['Long']>;
  grossIncome?: Maybe<Scalars['Long']>;
  grossProfit?: Maybe<Scalars['Long']>;
  operatingProfit?: Maybe<Scalars['Long']>;
  netProfit?: Maybe<Scalars['Long']>;
  detailsOfDefaultCP?: Maybe<Scalars['String']>;
  detailsOfDefaultDelay?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type FinancialSummaryEntityResponseCollection = {
  __typename?: 'FinancialSummaryEntityResponseCollection';
  nodes: Array<FinancialSummary>;
  pageInfo: Pagination;
};

export type FinancialSummaryFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  netWorth?: Maybe<LongFilterInput>;
  company?: Maybe<CompanyFiltersInput>;
  totalDeptOutstanding?: Maybe<LongFilterInput>;
  totalDeptOutstandingOther?: Maybe<LongFilterInput>;
  grossIncome?: Maybe<LongFilterInput>;
  grossProfit?: Maybe<LongFilterInput>;
  operatingProfit?: Maybe<LongFilterInput>;
  netProfit?: Maybe<LongFilterInput>;
  detailsOfDefaultCP?: Maybe<StringFilterInput>;
  detailsOfDefaultDelay?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<FinancialSummaryFiltersInput>>>;
  or?: Maybe<Array<Maybe<FinancialSummaryFiltersInput>>>;
  not?: Maybe<FinancialSummaryFiltersInput>;
};

export type FinancialSummaryInput = {
  netWorth?: Maybe<Scalars['Long']>;
  company?: Maybe<Scalars['ID']>;
  totalDeptOutstanding?: Maybe<Scalars['Long']>;
  totalDeptOutstandingOther?: Maybe<Scalars['Long']>;
  grossIncome?: Maybe<Scalars['Long']>;
  grossProfit?: Maybe<Scalars['Long']>;
  operatingProfit?: Maybe<Scalars['Long']>;
  netProfit?: Maybe<Scalars['Long']>;
  detailsOfDefaultCP?: Maybe<Scalars['String']>;
  detailsOfDefaultDelay?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type FloatFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Float']>>>;
  or?: Maybe<Array<Maybe<Scalars['Float']>>>;
  not?: Maybe<FloatFilterInput>;
  eq?: Maybe<Scalars['Float']>;
  eqi?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
  nei?: Maybe<Scalars['Float']>;
  startsWith?: Maybe<Scalars['Float']>;
  endsWith?: Maybe<Scalars['Float']>;
  contains?: Maybe<Scalars['Float']>;
  notContains?: Maybe<Scalars['Float']>;
  containsi?: Maybe<Scalars['Float']>;
  notContainsi?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Float']>>>;
  between?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type FundInterest = {
  __typename?: 'FundInterest';
  documentId: Scalars['ID'];
  data?: Maybe<Scalars['JSON']>;
  note?: Maybe<Note>;
  fundInterestStatus?: Maybe<Enum_Fundinterest_Fundintereststatus>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type FundInterestEntityResponseCollection = {
  __typename?: 'FundInterestEntityResponseCollection';
  nodes: Array<FundInterest>;
  pageInfo: Pagination;
};

export type FundInterestFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  data?: Maybe<JsonFilterInput>;
  note?: Maybe<NoteFiltersInput>;
  fundInterestStatus?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<FundInterestFiltersInput>>>;
  or?: Maybe<Array<Maybe<FundInterestFiltersInput>>>;
  not?: Maybe<FundInterestFiltersInput>;
};

export type FundInterestInput = {
  data?: Maybe<Scalars['JSON']>;
  note?: Maybe<Scalars['ID']>;
  fundInterestStatus?: Maybe<Enum_Fundinterest_Fundintereststatus>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type GenericMorph = ComponentSharedWelcomeSlides | ComponentSharedSlider | ComponentSharedSeo | ComponentSharedRichText | ComponentSharedQuote | ComponentSharedMedia | UploadFile | I18NLocale | ReviewWorkflowsWorkflow | ReviewWorkflowsWorkflowStage | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | BankWithdrawRequest | BankingInformation | Bond | BondHolding | BondPayout | BondPriceLog | BondSellRequest | ChatMessage | Comment | Company | Conversation | FinancialSummary | FundInterest | Investment | Jamiipesa | MarketValueLog | MasterBond | MasterNote | Note | Notification | PayoutRequest | PortifolioValueLog | PurchaseRequest | RealEstateAsset | RealEstateHolding | RealEstatePayout | RealEstatePriceLog | RealEstateSellRequest | RolloverRequest | RolloverResponse | SellRequest | TopupRequest | Transaction | UpdateRequest | Wallet | WelcomeSlide;

export type GetAcceptedSellRequestsResponse = {
  __typename?: 'GetAcceptedSellRequestsResponse';
  /** List of sell request losses */
  sellRequestLosses?: Maybe<Array<Maybe<SellRequestLoss>>>;
};

export type GetAllMyMasterNotesPayload = {
  __typename?: 'GetAllMyMasterNotesPayload';
  /** List of master notes */
  masterNotes?: Maybe<Array<Maybe<MasterNote>>>;
  /** Number of pages */
  pages?: Maybe<Scalars['Int']>;
  /** Total number of master notes */
  page?: Maybe<Scalars['Int']>;
  /** Total count of master notes */
  count?: Maybe<Scalars['Int']>;
};

export type GetAvailableBondsPayload = {
  __typename?: 'GetAvailableBondsPayload';
  bonds?: Maybe<Array<Maybe<BondForInvestorPayload>>>;
  pages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

export type GetAvailableNotesPayload = {
  __typename?: 'GetAvailableNotesPayload';
  /** List of available commercial papers */
  notes?: Maybe<Array<Maybe<NoteForInvestorPayload>>>;
  /** Number of pages */
  pages?: Maybe<Scalars['Int']>;
  /** Total number of notes */
  page?: Maybe<Scalars['Int']>;
};

export type GetAvailableRealEstateAssetsPayload = {
  __typename?: 'GetAvailableRealEstateAssetsPayload';
  /** List of available real estate assets */
  realEstateAssets?: Maybe<Array<Maybe<RealEstateAssetForInvestorPayload>>>;
  /** Number of pages */
  pages?: Maybe<Scalars['Int']>;
  /** Current page number */
  page?: Maybe<Scalars['Int']>;
};

export type GetBondHoldingsPayload = {
  __typename?: 'GetBondHoldingsPayload';
  holdings: Array<Maybe<BondHoldingPayload>>;
  pages: Scalars['Int'];
  page: Scalars['Int'];
};

export type GetBondsByMasterBondPayload = {
  __typename?: 'GetBondsByMasterBondPayload';
  bonds?: Maybe<Array<Maybe<Bond>>>;
  pages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

export type GetBondsPayload = {
  __typename?: 'GetBondsPayload';
  bonds?: Maybe<Array<Maybe<Bond>>>;
  pages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

export type GetInvestmentsByNoteIdPayload = {
  __typename?: 'GetInvestmentsByNoteIdPayload';
  /** List of investments */
  investments?: Maybe<Array<Maybe<Investment>>>;
  /** Total number of pages */
  pages?: Maybe<Scalars['Int']>;
  /** Current page number */
  page?: Maybe<Scalars['Int']>;
};

export type GetInvestmentsPayload = {
  __typename?: 'GetInvestmentsPayload';
  /** List of investments */
  investments?: Maybe<Array<Maybe<Investment>>>;
};

export type GetMasterNoteInvestorsPayload = {
  __typename?: 'GetMasterNoteInvestorsPayload';
  /** ID of the investor */
  id?: Maybe<Scalars['ID']>;
  /** Name of the investor */
  name?: Maybe<Scalars['String']>;
  /** Kestrel account number of the investor */
  kestrelAccountNumber?: Maybe<Scalars['String']>;
  /** Total amount invested by the investor */
  totalAmountInvested?: Maybe<Scalars['Float']>;
  /** List of notes invested by the investor */
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Total face value of the notes invested by the investor */
  totalFaceValue?: Maybe<Scalars['Float']>;
};

export type GetMasterNoteInvestorsResult = {
  __typename?: 'GetMasterNoteInvestorsResult';
  /** List of investors */
  investors?: Maybe<Array<Maybe<GetMasterNoteInvestorsPayload>>>;
  /** Current page number */
  page?: Maybe<Scalars['Int']>;
  /** Total number of pages */
  pages?: Maybe<Scalars['Int']>;
  /** Total number of investors */
  count?: Maybe<Scalars['Int']>;
};

export type GetMyBondsPayload = {
  __typename?: 'GetMyBondsPayload';
  bonds?: Maybe<Array<Maybe<Bond>>>;
  pages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

export type GetMyMasterBondsPayload = {
  __typename?: 'GetMyMasterBondsPayload';
  masterBonds?: Maybe<Array<Maybe<MasterBond>>>;
  pages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

export type GetMyRealEstateAssetsPayload = {
  __typename?: 'GetMyRealEstateAssetsPayload';
  realEstateAssets?: Maybe<Array<Maybe<RealEstateAsset>>>;
  pages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
};

export type GetNotesPayload = {
  __typename?: 'GetNotesPayload';
  /** List of notes */
  notes?: Maybe<Array<Maybe<Note>>>;
  /** Number of pages */
  pages?: Maybe<Scalars['Int']>;
  /** Total number of notes */
  page?: Maybe<Scalars['Int']>;
};

/** Response payload for portfolio value logs query */
export type GetPortfolioValueLogsPayload = {
  __typename?: 'GetPortfolioValueLogsPayload';
  /** List of portfolio value logs */
  logs: Array<PortfolioValueLogPayload>;
  /** Total number of logs */
  total: Scalars['Int'];
};

export type GetRealEstateAssetForInvestorInput = {
  /** ID of the real estate asset to retrieve */
  assetId: Scalars['String'];
};

export type GetRealEstateHoldingsInput = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type GetRealEstateHoldingsPayload = {
  __typename?: 'GetRealEstateHoldingsPayload';
  holdings: Array<Maybe<RealEstateHolding>>;
  pages: Scalars['Int'];
  page: Scalars['Int'];
};

export type GetRealEstatePriceLogsPayload = {
  __typename?: 'GetRealEstatePriceLogsPayload';
  realEstatePriceLogs?: Maybe<Array<Maybe<RealEstatePriceLog>>>;
  page?: Maybe<Scalars['Int']>;
  pages?: Maybe<Scalars['Int']>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  code?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<I18NLocaleFiltersInput>>>;
  or?: Maybe<Array<Maybe<I18NLocaleFiltersInput>>>;
  not?: Maybe<I18NLocaleFiltersInput>;
};

export type IdFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['ID']>>>;
  or?: Maybe<Array<Maybe<Scalars['ID']>>>;
  not?: Maybe<IdFilterInput>;
  eq?: Maybe<Scalars['ID']>;
  eqi?: Maybe<Scalars['ID']>;
  ne?: Maybe<Scalars['ID']>;
  nei?: Maybe<Scalars['ID']>;
  startsWith?: Maybe<Scalars['ID']>;
  endsWith?: Maybe<Scalars['ID']>;
  contains?: Maybe<Scalars['ID']>;
  notContains?: Maybe<Scalars['ID']>;
  containsi?: Maybe<Scalars['ID']>;
  notContainsi?: Maybe<Scalars['ID']>;
  gt?: Maybe<Scalars['ID']>;
  gte?: Maybe<Scalars['ID']>;
  lt?: Maybe<Scalars['ID']>;
  lte?: Maybe<Scalars['ID']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['ID']>>>;
  between?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type IntFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Int']>>>;
  or?: Maybe<Array<Maybe<Scalars['Int']>>>;
  not?: Maybe<IntFilterInput>;
  eq?: Maybe<Scalars['Int']>;
  eqi?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
  nei?: Maybe<Scalars['Int']>;
  startsWith?: Maybe<Scalars['Int']>;
  endsWith?: Maybe<Scalars['Int']>;
  contains?: Maybe<Scalars['Int']>;
  notContains?: Maybe<Scalars['Int']>;
  containsi?: Maybe<Scalars['Int']>;
  notContainsi?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Int']>>>;
  between?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type Investment = {
  __typename?: 'Investment';
  documentId: Scalars['ID'];
  amount?: Maybe<Scalars['Int']>;
  investmentStatus?: Maybe<Enum_Investment_Investmentstatus>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  totalReturn?: Maybe<Scalars['Float']>;
  lastPayInterestDate?: Maybe<Scalars['Date']>;
  currency?: Maybe<Enum_Investment_Currency>;
  interest?: Maybe<Scalars['Int']>;
  user?: Maybe<UsersPermissionsUser>;
  transactions_connection?: Maybe<TransactionRelationResponseCollection>;
  transactions: Array<Maybe<Transaction>>;
  note?: Maybe<Note>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type InvestmentTransactions_ConnectionArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type InvestmentTransactionsArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InvestmentEntityResponseCollection = {
  __typename?: 'InvestmentEntityResponseCollection';
  nodes: Array<Investment>;
  pageInfo: Pagination;
};

export type InvestmentFilter = {
  /** Search term */
  search?: Maybe<Scalars['String']>;
  /** Start date for approval filter */
  approvalStartDate?: Maybe<Scalars['Date']>;
  /** End date for approval filter */
  approvalEndDate?: Maybe<Scalars['Date']>;
  /** List of investment IDs to filter */
  investmentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type InvestmentFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  amount?: Maybe<IntFilterInput>;
  investmentStatus?: Maybe<StringFilterInput>;
  approvedAt?: Maybe<DateTimeFilterInput>;
  totalReturn?: Maybe<FloatFilterInput>;
  lastPayInterestDate?: Maybe<DateFilterInput>;
  currency?: Maybe<StringFilterInput>;
  interest?: Maybe<IntFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  transactions?: Maybe<TransactionFiltersInput>;
  note?: Maybe<NoteFiltersInput>;
  company?: Maybe<CompanyFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<InvestmentFiltersInput>>>;
  or?: Maybe<Array<Maybe<InvestmentFiltersInput>>>;
  not?: Maybe<InvestmentFiltersInput>;
};

export type InvestmentInput = {
  amount?: Maybe<Scalars['Int']>;
  investmentStatus?: Maybe<Enum_Investment_Investmentstatus>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  totalReturn?: Maybe<Scalars['Float']>;
  lastPayInterestDate?: Maybe<Scalars['Date']>;
  currency?: Maybe<Enum_Investment_Currency>;
  interest?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['ID']>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  note?: Maybe<Scalars['ID']>;
  company?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type InvestmentRelationResponseCollection = {
  __typename?: 'InvestmentRelationResponseCollection';
  nodes: Array<Investment>;
};

export type InvestorDashboardStatsPayload = {
  __typename?: 'InvestorDashboardStatsPayload';
  /** Total amount invested (notes + real estate) */
  totalInvested: Scalars['Float'];
  /** Total interest earned (notes + real estate) */
  totalInterestEarned: Scalars['Float'];
  /** Total amount invested in notes */
  notesInvested: Scalars['Float'];
  /** Total amount invested in real estate */
  realEstateInvested: Scalars['Float'];
  /** Total amount invested in bonds */
  bondsInvested: Scalars['Float'];
  /** Interest earned from notes */
  notesInterest: Scalars['Float'];
  /** Interest earned from real estate (REAL_ESTATE_PAYOUT_YIELD) */
  realEstateInterest: Scalars['Float'];
};

/** Input for investor onboarding process */
export type InvestorOnboardingInput = {
  /** Current step of the onboarding process */
  investorOnboardingStep: InvestorOnboardingSteps;
  /** Date of birth of the investor */
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** Tax identification number */
  taxNumber?: Maybe<Scalars['String']>;
  /** Country of citizenship */
  citizenship?: Maybe<Scalars['String']>;
  /** Country */
  country?: Maybe<Scalars['String']>;
  /** Date of occupancy */
  dateOfOccupancy?: Maybe<Scalars['Date']>;
  /** Reason for investing */
  reasonForInvesting?: Maybe<Reasons_For_Investing>;
  /** Annual net income of the investor */
  annualNetIncome?: Maybe<Scalars['String']>;
  /** Whether user agreed to investment terms */
  agreedToInvestTerms?: Maybe<Scalars['Boolean']>;
  /** ID of certified identity document */
  certifiedId?: Maybe<Scalars['ID']>;
  /** Identity document number */
  idNumber?: Maybe<Scalars['String']>;
  /** Type of investor */
  type?: Maybe<Scalars['String']>;
  /** Type of identity document */
  idType?: Maybe<Scalars['String']>;
  /** IDs of national identity documents */
  nationalId?: Maybe<Array<Scalars['ID']>>;
  /** ID of selfie image */
  selfie?: Maybe<Scalars['ID']>;
  /** Postal address */
  postalAddress?: Maybe<Scalars['String']>;
  /** Postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Tax Pin Certificate */
  taxPinCertificate?: Maybe<Scalars['ID']>;
  /** Street number */
  streetNumber?: Maybe<Scalars['String']>;
  /** Street name */
  streetName?: Maybe<Scalars['String']>;
  /** Apartment number */
  apartmentNumber?: Maybe<Scalars['String']>;
  /** City */
  city?: Maybe<Scalars['String']>;
  /** Residency status */
  residencyStatus?: Maybe<Enum_Userspermissionsuser_Residencystatus>;
  /** Physical address */
  physicalAddress?: Maybe<Scalars['String']>;
  /** Occupation */
  occupation?: Maybe<Scalars['String']>;
  /** Position held */
  positionHeld?: Maybe<Scalars['String']>;
  /** Years at current occupation */
  yearsAtCurrentOccupation?: Maybe<Scalars['Int']>;
  /** Employer business activity */
  businessActivity?: Maybe<Scalars['String']>;
  /** Business name */
  businessName?: Maybe<Scalars['String']>;
  /** Investment sources */
  investmentSources?: Maybe<Scalars['String']>;
  /** Employment status */
  employmentStatus?: Maybe<Scalars['String']>;
  /** Expected funding frequency */
  expectedFundingFrequency?: Maybe<Scalars['String']>;
  /** Office number */
  officeNumber?: Maybe<Scalars['String']>;
  /** Bank name */
  bankName?: Maybe<Scalars['String']>;
  /** Account number */
  accountNumber?: Maybe<Scalars['String']>;
  /** Bank branch */
  branch?: Maybe<Scalars['String']>;
  /** Account name */
  accountName?: Maybe<Scalars['String']>;
  /** Swift code */
  swiftCode?: Maybe<Scalars['String']>;
  /** ID of proof of account */
  proofOfAccount?: Maybe<Scalars['ID']>;
  /** Routing number */
  routingNumber?: Maybe<Scalars['String']>;
  /** Whether Facta applies */
  factaApplies?: Maybe<Scalars['Boolean']>;
  /** Whether the investor is a PEP */
  isPep?: Maybe<Scalars['Boolean']>;
  /** Additional information */
  additionalInfo?: Maybe<Scalars['String']>;
  /** Investment reaction */
  investmentReaction?: Maybe<Scalars['String']>;
  /** Investment knowledge */
  investmentKnowledge?: Maybe<Scalars['String']>;
  /** Investment horizon */
  investmentHorizon?: Maybe<Scalars['String']>;
};

/** Investor onboarding steps */
export enum InvestorOnboardingSteps {
  BasicInformation = 'BASIC_INFORMATION',
  Banking = 'BANKING',
  DocumentUpload = 'DOCUMENT_UPLOAD',
  Agreement = 'AGREEMENT',
  ReasonForInvesting = 'REASON_FOR_INVESTING',
  BusinessInformation = 'BUSINESS_INFORMATION'
}

/** Sort options for Investor */
export enum InvestorSortBy {
  ClosingDate = 'CLOSING_DATE',
  MaturityDate = 'MATURITY_DATE',
  InterestRate = 'INTEREST_RATE',
  DatePublished = 'DATE_PUBLISHED',
  Amount = 'AMOUNT'
}


export type JsonFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  or?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  not?: Maybe<JsonFilterInput>;
  eq?: Maybe<Scalars['JSON']>;
  eqi?: Maybe<Scalars['JSON']>;
  ne?: Maybe<Scalars['JSON']>;
  nei?: Maybe<Scalars['JSON']>;
  startsWith?: Maybe<Scalars['JSON']>;
  endsWith?: Maybe<Scalars['JSON']>;
  contains?: Maybe<Scalars['JSON']>;
  notContains?: Maybe<Scalars['JSON']>;
  containsi?: Maybe<Scalars['JSON']>;
  notContainsi?: Maybe<Scalars['JSON']>;
  gt?: Maybe<Scalars['JSON']>;
  gte?: Maybe<Scalars['JSON']>;
  lt?: Maybe<Scalars['JSON']>;
  lte?: Maybe<Scalars['JSON']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  between?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type Jamiipesa = {
  __typename?: 'Jamiipesa';
  documentId: Scalars['ID'];
  privacyPolicy: Scalars['String'];
  termsAndConditions: Scalars['String'];
  adminSupportEmail?: Maybe<Scalars['String']>;
  bankAccountNumberUSD?: Maybe<Scalars['String']>;
  bankAccountNameUSD?: Maybe<Scalars['String']>;
  bankNameUSD?: Maybe<Scalars['String']>;
  bankCodeUSD?: Maybe<Scalars['String']>;
  swiftCodeUSD?: Maybe<Scalars['String']>;
  bankAccountNumberKES?: Maybe<Scalars['String']>;
  bankAccountNameKES?: Maybe<Scalars['String']>;
  bankNameKES?: Maybe<Scalars['String']>;
  swiftCodeKES?: Maybe<Scalars['String']>;
  bankCodeKES?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type JamiipesaInput = {
  privacyPolicy?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  adminSupportEmail?: Maybe<Scalars['String']>;
  bankAccountNumberUSD?: Maybe<Scalars['String']>;
  bankAccountNameUSD?: Maybe<Scalars['String']>;
  bankNameUSD?: Maybe<Scalars['String']>;
  bankCodeUSD?: Maybe<Scalars['String']>;
  swiftCodeUSD?: Maybe<Scalars['String']>;
  bankAccountNumberKES?: Maybe<Scalars['String']>;
  bankAccountNameKES?: Maybe<Scalars['String']>;
  bankNameKES?: Maybe<Scalars['String']>;
  swiftCodeKES?: Maybe<Scalars['String']>;
  bankCodeKES?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type LongFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Long']>>>;
  or?: Maybe<Array<Maybe<Scalars['Long']>>>;
  not?: Maybe<LongFilterInput>;
  eq?: Maybe<Scalars['Long']>;
  eqi?: Maybe<Scalars['Long']>;
  ne?: Maybe<Scalars['Long']>;
  nei?: Maybe<Scalars['Long']>;
  startsWith?: Maybe<Scalars['Long']>;
  endsWith?: Maybe<Scalars['Long']>;
  contains?: Maybe<Scalars['Long']>;
  notContains?: Maybe<Scalars['Long']>;
  containsi?: Maybe<Scalars['Long']>;
  notContainsi?: Maybe<Scalars['Long']>;
  gt?: Maybe<Scalars['Long']>;
  gte?: Maybe<Scalars['Long']>;
  lt?: Maybe<Scalars['Long']>;
  lte?: Maybe<Scalars['Long']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Long']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Long']>>>;
  between?: Maybe<Array<Maybe<Scalars['Long']>>>;
};

/** Payload for manager metrics */
export type ManagerMetricsPayload = {
  __typename?: 'ManagerMetricsPayload';
  investors: Array<Maybe<UsersPermissionsUser>>;
  transactions: Array<Maybe<Transaction>>;
  createdNotes: Array<Maybe<Note>>;
  fundedNotes: Array<Maybe<Note>>;
  fundingNotes: Array<Maybe<Note>>;
  closedNotes: Array<Maybe<Note>>;
  fundCommercialPapers: Array<Maybe<Note>>;
};

/** Input for market value */
export type MarketValueInput = {
  /** ID of the market value */
  id?: Maybe<Scalars['ID']>;
  /** Market value of the note */
  value?: Maybe<Scalars['Float']>;
};

export type MarketValueLog = {
  __typename?: 'MarketValueLog';
  documentId: Scalars['ID'];
  value?: Maybe<Scalars['Float']>;
  approvedAt?: Maybe<Scalars['Date']>;
  logStatus?: Maybe<Enum_Marketvaluelog_Logstatus>;
  interest?: Maybe<Scalars['Int']>;
  type?: Maybe<Enum_Marketvaluelog_Type>;
  note?: Maybe<Note>;
  masterNote?: Maybe<MasterNote>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type MarketValueLogEntityResponseCollection = {
  __typename?: 'MarketValueLogEntityResponseCollection';
  nodes: Array<MarketValueLog>;
  pageInfo: Pagination;
};

export type MarketValueLogFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  value?: Maybe<FloatFilterInput>;
  approvedAt?: Maybe<DateFilterInput>;
  logStatus?: Maybe<StringFilterInput>;
  interest?: Maybe<IntFilterInput>;
  type?: Maybe<StringFilterInput>;
  note?: Maybe<NoteFiltersInput>;
  masterNote?: Maybe<MasterNoteFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<MarketValueLogFiltersInput>>>;
  or?: Maybe<Array<Maybe<MarketValueLogFiltersInput>>>;
  not?: Maybe<MarketValueLogFiltersInput>;
};

export type MarketValueLogInput = {
  value?: Maybe<Scalars['Float']>;
  approvedAt?: Maybe<Scalars['Date']>;
  logStatus?: Maybe<Enum_Marketvaluelog_Logstatus>;
  interest?: Maybe<Scalars['Int']>;
  type?: Maybe<Enum_Marketvaluelog_Type>;
  note?: Maybe<Scalars['ID']>;
  masterNote?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type MarketValueLogPayload = {
  __typename?: 'MarketValueLogPayload';
  /** List of market value logs */
  marketValueLog?: Maybe<Array<Maybe<MarketValueLog>>>;
  /** Total number of pages */
  pages?: Maybe<Scalars['Int']>;
  /** Current page number */
  page?: Maybe<Scalars['Int']>;
};

export type MarketValueLogRelationResponseCollection = {
  __typename?: 'MarketValueLogRelationResponseCollection';
  nodes: Array<MarketValueLog>;
};

export type MasterBond = {
  __typename?: 'MasterBond';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  interestFrequency?: Maybe<Enum_Masterbond_Interestfrequency>;
  maturityDate?: Maybe<Scalars['Date']>;
  bondPrice?: Maybe<Scalars['Float']>;
  currency?: Maybe<Enum_Masterbond_Currency>;
  investors_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  investors: Array<Maybe<UsersPermissionsUser>>;
  faceValuePerToken?: Maybe<Scalars['Int']>;
  initialFaceValuePerToken?: Maybe<Scalars['Int']>;
  contractAddress?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  MasterBondStatus?: Maybe<Enum_Masterbond_Masterbondstatus>;
  user?: Maybe<UsersPermissionsUser>;
  totalTokens?: Maybe<Scalars['Int']>;
  bonds_connection?: Maybe<BondRelationResponseCollection>;
  bonds: Array<Maybe<Bond>>;
  nextInterestPayment?: Maybe<Scalars['Date']>;
  supportDocuments_connection?: Maybe<UploadFileRelationResponseCollection>;
  supportDocuments: Array<Maybe<UploadFile>>;
  bondPayouts_connection?: Maybe<BondPayoutRelationResponseCollection>;
  bondPayouts: Array<Maybe<BondPayout>>;
  bondPriceLogs_connection?: Maybe<BondPriceLogRelationResponseCollection>;
  bondPriceLogs: Array<Maybe<BondPriceLog>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type MasterBondInvestors_ConnectionArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterBondInvestorsArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterBondBonds_ConnectionArgs = {
  filters?: Maybe<BondFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterBondBondsArgs = {
  filters?: Maybe<BondFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterBondSupportDocuments_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterBondSupportDocumentsArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterBondBondPayouts_ConnectionArgs = {
  filters?: Maybe<BondPayoutFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterBondBondPayoutsArgs = {
  filters?: Maybe<BondPayoutFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterBondBondPriceLogs_ConnectionArgs = {
  filters?: Maybe<BondPriceLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterBondBondPriceLogsArgs = {
  filters?: Maybe<BondPriceLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** A bond under a master bond with computed summary fields */
export type MasterBondBondEntry = {
  __typename?: 'MasterBondBondEntry';
  documentId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  numberOfTokens?: Maybe<Scalars['Int']>;
  investorCount?: Maybe<Scalars['Int']>;
  /** faceValuePerToken * numberOfTokens */
  bondFaceValue?: Maybe<Scalars['Float']>;
  bondStatus?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  investedTokens?: Maybe<Scalars['Int']>;
};

/** List of bonds under a master bond */
export type MasterBondBondsPayload = {
  __typename?: 'MasterBondBondsPayload';
  bonds: Array<Maybe<MasterBondBondEntry>>;
  total: Scalars['Int'];
};

export type MasterBondCountsPayload = {
  __typename?: 'MasterBondCountsPayload';
  listedCount?: Maybe<Scalars['Int']>;
  submittedCount?: Maybe<Scalars['Int']>;
  approvedCount?: Maybe<Scalars['Int']>;
};

export type MasterBondEntityResponseCollection = {
  __typename?: 'MasterBondEntityResponseCollection';
  nodes: Array<MasterBond>;
  pageInfo: Pagination;
};

export type MasterBondFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  interestRate?: Maybe<FloatFilterInput>;
  interestFrequency?: Maybe<StringFilterInput>;
  maturityDate?: Maybe<DateFilterInput>;
  bondPrice?: Maybe<FloatFilterInput>;
  currency?: Maybe<StringFilterInput>;
  investors?: Maybe<UsersPermissionsUserFiltersInput>;
  faceValuePerToken?: Maybe<IntFilterInput>;
  initialFaceValuePerToken?: Maybe<IntFilterInput>;
  contractAddress?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  potentialRisks?: Maybe<StringFilterInput>;
  MasterBondStatus?: Maybe<StringFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  totalTokens?: Maybe<IntFilterInput>;
  bonds?: Maybe<BondFiltersInput>;
  nextInterestPayment?: Maybe<DateFilterInput>;
  bondPayouts?: Maybe<BondPayoutFiltersInput>;
  bondPriceLogs?: Maybe<BondPriceLogFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<MasterBondFiltersInput>>>;
  or?: Maybe<Array<Maybe<MasterBondFiltersInput>>>;
  not?: Maybe<MasterBondFiltersInput>;
};

export type MasterBondInput = {
  title?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  interestFrequency?: Maybe<Enum_Masterbond_Interestfrequency>;
  maturityDate?: Maybe<Scalars['Date']>;
  bondPrice?: Maybe<Scalars['Float']>;
  currency?: Maybe<Enum_Masterbond_Currency>;
  investors?: Maybe<Array<Maybe<Scalars['ID']>>>;
  faceValuePerToken?: Maybe<Scalars['Int']>;
  initialFaceValuePerToken?: Maybe<Scalars['Int']>;
  contractAddress?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  MasterBondStatus?: Maybe<Enum_Masterbond_Masterbondstatus>;
  user?: Maybe<Scalars['ID']>;
  totalTokens?: Maybe<Scalars['Int']>;
  bonds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  nextInterestPayment?: Maybe<Scalars['Date']>;
  supportDocuments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bondPayouts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bondPriceLogs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

/** An investor in a master bond with aggregated totals */
export type MasterBondInvestorEntry = {
  __typename?: 'MasterBondInvestorEntry';
  documentId: Scalars['String'];
  /** User ID on the platform */
  platformId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  kestrelAccountNumber?: Maybe<Scalars['String']>;
  /** Comma-separated bond titles the investor holds under this master bond */
  bondsInvested?: Maybe<Scalars['String']>;
  /** Total tokens bought across all bonds under this master bond */
  totalLots: Scalars['Int'];
  /** totalLots * faceValuePerToken */
  totalFaceValue: Scalars['Float'];
  /** Sum of (tokens * faceValuePerToken * purchasePrice / 100) across all bonds */
  totalAmountInvested: Scalars['Float'];
};

/** List of investors in a master bond */
export type MasterBondInvestorsPayload = {
  __typename?: 'MasterBondInvestorsPayload';
  investors: Array<Maybe<MasterBondInvestorEntry>>;
  total: Scalars['Int'];
};

export type MasterBondRelationResponseCollection = {
  __typename?: 'MasterBondRelationResponseCollection';
  nodes: Array<MasterBond>;
};

export type MasterNote = {
  __typename?: 'MasterNote';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Masternote_Type>;
  interestRate?: Maybe<Scalars['Float']>;
  interestFrequency?: Maybe<Enum_Masternote_Interestfrequency>;
  maturityDate?: Maybe<Scalars['Date']>;
  marketValue?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  currentStep?: Maybe<Enum_Masternote_Currentstep>;
  masterNoteStatus?: Maybe<Enum_Masternote_Masternotestatus>;
  currency?: Maybe<Enum_Masternote_Currency>;
  fundManager?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  compoundingFrequency?: Maybe<Enum_Masternote_Compoundingfrequency>;
  marketValueLogs_connection?: Maybe<MarketValueLogRelationResponseCollection>;
  marketValueLogs: Array<Maybe<MarketValueLog>>;
  notes_connection?: Maybe<NoteRelationResponseCollection>;
  notes: Array<Maybe<Note>>;
  memorandum_connection?: Maybe<UploadFileRelationResponseCollection>;
  memorandum: Array<Maybe<UploadFile>>;
  user?: Maybe<UsersPermissionsUser>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type MasterNoteMarketValueLogs_ConnectionArgs = {
  filters?: Maybe<MarketValueLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterNoteMarketValueLogsArgs = {
  filters?: Maybe<MarketValueLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterNoteNotes_ConnectionArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterNoteNotesArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterNoteMemorandum_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MasterNoteMemorandumArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MasterNoteEntityResponseCollection = {
  __typename?: 'MasterNoteEntityResponseCollection';
  nodes: Array<MasterNote>;
  pageInfo: Pagination;
};

/** Input for filtering master notes */
export type MasterNoteFilter = {
  /** Search term for filtering master notes */
  search?: Maybe<Scalars['String']>;
  /** Status of the master note */
  status?: Maybe<Enum_Masternote_Masternotestatus>;
  /** Current step of the master note */
  currency?: Maybe<Enum_Masternote_Currency>;
};

export type MasterNoteFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  interestRate?: Maybe<FloatFilterInput>;
  interestFrequency?: Maybe<StringFilterInput>;
  maturityDate?: Maybe<DateFilterInput>;
  marketValue?: Maybe<FloatFilterInput>;
  description?: Maybe<StringFilterInput>;
  potentialRisks?: Maybe<StringFilterInput>;
  currentStep?: Maybe<StringFilterInput>;
  masterNoteStatus?: Maybe<StringFilterInput>;
  currency?: Maybe<StringFilterInput>;
  fundManager?: Maybe<StringFilterInput>;
  assetType?: Maybe<StringFilterInput>;
  compoundingFrequency?: Maybe<StringFilterInput>;
  marketValueLogs?: Maybe<MarketValueLogFiltersInput>;
  notes?: Maybe<NoteFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<MasterNoteFiltersInput>>>;
  or?: Maybe<Array<Maybe<MasterNoteFiltersInput>>>;
  not?: Maybe<MasterNoteFiltersInput>;
};

export type MasterNoteInput = {
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Masternote_Type>;
  interestRate?: Maybe<Scalars['Float']>;
  interestFrequency?: Maybe<Enum_Masternote_Interestfrequency>;
  maturityDate?: Maybe<Scalars['Date']>;
  marketValue?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  currentStep?: Maybe<Enum_Masternote_Currentstep>;
  masterNoteStatus?: Maybe<Enum_Masternote_Masternotestatus>;
  currency?: Maybe<Enum_Masternote_Currency>;
  fundManager?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  compoundingFrequency?: Maybe<Enum_Masternote_Compoundingfrequency>;
  marketValueLogs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  memorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  user?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type MasterNoteRelationResponseCollection = {
  __typename?: 'MasterNoteRelationResponseCollection';
  nodes: Array<MasterNote>;
};

export type MintRealEstateAssetTokensInput = {
  /** Document ID of the real estate asset to mint tokens for */
  assetId: Scalars['String'];
  /** Number of tokens to mint */
  amount: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  createBankWithdrawRequest?: Maybe<BankWithdrawRequest>;
  updateBankWithdrawRequest?: Maybe<BankWithdrawRequest>;
  deleteBankWithdrawRequest?: Maybe<DeleteMutationResponse>;
  createBankingInformation?: Maybe<BankingInformation>;
  updateBankingInformation?: Maybe<BankingInformation>;
  deleteBankingInformation?: Maybe<DeleteMutationResponse>;
  /** Corporate owner creates a bond under an APPROVED or LISTED master bond. Title and interestRate are inherited from the master bond. */
  createBond?: Maybe<Bond>;
  updateBond?: Maybe<Bond>;
  deleteBond?: Maybe<DeleteMutationResponse>;
  createBondHolding?: Maybe<BondHolding>;
  updateBondHolding?: Maybe<BondHolding>;
  deleteBondHolding?: Maybe<DeleteMutationResponse>;
  createBondPayout?: Maybe<BondPayout>;
  updateBondPayout?: Maybe<BondPayout>;
  deleteBondPayout?: Maybe<DeleteMutationResponse>;
  createBondPriceLog?: Maybe<BondPriceLog>;
  updateBondPriceLog?: Maybe<BondPriceLog>;
  deleteBondPriceLog?: Maybe<DeleteMutationResponse>;
  /** Investor creates a sell request for bond tokens */
  createBondSellRequest?: Maybe<OkResponse>;
  updateBondSellRequest?: Maybe<BondSellRequest>;
  deleteBondSellRequest?: Maybe<DeleteMutationResponse>;
  createChatMessage?: Maybe<ChatMessage>;
  updateChatMessage?: Maybe<ChatMessage>;
  deleteChatMessage?: Maybe<DeleteMutationResponse>;
  createComment?: Maybe<Comment>;
  updateComment?: Maybe<Comment>;
  deleteComment?: Maybe<DeleteMutationResponse>;
  createCompany?: Maybe<Company>;
  updateCompany?: Maybe<Company>;
  deleteCompany?: Maybe<DeleteMutationResponse>;
  createConversation?: Maybe<Conversation>;
  updateConversation?: Maybe<Conversation>;
  deleteConversation?: Maybe<DeleteMutationResponse>;
  createFinancialSummary?: Maybe<FinancialSummary>;
  updateFinancialSummary?: Maybe<FinancialSummary>;
  deleteFinancialSummary?: Maybe<DeleteMutationResponse>;
  createFundInterest?: Maybe<FundInterest>;
  updateFundInterest?: Maybe<FundInterest>;
  deleteFundInterest?: Maybe<DeleteMutationResponse>;
  createInvestment?: Maybe<Investment>;
  updateInvestment?: Maybe<Investment>;
  deleteInvestment?: Maybe<DeleteMutationResponse>;
  updateJamiipesa?: Maybe<Jamiipesa>;
  deleteJamiipesa?: Maybe<DeleteMutationResponse>;
  createMarketValueLog?: Maybe<MarketValueLog>;
  updateMarketValueLog?: Maybe<MarketValueLog>;
  deleteMarketValueLog?: Maybe<DeleteMutationResponse>;
  createMasterBond?: Maybe<MasterBond>;
  /** Corporate updates description, potential risks, and support documents for a SUBMITTED master bond (step 2) */
  updateMasterBond?: Maybe<MasterBond>;
  deleteMasterBond?: Maybe<DeleteMutationResponse>;
  createMasterNote?: Maybe<MasterNote>;
  updateMasterNote?: Maybe<MasterNote>;
  deleteMasterNote?: Maybe<DeleteMutationResponse>;
  createNote?: Maybe<Note>;
  updateNote?: Maybe<Note>;
  deleteNote?: Maybe<DeleteMutationResponse>;
  createNotification?: Maybe<Notification>;
  updateNotification?: Maybe<Notification>;
  deleteNotification?: Maybe<DeleteMutationResponse>;
  createPayoutRequest?: Maybe<PayoutRequest>;
  updatePayoutRequest?: Maybe<PayoutRequest>;
  deletePayoutRequest?: Maybe<DeleteMutationResponse>;
  createPortifolioValueLog?: Maybe<PortifolioValueLog>;
  updatePortifolioValueLog?: Maybe<PortifolioValueLog>;
  deletePortifolioValueLog?: Maybe<DeleteMutationResponse>;
  createPurchaseRequest?: Maybe<PurchaseRequest>;
  updatePurchaseRequest?: Maybe<PurchaseRequest>;
  deletePurchaseRequest?: Maybe<DeleteMutationResponse>;
  createRealEstateAsset?: Maybe<RealEstateAsset>;
  updateRealEstateAsset?: Maybe<RealEstateAsset>;
  deleteRealEstateAsset?: Maybe<DeleteMutationResponse>;
  createRealEstateHolding?: Maybe<RealEstateHolding>;
  updateRealEstateHolding?: Maybe<RealEstateHolding>;
  deleteRealEstateHolding?: Maybe<DeleteMutationResponse>;
  createRealEstatePayout?: Maybe<RealEstatePayout>;
  updateRealEstatePayout?: Maybe<RealEstatePayout>;
  deleteRealEstatePayout?: Maybe<DeleteMutationResponse>;
  createRealEstatePriceLog?: Maybe<RealEstatePriceLog>;
  updateRealEstatePriceLog?: Maybe<RealEstatePriceLog>;
  deleteRealEstatePriceLog?: Maybe<DeleteMutationResponse>;
  createRealEstateSellRequest?: Maybe<RealEstateSellRequest>;
  updateRealEstateSellRequest?: Maybe<RealEstateSellRequest>;
  deleteRealEstateSellRequest?: Maybe<DeleteMutationResponse>;
  createRolloverRequest?: Maybe<RolloverRequest>;
  updateRolloverRequest?: Maybe<RolloverRequest>;
  deleteRolloverRequest?: Maybe<DeleteMutationResponse>;
  createRolloverResponse?: Maybe<RolloverResponse>;
  updateRolloverResponse?: Maybe<RolloverResponse>;
  deleteRolloverResponse?: Maybe<DeleteMutationResponse>;
  createSellRequest?: Maybe<SellRequest>;
  updateSellRequest?: Maybe<SellRequest>;
  deleteSellRequest?: Maybe<DeleteMutationResponse>;
  createTopupRequest?: Maybe<TopupRequest>;
  updateTopupRequest?: Maybe<TopupRequest>;
  deleteTopupRequest?: Maybe<DeleteMutationResponse>;
  createTransaction?: Maybe<Transaction>;
  updateTransaction?: Maybe<Transaction>;
  deleteTransaction?: Maybe<DeleteMutationResponse>;
  createUpdateRequest?: Maybe<UpdateRequest>;
  updateUpdateRequest?: Maybe<UpdateRequest>;
  deleteUpdateRequest?: Maybe<DeleteMutationResponse>;
  createWallet?: Maybe<Wallet>;
  updateWallet?: Maybe<Wallet>;
  deleteWallet?: Maybe<DeleteMutationResponse>;
  updateWelcomeSlide?: Maybe<WelcomeSlide>;
  deleteWelcomeSlide?: Maybe<DeleteMutationResponse>;
  updateUploadFile: UploadFile;
  deleteUploadFile?: Maybe<UploadFile>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Change the current user password after verification */
  changeMyPassword?: Maybe<OkResponse>;
  /** Change the purpose for using the application */
  changeAppUse?: Maybe<UsersPermissionsUser>;
  /** Onboard a user with their information */
  onboarding?: Maybe<UsersPermissionsUser>;
  /** Onboard an investor with their information */
  investorOnboarding?: Maybe<UsersPermissionsUser>;
  /** Change the currency of the user */
  changeCurrency?: Maybe<UsersPermissionsUser>;
  /** Update the regulatory profile of the user */
  updateRegulatoryProfile?: Maybe<UsersPermissionsUser>;
  /** Submit a support request */
  helpAndSupport?: Maybe<OkResponse>;
  /** Calculate investment returns */
  calculateInvestment?: Maybe<CalculateInvestmentPayload>;
  /** Buy an investment in a note */
  buyInvestment?: Maybe<Transaction>;
  /** Calculate sell fees and amounts for an investment */
  calculateSell?: Maybe<CalculateSellPayload>;
  /** Create a sell request for an investment */
  createSell?: Maybe<OkResponse>;
  /** Create a new note */
  createMyNote?: Maybe<Note>;
  /** Submit a note for review */
  submitNote?: Maybe<Note>;
  /** Approve a note */
  approveNote?: Maybe<Note>;
  /** Decline a note and add a note with reason */
  declineNote?: Maybe<Note>;
  /** Request more information about a note */
  requestMoreInfo?: Maybe<Note>;
  /** Create an internal comment for a note */
  createInternalComment?: Maybe<Comment>;
  /** Update the market value of a note */
  updateMarketValue?: Maybe<OkResponse>;
  /** Change the status of a note */
  changeStatus?: Maybe<OkResponse>;
  /** Create or update a master note */
  createMasterNoteByUser?: Maybe<MasterNote>;
  /** Submit a bank withdrawal request */
  submitBankWithdrawRequest?: Maybe<OkResponse>;
  /** Corporate creates a standalone real-estate asset (DRAFT) with base fields only */
  createRealEstateAssetBase?: Maybe<RealEstateAsset>;
  /** Corporate updates real-estate-specific details for a DRAFT real-estate asset */
  updateRealEstateAssetDetails?: Maybe<RealEstateAsset>;
  /** Corporate submits a real-estate asset for review (requires minimal details) */
  submitRealEstateAsset?: Maybe<OkResponse>;
  /** Regulatory reviews a submitted real-estate asset (APPROVE or REJECT) */
  reviewRealEstateAsset?: Maybe<OkResponse>;
  /** Regulatory approves a submitted real-estate asset (LISTED) */
  approveRealEstateAsset?: Maybe<RealEstateAsset>;
  /** Create a new real estate price log entry for approval */
  createMyRealEstatePriceLog?: Maybe<RealEstatePriceLog>;
  /** Purchase tokens of a real estate asset */
  purchaseRealEstateAsset?: Maybe<OkResponse>;
  /** Create a sell request for real estate asset holdings */
  createRealEstateSell?: Maybe<OkResponse>;
  /** Mint additional tokens for a real estate asset contract */
  mintRealEstateAssetTokens?: Maybe<OkResponse>;
  /** Create a payout request for a real estate asset (yield or payout all) */
  createRealEstatePayoutRequest?: Maybe<RealEstatePayout>;
  /** Update company documents */
  updateCompanyDocuments?: Maybe<Company>;
  /** Submit a top-up request */
  submitTopupRequest?: Maybe<OkResponse>;
  /** Archive (mark as read) notifications */
  archiveNotification?: Maybe<OkResponse>;
  /** Send payout by user */
  sendPayoutByUser?: Maybe<OkResponse>;
  /** Send interest payout for a note */
  sendInterest?: Maybe<OkResponse>;
  /** Request a profile update */
  requestProfileUpdate?: Maybe<OkResponse>;
  /** Request a company update */
  requestCompanyUpdate?: Maybe<OkResponse>;
  /** Request a master note update */
  requestMasterNoteUpdate?: Maybe<OkResponse>;
  /** Top up wallet using M-Pesa */
  topupMyWallet?: Maybe<Transaction>;
  /** Update or create my banking information */
  updateOrCreateMyBankingInformation?: Maybe<BankingInformation>;
  /** Update or create my financial summary */
  updateOrCreateMyFinancialSummary?: Maybe<FinancialSummary>;
  /** Corporate creates a master bond (SUBMITTED) with base fields (step 1) */
  createBaseMasterBond?: Maybe<MasterBond>;
  /** Regulatory reviews a submitted master bond (APPROVE or DECLINE) */
  reviewMasterBond?: Maybe<OkResponse>;
  /** Regulatory approves an APPROVED master bond to LISTED */
  approveMasterBond?: Maybe<MasterBond>;
  /** Bond owner submits a price change request. Creates a PENDING log for admin approval. */
  updateBondPrice?: Maybe<OkResponse>;
  /** Regulatory reviews a submitted bond (APPROVE or DECLINE). On approve, tokens are minted and masterBond totalTokens updated. */
  reviewBond?: Maybe<OkResponse>;
  /** Corporate user creates an interest payout request for a master bond */
  createBondPayoutRequest?: Maybe<OkResponse>;
  /** Corporate user creates a maturity payout request for a master bond with a percentage of face value */
  createBondMaturityPayoutRequest?: Maybe<OkResponse>;
  /** Investor purchases tokens of a listed bond */
  purchaseBondTokens?: Maybe<OkResponse>;
};


export type MutationCreateReviewWorkflowsWorkflowArgs = {
  status?: Maybe<PublicationStatus>;
  data: ReviewWorkflowsWorkflowInput;
};


export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: ReviewWorkflowsWorkflowInput;
};


export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  status?: Maybe<PublicationStatus>;
  data: ReviewWorkflowsWorkflowStageInput;
};


export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: ReviewWorkflowsWorkflowStageInput;
};


export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateBankWithdrawRequestArgs = {
  status?: Maybe<PublicationStatus>;
  data: BankWithdrawRequestInput;
};


export type MutationUpdateBankWithdrawRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: BankWithdrawRequestInput;
};


export type MutationDeleteBankWithdrawRequestArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateBankingInformationArgs = {
  status?: Maybe<PublicationStatus>;
  data: BankingInformationInput;
};


export type MutationUpdateBankingInformationArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: BankingInformationInput;
};


export type MutationDeleteBankingInformationArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateBondArgs = {
  input?: Maybe<CreateBondInput>;
};


export type MutationUpdateBondArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: BondInput;
};


export type MutationDeleteBondArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateBondHoldingArgs = {
  status?: Maybe<PublicationStatus>;
  data: BondHoldingInput;
};


export type MutationUpdateBondHoldingArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: BondHoldingInput;
};


export type MutationDeleteBondHoldingArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateBondPayoutArgs = {
  status?: Maybe<PublicationStatus>;
  data: BondPayoutInput;
};


export type MutationUpdateBondPayoutArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: BondPayoutInput;
};


export type MutationDeleteBondPayoutArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateBondPriceLogArgs = {
  status?: Maybe<PublicationStatus>;
  data: BondPriceLogInput;
};


export type MutationUpdateBondPriceLogArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: BondPriceLogInput;
};


export type MutationDeleteBondPriceLogArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateBondSellRequestArgs = {
  input?: Maybe<CreateBondSellRequestInput>;
};


export type MutationUpdateBondSellRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: BondSellRequestInput;
};


export type MutationDeleteBondSellRequestArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateChatMessageArgs = {
  status?: Maybe<PublicationStatus>;
  data: ChatMessageInput;
};


export type MutationUpdateChatMessageArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: ChatMessageInput;
};


export type MutationDeleteChatMessageArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateCommentArgs = {
  status?: Maybe<PublicationStatus>;
  data: CommentInput;
};


export type MutationUpdateCommentArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: CommentInput;
};


export type MutationDeleteCommentArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateCompanyArgs = {
  status?: Maybe<PublicationStatus>;
  data: CompanyInput;
};


export type MutationUpdateCompanyArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: CompanyInput;
};


export type MutationDeleteCompanyArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateConversationArgs = {
  status?: Maybe<PublicationStatus>;
  data: ConversationInput;
};


export type MutationUpdateConversationArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: ConversationInput;
};


export type MutationDeleteConversationArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateFinancialSummaryArgs = {
  status?: Maybe<PublicationStatus>;
  data: FinancialSummaryInput;
};


export type MutationUpdateFinancialSummaryArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: FinancialSummaryInput;
};


export type MutationDeleteFinancialSummaryArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateFundInterestArgs = {
  status?: Maybe<PublicationStatus>;
  data: FundInterestInput;
};


export type MutationUpdateFundInterestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: FundInterestInput;
};


export type MutationDeleteFundInterestArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateInvestmentArgs = {
  status?: Maybe<PublicationStatus>;
  data: InvestmentInput;
};


export type MutationUpdateInvestmentArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: InvestmentInput;
};


export type MutationDeleteInvestmentArgs = {
  documentId: Scalars['ID'];
};


export type MutationUpdateJamiipesaArgs = {
  status?: Maybe<PublicationStatus>;
  data: JamiipesaInput;
};


export type MutationCreateMarketValueLogArgs = {
  status?: Maybe<PublicationStatus>;
  data: MarketValueLogInput;
};


export type MutationUpdateMarketValueLogArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: MarketValueLogInput;
};


export type MutationDeleteMarketValueLogArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateMasterBondArgs = {
  status?: Maybe<PublicationStatus>;
  data: MasterBondInput;
};


export type MutationUpdateMasterBondArgs = {
  input?: Maybe<UpdateMasterBondInput>;
};


export type MutationDeleteMasterBondArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateMasterNoteArgs = {
  status?: Maybe<PublicationStatus>;
  data: MasterNoteInput;
};


export type MutationUpdateMasterNoteArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: MasterNoteInput;
};


export type MutationDeleteMasterNoteArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateNoteArgs = {
  status?: Maybe<PublicationStatus>;
  data: NoteInput;
};


export type MutationUpdateNoteArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: NoteInput;
};


export type MutationDeleteNoteArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateNotificationArgs = {
  status?: Maybe<PublicationStatus>;
  data: NotificationInput;
};


export type MutationUpdateNotificationArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: NotificationInput;
};


export type MutationDeleteNotificationArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreatePayoutRequestArgs = {
  status?: Maybe<PublicationStatus>;
  data: PayoutRequestInput;
};


export type MutationUpdatePayoutRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: PayoutRequestInput;
};


export type MutationDeletePayoutRequestArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreatePortifolioValueLogArgs = {
  status?: Maybe<PublicationStatus>;
  data: PortifolioValueLogInput;
};


export type MutationUpdatePortifolioValueLogArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: PortifolioValueLogInput;
};


export type MutationDeletePortifolioValueLogArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreatePurchaseRequestArgs = {
  status?: Maybe<PublicationStatus>;
  data: PurchaseRequestInput;
};


export type MutationUpdatePurchaseRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: PurchaseRequestInput;
};


export type MutationDeletePurchaseRequestArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateRealEstateAssetArgs = {
  status?: Maybe<PublicationStatus>;
  data: RealEstateAssetInput;
};


export type MutationUpdateRealEstateAssetArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: RealEstateAssetInput;
};


export type MutationDeleteRealEstateAssetArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateRealEstateHoldingArgs = {
  status?: Maybe<PublicationStatus>;
  data: RealEstateHoldingInput;
};


export type MutationUpdateRealEstateHoldingArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: RealEstateHoldingInput;
};


export type MutationDeleteRealEstateHoldingArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateRealEstatePayoutArgs = {
  status?: Maybe<PublicationStatus>;
  data: RealEstatePayoutInput;
};


export type MutationUpdateRealEstatePayoutArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: RealEstatePayoutInput;
};


export type MutationDeleteRealEstatePayoutArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateRealEstatePriceLogArgs = {
  status?: Maybe<PublicationStatus>;
  data: RealEstatePriceLogInput;
};


export type MutationUpdateRealEstatePriceLogArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: RealEstatePriceLogInput;
};


export type MutationDeleteRealEstatePriceLogArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateRealEstateSellRequestArgs = {
  status?: Maybe<PublicationStatus>;
  data: RealEstateSellRequestInput;
};


export type MutationUpdateRealEstateSellRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: RealEstateSellRequestInput;
};


export type MutationDeleteRealEstateSellRequestArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateRolloverRequestArgs = {
  status?: Maybe<PublicationStatus>;
  data: RolloverRequestInput;
};


export type MutationUpdateRolloverRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: RolloverRequestInput;
};


export type MutationDeleteRolloverRequestArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateRolloverResponseArgs = {
  status?: Maybe<PublicationStatus>;
  data: RolloverResponseInput;
};


export type MutationUpdateRolloverResponseArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: RolloverResponseInput;
};


export type MutationDeleteRolloverResponseArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateSellRequestArgs = {
  status?: Maybe<PublicationStatus>;
  data: SellRequestInput;
};


export type MutationUpdateSellRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: SellRequestInput;
};


export type MutationDeleteSellRequestArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateTopupRequestArgs = {
  status?: Maybe<PublicationStatus>;
  data: TopupRequestInput;
};


export type MutationUpdateTopupRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: TopupRequestInput;
};


export type MutationDeleteTopupRequestArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateTransactionArgs = {
  status?: Maybe<PublicationStatus>;
  data: TransactionInput;
};


export type MutationUpdateTransactionArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: TransactionInput;
};


export type MutationDeleteTransactionArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateUpdateRequestArgs = {
  status?: Maybe<PublicationStatus>;
  data: UpdateRequestInput;
};


export type MutationUpdateUpdateRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: UpdateRequestInput;
};


export type MutationDeleteUpdateRequestArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateWalletArgs = {
  status?: Maybe<PublicationStatus>;
  data: WalletInput;
};


export type MutationUpdateWalletArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: WalletInput;
};


export type MutationDeleteWalletArgs = {
  documentId: Scalars['ID'];
};


export type MutationUpdateWelcomeSlideArgs = {
  status?: Maybe<PublicationStatus>;
  data: WelcomeSlideInput;
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID'];
  info?: Maybe<FileInfoInput>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
  data: UsersPermissionsRoleInput;
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationUpdateUsersPermissionsUserArgs = {
  id: Scalars['ID'];
  data: UsersPermissionsUserInput;
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationChangeMyPasswordArgs = {
  input?: Maybe<ChangePasswordInput>;
};


export type MutationChangeAppUseArgs = {
  input?: Maybe<ChangeAppUseInput>;
};


export type MutationOnboardingArgs = {
  input?: Maybe<OnboardingInput>;
  companyInformation?: Maybe<OnboardingCompanyInput>;
};


export type MutationInvestorOnboardingArgs = {
  input?: Maybe<InvestorOnboardingInput>;
};


export type MutationChangeCurrencyArgs = {
  input?: Maybe<ChangeCurrencyInput>;
};


export type MutationUpdateRegulatoryProfileArgs = {
  input?: Maybe<UpdateRegulatoryProfileInput>;
};


export type MutationHelpAndSupportArgs = {
  input?: Maybe<SupportRequestInput>;
};


export type MutationCalculateInvestmentArgs = {
  input?: Maybe<CalculateInvestmentInput>;
};


export type MutationBuyInvestmentArgs = {
  input?: Maybe<BuyInvestmentInput>;
};


export type MutationCalculateSellArgs = {
  input?: Maybe<CalculateSellInput>;
};


export type MutationCreateSellArgs = {
  input?: Maybe<CreateSellInput>;
};


export type MutationCreateMyNoteArgs = {
  input?: Maybe<CreateMyNoteInput>;
};


export type MutationSubmitNoteArgs = {
  input?: Maybe<SubmitNoteInput>;
};


export type MutationApproveNoteArgs = {
  input?: Maybe<ApproveNoteInput>;
};


export type MutationDeclineNoteArgs = {
  input?: Maybe<DeclineNoteInput>;
};


export type MutationRequestMoreInfoArgs = {
  input?: Maybe<RequestMoreInfoInput>;
};


export type MutationCreateInternalCommentArgs = {
  input?: Maybe<CreateInternalCommentInput>;
};


export type MutationUpdateMarketValueArgs = {
  input?: Maybe<MarketValueInput>;
};


export type MutationChangeStatusArgs = {
  input?: Maybe<ChangeStatusInput>;
};


export type MutationCreateMasterNoteByUserArgs = {
  input?: Maybe<CreateMasterNoteByUserInput>;
};


export type MutationSubmitBankWithdrawRequestArgs = {
  input?: Maybe<SubmitBankWithdrawRequestInput>;
};


export type MutationCreateRealEstateAssetBaseArgs = {
  input?: Maybe<CreateRealEstateAssetBaseInput>;
};


export type MutationUpdateRealEstateAssetDetailsArgs = {
  input?: Maybe<UpdateRealEstateAssetDetailsInput>;
};


export type MutationSubmitRealEstateAssetArgs = {
  input?: Maybe<SubmitRealEstateAssetInput>;
};


export type MutationReviewRealEstateAssetArgs = {
  input?: Maybe<ReviewRealEstateAssetInput>;
};


export type MutationApproveRealEstateAssetArgs = {
  input?: Maybe<ApproveRealEstateAssetInput>;
};


export type MutationCreateMyRealEstatePriceLogArgs = {
  input?: Maybe<CreateRealEstatePriceLogInput>;
};


export type MutationPurchaseRealEstateAssetArgs = {
  input?: Maybe<PurchaseRealEstateAssetInput>;
};


export type MutationCreateRealEstateSellArgs = {
  input?: Maybe<CreateRealEstateSellInput>;
};


export type MutationMintRealEstateAssetTokensArgs = {
  input?: Maybe<MintRealEstateAssetTokensInput>;
};


export type MutationCreateRealEstatePayoutRequestArgs = {
  input?: Maybe<CreatePayoutRequestInput>;
};


export type MutationUpdateCompanyDocumentsArgs = {
  input?: Maybe<CompanyDocumentsInput>;
};


export type MutationSubmitTopupRequestArgs = {
  input?: Maybe<SubmitTopupRequestInput>;
};


export type MutationArchiveNotificationArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationSendPayoutByUserArgs = {
  input?: Maybe<SendPayoutByUserInput>;
};


export type MutationSendInterestArgs = {
  input?: Maybe<SendInterestInput>;
};


export type MutationRequestProfileUpdateArgs = {
  input?: Maybe<RequestProfileUpdateInput>;
};


export type MutationRequestCompanyUpdateArgs = {
  input?: Maybe<RequestCompanyUpdateInput>;
};


export type MutationRequestMasterNoteUpdateArgs = {
  input?: Maybe<RequestMasterNoteUpdateInput>;
  type?: Maybe<Enum_Updaterequest_Updatetype>;
};


export type MutationTopupMyWalletArgs = {
  input?: Maybe<TopupMyWalletInput>;
};


export type MutationUpdateOrCreateMyBankingInformationArgs = {
  input?: Maybe<UpdateOrCreateMyBankingInput>;
};


export type MutationUpdateOrCreateMyFinancialSummaryArgs = {
  input?: Maybe<UpdateOrCreateMyFinancialSummaryInput>;
};


export type MutationCreateBaseMasterBondArgs = {
  input?: Maybe<CreateBaseMasterBondInput>;
};


export type MutationReviewMasterBondArgs = {
  input?: Maybe<ReviewMasterBondInput>;
};


export type MutationApproveMasterBondArgs = {
  input?: Maybe<ApproveMasterBondInput>;
};


export type MutationUpdateBondPriceArgs = {
  input?: Maybe<UpdateBondPriceInput>;
};


export type MutationReviewBondArgs = {
  input?: Maybe<ReviewBondInput>;
};


export type MutationCreateBondPayoutRequestArgs = {
  input?: Maybe<CreateBondPayoutRequestInput>;
};


export type MutationCreateBondMaturityPayoutRequestArgs = {
  input?: Maybe<CreateBondMaturityPayoutRequestInput>;
};


export type MutationPurchaseBondTokensArgs = {
  input?: Maybe<PurchaseBondTokensInput>;
};

export type Note = {
  __typename?: 'Note';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['Date']>;
  amount?: Maybe<Scalars['Long']>;
  amountNeeded?: Maybe<Scalars['Long']>;
  payoutDate?: Maybe<Scalars['Date']>;
  interestRate?: Maybe<Scalars['Float']>;
  serviceInterestRate?: Maybe<Scalars['Float']>;
  proposedDateOfIssue?: Maybe<Scalars['Date']>;
  conditions?: Maybe<Scalars['String']>;
  purposeOfIssue?: Maybe<Scalars['String']>;
  noteType?: Maybe<Enum_Note_Notetype>;
  signedBy?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['Date']>;
  memorandum_connection?: Maybe<UploadFileRelationResponseCollection>;
  memorandum: Array<Maybe<UploadFile>>;
  transactions_connection?: Maybe<TransactionRelationResponseCollection>;
  transactions: Array<Maybe<Transaction>>;
  user?: Maybe<UsersPermissionsUser>;
  investments_connection?: Maybe<InvestmentRelationResponseCollection>;
  investments: Array<Maybe<Investment>>;
  currentStep?: Maybe<Enum_Note_Currentstep>;
  contractAddress?: Maybe<Scalars['String']>;
  dateFunded?: Maybe<Scalars['Date']>;
  noteStatus?: Maybe<Enum_Note_Notestatus>;
  lengthOfCP?: Maybe<Scalars['Int']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  minInvestment?: Maybe<Scalars['Long']>;
  interestFrequency?: Maybe<Enum_Note_Interestfrequency>;
  purchaseFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  shortHoldDescription?: Maybe<Scalars['String']>;
  interestFrequencyDescription?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Note_Type>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  managementFee?: Maybe<Scalars['Float']>;
  shortHoldFeeDuration?: Maybe<Scalars['Int']>;
  sellFee?: Maybe<Scalars['Float']>;
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  noteMarketValue?: Maybe<Scalars['Float']>;
  numberOfPaidInterest?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  lockDown?: Maybe<Scalars['Int']>;
  faceValue?: Maybe<Scalars['Long']>;
  nextInterestPayment?: Maybe<Scalars['Date']>;
  currency?: Maybe<Enum_Note_Currency>;
  fundManager?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  followup?: Maybe<Scalars['Int']>;
  compoundingFrequency?: Maybe<Enum_Note_Compoundingfrequency>;
  company?: Maybe<Company>;
  market_value_logs_connection?: Maybe<MarketValueLogRelationResponseCollection>;
  market_value_logs: Array<Maybe<MarketValueLog>>;
  masterNote?: Maybe<MasterNote>;
  comments_connection?: Maybe<CommentRelationResponseCollection>;
  comments: Array<Maybe<Comment>>;
  payout_requests_connection?: Maybe<PayoutRequestRelationResponseCollection>;
  payout_requests: Array<Maybe<PayoutRequest>>;
  purchaseRequests_connection?: Maybe<PurchaseRequestRelationResponseCollection>;
  purchaseRequests: Array<Maybe<PurchaseRequest>>;
  rolloverRequests_connection?: Maybe<RolloverRequestRelationResponseCollection>;
  rolloverRequests: Array<Maybe<RolloverRequest>>;
  datePending?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type NoteMemorandum_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteMemorandumArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteTransactions_ConnectionArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteTransactionsArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteInvestments_ConnectionArgs = {
  filters?: Maybe<InvestmentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteInvestmentsArgs = {
  filters?: Maybe<InvestmentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteMarket_Value_Logs_ConnectionArgs = {
  filters?: Maybe<MarketValueLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteMarket_Value_LogsArgs = {
  filters?: Maybe<MarketValueLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteComments_ConnectionArgs = {
  filters?: Maybe<CommentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteCommentsArgs = {
  filters?: Maybe<CommentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NotePayout_Requests_ConnectionArgs = {
  filters?: Maybe<PayoutRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NotePayout_RequestsArgs = {
  filters?: Maybe<PayoutRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NotePurchaseRequests_ConnectionArgs = {
  filters?: Maybe<PurchaseRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NotePurchaseRequestsArgs = {
  filters?: Maybe<PurchaseRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteRolloverRequests_ConnectionArgs = {
  filters?: Maybe<RolloverRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type NoteRolloverRequestsArgs = {
  filters?: Maybe<RolloverRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NoteEntityResponseCollection = {
  __typename?: 'NoteEntityResponseCollection';
  nodes: Array<Note>;
  pageInfo: Pagination;
};

export type NoteFilter = {
  /** Search term for filtering notes */
  search?: Maybe<Scalars['String']>;
  /** User ID for filtering notes */
  userId?: Maybe<Scalars['String']>;
  /** Status of the note */
  noteStatus?: Maybe<Scalars['String']>;
  /** Currency of the note */
  currency?: Maybe<Scalars['String']>;
  /** Start date for filtering notes */
  startDate?: Maybe<Scalars['String']>;
  /** End date for filtering notes */
  endDate?: Maybe<Scalars['String']>;
  /** Start date for payout filtering */
  payoutStartDate?: Maybe<Scalars['String']>;
  /** End date for payout filtering */
  payoutEndDate?: Maybe<Scalars['String']>;
  /** Start date for approval filtering */
  approvalStartDate?: Maybe<Scalars['String']>;
  /** End date for approval filtering */
  approvalEndDate?: Maybe<Scalars['String']>;
};

export type NoteFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  submittedAt?: Maybe<DateFilterInput>;
  amount?: Maybe<LongFilterInput>;
  amountNeeded?: Maybe<LongFilterInput>;
  payoutDate?: Maybe<DateFilterInput>;
  interestRate?: Maybe<FloatFilterInput>;
  serviceInterestRate?: Maybe<FloatFilterInput>;
  proposedDateOfIssue?: Maybe<DateFilterInput>;
  conditions?: Maybe<StringFilterInput>;
  purposeOfIssue?: Maybe<StringFilterInput>;
  noteType?: Maybe<StringFilterInput>;
  signedBy?: Maybe<StringFilterInput>;
  signedAt?: Maybe<DateFilterInput>;
  transactions?: Maybe<TransactionFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  investments?: Maybe<InvestmentFiltersInput>;
  currentStep?: Maybe<StringFilterInput>;
  contractAddress?: Maybe<StringFilterInput>;
  dateFunded?: Maybe<DateFilterInput>;
  noteStatus?: Maybe<StringFilterInput>;
  lengthOfCP?: Maybe<IntFilterInput>;
  approvedAt?: Maybe<DateTimeFilterInput>;
  minInvestment?: Maybe<LongFilterInput>;
  interestFrequency?: Maybe<StringFilterInput>;
  purchaseFee?: Maybe<FloatFilterInput>;
  shortHoldFee?: Maybe<FloatFilterInput>;
  shortHoldDescription?: Maybe<StringFilterInput>;
  interestFrequencyDescription?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  potentialRisks?: Maybe<StringFilterInput>;
  managementFee?: Maybe<FloatFilterInput>;
  shortHoldFeeDuration?: Maybe<IntFilterInput>;
  sellFee?: Maybe<FloatFilterInput>;
  masterNoteMarketValue?: Maybe<FloatFilterInput>;
  noteMarketValue?: Maybe<FloatFilterInput>;
  numberOfPaidInterest?: Maybe<IntFilterInput>;
  purchasePrice?: Maybe<FloatFilterInput>;
  lockDown?: Maybe<IntFilterInput>;
  faceValue?: Maybe<LongFilterInput>;
  nextInterestPayment?: Maybe<DateFilterInput>;
  currency?: Maybe<StringFilterInput>;
  fundManager?: Maybe<StringFilterInput>;
  assetType?: Maybe<StringFilterInput>;
  followup?: Maybe<IntFilterInput>;
  compoundingFrequency?: Maybe<StringFilterInput>;
  company?: Maybe<CompanyFiltersInput>;
  market_value_logs?: Maybe<MarketValueLogFiltersInput>;
  masterNote?: Maybe<MasterNoteFiltersInput>;
  comments?: Maybe<CommentFiltersInput>;
  payout_requests?: Maybe<PayoutRequestFiltersInput>;
  purchaseRequests?: Maybe<PurchaseRequestFiltersInput>;
  rolloverRequests?: Maybe<RolloverRequestFiltersInput>;
  datePending?: Maybe<DateFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<NoteFiltersInput>>>;
  or?: Maybe<Array<Maybe<NoteFiltersInput>>>;
  not?: Maybe<NoteFiltersInput>;
};

export type NoteForInvestorPayload = {
  __typename?: 'NoteForInvestorPayload';
  /** Note for the investor */
  note?: Maybe<Note>;
  /** Whether the user is an investor of the commercial paper */
  isAnInvestorOfCP?: Maybe<Scalars['Boolean']>;
  /** Date of investment */
  investedAt?: Maybe<Scalars['Date']>;
  /** Amount invested */
  amountInvested?: Maybe<Scalars['Float']>;
  /** Interest rate of the note */
  interest?: Maybe<Scalars['Int']>;
};

export type NoteInput = {
  title?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['Date']>;
  amount?: Maybe<Scalars['Long']>;
  amountNeeded?: Maybe<Scalars['Long']>;
  payoutDate?: Maybe<Scalars['Date']>;
  interestRate?: Maybe<Scalars['Float']>;
  serviceInterestRate?: Maybe<Scalars['Float']>;
  proposedDateOfIssue?: Maybe<Scalars['Date']>;
  conditions?: Maybe<Scalars['String']>;
  purposeOfIssue?: Maybe<Scalars['String']>;
  noteType?: Maybe<Enum_Note_Notetype>;
  signedBy?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['Date']>;
  memorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  user?: Maybe<Scalars['ID']>;
  investments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  currentStep?: Maybe<Enum_Note_Currentstep>;
  contractAddress?: Maybe<Scalars['String']>;
  dateFunded?: Maybe<Scalars['Date']>;
  noteStatus?: Maybe<Enum_Note_Notestatus>;
  lengthOfCP?: Maybe<Scalars['Int']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  minInvestment?: Maybe<Scalars['Long']>;
  interestFrequency?: Maybe<Enum_Note_Interestfrequency>;
  purchaseFee?: Maybe<Scalars['Float']>;
  shortHoldFee?: Maybe<Scalars['Float']>;
  shortHoldDescription?: Maybe<Scalars['String']>;
  interestFrequencyDescription?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Note_Type>;
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  managementFee?: Maybe<Scalars['Float']>;
  shortHoldFeeDuration?: Maybe<Scalars['Int']>;
  sellFee?: Maybe<Scalars['Float']>;
  masterNoteMarketValue?: Maybe<Scalars['Float']>;
  noteMarketValue?: Maybe<Scalars['Float']>;
  numberOfPaidInterest?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  lockDown?: Maybe<Scalars['Int']>;
  faceValue?: Maybe<Scalars['Long']>;
  nextInterestPayment?: Maybe<Scalars['Date']>;
  currency?: Maybe<Enum_Note_Currency>;
  fundManager?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  followup?: Maybe<Scalars['Int']>;
  compoundingFrequency?: Maybe<Enum_Note_Compoundingfrequency>;
  company?: Maybe<Scalars['ID']>;
  market_value_logs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  masterNote?: Maybe<Scalars['ID']>;
  comments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  payout_requests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  purchaseRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  rolloverRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  datePending?: Maybe<Scalars['Date']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type NoteRelationResponseCollection = {
  __typename?: 'NoteRelationResponseCollection';
  nodes: Array<Note>;
};

export type Notification = {
  __typename?: 'Notification';
  documentId: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  category?: Maybe<Enum_Notification_Category>;
  additionalInformation?: Maybe<Scalars['JSON']>;
  user?: Maybe<UsersPermissionsUser>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEntityResponseCollection = {
  __typename?: 'NotificationEntityResponseCollection';
  nodes: Array<Notification>;
  pageInfo: Pagination;
};

export type NotificationFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  message?: Maybe<StringFilterInput>;
  isRead?: Maybe<BooleanFilterInput>;
  title?: Maybe<StringFilterInput>;
  category?: Maybe<StringFilterInput>;
  additionalInformation?: Maybe<JsonFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<NotificationFiltersInput>>>;
  or?: Maybe<Array<Maybe<NotificationFiltersInput>>>;
  not?: Maybe<NotificationFiltersInput>;
};

export type NotificationInput = {
  message?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  category?: Maybe<Enum_Notification_Category>;
  additionalInformation?: Maybe<Scalars['JSON']>;
  user?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationRelationResponseCollection = {
  __typename?: 'NotificationRelationResponseCollection';
  nodes: Array<Notification>;
};

/** Standard response for operations that just need success/failure indication */
export type OkResponse = {
  __typename?: 'OkResponse';
  /** Indicates if the operation was successful */
  ok: Scalars['Boolean'];
};

/** Input for onboarding company information */
export type OnboardingCompanyInput = {
  logo?: Maybe<Scalars['ID']>;
  /** Name of the company */
  name?: Maybe<Scalars['String']>;
  /** Type of the company */
  companyType?: Maybe<Enum_Company_Companytype>;
  /** Industry of the company */
  industryType?: Maybe<Enum_Company_Industrytype>;
  /** description of the company */
  briefDescription?: Maybe<Scalars['String']>;
  /** platform use of the company */
  platformUseReason?: Maybe<Scalars['String']>;
  /** Registration Number of the company */
  registrationNumber?: Maybe<Scalars['String']>;
  /** Date of registration of the company */
  registeredAt?: Maybe<Scalars['DateTime']>;
  /** Country of registration of the company */
  countryOfRegistration?: Maybe<Scalars['String']>;
  /** Address of the company */
  formattedAddress?: Maybe<Scalars['String']>;
  /** VAT Number of the company */
  vatNumber?: Maybe<Scalars['String']>;
  /** Tax Number of the company */
  taxNumber?: Maybe<Scalars['String']>;
};

/** Input for onboarding user information */
export type OnboardingInput = {
  /** Current step in the onboarding process */
  onboardingStep?: Maybe<OnboardingSteps>;
  /** ID number of the user */
  idNumber?: Maybe<Scalars['String']>;
  /** Date of birth of the user */
  dateOfBirth?: Maybe<Scalars['Date']>;
};

/** Steps in the onboarding process */
export enum OnboardingSteps {
  PersonalInformation = 'PERSONAL_INFORMATION',
  CompanyInformation = 'COMPANY_INFORMATION',
  CompanyDetails = 'COMPANY_DETAILS',
  Agreement = 'AGREEMENT'
}

export type Pagination = {
  __typename?: 'Pagination';
  total: Scalars['Int'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  pageCount: Scalars['Int'];
};

export type PaginationArg = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type PayoutRequest = {
  __typename?: 'PayoutRequest';
  documentId: Scalars['ID'];
  amount?: Maybe<Scalars['Int']>;
  payoutStatus?: Maybe<Enum_Payoutrequest_Payoutstatus>;
  type?: Maybe<Enum_Payoutrequest_Type>;
  corporateAmount?: Maybe<Scalars['Long']>;
  currency?: Maybe<Enum_Payoutrequest_Currency>;
  interestMetric?: Maybe<Scalars['Int']>;
  note?: Maybe<Note>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutRequestEntityResponseCollection = {
  __typename?: 'PayoutRequestEntityResponseCollection';
  nodes: Array<PayoutRequest>;
  pageInfo: Pagination;
};

export type PayoutRequestFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  amount?: Maybe<IntFilterInput>;
  payoutStatus?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  corporateAmount?: Maybe<LongFilterInput>;
  currency?: Maybe<StringFilterInput>;
  interestMetric?: Maybe<IntFilterInput>;
  note?: Maybe<NoteFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<PayoutRequestFiltersInput>>>;
  or?: Maybe<Array<Maybe<PayoutRequestFiltersInput>>>;
  not?: Maybe<PayoutRequestFiltersInput>;
};

export type PayoutRequestInput = {
  amount?: Maybe<Scalars['Int']>;
  payoutStatus?: Maybe<Enum_Payoutrequest_Payoutstatus>;
  type?: Maybe<Enum_Payoutrequest_Type>;
  corporateAmount?: Maybe<Scalars['Long']>;
  currency?: Maybe<Enum_Payoutrequest_Currency>;
  interestMetric?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type PayoutRequestRelationResponseCollection = {
  __typename?: 'PayoutRequestRelationResponseCollection';
  nodes: Array<PayoutRequest>;
};

/** Portfolio value log entry */
export type PortfolioValueLogPayload = {
  __typename?: 'PortfolioValueLogPayload';
  /** Log entry ID */
  id: Scalars['ID'];
  /** Portfolio value in USD */
  amountUSD?: Maybe<Scalars['Float']>;
  /** Portfolio value in KES */
  amountKES?: Maybe<Scalars['Float']>;
  /** Date when the log was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Date when the log was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PortifolioValueLog = {
  __typename?: 'PortifolioValueLog';
  documentId: Scalars['ID'];
  amountUSD?: Maybe<Scalars['Float']>;
  user?: Maybe<UsersPermissionsUser>;
  amountKES?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type PortifolioValueLogEntityResponseCollection = {
  __typename?: 'PortifolioValueLogEntityResponseCollection';
  nodes: Array<PortifolioValueLog>;
  pageInfo: Pagination;
};

export type PortifolioValueLogFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  amountUSD?: Maybe<FloatFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  amountKES?: Maybe<FloatFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<PortifolioValueLogFiltersInput>>>;
  or?: Maybe<Array<Maybe<PortifolioValueLogFiltersInput>>>;
  not?: Maybe<PortifolioValueLogFiltersInput>;
};

export type PortifolioValueLogInput = {
  amountUSD?: Maybe<Scalars['Float']>;
  user?: Maybe<Scalars['ID']>;
  amountKES?: Maybe<Scalars['Float']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type PortifolioValueLogRelationResponseCollection = {
  __typename?: 'PortifolioValueLogRelationResponseCollection';
  nodes: Array<PortifolioValueLog>;
};

/** Price range input for filtering */
export type PriceRangeInput = {
  /** Minimum price */
  min?: Maybe<Scalars['Float']>;
  /** Maximum price */
  max?: Maybe<Scalars['Float']>;
};

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type PurchaseBondTokensInput = {
  /** Document ID of the bond to purchase */
  bondId: Scalars['String'];
  /** Number of tokens to purchase (minimum 1) */
  tokens: Scalars['Int'];
  /** Currency for the purchase (USD or KES) */
  currency: Scalars['String'];
};

export type PurchaseRealEstateAssetInput = {
  /** ID of the real estate asset to purchase */
  assetId: Scalars['String'];
  /** Number of units to purchase (minimum 1) */
  units: Scalars['Int'];
  /** Currency for the purchase (USD or KES) */
  currency: Scalars['String'];
};

export type PurchaseRequest = {
  __typename?: 'PurchaseRequest';
  documentId: Scalars['ID'];
  purchaseStatus?: Maybe<Enum_Purchaserequest_Purchasestatus>;
  note?: Maybe<Note>;
  interestRate?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  investmentTerm?: Maybe<Scalars['Int']>;
  investmentTermType?: Maybe<Enum_Purchaserequest_Investmenttermtype>;
  investmentDate?: Maybe<Scalars['DateTime']>;
  faceValue?: Maybe<Scalars['Int']>;
  withHoldingTax?: Maybe<Scalars['Int']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['Date']>;
  signedBy?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type PurchaseRequestEntityResponseCollection = {
  __typename?: 'PurchaseRequestEntityResponseCollection';
  nodes: Array<PurchaseRequest>;
  pageInfo: Pagination;
};

export type PurchaseRequestFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  purchaseStatus?: Maybe<StringFilterInput>;
  note?: Maybe<NoteFiltersInput>;
  interestRate?: Maybe<FloatFilterInput>;
  totalReturn?: Maybe<IntFilterInput>;
  purchasePrice?: Maybe<IntFilterInput>;
  investmentTerm?: Maybe<IntFilterInput>;
  investmentTermType?: Maybe<StringFilterInput>;
  investmentDate?: Maybe<DateTimeFilterInput>;
  faceValue?: Maybe<IntFilterInput>;
  withHoldingTax?: Maybe<IntFilterInput>;
  signedAt?: Maybe<DateTimeFilterInput>;
  dueDate?: Maybe<DateFilterInput>;
  signedBy?: Maybe<StringFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<PurchaseRequestFiltersInput>>>;
  or?: Maybe<Array<Maybe<PurchaseRequestFiltersInput>>>;
  not?: Maybe<PurchaseRequestFiltersInput>;
};

export type PurchaseRequestInput = {
  purchaseStatus?: Maybe<Enum_Purchaserequest_Purchasestatus>;
  note?: Maybe<Scalars['ID']>;
  interestRate?: Maybe<Scalars['Float']>;
  totalReturn?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  investmentTerm?: Maybe<Scalars['Int']>;
  investmentTermType?: Maybe<Enum_Purchaserequest_Investmenttermtype>;
  investmentDate?: Maybe<Scalars['DateTime']>;
  faceValue?: Maybe<Scalars['Int']>;
  withHoldingTax?: Maybe<Scalars['Int']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['Date']>;
  signedBy?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type PurchaseRequestRelationResponseCollection = {
  __typename?: 'PurchaseRequestRelationResponseCollection';
  nodes: Array<PurchaseRequest>;
};

export type Query = {
  __typename?: 'Query';
  uploadFile?: Maybe<UploadFile>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  uploadFiles: Array<Maybe<UploadFile>>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  bankWithdrawRequest?: Maybe<BankWithdrawRequest>;
  bankWithdrawRequests_connection?: Maybe<BankWithdrawRequestEntityResponseCollection>;
  bankWithdrawRequests: Array<Maybe<BankWithdrawRequest>>;
  bankingInformation?: Maybe<BankingInformation>;
  bankingInformations_connection?: Maybe<BankingInformationEntityResponseCollection>;
  bankingInformations: Array<Maybe<BankingInformation>>;
  bond?: Maybe<Bond>;
  bonds_connection?: Maybe<BondEntityResponseCollection>;
  bonds: Array<Maybe<Bond>>;
  bondHolding?: Maybe<BondHolding>;
  bondHoldings_connection?: Maybe<BondHoldingEntityResponseCollection>;
  bondHoldings: Array<Maybe<BondHolding>>;
  bondPayout?: Maybe<BondPayout>;
  bondPayouts_connection?: Maybe<BondPayoutEntityResponseCollection>;
  bondPayouts: Array<Maybe<BondPayout>>;
  bondPriceLog?: Maybe<BondPriceLog>;
  bondPriceLogs_connection?: Maybe<BondPriceLogEntityResponseCollection>;
  bondPriceLogs: Array<Maybe<BondPriceLog>>;
  bondSellRequest?: Maybe<BondSellRequest>;
  bondSellRequests_connection?: Maybe<BondSellRequestEntityResponseCollection>;
  bondSellRequests: Array<Maybe<BondSellRequest>>;
  chatMessage?: Maybe<ChatMessage>;
  chatMessages_connection?: Maybe<ChatMessageEntityResponseCollection>;
  chatMessages: Array<Maybe<ChatMessage>>;
  comment?: Maybe<Comment>;
  comments_connection?: Maybe<CommentEntityResponseCollection>;
  comments: Array<Maybe<Comment>>;
  company?: Maybe<Company>;
  companies_connection?: Maybe<CompanyEntityResponseCollection>;
  companies: Array<Maybe<Company>>;
  conversation?: Maybe<Conversation>;
  conversations_connection?: Maybe<ConversationEntityResponseCollection>;
  conversations: Array<Maybe<Conversation>>;
  financialSummary?: Maybe<FinancialSummary>;
  financialSummaries_connection?: Maybe<FinancialSummaryEntityResponseCollection>;
  financialSummaries: Array<Maybe<FinancialSummary>>;
  fundInterest?: Maybe<FundInterest>;
  fundInterests_connection?: Maybe<FundInterestEntityResponseCollection>;
  fundInterests: Array<Maybe<FundInterest>>;
  investment?: Maybe<Investment>;
  investments_connection?: Maybe<InvestmentEntityResponseCollection>;
  investments: Array<Maybe<Investment>>;
  jamiipesa?: Maybe<Jamiipesa>;
  marketValueLog?: Maybe<MarketValueLog>;
  marketValueLogs_connection?: Maybe<MarketValueLogEntityResponseCollection>;
  marketValueLogs: Array<Maybe<MarketValueLog>>;
  masterBond?: Maybe<MasterBond>;
  masterBonds_connection?: Maybe<MasterBondEntityResponseCollection>;
  masterBonds: Array<Maybe<MasterBond>>;
  masterNote?: Maybe<MasterNote>;
  masterNotes_connection?: Maybe<MasterNoteEntityResponseCollection>;
  masterNotes: Array<Maybe<MasterNote>>;
  note?: Maybe<Note>;
  notes_connection?: Maybe<NoteEntityResponseCollection>;
  notes: Array<Maybe<Note>>;
  notification?: Maybe<Notification>;
  notifications_connection?: Maybe<NotificationEntityResponseCollection>;
  notifications: Array<Maybe<Notification>>;
  payoutRequest?: Maybe<PayoutRequest>;
  payoutRequests_connection?: Maybe<PayoutRequestEntityResponseCollection>;
  payoutRequests: Array<Maybe<PayoutRequest>>;
  portifolioValueLog?: Maybe<PortifolioValueLog>;
  portifolioValueLogs_connection?: Maybe<PortifolioValueLogEntityResponseCollection>;
  portifolioValueLogs: Array<Maybe<PortifolioValueLog>>;
  purchaseRequest?: Maybe<PurchaseRequest>;
  purchaseRequests_connection?: Maybe<PurchaseRequestEntityResponseCollection>;
  purchaseRequests: Array<Maybe<PurchaseRequest>>;
  realEstateAsset?: Maybe<RealEstateAsset>;
  realEstateAssets_connection?: Maybe<RealEstateAssetEntityResponseCollection>;
  realEstateAssets: Array<Maybe<RealEstateAsset>>;
  realEstateHolding?: Maybe<RealEstateHolding>;
  realEstateHoldings_connection?: Maybe<RealEstateHoldingEntityResponseCollection>;
  realEstateHoldings: Array<Maybe<RealEstateHolding>>;
  realEstatePayout?: Maybe<RealEstatePayout>;
  realEstatePayouts_connection?: Maybe<RealEstatePayoutEntityResponseCollection>;
  realEstatePayouts: Array<Maybe<RealEstatePayout>>;
  realEstatePriceLog?: Maybe<RealEstatePriceLog>;
  realEstatePriceLogs_connection?: Maybe<RealEstatePriceLogEntityResponseCollection>;
  realEstatePriceLogs: Array<Maybe<RealEstatePriceLog>>;
  realEstateSellRequest?: Maybe<RealEstateSellRequest>;
  realEstateSellRequests_connection?: Maybe<RealEstateSellRequestEntityResponseCollection>;
  realEstateSellRequests: Array<Maybe<RealEstateSellRequest>>;
  rolloverRequest?: Maybe<RolloverRequest>;
  rolloverRequests_connection?: Maybe<RolloverRequestEntityResponseCollection>;
  rolloverRequests: Array<Maybe<RolloverRequest>>;
  rolloverResponse?: Maybe<RolloverResponse>;
  rolloverResponses_connection?: Maybe<RolloverResponseEntityResponseCollection>;
  rolloverResponses: Array<Maybe<RolloverResponse>>;
  sellRequest?: Maybe<SellRequest>;
  sellRequests_connection?: Maybe<SellRequestEntityResponseCollection>;
  sellRequests: Array<Maybe<SellRequest>>;
  topupRequest?: Maybe<TopupRequest>;
  topupRequests_connection?: Maybe<TopupRequestEntityResponseCollection>;
  topupRequests: Array<Maybe<TopupRequest>>;
  transaction?: Maybe<Transaction>;
  transactions_connection?: Maybe<TransactionEntityResponseCollection>;
  transactions: Array<Maybe<Transaction>>;
  updateRequest?: Maybe<UpdateRequest>;
  updateRequests_connection?: Maybe<UpdateRequestEntityResponseCollection>;
  updateRequests: Array<Maybe<UpdateRequest>>;
  wallet?: Maybe<Wallet>;
  wallets_connection?: Maybe<WalletEntityResponseCollection>;
  wallets: Array<Maybe<Wallet>>;
  welcomeSlide?: Maybe<WelcomeSlide>;
  me?: Maybe<UsersPermissionsMe>;
  /** Get unread notifications for the current user */
  getMyNotifications?: Maybe<Array<Maybe<Notification>>>;
  /** Get my wallet balance */
  myWalletBalance?: Maybe<Scalars['Float']>;
  /** Get the banking information for the current user */
  getMyBankingInformation?: Maybe<BankingInformation>;
  /** Get accepted sell requests for the current user */
  getAcceptedSellRequests?: Maybe<GetAcceptedSellRequestsResponse>;
  /** Get financial summary for the current user */
  getMyFinancialSummary?: Maybe<FinancialSummary>;
  /** Get investments for the current user */
  getInvestments?: Maybe<GetInvestmentsPayload>;
  /** Get total invested amount for the current user on a specific note */
  myTotalInvestedAmountByNote?: Maybe<Scalars['Float']>;
  /** Get investments for a specific note with pagination */
  getInvestmentsByNoteId?: Maybe<GetInvestmentsByNoteIdPayload>;
  /** Get aggregated dashboard statistics for the current investor */
  getInvestorDashboardStats?: Maybe<InvestorDashboardStatsPayload>;
  /** Get notes with filtering and pagination */
  getNotes?: Maybe<GetNotesPayload>;
  /** Count notes with filtering */
  countMyActivePapers?: Maybe<Scalars['Int']>;
  /** Count notes with filtering */
  getNotesCount?: Maybe<Scalars['Int']>;
  /** Get a note by ID */
  getNoteById?: Maybe<Note>;
  /** Get available notes for a user */
  getAvailableNotes?: Maybe<GetAvailableNotesPayload>;
  /** Get notes for an investor */
  getNoteForInvestor?: Maybe<NoteForInvestorPayload>;
  /** Generate a summary URL for a note */
  downloadNoteSummary?: Maybe<DownloadNoteSummaryPayload>;
  /** Get a master note by ID */
  getMyMasterNoteById?: Maybe<MasterNote>;
  /** Get all master notes for the current user */
  getAllMyMasterNotes?: Maybe<GetAllMyMasterNotesPayload>;
  /** Get paginated market value logs for a master note */
  getMarketValueLog?: Maybe<MarketValueLogPayload>;
  /** Get investors for a master note (paginated) */
  getMasterNoteInvestors?: Maybe<GetMasterNoteInvestorsResult>;
  /** Get notes associated with a master note */
  getAssociatedNotes?: Maybe<Array<Maybe<AssociatedNotePayload>>>;
  /** Export master note investors to CSV and return a download URL */
  exportMasterNoteInvestorsCsv?: Maybe<ExportFilePayload>;
  /** Get current user's real-estate assets with pagination and filtering */
  getMyRealEstateAssets?: Maybe<GetMyRealEstateAssetsPayload>;
  /** List all real-estate assets (regulatory only) */
  getRealEstateAssets?: Maybe<GetMyRealEstateAssetsPayload>;
  /** Get counts of listed and submitted real estate assets (regulatory only) */
  getRealEstateAssetCounts?: Maybe<RealEstateAssetCountsPayload>;
  /** Get a single real-estate asset (owned by current user) by documentId */
  getRealEstateAssetById?: Maybe<RealEstateAsset>;
  /** Get approved price logs for a specific real estate asset with pagination */
  getRealEstatePriceLogs?: Maybe<GetRealEstatePriceLogsPayload>;
  /** Get available real estate assets for investors (LISTED status) */
  getAvailableRealEstateAssets?: Maybe<GetAvailableRealEstateAssetsPayload>;
  /** Get current user's real estate holdings */
  getMyRealEstateHoldings?: Maybe<GetRealEstateHoldingsPayload>;
  /** Get a single real estate asset with investor-specific data */
  getRealEstateAssetForInvestor?: Maybe<RealEstateAssetForInvestorPayload>;
  /** Get portfolio value logs for the current investor */
  getMyPortfolioValueLogs?: Maybe<GetPortfolioValueLogsPayload>;
  /** Get the current user profile */
  getMyProfile?: Maybe<UsersPermissionsUser>;
  /** Get transaction by ID */
  getTransactionById?: Maybe<Transaction>;
  /** Get transactions for the current user */
  getMyTransactions?: Maybe<Array<Maybe<Transaction>>>;
  /** Download transaction receipt */
  downloadReceipt?: Maybe<DownloadTransactionReceiptPayload>;
  /** Get manager metrics */
  getManagerMetrics?: Maybe<ManagerMetricsPayload>;
  /** Get all successful real estate holdings for the current user */
  getMySuccessfulRealEstateHoldings?: Maybe<Array<Maybe<RealEstateHolding>>>;
  /** Get current user's master bonds with pagination and filtering */
  getMyMasterBonds?: Maybe<GetMyMasterBondsPayload>;
  /** List all master bonds (regulatory only) */
  getMasterBonds?: Maybe<GetMyMasterBondsPayload>;
  /** Get counts of master bonds by status (regulatory only) */
  getMasterBondCounts?: Maybe<MasterBondCountsPayload>;
  /** Get a single master bond by documentId */
  getMasterBondById?: Maybe<MasterBond>;
  /** Get approved/funded bonds for a master bond with computed fields */
  getMasterBondBonds?: Maybe<MasterBondBondsPayload>;
  /** Get investors in a master bond with aggregated investment totals */
  getMasterBondInvestors?: Maybe<MasterBondInvestorsPayload>;
  /** Get paginated approved bond price logs for a master bond */
  getBondPriceLogs?: Maybe<BondPriceLogsPayload>;
  /** Get bonds under the current user's master bonds with pagination and filtering */
  getMyBonds?: Maybe<GetMyBondsPayload>;
  /** Get all bonds belonging to a specific master bond with pagination */
  getBondsByMasterBond?: Maybe<GetBondsByMasterBondPayload>;
  /** Get a single bond by documentId */
  getBondById?: Maybe<Bond>;
  /** List all bonds (regulatory only) */
  getBonds?: Maybe<GetBondsPayload>;
  /** Get available bonds for investors (LISTED status only) */
  getAvailableBonds?: Maybe<GetAvailableBondsPayload>;
  /** Get a single bond with investor-specific data (must be LISTED) */
  getBondForInvestor?: Maybe<BondForInvestorPayload>;
  /** Get counts of bonds by status (regulatory only) */
  getBondCounts?: Maybe<BondCountsPayload>;
  /** Get current user's bond holdings with pagination */
  getMyBondHoldings?: Maybe<GetBondHoldingsPayload>;
  /** Get all successful (ACTIVE) bond holdings for the current user */
  getMySuccessfulBondHoldings?: Maybe<Array<Maybe<BondHoldingPayload>>>;
};


export type QueryUploadFileArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryUploadFiles_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUploadFilesArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryI18NLocales_ConnectionArgs = {
  filters?: Maybe<I18NLocaleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryI18NLocalesArgs = {
  filters?: Maybe<I18NLocaleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: Maybe<UsersPermissionsRoleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: Maybe<UsersPermissionsRoleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBankWithdrawRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryBankWithdrawRequests_ConnectionArgs = {
  filters?: Maybe<BankWithdrawRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBankWithdrawRequestsArgs = {
  filters?: Maybe<BankWithdrawRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBankingInformationArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryBankingInformations_ConnectionArgs = {
  filters?: Maybe<BankingInformationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBankingInformationsArgs = {
  filters?: Maybe<BankingInformationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBondArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryBonds_ConnectionArgs = {
  filters?: Maybe<BondFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBondsArgs = {
  filters?: Maybe<BondFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBondHoldingArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryBondHoldings_ConnectionArgs = {
  filters?: Maybe<BondHoldingFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBondHoldingsArgs = {
  filters?: Maybe<BondHoldingFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBondPayoutArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryBondPayouts_ConnectionArgs = {
  filters?: Maybe<BondPayoutFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBondPayoutsArgs = {
  filters?: Maybe<BondPayoutFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBondPriceLogArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryBondPriceLogs_ConnectionArgs = {
  filters?: Maybe<BondPriceLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBondPriceLogsArgs = {
  filters?: Maybe<BondPriceLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBondSellRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryBondSellRequests_ConnectionArgs = {
  filters?: Maybe<BondSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryBondSellRequestsArgs = {
  filters?: Maybe<BondSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryChatMessageArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryChatMessages_ConnectionArgs = {
  filters?: Maybe<ChatMessageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryChatMessagesArgs = {
  filters?: Maybe<ChatMessageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryCommentArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryComments_ConnectionArgs = {
  filters?: Maybe<CommentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryCommentsArgs = {
  filters?: Maybe<CommentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryCompanyArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryCompanies_ConnectionArgs = {
  filters?: Maybe<CompanyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryCompaniesArgs = {
  filters?: Maybe<CompanyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryConversationArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryConversations_ConnectionArgs = {
  filters?: Maybe<ConversationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryConversationsArgs = {
  filters?: Maybe<ConversationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryFinancialSummaryArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryFinancialSummaries_ConnectionArgs = {
  filters?: Maybe<FinancialSummaryFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryFinancialSummariesArgs = {
  filters?: Maybe<FinancialSummaryFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryFundInterestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryFundInterests_ConnectionArgs = {
  filters?: Maybe<FundInterestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryFundInterestsArgs = {
  filters?: Maybe<FundInterestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryInvestmentArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryInvestments_ConnectionArgs = {
  filters?: Maybe<InvestmentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryInvestmentsArgs = {
  filters?: Maybe<InvestmentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryJamiipesaArgs = {
  status?: Maybe<PublicationStatus>;
};


export type QueryMarketValueLogArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryMarketValueLogs_ConnectionArgs = {
  filters?: Maybe<MarketValueLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryMarketValueLogsArgs = {
  filters?: Maybe<MarketValueLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryMasterBondArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryMasterBonds_ConnectionArgs = {
  filters?: Maybe<MasterBondFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryMasterBondsArgs = {
  filters?: Maybe<MasterBondFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryMasterNoteArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryMasterNotes_ConnectionArgs = {
  filters?: Maybe<MasterNoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryMasterNotesArgs = {
  filters?: Maybe<MasterNoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryNoteArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryNotes_ConnectionArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryNotesArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryNotificationArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryNotifications_ConnectionArgs = {
  filters?: Maybe<NotificationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryNotificationsArgs = {
  filters?: Maybe<NotificationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryPayoutRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryPayoutRequests_ConnectionArgs = {
  filters?: Maybe<PayoutRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryPayoutRequestsArgs = {
  filters?: Maybe<PayoutRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryPortifolioValueLogArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryPortifolioValueLogs_ConnectionArgs = {
  filters?: Maybe<PortifolioValueLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryPortifolioValueLogsArgs = {
  filters?: Maybe<PortifolioValueLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryPurchaseRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryPurchaseRequests_ConnectionArgs = {
  filters?: Maybe<PurchaseRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryPurchaseRequestsArgs = {
  filters?: Maybe<PurchaseRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstateAssetArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstateAssets_ConnectionArgs = {
  filters?: Maybe<RealEstateAssetFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstateAssetsArgs = {
  filters?: Maybe<RealEstateAssetFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstateHoldingArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstateHoldings_ConnectionArgs = {
  filters?: Maybe<RealEstateHoldingFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstateHoldingsArgs = {
  filters?: Maybe<RealEstateHoldingFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstatePayoutArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstatePayouts_ConnectionArgs = {
  filters?: Maybe<RealEstatePayoutFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstatePayoutsArgs = {
  filters?: Maybe<RealEstatePayoutFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstatePriceLogArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstatePriceLogs_ConnectionArgs = {
  filters?: Maybe<RealEstatePriceLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstatePriceLogsArgs = {
  filters?: Maybe<RealEstatePriceLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstateSellRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstateSellRequests_ConnectionArgs = {
  filters?: Maybe<RealEstateSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRealEstateSellRequestsArgs = {
  filters?: Maybe<RealEstateSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRolloverRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryRolloverRequests_ConnectionArgs = {
  filters?: Maybe<RolloverRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRolloverRequestsArgs = {
  filters?: Maybe<RolloverRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRolloverResponseArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryRolloverResponses_ConnectionArgs = {
  filters?: Maybe<RolloverResponseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryRolloverResponsesArgs = {
  filters?: Maybe<RolloverResponseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QuerySellRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QuerySellRequests_ConnectionArgs = {
  filters?: Maybe<SellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QuerySellRequestsArgs = {
  filters?: Maybe<SellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryTopupRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryTopupRequests_ConnectionArgs = {
  filters?: Maybe<TopupRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryTopupRequestsArgs = {
  filters?: Maybe<TopupRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryTransactionArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryTransactions_ConnectionArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryTransactionsArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUpdateRequestArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryUpdateRequests_ConnectionArgs = {
  filters?: Maybe<UpdateRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUpdateRequestsArgs = {
  filters?: Maybe<UpdateRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryWalletArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryWallets_ConnectionArgs = {
  filters?: Maybe<WalletFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryWalletsArgs = {
  filters?: Maybe<WalletFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryWelcomeSlideArgs = {
  status?: Maybe<PublicationStatus>;
};


export type QueryGetMyNotificationsArgs = {
  sort?: Maybe<Scalars['String']>;
};


export type QueryMyWalletBalanceArgs = {
  currency?: Maybe<Scalars['String']>;
};


export type QueryGetAcceptedSellRequestsArgs = {
  currency?: Maybe<Scalars['String']>;
};


export type QueryGetInvestmentsArgs = {
  filters?: Maybe<InvestmentFilter>;
  currency?: Maybe<Scalars['String']>;
};


export type QueryMyTotalInvestedAmountByNoteArgs = {
  noteId?: Maybe<Scalars['ID']>;
};


export type QueryGetInvestmentsByNoteIdArgs = {
  noteId?: Maybe<Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetInvestorDashboardStatsArgs = {
  currency?: Maybe<Scalars['String']>;
};


export type QueryGetNotesArgs = {
  filters?: Maybe<NoteFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  sort?: Maybe<Cp_Sort_By>;
  showClosed?: Maybe<Scalars['Boolean']>;
};


export type QueryCountMyActivePapersArgs = {
  currency?: Maybe<Enum_Note_Currency>;
};


export type QueryGetNotesCountArgs = {
  filters?: Maybe<NoteFilter>;
};


export type QueryGetNoteByIdArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryGetAvailableNotesArgs = {
  input?: Maybe<AvailableNotesInput>;
};


export type QueryGetNoteForInvestorArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryDownloadNoteSummaryArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryGetMyMasterNoteByIdArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryGetAllMyMasterNotesArgs = {
  filters?: Maybe<MasterNoteFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryGetMarketValueLogArgs = {
  masterNoteId?: Maybe<Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetMasterNoteInvestorsArgs = {
  masterNoteId?: Maybe<Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetAssociatedNotesArgs = {
  masterNoteId?: Maybe<Scalars['ID']>;
};


export type QueryExportMasterNoteInvestorsCsvArgs = {
  masterNoteId?: Maybe<Scalars['ID']>;
};


export type QueryGetMyRealEstateAssetsArgs = {
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetRealEstateAssetsArgs = {
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetRealEstateAssetByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetRealEstatePriceLogsArgs = {
  realEstateAssetId: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetAvailableRealEstateAssetsArgs = {
  input?: Maybe<AvailableRealEstateAssetsInput>;
};


export type QueryGetMyRealEstateHoldingsArgs = {
  input?: Maybe<GetRealEstateHoldingsInput>;
};


export type QueryGetRealEstateAssetForInvestorArgs = {
  input?: Maybe<GetRealEstateAssetForInvestorInput>;
};


export type QueryGetMyPortfolioValueLogsArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetTransactionByIdArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryGetMyTransactionsArgs = {
  currency?: Maybe<Scalars['String']>;
};


export type QueryDownloadReceiptArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryGetManagerMetricsArgs = {
  startDate?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
};


export type QueryGetMySuccessfulRealEstateHoldingsArgs = {
  search?: Maybe<Scalars['String']>;
};


export type QueryGetMyMasterBondsArgs = {
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetMasterBondsArgs = {
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetMasterBondByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetMasterBondBondsArgs = {
  masterBondId: Scalars['String'];
};


export type QueryGetMasterBondInvestorsArgs = {
  masterBondId: Scalars['String'];
};


export type QueryGetBondPriceLogsArgs = {
  masterBondId: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetMyBondsArgs = {
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  bondType?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetBondsByMasterBondArgs = {
  masterBondId: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  bondType?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetBondByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetBondsArgs = {
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  bondType?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetAvailableBondsArgs = {
  input?: Maybe<AvailableBondsInput>;
};


export type QueryGetBondForInvestorArgs = {
  bondId: Scalars['String'];
};


export type QueryGetMyBondHoldingsArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetMySuccessfulBondHoldingsArgs = {
  search?: Maybe<Scalars['String']>;
};

export type RealEstateAsset = {
  __typename?: 'RealEstateAsset';
  documentId: Scalars['ID'];
  title: Scalars['String'];
  symbol?: Maybe<Scalars['String']>;
  currency: Enum_Realestateasset_Currency;
  assetStatus?: Maybe<Enum_Realestateasset_Assetstatus>;
  contractAddress?: Maybe<Scalars['String']>;
  totalSupply?: Maybe<Scalars['Int']>;
  decimals?: Maybe<Scalars['Int']>;
  tokenPrice?: Maybe<Scalars['Float']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  lockDownMonths?: Maybe<Scalars['Int']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  rejectedAt?: Maybe<Scalars['DateTime']>;
  listedAt?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Company>;
  user?: Maybe<UsersPermissionsUser>;
  propertyName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  manager?: Maybe<Scalars['String']>;
  images_connection?: Maybe<UploadFileRelationResponseCollection>;
  images: Array<Maybe<UploadFile>>;
  beds?: Maybe<Scalars['Float']>;
  bathrooms?: Maybe<Scalars['Float']>;
  dateBuilt?: Maybe<Scalars['Date']>;
  sqft?: Maybe<Scalars['Float']>;
  documents_connection?: Maybe<UploadFileRelationResponseCollection>;
  documents: Array<Maybe<UploadFile>>;
  propertyType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
  marketPropertyValue?: Maybe<Scalars['Int']>;
  expectedRent?: Maybe<Scalars['Int']>;
  expectedExpenses?: Maybe<Scalars['Int']>;
  expectedYield?: Maybe<Scalars['Float']>;
  rejectionReason?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  propertyDescription?: Maybe<Scalars['String']>;
  marketDescription?: Maybe<Scalars['String']>;
  holdings_connection?: Maybe<RealEstateHoldingRelationResponseCollection>;
  holdings: Array<Maybe<RealEstateHolding>>;
  priceLogs_connection?: Maybe<RealEstatePriceLogRelationResponseCollection>;
  priceLogs: Array<Maybe<RealEstatePriceLog>>;
  sellRequests_connection?: Maybe<RealEstateSellRequestRelationResponseCollection>;
  sellRequests: Array<Maybe<RealEstateSellRequest>>;
  transactions_connection?: Maybe<TransactionRelationResponseCollection>;
  transactions: Array<Maybe<Transaction>>;
  investedSupply?: Maybe<Scalars['Float']>;
  soldSupply?: Maybe<Scalars['Float']>;
  reviewedBy?: Maybe<UsersPermissionsUser>;
  additionalInfo?: Maybe<Scalars['String']>;
  expensesInfo?: Maybe<Scalars['String']>;
  availableSupply?: Maybe<Scalars['Float']>;
  payouts_connection?: Maybe<RealEstatePayoutRelationResponseCollection>;
  payouts: Array<Maybe<RealEstatePayout>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** Google Static Map URL for the property location (if available) */
  mapUrl?: Maybe<Scalars['String']>;
};


export type RealEstateAssetImages_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetImagesArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetDocuments_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetDocumentsArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetHoldings_ConnectionArgs = {
  filters?: Maybe<RealEstateHoldingFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetHoldingsArgs = {
  filters?: Maybe<RealEstateHoldingFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetPriceLogs_ConnectionArgs = {
  filters?: Maybe<RealEstatePriceLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetPriceLogsArgs = {
  filters?: Maybe<RealEstatePriceLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetSellRequests_ConnectionArgs = {
  filters?: Maybe<RealEstateSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetSellRequestsArgs = {
  filters?: Maybe<RealEstateSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetTransactions_ConnectionArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetTransactionsArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetPayouts_ConnectionArgs = {
  filters?: Maybe<RealEstatePayoutFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateAssetPayoutsArgs = {
  filters?: Maybe<RealEstatePayoutFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RealEstateAssetCountsPayload = {
  __typename?: 'RealEstateAssetCountsPayload';
  listedCount?: Maybe<Scalars['Int']>;
  submittedCount?: Maybe<Scalars['Int']>;
  approvedCount?: Maybe<Scalars['Int']>;
};

export type RealEstateAssetEntityResponseCollection = {
  __typename?: 'RealEstateAssetEntityResponseCollection';
  nodes: Array<RealEstateAsset>;
  pageInfo: Pagination;
};

export type RealEstateAssetFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  symbol?: Maybe<StringFilterInput>;
  currency?: Maybe<StringFilterInput>;
  assetStatus?: Maybe<StringFilterInput>;
  contractAddress?: Maybe<StringFilterInput>;
  totalSupply?: Maybe<IntFilterInput>;
  decimals?: Maybe<IntFilterInput>;
  tokenPrice?: Maybe<FloatFilterInput>;
  purchaseFee?: Maybe<FloatFilterInput>;
  sellFee?: Maybe<FloatFilterInput>;
  lockDownMonths?: Maybe<IntFilterInput>;
  approvedAt?: Maybe<DateTimeFilterInput>;
  rejectedAt?: Maybe<DateTimeFilterInput>;
  listedAt?: Maybe<DateTimeFilterInput>;
  company?: Maybe<CompanyFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  propertyName?: Maybe<StringFilterInput>;
  location?: Maybe<StringFilterInput>;
  manager?: Maybe<StringFilterInput>;
  beds?: Maybe<FloatFilterInput>;
  bathrooms?: Maybe<FloatFilterInput>;
  dateBuilt?: Maybe<DateFilterInput>;
  sqft?: Maybe<FloatFilterInput>;
  propertyType?: Maybe<StringFilterInput>;
  value?: Maybe<IntFilterInput>;
  marketPropertyValue?: Maybe<IntFilterInput>;
  expectedRent?: Maybe<IntFilterInput>;
  expectedExpenses?: Maybe<IntFilterInput>;
  expectedYield?: Maybe<FloatFilterInput>;
  rejectionReason?: Maybe<StringFilterInput>;
  address?: Maybe<StringFilterInput>;
  propertyDescription?: Maybe<StringFilterInput>;
  marketDescription?: Maybe<StringFilterInput>;
  holdings?: Maybe<RealEstateHoldingFiltersInput>;
  priceLogs?: Maybe<RealEstatePriceLogFiltersInput>;
  sellRequests?: Maybe<RealEstateSellRequestFiltersInput>;
  transactions?: Maybe<TransactionFiltersInput>;
  investedSupply?: Maybe<FloatFilterInput>;
  soldSupply?: Maybe<FloatFilterInput>;
  reviewedBy?: Maybe<UsersPermissionsUserFiltersInput>;
  additionalInfo?: Maybe<StringFilterInput>;
  expensesInfo?: Maybe<StringFilterInput>;
  availableSupply?: Maybe<FloatFilterInput>;
  payouts?: Maybe<RealEstatePayoutFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<RealEstateAssetFiltersInput>>>;
  or?: Maybe<Array<Maybe<RealEstateAssetFiltersInput>>>;
  not?: Maybe<RealEstateAssetFiltersInput>;
};

export type RealEstateAssetForInvestorPayload = {
  __typename?: 'RealEstateAssetForInvestorPayload';
  /** Real estate asset for the investor */
  asset?: Maybe<RealEstateAsset>;
  /** Whether the user is an investor of the real estate asset */
  isAnInvestorOfAsset?: Maybe<Scalars['Boolean']>;
  /** Number of unique investors in the real estate asset */
  investorCount?: Maybe<Scalars['Int']>;
  /** Percentage of funding for the real estate asset */
  fundingPercentage?: Maybe<Scalars['Float']>;
  /** Number of units held by the investor */
  unitsHeld?: Maybe<Scalars['Float']>;
  /** Number of tokens posted by the investor */
  tokensPosted?: Maybe<Scalars['Float']>;
  /** Number of tokens owned by the investor */
  tokensOwned?: Maybe<Scalars['Float']>;
  /** Number of tokens available in an asset */
  tokensAvailable?: Maybe<Scalars['Float']>;
};

export type RealEstateAssetInput = {
  title?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Realestateasset_Currency>;
  assetStatus?: Maybe<Enum_Realestateasset_Assetstatus>;
  contractAddress?: Maybe<Scalars['String']>;
  totalSupply?: Maybe<Scalars['Int']>;
  decimals?: Maybe<Scalars['Int']>;
  tokenPrice?: Maybe<Scalars['Float']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  lockDownMonths?: Maybe<Scalars['Int']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  rejectedAt?: Maybe<Scalars['DateTime']>;
  listedAt?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  propertyName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  manager?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['ID']>>>;
  beds?: Maybe<Scalars['Float']>;
  bathrooms?: Maybe<Scalars['Float']>;
  dateBuilt?: Maybe<Scalars['Date']>;
  sqft?: Maybe<Scalars['Float']>;
  documents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  propertyType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
  marketPropertyValue?: Maybe<Scalars['Int']>;
  expectedRent?: Maybe<Scalars['Int']>;
  expectedExpenses?: Maybe<Scalars['Int']>;
  expectedYield?: Maybe<Scalars['Float']>;
  rejectionReason?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  propertyDescription?: Maybe<Scalars['String']>;
  marketDescription?: Maybe<Scalars['String']>;
  holdings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  priceLogs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sellRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  investedSupply?: Maybe<Scalars['Float']>;
  soldSupply?: Maybe<Scalars['Float']>;
  reviewedBy?: Maybe<Scalars['ID']>;
  additionalInfo?: Maybe<Scalars['String']>;
  expensesInfo?: Maybe<Scalars['String']>;
  availableSupply?: Maybe<Scalars['Float']>;
  payouts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RealEstateAssetRelationResponseCollection = {
  __typename?: 'RealEstateAssetRelationResponseCollection';
  nodes: Array<RealEstateAsset>;
};

export type RealEstateHolding = {
  __typename?: 'RealEstateHolding';
  documentId: Scalars['ID'];
  realEstateAsset?: Maybe<RealEstateAsset>;
  user?: Maybe<UsersPermissionsUser>;
  quantity: Scalars['Float'];
  avgCostBasis?: Maybe<Scalars['Float']>;
  currency: Enum_Realestateholding_Currency;
  holdingStatus?: Maybe<Enum_Realestateholding_Holdingstatus>;
  transactions_connection?: Maybe<TransactionRelationResponseCollection>;
  transactions: Array<Maybe<Transaction>>;
  sellRequests_connection?: Maybe<RealEstateSellRequestRelationResponseCollection>;
  sellRequests: Array<Maybe<RealEstateSellRequest>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type RealEstateHoldingTransactions_ConnectionArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateHoldingTransactionsArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateHoldingSellRequests_ConnectionArgs = {
  filters?: Maybe<RealEstateSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RealEstateHoldingSellRequestsArgs = {
  filters?: Maybe<RealEstateSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RealEstateHoldingEntityResponseCollection = {
  __typename?: 'RealEstateHoldingEntityResponseCollection';
  nodes: Array<RealEstateHolding>;
  pageInfo: Pagination;
};

export type RealEstateHoldingFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  realEstateAsset?: Maybe<RealEstateAssetFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  quantity?: Maybe<FloatFilterInput>;
  avgCostBasis?: Maybe<FloatFilterInput>;
  currency?: Maybe<StringFilterInput>;
  holdingStatus?: Maybe<StringFilterInput>;
  transactions?: Maybe<TransactionFiltersInput>;
  sellRequests?: Maybe<RealEstateSellRequestFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<RealEstateHoldingFiltersInput>>>;
  or?: Maybe<Array<Maybe<RealEstateHoldingFiltersInput>>>;
  not?: Maybe<RealEstateHoldingFiltersInput>;
};

export type RealEstateHoldingInput = {
  realEstateAsset?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Float']>;
  avgCostBasis?: Maybe<Scalars['Float']>;
  currency?: Maybe<Enum_Realestateholding_Currency>;
  holdingStatus?: Maybe<Enum_Realestateholding_Holdingstatus>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  sellRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RealEstateHoldingRelationResponseCollection = {
  __typename?: 'RealEstateHoldingRelationResponseCollection';
  nodes: Array<RealEstateHolding>;
};

export type RealEstatePayout = {
  __typename?: 'RealEstatePayout';
  documentId: Scalars['ID'];
  isYield?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Float']>;
  realEstateAsset?: Maybe<RealEstateAsset>;
  payoutStatus?: Maybe<Enum_Realestatepayout_Payoutstatus>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RealEstatePayoutEntityResponseCollection = {
  __typename?: 'RealEstatePayoutEntityResponseCollection';
  nodes: Array<RealEstatePayout>;
  pageInfo: Pagination;
};

export type RealEstatePayoutFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  isYield?: Maybe<BooleanFilterInput>;
  amount?: Maybe<FloatFilterInput>;
  realEstateAsset?: Maybe<RealEstateAssetFiltersInput>;
  payoutStatus?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<RealEstatePayoutFiltersInput>>>;
  or?: Maybe<Array<Maybe<RealEstatePayoutFiltersInput>>>;
  not?: Maybe<RealEstatePayoutFiltersInput>;
};

export type RealEstatePayoutInput = {
  isYield?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Float']>;
  realEstateAsset?: Maybe<Scalars['ID']>;
  payoutStatus?: Maybe<Enum_Realestatepayout_Payoutstatus>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RealEstatePayoutRelationResponseCollection = {
  __typename?: 'RealEstatePayoutRelationResponseCollection';
  nodes: Array<RealEstatePayout>;
};

export type RealEstatePriceLog = {
  __typename?: 'RealEstatePriceLog';
  documentId: Scalars['ID'];
  realEstateAsset?: Maybe<RealEstateAsset>;
  value: Scalars['Float'];
  logStatus?: Maybe<Enum_Realestatepricelog_Logstatus>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RealEstatePriceLogEntityResponseCollection = {
  __typename?: 'RealEstatePriceLogEntityResponseCollection';
  nodes: Array<RealEstatePriceLog>;
  pageInfo: Pagination;
};

export type RealEstatePriceLogFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  realEstateAsset?: Maybe<RealEstateAssetFiltersInput>;
  value?: Maybe<FloatFilterInput>;
  logStatus?: Maybe<StringFilterInput>;
  approvedAt?: Maybe<DateTimeFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<RealEstatePriceLogFiltersInput>>>;
  or?: Maybe<Array<Maybe<RealEstatePriceLogFiltersInput>>>;
  not?: Maybe<RealEstatePriceLogFiltersInput>;
};

export type RealEstatePriceLogInput = {
  realEstateAsset?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['Float']>;
  logStatus?: Maybe<Enum_Realestatepricelog_Logstatus>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RealEstatePriceLogRelationResponseCollection = {
  __typename?: 'RealEstatePriceLogRelationResponseCollection';
  nodes: Array<RealEstatePriceLog>;
};

export type RealEstateSellRequest = {
  __typename?: 'RealEstateSellRequest';
  documentId: Scalars['ID'];
  realEstateAsset?: Maybe<RealEstateAsset>;
  user?: Maybe<UsersPermissionsUser>;
  quantity: Scalars['Float'];
  currency: Enum_Realestatesellrequest_Currency;
  customerAmount?: Maybe<Scalars['Float']>;
  sellFeeAmount?: Maybe<Scalars['Float']>;
  sellStatus?: Maybe<Enum_Realestatesellrequest_Sellstatus>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  holding?: Maybe<RealEstateHolding>;
  sellAmount?: Maybe<Scalars['Float']>;
  fulfilledQuantity?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RealEstateSellRequestEntityResponseCollection = {
  __typename?: 'RealEstateSellRequestEntityResponseCollection';
  nodes: Array<RealEstateSellRequest>;
  pageInfo: Pagination;
};

export type RealEstateSellRequestFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  realEstateAsset?: Maybe<RealEstateAssetFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  quantity?: Maybe<FloatFilterInput>;
  currency?: Maybe<StringFilterInput>;
  customerAmount?: Maybe<FloatFilterInput>;
  sellFeeAmount?: Maybe<FloatFilterInput>;
  sellStatus?: Maybe<StringFilterInput>;
  approvedAt?: Maybe<DateTimeFilterInput>;
  holding?: Maybe<RealEstateHoldingFiltersInput>;
  sellAmount?: Maybe<FloatFilterInput>;
  fulfilledQuantity?: Maybe<FloatFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<RealEstateSellRequestFiltersInput>>>;
  or?: Maybe<Array<Maybe<RealEstateSellRequestFiltersInput>>>;
  not?: Maybe<RealEstateSellRequestFiltersInput>;
};

export type RealEstateSellRequestInput = {
  realEstateAsset?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Float']>;
  currency?: Maybe<Enum_Realestatesellrequest_Currency>;
  customerAmount?: Maybe<Scalars['Float']>;
  sellFeeAmount?: Maybe<Scalars['Float']>;
  sellStatus?: Maybe<Enum_Realestatesellrequest_Sellstatus>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  holding?: Maybe<Scalars['ID']>;
  sellAmount?: Maybe<Scalars['Float']>;
  fulfilledQuantity?: Maybe<Scalars['Float']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RealEstateSellRequestRelationResponseCollection = {
  __typename?: 'RealEstateSellRequestRelationResponseCollection';
  nodes: Array<RealEstateSellRequest>;
};

/** Reasons for investing */
export enum Reasons_For_Investing {
  Retirement = 'RETIREMENT',
  TuitionSavings = 'TUITION_SAVINGS',
  BuildingSavings = 'BUILDING_SAVINGS',
  EarnAGoodReturn = 'EARN_A_GOOD_RETURN'
}

export type RequestCompanyUpdateInput = {
  /** ID of the company logo */
  logo?: Maybe<Scalars['ID']>;
  /** Company name */
  name?: Maybe<Scalars['String']>;
  /** Company type */
  companyType?: Maybe<Enum_Company_Companytype>;
  /** Industry type */
  industryType?: Maybe<Enum_Company_Industrytype>;
  /** Registration number */
  registrationNumber?: Maybe<Scalars['String']>;
  /** Registered at */
  registeredAt?: Maybe<Scalars['String']>;
  /** Country of registration */
  countryOfRegistration?: Maybe<Scalars['String']>;
  /** Formatted address */
  formattedAddress?: Maybe<Scalars['String']>;
  /** VAT number */
  vatNumber?: Maybe<Scalars['String']>;
  /** Tax number */
  taxNumber?: Maybe<Scalars['String']>;
};

export type RequestMasterNoteUpdateInput = {
  /** Master note ID */
  id?: Maybe<Scalars['ID']>;
  /** Title */
  title?: Maybe<Scalars['String']>;
  /** Currency */
  currency?: Maybe<Scalars['String']>;
  /** Compounding frequency */
  compoundingFrequency?: Maybe<Scalars['String']>;
  /** Type */
  type?: Maybe<Scalars['String']>;
  /** Asset type */
  assetType?: Maybe<Scalars['String']>;
  /** Fund manager */
  fundManager?: Maybe<Scalars['String']>;
  /** Interest rate */
  interestRate?: Maybe<Scalars['Float']>;
  /** Interest frequency */
  interestFrequency?: Maybe<Scalars['String']>;
  /** Maturity date */
  maturityDate?: Maybe<Scalars['DateTime']>;
  /** Memorandum IDs */
  memorandum?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Potential risks */
  potentialRisks?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
};

/** Input for requesting more information about a note */
export type RequestMoreInfoInput = {
  /** ID of the note */
  id?: Maybe<Scalars['ID']>;
  /** Reason for requesting more information */
  reason?: Maybe<Scalars['String']>;
};

export type RequestProfileUpdateInput = {
  /** ID of the profile picture */
  profilePicture?: Maybe<Scalars['ID']>;
  /** First name */
  firstName?: Maybe<Scalars['String']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']>;
  /** ID number */
  idNumber?: Maybe<Scalars['String']>;
  /** Email address */
  email?: Maybe<Scalars['String']>;
  /** Phone number */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Date of birth */
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** Tax number */
  taxNumber?: Maybe<Scalars['String']>;
  /** Type of user */
  type?: Maybe<Scalars['String']>;
  /** Country */
  country?: Maybe<Scalars['String']>;
  /** Residential address */
  residentialAddress?: Maybe<Scalars['String']>;
};

export type ReviewBondInput = {
  id: Scalars['String'];
  decision: ReviewDecision;
  reason?: Maybe<Scalars['String']>;
};

export enum ReviewDecision {
  Approve = 'APPROVE',
  Reject = 'REJECT'
}

export type ReviewMasterBondInput = {
  id: Scalars['String'];
  decision: ReviewDecision;
  reason?: Maybe<Scalars['String']>;
};

export type ReviewRealEstateAssetInput = {
  id: Scalars['String'];
  decision: ReviewDecision;
  reason?: Maybe<Scalars['String']>;
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  documentId: Scalars['ID'];
  name: Scalars['String'];
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  contentTypes: Scalars['JSON'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  stages?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  contentTypes?: Maybe<JsonFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  or?: Maybe<Array<Maybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  not?: Maybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  name?: Maybe<Scalars['String']>;
  stages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  stageRequiredToPublish?: Maybe<Scalars['ID']>;
  contentTypes?: Maybe<Scalars['JSON']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  color?: Maybe<StringFilterInput>;
  workflow?: Maybe<ReviewWorkflowsWorkflowFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  or?: Maybe<Array<Maybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  not?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  name?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  workflow?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type RolloverRequest = {
  __typename?: 'RolloverRequest';
  documentId: Scalars['ID'];
  proposedMaturityDate?: Maybe<Scalars['Date']>;
  reason?: Maybe<Scalars['String']>;
  note?: Maybe<Note>;
  rolloverPeriod?: Maybe<Scalars['Int']>;
  rolloverResponses_connection?: Maybe<RolloverResponseRelationResponseCollection>;
  rolloverResponses: Array<Maybe<RolloverResponse>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type RolloverRequestRolloverResponses_ConnectionArgs = {
  filters?: Maybe<RolloverResponseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type RolloverRequestRolloverResponsesArgs = {
  filters?: Maybe<RolloverResponseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RolloverRequestEntityResponseCollection = {
  __typename?: 'RolloverRequestEntityResponseCollection';
  nodes: Array<RolloverRequest>;
  pageInfo: Pagination;
};

export type RolloverRequestFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  proposedMaturityDate?: Maybe<DateFilterInput>;
  reason?: Maybe<StringFilterInput>;
  note?: Maybe<NoteFiltersInput>;
  rolloverPeriod?: Maybe<IntFilterInput>;
  rolloverResponses?: Maybe<RolloverResponseFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<RolloverRequestFiltersInput>>>;
  or?: Maybe<Array<Maybe<RolloverRequestFiltersInput>>>;
  not?: Maybe<RolloverRequestFiltersInput>;
};

export type RolloverRequestInput = {
  proposedMaturityDate?: Maybe<Scalars['Date']>;
  reason?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['ID']>;
  rolloverPeriod?: Maybe<Scalars['Int']>;
  rolloverResponses?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RolloverRequestRelationResponseCollection = {
  __typename?: 'RolloverRequestRelationResponseCollection';
  nodes: Array<RolloverRequest>;
};

export type RolloverResponse = {
  __typename?: 'RolloverResponse';
  documentId: Scalars['ID'];
  rolloverStatus?: Maybe<Enum_Rolloverresponse_Rolloverstatus>;
  rolloverRequest?: Maybe<RolloverRequest>;
  user?: Maybe<UsersPermissionsUser>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RolloverResponseEntityResponseCollection = {
  __typename?: 'RolloverResponseEntityResponseCollection';
  nodes: Array<RolloverResponse>;
  pageInfo: Pagination;
};

export type RolloverResponseFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  rolloverStatus?: Maybe<StringFilterInput>;
  rolloverRequest?: Maybe<RolloverRequestFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<RolloverResponseFiltersInput>>>;
  or?: Maybe<Array<Maybe<RolloverResponseFiltersInput>>>;
  not?: Maybe<RolloverResponseFiltersInput>;
};

export type RolloverResponseInput = {
  rolloverStatus?: Maybe<Enum_Rolloverresponse_Rolloverstatus>;
  rolloverRequest?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RolloverResponseRelationResponseCollection = {
  __typename?: 'RolloverResponseRelationResponseCollection';
  nodes: Array<RolloverResponse>;
};

export type SellRequest = {
  __typename?: 'SellRequest';
  documentId: Scalars['ID'];
  customerValue?: Maybe<Scalars['Float']>;
  sellAmount?: Maybe<Scalars['Float']>;
  note?: Maybe<Note>;
  user?: Maybe<UsersPermissionsUser>;
  investment?: Maybe<Investment>;
  sellStatus?: Maybe<Enum_Sellrequest_Sellstatus>;
  shortHoldFeeAmount?: Maybe<Scalars['Float']>;
  sellFeeAmount?: Maybe<Scalars['Float']>;
  check?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Sellrequest_Currency>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type SellRequestEntityResponseCollection = {
  __typename?: 'SellRequestEntityResponseCollection';
  nodes: Array<SellRequest>;
  pageInfo: Pagination;
};

export type SellRequestFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  customerValue?: Maybe<FloatFilterInput>;
  sellAmount?: Maybe<FloatFilterInput>;
  note?: Maybe<NoteFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  investment?: Maybe<InvestmentFiltersInput>;
  sellStatus?: Maybe<StringFilterInput>;
  shortHoldFeeAmount?: Maybe<FloatFilterInput>;
  sellFeeAmount?: Maybe<FloatFilterInput>;
  check?: Maybe<StringFilterInput>;
  currency?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<SellRequestFiltersInput>>>;
  or?: Maybe<Array<Maybe<SellRequestFiltersInput>>>;
  not?: Maybe<SellRequestFiltersInput>;
};

export type SellRequestInput = {
  customerValue?: Maybe<Scalars['Float']>;
  sellAmount?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  investment?: Maybe<Scalars['ID']>;
  sellStatus?: Maybe<Enum_Sellrequest_Sellstatus>;
  shortHoldFeeAmount?: Maybe<Scalars['Float']>;
  sellFeeAmount?: Maybe<Scalars['Float']>;
  check?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Sellrequest_Currency>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type SellRequestLoss = {
  __typename?: 'SellRequestLoss';
  /** Loss amount */
  loss?: Maybe<Scalars['Float']>;
  /** Time of the loss */
  time?: Maybe<Scalars['Date']>;
};

export type SendInterestInput = {
  /** ID of the note to send interest */
  id: Scalars['String'];
  /** Interest metric to send */
  interestMetric: Scalars['Int'];
};

export type SendPayoutByUserInput = {
  /** ID of the note to send payout */
  id: Scalars['String'];
};

export type StringFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['String']>>>;
  or?: Maybe<Array<Maybe<Scalars['String']>>>;
  not?: Maybe<StringFilterInput>;
  eq?: Maybe<Scalars['String']>;
  eqi?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  nei?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  notContains?: Maybe<Scalars['String']>;
  containsi?: Maybe<Scalars['String']>;
  notContainsi?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  between?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SubmitBankWithdrawRequestInput = {
  /** The amount requested for withdrawal */
  amount: Scalars['Float'];
  /** The name of the bank */
  bankName: Scalars['String'];
  /** The name of the account holder */
  accountName: Scalars['String'];
  /** The account number for the withdrawal */
  accountNumber: Scalars['String'];
  /** The currency of the withdrawal */
  currency: Scalars['String'];
  /** The type of withdrawal (e.g., bank transfer, M-Pesa) */
  withdrawType: Scalars['String'];
  /** The M-Pesa number for the withdrawal */
  mpesaNumber?: Maybe<Scalars['String']>;
};

/** Input for submitting a commercial paper */
export type SubmitNoteInput = {
  /** ID of the commercial paper */
  id?: Maybe<Scalars['ID']>;
  /** In favor of whom */
  inFavorOf?: Maybe<Scalars['String']>;
};

export type SubmitRealEstateAssetInput = {
  id: Scalars['String'];
};

export type SubmitTopupRequestInput = {
  /** source of the topup request income */
  source?: Maybe<Enum_Transaction_Source>;
  /** Amount to top up */
  amount: Scalars['Int'];
  /** Currency code */
  currency: Scalars['String'];
};

/** Support request input */
export type SupportRequestInput = {
  /** Type of query */
  queryType: Scalars['String'];
  /** Description of the query */
  description: Scalars['String'];
};

export type TopupMyWalletInput = {
  /** Amount to top up */
  amount: Scalars['Int'];
  /** Phone number */
  phoneNumber: Scalars['String'];
  /** Source of the topup */
  source: Scalars['String'];
};

export type TopupRequest = {
  __typename?: 'TopupRequest';
  documentId: Scalars['ID'];
  intendedAmount?: Maybe<Scalars['Int']>;
  depositedAmount?: Maybe<Scalars['Int']>;
  topupStatus?: Maybe<Enum_Topuprequest_Topupstatus>;
  completedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<UsersPermissionsUser>;
  referenceNumber?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Topuprequest_Currency>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TopupRequestEntityResponseCollection = {
  __typename?: 'TopupRequestEntityResponseCollection';
  nodes: Array<TopupRequest>;
  pageInfo: Pagination;
};

export type TopupRequestFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  intendedAmount?: Maybe<IntFilterInput>;
  depositedAmount?: Maybe<IntFilterInput>;
  topupStatus?: Maybe<StringFilterInput>;
  completedAt?: Maybe<DateFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  referenceNumber?: Maybe<StringFilterInput>;
  currency?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<TopupRequestFiltersInput>>>;
  or?: Maybe<Array<Maybe<TopupRequestFiltersInput>>>;
  not?: Maybe<TopupRequestFiltersInput>;
};

export type TopupRequestInput = {
  intendedAmount?: Maybe<Scalars['Int']>;
  depositedAmount?: Maybe<Scalars['Int']>;
  topupStatus?: Maybe<Enum_Topuprequest_Topupstatus>;
  completedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<Scalars['ID']>;
  referenceNumber?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Topuprequest_Currency>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TopupRequestRelationResponseCollection = {
  __typename?: 'TopupRequestRelationResponseCollection';
  nodes: Array<TopupRequest>;
};

export type Transaction = {
  __typename?: 'Transaction';
  documentId: Scalars['ID'];
  amount?: Maybe<Scalars['Float']>;
  user?: Maybe<UsersPermissionsUser>;
  investment?: Maybe<Investment>;
  transactionType?: Maybe<Enum_Transaction_Transactiontype>;
  mpesaReceiptNumber?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Enum_Transaction_Transactionstatus>;
  description?: Maybe<Scalars['String']>;
  mpesaNumber?: Maybe<Scalars['Long']>;
  merchantRequestID?: Maybe<Scalars['String']>;
  checkoutRequestID?: Maybe<Scalars['String']>;
  source?: Maybe<Enum_Transaction_Source>;
  currency?: Maybe<Enum_Transaction_Currency>;
  note?: Maybe<Note>;
  wallet?: Maybe<Wallet>;
  realEstateAsset?: Maybe<RealEstateAsset>;
  bankWithdrawRequest?: Maybe<BankWithdrawRequest>;
  transactionNumber?: Maybe<Scalars['String']>;
  invoice?: Maybe<UploadFile>;
  payoutDate?: Maybe<Scalars['Date']>;
  realEstateHolding?: Maybe<RealEstateHolding>;
  bondHolding?: Maybe<BondHolding>;
  bond?: Maybe<Bond>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionEntityResponseCollection = {
  __typename?: 'TransactionEntityResponseCollection';
  nodes: Array<Transaction>;
  pageInfo: Pagination;
};

export type TransactionFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  amount?: Maybe<FloatFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  investment?: Maybe<InvestmentFiltersInput>;
  transactionType?: Maybe<StringFilterInput>;
  mpesaReceiptNumber?: Maybe<StringFilterInput>;
  transactionStatus?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  mpesaNumber?: Maybe<LongFilterInput>;
  merchantRequestID?: Maybe<StringFilterInput>;
  checkoutRequestID?: Maybe<StringFilterInput>;
  source?: Maybe<StringFilterInput>;
  currency?: Maybe<StringFilterInput>;
  note?: Maybe<NoteFiltersInput>;
  wallet?: Maybe<WalletFiltersInput>;
  realEstateAsset?: Maybe<RealEstateAssetFiltersInput>;
  bankWithdrawRequest?: Maybe<BankWithdrawRequestFiltersInput>;
  transactionNumber?: Maybe<StringFilterInput>;
  payoutDate?: Maybe<DateFilterInput>;
  realEstateHolding?: Maybe<RealEstateHoldingFiltersInput>;
  bondHolding?: Maybe<BondHoldingFiltersInput>;
  bond?: Maybe<BondFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<TransactionFiltersInput>>>;
  or?: Maybe<Array<Maybe<TransactionFiltersInput>>>;
  not?: Maybe<TransactionFiltersInput>;
};

export type TransactionInput = {
  amount?: Maybe<Scalars['Float']>;
  user?: Maybe<Scalars['ID']>;
  investment?: Maybe<Scalars['ID']>;
  transactionType?: Maybe<Enum_Transaction_Transactiontype>;
  mpesaReceiptNumber?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Enum_Transaction_Transactionstatus>;
  description?: Maybe<Scalars['String']>;
  mpesaNumber?: Maybe<Scalars['Long']>;
  merchantRequestID?: Maybe<Scalars['String']>;
  checkoutRequestID?: Maybe<Scalars['String']>;
  source?: Maybe<Enum_Transaction_Source>;
  currency?: Maybe<Enum_Transaction_Currency>;
  note?: Maybe<Scalars['ID']>;
  wallet?: Maybe<Scalars['ID']>;
  realEstateAsset?: Maybe<Scalars['ID']>;
  bankWithdrawRequest?: Maybe<Scalars['ID']>;
  transactionNumber?: Maybe<Scalars['String']>;
  invoice?: Maybe<Scalars['ID']>;
  payoutDate?: Maybe<Scalars['Date']>;
  realEstateHolding?: Maybe<Scalars['ID']>;
  bondHolding?: Maybe<Scalars['ID']>;
  bond?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TransactionRelationResponseCollection = {
  __typename?: 'TransactionRelationResponseCollection';
  nodes: Array<Transaction>;
};

/** Input for submitting a bond price change */
export type UpdateBondPriceInput = {
  /** Document ID of the master bond */
  masterBondId: Scalars['String'];
  /** Proposed new bond price */
  newPrice: Scalars['Float'];
};

export type UpdateMasterBondInput = {
  id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  potentialRisks?: Maybe<Scalars['String']>;
  supportDocuments?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Update or create my banking information */
export type UpdateOrCreateMyBankingInput = {
  /** Account holder name */
  accountHolder: Scalars['String'];
  /** Account number */
  accountNumber: Scalars['String'];
  /** Bank name */
  bankName: Scalars['String'];
  /** Type of account */
  typeOfAccount: Scalars['String'];
};

/** Update or create my financial summary */
export type UpdateOrCreateMyFinancialSummaryInput = {
  /** Net worth of the company */
  netWorth: Scalars['Float'];
  /** Total debt outstanding of the company */
  totalDeptOutstanding: Scalars['Float'];
  /** Total debt outstanding other of the company */
  totalDeptOutstandingOther: Scalars['Float'];
  /** Gross income of the company */
  grossIncome: Scalars['Float'];
  /** Gross profit of the company */
  grossProfit: Scalars['Float'];
  /** Operating profit of the company */
  operatingProfit: Scalars['Float'];
  /** Net profit of the company */
  netProfit: Scalars['Float'];
  /** Details of default CP of the company */
  detailsOfDefaultCP: Scalars['String'];
  /** Details of default delay of the company */
  detailsOfDefaultDelay: Scalars['String'];
};

export type UpdateRealEstateAssetDetailsInput = {
  id: Scalars['String'];
  marketPrice?: Maybe<Scalars['Float']>;
  purchaseFee?: Maybe<Scalars['Float']>;
  sellFee?: Maybe<Scalars['Float']>;
  lockDownMonths?: Maybe<Scalars['Int']>;
  propertyName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  manager?: Maybe<Scalars['String']>;
  beds?: Maybe<Scalars['Float']>;
  bathrooms?: Maybe<Scalars['Float']>;
  dateBuilt?: Maybe<Scalars['String']>;
  sqft?: Maybe<Scalars['Float']>;
  propertyType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
  expectedRent?: Maybe<Scalars['Int']>;
  expectedExpenses?: Maybe<Scalars['Int']>;
  expectedYield?: Maybe<Scalars['Float']>;
  address?: Maybe<Scalars['String']>;
  propertyDescription?: Maybe<Scalars['String']>;
  marketDescription?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  documents?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Input for updating regulatory profile */
export type UpdateRegulatoryProfileInput = {
  /** ID of the profile picture */
  profilePicture: Scalars['ID'];
  /** First name of the user */
  firstName?: Maybe<Scalars['String']>;
  /** Last name of the user */
  lastName?: Maybe<Scalars['String']>;
  /** Email address of the user */
  email?: Maybe<Scalars['String']>;
};

export type UpdateRequest = {
  __typename?: 'UpdateRequest';
  documentId: Scalars['ID'];
  user?: Maybe<UsersPermissionsUser>;
  updateType: Enum_Updaterequest_Updatetype;
  newData?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Enum_Updaterequest_Updatestatus>;
  oldData?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UpdateRequestEntityResponseCollection = {
  __typename?: 'UpdateRequestEntityResponseCollection';
  nodes: Array<UpdateRequest>;
  pageInfo: Pagination;
};

export type UpdateRequestFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  updateType?: Maybe<StringFilterInput>;
  newData?: Maybe<JsonFilterInput>;
  updateStatus?: Maybe<StringFilterInput>;
  oldData?: Maybe<JsonFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UpdateRequestFiltersInput>>>;
  or?: Maybe<Array<Maybe<UpdateRequestFiltersInput>>>;
  not?: Maybe<UpdateRequestFiltersInput>;
};

export type UpdateRequestInput = {
  user?: Maybe<Scalars['ID']>;
  updateType?: Maybe<Enum_Updaterequest_Updatetype>;
  newData?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Enum_Updaterequest_Updatestatus>;
  oldData?: Maybe<Scalars['JSON']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UpdateRequestRelationResponseCollection = {
  __typename?: 'UpdateRequestRelationResponseCollection';
  nodes: Array<UpdateRequest>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  documentId: Scalars['ID'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  focalPoint?: Maybe<Scalars['JSON']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  alternativeText?: Maybe<StringFilterInput>;
  caption?: Maybe<StringFilterInput>;
  focalPoint?: Maybe<JsonFilterInput>;
  width?: Maybe<IntFilterInput>;
  height?: Maybe<IntFilterInput>;
  formats?: Maybe<JsonFilterInput>;
  hash?: Maybe<StringFilterInput>;
  ext?: Maybe<StringFilterInput>;
  mime?: Maybe<StringFilterInput>;
  size?: Maybe<FloatFilterInput>;
  url?: Maybe<StringFilterInput>;
  previewUrl?: Maybe<StringFilterInput>;
  provider?: Maybe<StringFilterInput>;
  provider_metadata?: Maybe<JsonFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UploadFileFiltersInput>>>;
  or?: Maybe<Array<Maybe<UploadFileFiltersInput>>>;
  not?: Maybe<UploadFileFiltersInput>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  nodes: Array<UploadFile>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  documentId: Scalars['ID'];
  username: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  documentId: Scalars['ID'];
  action: Scalars['String'];
  role?: Maybe<UsersPermissionsRole>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  action?: Maybe<StringFilterInput>;
  role?: Maybe<UsersPermissionsRoleFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsPermissionFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsPermissionFiltersInput>>>;
  not?: Maybe<UsersPermissionsPermissionFiltersInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  documentId: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  users: Array<Maybe<UsersPermissionsUser>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: Maybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: Maybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  permissions?: Maybe<UsersPermissionsPermissionFiltersInput>;
  users?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsRoleFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsRoleFiltersInput>>>;
  not?: Maybe<UsersPermissionsRoleFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  documentId: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  phoneNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  idNumber?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  officeNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  citizenship?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  reasonForInvesting?: Maybe<Scalars['String']>;
  agreedToInvestTerms?: Maybe<Scalars['Boolean']>;
  onboardingStatus: Enum_Userspermissionsuser_Onboardingstatus;
  investorOnboardingSteps?: Maybe<Enum_Userspermissionsuser_Investoronboardingsteps>;
  smileJobId?: Maybe<Scalars['String']>;
  smileVerificationStatus?: Maybe<Enum_Userspermissionsuser_Smileverificationstatus>;
  type?: Maybe<Enum_Userspermissionsuser_Type>;
  currency?: Maybe<Enum_Userspermissionsuser_Currency>;
  notifications_connection?: Maybe<NotificationRelationResponseCollection>;
  notifications: Array<Maybe<Notification>>;
  investments_connection?: Maybe<InvestmentRelationResponseCollection>;
  investments: Array<Maybe<Investment>>;
  transactions_connection?: Maybe<TransactionRelationResponseCollection>;
  transactions: Array<Maybe<Transaction>>;
  bank_withdraw_requests_connection?: Maybe<BankWithdrawRequestRelationResponseCollection>;
  bank_withdraw_requests: Array<Maybe<BankWithdrawRequest>>;
  notes_connection?: Maybe<NoteRelationResponseCollection>;
  notes: Array<Maybe<Note>>;
  company?: Maybe<Company>;
  master_notes_connection?: Maybe<MasterNoteRelationResponseCollection>;
  master_notes: Array<Maybe<MasterNote>>;
  comments_connection?: Maybe<CommentRelationResponseCollection>;
  comments: Array<Maybe<Comment>>;
  purchaseRequests_connection?: Maybe<PurchaseRequestRelationResponseCollection>;
  purchaseRequests: Array<Maybe<PurchaseRequest>>;
  rolloverResponses_connection?: Maybe<RolloverResponseRelationResponseCollection>;
  rolloverResponses: Array<Maybe<RolloverResponse>>;
  updateRequests_connection?: Maybe<UpdateRequestRelationResponseCollection>;
  updateRequests: Array<Maybe<UpdateRequest>>;
  wallet?: Maybe<Wallet>;
  nationalId?: Maybe<UploadFile>;
  profilePicture?: Maybe<UploadFile>;
  selfie?: Maybe<UploadFile>;
  certifiedId?: Maybe<UploadFile>;
  country?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<Enum_Userspermissionsuser_Employmentstatus>;
  investmentSources?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  businessActivity?: Maybe<Scalars['String']>;
  yearsAtCurrentOccupation?: Maybe<Scalars['Int']>;
  positionHeld?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  physicalAddress?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  expectedFundingFrequency?: Maybe<Enum_Userspermissionsuser_Expectedfundingfrequency>;
  annualNetIncome?: Maybe<Enum_Userspermissionsuser_Annualnetincome>;
  accountName?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  swiftCode?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
  factaApplies?: Maybe<Scalars['Boolean']>;
  isPep?: Maybe<Scalars['Boolean']>;
  additionalInfo?: Maybe<Scalars['String']>;
  investmentHorizon?: Maybe<Enum_Userspermissionsuser_Investmenthorizon>;
  investmentKnowledge?: Maybe<Enum_Userspermissionsuser_Investmentknowledge>;
  investmentReaction?: Maybe<Enum_Userspermissionsuser_Investmentreaction>;
  onboardingPdf_connection?: Maybe<UploadFileRelationResponseCollection>;
  onboardingPdf: Array<Maybe<UploadFile>>;
  platformAccess?: Maybe<Enum_Userspermissionsuser_Platformaccess>;
  kestrelAccountNumber?: Maybe<Scalars['String']>;
  topup_requests_connection?: Maybe<TopupRequestRelationResponseCollection>;
  topup_requests: Array<Maybe<TopupRequest>>;
  proofOfAccount?: Maybe<UploadFile>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  apartmentNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  residencyStatus?: Maybe<Enum_Userspermissionsuser_Residencystatus>;
  dateOfOccupancy?: Maybe<Scalars['Date']>;
  portfolioValueLogs_connection?: Maybe<PortifolioValueLogRelationResponseCollection>;
  portfolioValueLogs: Array<Maybe<PortifolioValueLog>>;
  taxPinCertificate?: Maybe<UploadFile>;
  masterAsset?: Maybe<MasterBond>;
  masterBonds_connection?: Maybe<MasterBondRelationResponseCollection>;
  masterBonds: Array<Maybe<MasterBond>>;
  masterBond?: Maybe<MasterBond>;
  bondSellRequests_connection?: Maybe<BondSellRequestRelationResponseCollection>;
  bondSellRequests: Array<Maybe<BondSellRequest>>;
  conversations_connection?: Maybe<ConversationRelationResponseCollection>;
  conversations: Array<Maybe<Conversation>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** Google Static Map URL for the user's residence (if available) */
  mapUrl?: Maybe<Scalars['String']>;
};


export type UsersPermissionsUserNotifications_ConnectionArgs = {
  filters?: Maybe<NotificationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserNotificationsArgs = {
  filters?: Maybe<NotificationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserInvestments_ConnectionArgs = {
  filters?: Maybe<InvestmentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserInvestmentsArgs = {
  filters?: Maybe<InvestmentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserTransactions_ConnectionArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserTransactionsArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserBank_Withdraw_Requests_ConnectionArgs = {
  filters?: Maybe<BankWithdrawRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserBank_Withdraw_RequestsArgs = {
  filters?: Maybe<BankWithdrawRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserNotes_ConnectionArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserNotesArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserMaster_Notes_ConnectionArgs = {
  filters?: Maybe<MasterNoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserMaster_NotesArgs = {
  filters?: Maybe<MasterNoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserComments_ConnectionArgs = {
  filters?: Maybe<CommentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserCommentsArgs = {
  filters?: Maybe<CommentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserPurchaseRequests_ConnectionArgs = {
  filters?: Maybe<PurchaseRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserPurchaseRequestsArgs = {
  filters?: Maybe<PurchaseRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserRolloverResponses_ConnectionArgs = {
  filters?: Maybe<RolloverResponseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserRolloverResponsesArgs = {
  filters?: Maybe<RolloverResponseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserUpdateRequests_ConnectionArgs = {
  filters?: Maybe<UpdateRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserUpdateRequestsArgs = {
  filters?: Maybe<UpdateRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserOnboardingPdf_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserOnboardingPdfArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserTopup_Requests_ConnectionArgs = {
  filters?: Maybe<TopupRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserTopup_RequestsArgs = {
  filters?: Maybe<TopupRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserPortfolioValueLogs_ConnectionArgs = {
  filters?: Maybe<PortifolioValueLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserPortfolioValueLogsArgs = {
  filters?: Maybe<PortifolioValueLogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserMasterBonds_ConnectionArgs = {
  filters?: Maybe<MasterBondFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserMasterBondsArgs = {
  filters?: Maybe<MasterBondFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserBondSellRequests_ConnectionArgs = {
  filters?: Maybe<BondSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserBondSellRequestsArgs = {
  filters?: Maybe<BondSellRequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserConversations_ConnectionArgs = {
  filters?: Maybe<ConversationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserConversationsArgs = {
  filters?: Maybe<ConversationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  username?: Maybe<StringFilterInput>;
  email?: Maybe<StringFilterInput>;
  provider?: Maybe<StringFilterInput>;
  confirmed?: Maybe<BooleanFilterInput>;
  blocked?: Maybe<BooleanFilterInput>;
  role?: Maybe<UsersPermissionsRoleFiltersInput>;
  phoneNumber?: Maybe<StringFilterInput>;
  firstName?: Maybe<StringFilterInput>;
  lastName?: Maybe<StringFilterInput>;
  dateOfBirth?: Maybe<DateFilterInput>;
  idNumber?: Maybe<StringFilterInput>;
  mobileNumber?: Maybe<StringFilterInput>;
  officeNumber?: Maybe<StringFilterInput>;
  taxNumber?: Maybe<StringFilterInput>;
  citizenship?: Maybe<StringFilterInput>;
  residentialAddress?: Maybe<StringFilterInput>;
  reasonForInvesting?: Maybe<StringFilterInput>;
  agreedToInvestTerms?: Maybe<BooleanFilterInput>;
  onboardingStatus?: Maybe<StringFilterInput>;
  investorOnboardingSteps?: Maybe<StringFilterInput>;
  smileJobId?: Maybe<StringFilterInput>;
  smileVerificationStatus?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  currency?: Maybe<StringFilterInput>;
  notifications?: Maybe<NotificationFiltersInput>;
  investments?: Maybe<InvestmentFiltersInput>;
  transactions?: Maybe<TransactionFiltersInput>;
  bank_withdraw_requests?: Maybe<BankWithdrawRequestFiltersInput>;
  notes?: Maybe<NoteFiltersInput>;
  company?: Maybe<CompanyFiltersInput>;
  master_notes?: Maybe<MasterNoteFiltersInput>;
  comments?: Maybe<CommentFiltersInput>;
  purchaseRequests?: Maybe<PurchaseRequestFiltersInput>;
  rolloverResponses?: Maybe<RolloverResponseFiltersInput>;
  updateRequests?: Maybe<UpdateRequestFiltersInput>;
  wallet?: Maybe<WalletFiltersInput>;
  country?: Maybe<StringFilterInput>;
  employmentStatus?: Maybe<StringFilterInput>;
  investmentSources?: Maybe<StringFilterInput>;
  businessName?: Maybe<StringFilterInput>;
  businessActivity?: Maybe<StringFilterInput>;
  yearsAtCurrentOccupation?: Maybe<IntFilterInput>;
  positionHeld?: Maybe<StringFilterInput>;
  occupation?: Maybe<StringFilterInput>;
  physicalAddress?: Maybe<StringFilterInput>;
  postalCode?: Maybe<StringFilterInput>;
  postalAddress?: Maybe<StringFilterInput>;
  expectedFundingFrequency?: Maybe<StringFilterInput>;
  annualNetIncome?: Maybe<StringFilterInput>;
  accountName?: Maybe<StringFilterInput>;
  bankName?: Maybe<StringFilterInput>;
  branch?: Maybe<StringFilterInput>;
  accountNumber?: Maybe<StringFilterInput>;
  swiftCode?: Maybe<StringFilterInput>;
  routingNumber?: Maybe<StringFilterInput>;
  factaApplies?: Maybe<BooleanFilterInput>;
  isPep?: Maybe<BooleanFilterInput>;
  additionalInfo?: Maybe<StringFilterInput>;
  investmentHorizon?: Maybe<StringFilterInput>;
  investmentKnowledge?: Maybe<StringFilterInput>;
  investmentReaction?: Maybe<StringFilterInput>;
  platformAccess?: Maybe<StringFilterInput>;
  kestrelAccountNumber?: Maybe<StringFilterInput>;
  topup_requests?: Maybe<TopupRequestFiltersInput>;
  streetName?: Maybe<StringFilterInput>;
  streetNumber?: Maybe<StringFilterInput>;
  apartmentNumber?: Maybe<StringFilterInput>;
  city?: Maybe<StringFilterInput>;
  residencyStatus?: Maybe<StringFilterInput>;
  dateOfOccupancy?: Maybe<DateFilterInput>;
  portfolioValueLogs?: Maybe<PortifolioValueLogFiltersInput>;
  masterAsset?: Maybe<MasterBondFiltersInput>;
  masterBonds?: Maybe<MasterBondFiltersInput>;
  masterBond?: Maybe<MasterBondFiltersInput>;
  bondSellRequests?: Maybe<BondSellRequestFiltersInput>;
  conversations?: Maybe<ConversationFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsUserFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsUserFiltersInput>>>;
  not?: Maybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  idNumber?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  officeNumber?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  citizenship?: Maybe<Scalars['String']>;
  residentialAddress?: Maybe<Scalars['String']>;
  reasonForInvesting?: Maybe<Scalars['String']>;
  agreedToInvestTerms?: Maybe<Scalars['Boolean']>;
  onboardingStatus?: Maybe<Enum_Userspermissionsuser_Onboardingstatus>;
  investorOnboardingSteps?: Maybe<Enum_Userspermissionsuser_Investoronboardingsteps>;
  smileJobId?: Maybe<Scalars['String']>;
  smileVerificationStatus?: Maybe<Enum_Userspermissionsuser_Smileverificationstatus>;
  type?: Maybe<Enum_Userspermissionsuser_Type>;
  currency?: Maybe<Enum_Userspermissionsuser_Currency>;
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  investments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bank_withdraw_requests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  company?: Maybe<Scalars['ID']>;
  master_notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  comments?: Maybe<Array<Maybe<Scalars['ID']>>>;
  purchaseRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  rolloverResponses?: Maybe<Array<Maybe<Scalars['ID']>>>;
  updateRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  wallet?: Maybe<Scalars['ID']>;
  nationalId?: Maybe<Scalars['ID']>;
  profilePicture?: Maybe<Scalars['ID']>;
  selfie?: Maybe<Scalars['ID']>;
  certifiedId?: Maybe<Scalars['ID']>;
  country?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<Enum_Userspermissionsuser_Employmentstatus>;
  investmentSources?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  businessActivity?: Maybe<Scalars['String']>;
  yearsAtCurrentOccupation?: Maybe<Scalars['Int']>;
  positionHeld?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  physicalAddress?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  expectedFundingFrequency?: Maybe<Enum_Userspermissionsuser_Expectedfundingfrequency>;
  annualNetIncome?: Maybe<Enum_Userspermissionsuser_Annualnetincome>;
  accountName?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  swiftCode?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
  factaApplies?: Maybe<Scalars['Boolean']>;
  isPep?: Maybe<Scalars['Boolean']>;
  additionalInfo?: Maybe<Scalars['String']>;
  investmentHorizon?: Maybe<Enum_Userspermissionsuser_Investmenthorizon>;
  investmentKnowledge?: Maybe<Enum_Userspermissionsuser_Investmentknowledge>;
  investmentReaction?: Maybe<Enum_Userspermissionsuser_Investmentreaction>;
  onboardingPdf?: Maybe<Array<Maybe<Scalars['ID']>>>;
  platformAccess?: Maybe<Enum_Userspermissionsuser_Platformaccess>;
  kestrelAccountNumber?: Maybe<Scalars['String']>;
  topup_requests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  proofOfAccount?: Maybe<Scalars['ID']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  apartmentNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  residencyStatus?: Maybe<Enum_Userspermissionsuser_Residencystatus>;
  dateOfOccupancy?: Maybe<Scalars['Date']>;
  portfolioValueLogs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  taxPinCertificate?: Maybe<Scalars['ID']>;
  masterAsset?: Maybe<Scalars['ID']>;
  masterBonds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  masterBond?: Maybe<Scalars['ID']>;
  bondSellRequests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  conversations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  password?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  nodes: Array<UsersPermissionsUser>;
};

export type Wallet = {
  __typename?: 'Wallet';
  documentId: Scalars['ID'];
  balance?: Maybe<Scalars['Float']>;
  kesBalance?: Maybe<Scalars['Float']>;
  user?: Maybe<UsersPermissionsUser>;
  transactions_connection?: Maybe<TransactionRelationResponseCollection>;
  transactions: Array<Maybe<Transaction>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type WalletTransactions_ConnectionArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type WalletTransactionsArgs = {
  filters?: Maybe<TransactionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WalletEntityResponseCollection = {
  __typename?: 'WalletEntityResponseCollection';
  nodes: Array<Wallet>;
  pageInfo: Pagination;
};

export type WalletFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  balance?: Maybe<FloatFilterInput>;
  kesBalance?: Maybe<FloatFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  transactions?: Maybe<TransactionFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<WalletFiltersInput>>>;
  or?: Maybe<Array<Maybe<WalletFiltersInput>>>;
  not?: Maybe<WalletFiltersInput>;
};

export type WalletInput = {
  balance?: Maybe<Scalars['Float']>;
  kesBalance?: Maybe<Scalars['Float']>;
  user?: Maybe<Scalars['ID']>;
  transactions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type WelcomeSlide = {
  __typename?: 'WelcomeSlide';
  documentId: Scalars['ID'];
  welcomeSlides?: Maybe<Array<Maybe<ComponentSharedWelcomeSlides>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type WelcomeSlideWelcomeSlidesArgs = {
  filters?: Maybe<ComponentSharedWelcomeSlidesFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WelcomeSlideInput = {
  welcomeSlides?: Maybe<Array<Maybe<ComponentSharedWelcomeSlidesInput>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type NoteFragment = (
  { __typename?: 'Note' }
  & Pick<Note, 'documentId' | 'submittedAt' | 'title' | 'interestFrequency' | 'purchaseFee' | 'shortHoldFee' | 'shortHoldDescription' | 'compoundingFrequency' | 'assetType' | 'fundManager' | 'followup' | 'lockDown' | 'purchasePrice' | 'managementFee' | 'interestFrequencyDescription' | 'type' | 'numberOfPaidInterest' | 'potentialRisks' | 'masterNoteMarketValue' | 'noteMarketValue' | 'payoutDate' | 'nextInterestPayment' | 'sellFee' | 'shortHoldFeeDuration' | 'description' | 'amount' | 'amountNeeded' | 'interestRate' | 'minInvestment' | 'serviceInterestRate' | 'noteStatus' | 'currency' | 'proposedDateOfIssue' | 'purposeOfIssue' | 'noteType' | 'currentStep'>
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & CompanyFragment
  )>, masterNote?: Maybe<(
    { __typename?: 'MasterNote' }
    & MasterNoteFragment
  )>, memorandum: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )>>, comments: Array<Maybe<(
    { __typename?: 'Comment' }
    & Pick<Comment, 'documentId' | 'createdAt' | 'message' | 'noteType'>
    & { user?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'firstName' | 'lastName'>
      & { profilePicture?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'url'>
      )> }
    )> }
  )>>, investments: Array<Maybe<(
    { __typename?: 'Investment' }
    & Pick<Investment, 'amount' | 'investmentStatus'>
  )>> }
);

export type BondFragment = (
  { __typename?: 'Bond' }
  & Pick<Bond, 'documentId' | 'title' | 'numberOfTokens' | 'interestRate' | 'purchasePrice' | 'yieldToMaturity' | 'bondType' | 'bondStatus' | 'proposedDateOfIssue' | 'purchaseFee' | 'sellFee' | 'shortHoldFee' | 'shortHoldDuration' | 'managementFee' | 'contractAddress' | 'investedTokens'>
  & { masterBond?: Maybe<(
    { __typename?: 'MasterBond' }
    & Pick<MasterBond, 'documentId' | 'title' | 'interestFrequency' | 'bondPrice' | 'maturityDate' | 'interestRate' | 'faceValuePerToken' | 'currency' | 'MasterBondStatus' | 'contractAddress'>
    & { supportDocuments: Array<Maybe<(
      { __typename?: 'UploadFile' }
      & UploadFileFragment
    )>> }
  )> }
);

export type BondForInvestorFragment = (
  { __typename?: 'BondForInvestorPayload' }
  & Pick<BondForInvestorPayload, 'documentId' | 'title' | 'numberOfTokens' | 'investedTokens' | 'interestRate' | 'purchasePrice' | 'yieldToMaturity' | 'estimatedYTM' | 'bondType' | 'bondStatus' | 'proposedDateOfIssue' | 'purchaseFee' | 'sellFee' | 'shortHoldFee' | 'shortHoldDuration' | 'managementFee' | 'contractAddress' | 'tokenPrice' | 'bondTokenPrice' | 'createdAt' | 'updatedAt'>
  & { masterBond?: Maybe<(
    { __typename?: 'MasterBond' }
    & Pick<MasterBond, 'documentId' | 'title' | 'maturityDate' | 'interestRate' | 'faceValuePerToken' | 'currency' | 'MasterBondStatus' | 'interestFrequency' | 'bondPrice' | 'nextInterestPayment' | 'contractAddress' | 'description' | 'potentialRisks'>
  )> }
);

export type CompanyFragment = (
  { __typename?: 'Company' }
  & Pick<Company, 'documentId' | 'name' | 'companyType' | 'industryType' | 'activeSince' | 'briefDescription' | 'platformUseReason' | 'registrationNumber' | 'registeredAt' | 'countryOfRegistration' | 'vatNumber' | 'taxNumber' | 'formattedAddress' | 'netWorth' | 'grossIncome' | 'totalDebt'>
  & { logo?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )>, bankingInformation?: Maybe<(
    { __typename?: 'BankingInformation' }
    & Pick<BankingInformation, 'documentId' | 'bankName' | 'accountHolder' | 'typeOfAccount' | 'accountNumber'>
  )>, informationMemorandum: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, certificateOfIncorporation: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, memorandumAndArticlesOfAssociation: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, boardOfDirectorsApproval: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, reportingAccountsReport: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, financialStatements: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, companyTAXCertificate: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, relevantCompanyDocuments: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, companyConsent: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>> }
);

export type FinancialSummaryFragment = (
  { __typename?: 'FinancialSummary' }
  & Pick<FinancialSummary, 'documentId' | 'netWorth' | 'totalDeptOutstanding' | 'totalDeptOutstandingOther' | 'grossIncome' | 'grossProfit' | 'operatingProfit' | 'netProfit' | 'detailsOfDefaultCP' | 'detailsOfDefaultDelay'>
);

export type MasterBondFragment = (
  { __typename?: 'MasterBond' }
  & Pick<MasterBond, 'documentId' | 'title' | 'interestRate' | 'interestFrequency' | 'maturityDate' | 'bondPrice' | 'faceValuePerToken' | 'initialFaceValuePerToken' | 'totalTokens' | 'currency' | 'MasterBondStatus' | 'contractAddress' | 'description' | 'potentialRisks' | 'nextInterestPayment'>
  & { faceValue: MasterBond['faceValuePerToken'], marketValue: MasterBond['bondPrice'] }
  & { supportDocuments: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, bonds: Array<Maybe<(
    { __typename?: 'Bond' }
    & Pick<Bond, 'documentId' | 'investedTokens'>
    & { holdings: Array<Maybe<(
      { __typename?: 'BondHolding' }
      & Pick<BondHolding, 'documentId'>
      & { user?: Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'documentId'>
      )> }
    )>> }
  )>>, investors: Array<Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'documentId'>
  )>>, user?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'documentId' | 'firstName' | 'lastName'>
  )> }
);

export type MasterNoteFragment = (
  { __typename?: 'MasterNote' }
  & Pick<MasterNote, 'documentId' | 'title' | 'type' | 'interestFrequency' | 'assetType' | 'fundManager' | 'compoundingFrequency' | 'interestRate' | 'currentStep' | 'currency' | 'maturityDate' | 'description' | 'potentialRisks' | 'marketValue' | 'masterNoteStatus'>
  & { memorandum: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>> }
);

export type RealEstateAssetFragment = (
  { __typename?: 'RealEstateAsset' }
  & Pick<RealEstateAsset, 'documentId' | 'address' | 'assetStatus' | 'title' | 'currency' | 'tokenPrice' | 'purchaseFee' | 'sellFee' | 'propertyName' | 'location' | 'propertyType' | 'dateBuilt' | 'soldSupply' | 'sqft' | 'beds' | 'bathrooms' | 'symbol' | 'decimals' | 'totalSupply' | 'investedSupply' | 'lockDownMonths' | 'value' | 'expectedRent' | 'expectedExpenses' | 'expectedYield' | 'propertyDescription' | 'marketDescription' | 'expensesInfo'>
  & { images: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, documents: Array<Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>>, user?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & UserFragment
  )> }
);

export type TransactionFragment = (
  { __typename?: 'Transaction' }
  & Pick<Transaction, 'documentId' | 'createdAt' | 'updatedAt' | 'transactionNumber' | 'amount' | 'transactionStatus' | 'description' | 'mpesaNumber' | 'merchantRequestID' | 'checkoutRequestID' | 'mpesaReceiptNumber' | 'transactionType'>
  & { invoice?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'url'>
  )> }
);

export type UploadFileFragment = (
  { __typename?: 'UploadFile' }
  & Pick<UploadFile, 'documentId' | 'name' | 'alternativeText' | 'caption' | 'width' | 'height' | 'formats' | 'hash' | 'ext' | 'mime' | 'size' | 'url' | 'previewUrl' | 'provider' | 'provider_metadata'>
);

export type UserFragment = (
  { __typename?: 'UsersPermissionsUser' }
  & Pick<UsersPermissionsUser, 'documentId' | 'email' | 'confirmed' | 'blocked' | 'phoneNumber' | 'firstName' | 'lastName' | 'type' | 'dateOfBirth' | 'idNumber' | 'mobileNumber' | 'officeNumber' | 'currency' | 'taxNumber' | 'citizenship' | 'residentialAddress' | 'reasonForInvesting' | 'agreedToInvestTerms' | 'onboardingStatus' | 'investorOnboardingSteps' | 'smileVerificationStatus' | 'employmentStatus' | 'businessName' | 'occupation' | 'positionHeld' | 'yearsAtCurrentOccupation' | 'businessActivity' | 'physicalAddress' | 'postalCode' | 'postalAddress' | 'investmentSources' | 'annualNetIncome' | 'additionalInfo' | 'factaApplies' | 'isPep' | 'bankName' | 'accountName' | 'accountNumber' | 'swiftCode' | 'streetName' | 'streetNumber' | 'city' | 'apartmentNumber' | 'residencyStatus' | 'dateOfOccupancy' | 'routingNumber' | 'branch' | 'expectedFundingFrequency'>
  & { role?: Maybe<(
    { __typename?: 'UsersPermissionsRole' }
    & Pick<UsersPermissionsRole, 'type'>
  )>, profilePicture?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>, nationalId?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>, selfie?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>, taxPinCertificate?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>, company?: Maybe<(
    { __typename?: 'Company' }
    & CompanyFragment
  )>, certifiedId?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )>, proofOfAccount?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )> }
);

export type SubmitBankWithdrawRequestMutationVariables = Exact<{
  input?: Maybe<SubmitBankWithdrawRequestInput>;
}>;


export type SubmitBankWithdrawRequestMutation = (
  { __typename?: 'Mutation' }
  & { submitBankWithdrawRequest?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateBondMutationVariables = Exact<{
  input: CreateBondInput;
}>;


export type CreateBondMutation = (
  { __typename?: 'Mutation' }
  & { createBond?: Maybe<(
    { __typename?: 'Bond' }
    & BondFragment
  )> }
);

export type ReviewBondMutationVariables = Exact<{
  input: ReviewBondInput;
}>;


export type ReviewBondMutation = (
  { __typename?: 'Mutation' }
  & { reviewBond?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type PurchaseBondTokensMutationVariables = Exact<{
  input: PurchaseBondTokensInput;
}>;


export type PurchaseBondTokensMutation = (
  { __typename?: 'Mutation' }
  & { purchaseBondTokens?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateBondSellRequestMutationVariables = Exact<{
  input: CreateBondSellRequestInput;
}>;


export type CreateBondSellRequestMutation = (
  { __typename?: 'Mutation' }
  & { createBondSellRequest?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateBondPayoutRequestMutationVariables = Exact<{
  input: CreateBondPayoutRequestInput;
}>;


export type CreateBondPayoutRequestMutation = (
  { __typename?: 'Mutation' }
  & { createBondPayoutRequest?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateBondMaturityPayoutRequestMutationVariables = Exact<{
  input: CreateBondMaturityPayoutRequestInput;
}>;


export type CreateBondMaturityPayoutRequestMutation = (
  { __typename?: 'Mutation' }
  & { createBondMaturityPayoutRequest?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type UpdateBondPriceMutationVariables = Exact<{
  input: UpdateBondPriceInput;
}>;


export type UpdateBondPriceMutation = (
  { __typename?: 'Mutation' }
  & { updateBondPrice?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CalculateInvestmentMutationVariables = Exact<{
  input?: Maybe<CalculateInvestmentInput>;
}>;


export type CalculateInvestmentMutation = (
  { __typename?: 'Mutation' }
  & { calculateInvestment?: Maybe<(
    { __typename?: 'CalculateInvestmentPayload' }
    & Pick<CalculateInvestmentPayload, 'interestRate' | 'investmentTerm' | 'investmentDate' | 'dueDate' | 'purchasePrice' | 'investorTotalReturn'>
  )> }
);

export type ChangeAppUseMutationVariables = Exact<{
  input?: Maybe<ChangeAppUseInput>;
}>;


export type ChangeAppUseMutation = (
  { __typename?: 'Mutation' }
  & { changeAppUse?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & UserFragment
  )> }
);

export type ChangeCurrencyMutationVariables = Exact<{
  input?: Maybe<ChangeCurrencyInput>;
}>;


export type ChangeCurrencyMutation = (
  { __typename?: 'Mutation' }
  & { changeCurrency?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'currency'>
  )> }
);

export type ChangeMyPasswordMutationVariables = Exact<{
  input?: Maybe<ChangePasswordInput>;
}>;


export type ChangeMyPasswordMutation = (
  { __typename?: 'Mutation' }
  & { changeMyPassword?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateMyNoteMutationVariables = Exact<{
  input?: Maybe<CreateMyNoteInput>;
}>;


export type CreateMyNoteMutation = (
  { __typename?: 'Mutation' }
  & { createMyNote?: Maybe<(
    { __typename?: 'Note' }
    & NoteFragment
  )> }
);

export type HelpAndSupportMutationVariables = Exact<{
  input?: Maybe<SupportRequestInput>;
}>;


export type HelpAndSupportMutation = (
  { __typename?: 'Mutation' }
  & { helpAndSupport?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type BuyInvestmentMutationVariables = Exact<{
  input?: Maybe<BuyInvestmentInput>;
}>;


export type BuyInvestmentMutation = (
  { __typename?: 'Mutation' }
  & { buyInvestment?: Maybe<(
    { __typename?: 'Transaction' }
    & Pick<Transaction, 'documentId' | 'amount'>
  )> }
);

export type CalculateSellMutationVariables = Exact<{
  input?: Maybe<CalculateSellInput>;
}>;


export type CalculateSellMutation = (
  { __typename?: 'Mutation' }
  & { calculateSell?: Maybe<(
    { __typename?: 'CalculateSellPayload' }
    & Pick<CalculateSellPayload, 'customerAmount' | 'deadline' | 'sellAmount' | 'shortHoldFeeAmount' | 'sellFeeAmount'>
  )> }
);

export type CreateSellMutationVariables = Exact<{
  input?: Maybe<CreateSellInput>;
}>;


export type CreateSellMutation = (
  { __typename?: 'Mutation' }
  & { createSell?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type InvestorOnboardingMutationVariables = Exact<{
  input?: Maybe<InvestorOnboardingInput>;
}>;


export type InvestorOnboardingMutation = (
  { __typename?: 'Mutation' }
  & { investorOnboarding?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'documentId'>
  )> }
);

export type CreateBaseMasterBondMutationVariables = Exact<{
  input: CreateBaseMasterBondInput;
}>;


export type CreateBaseMasterBondMutation = (
  { __typename?: 'Mutation' }
  & { createBaseMasterBond?: Maybe<(
    { __typename?: 'MasterBond' }
    & MasterBondFragment
  )> }
);

export type UpdateMasterBondMutationVariables = Exact<{
  input: UpdateMasterBondInput;
}>;


export type UpdateMasterBondMutation = (
  { __typename?: 'Mutation' }
  & { updateMasterBond?: Maybe<(
    { __typename?: 'MasterBond' }
    & MasterBondFragment
  )> }
);

export type ReviewMasterBondMutationVariables = Exact<{
  input: ReviewMasterBondInput;
}>;


export type ReviewMasterBondMutation = (
  { __typename?: 'Mutation' }
  & { reviewMasterBond?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type ApproveMasterBondMutationVariables = Exact<{
  input: ApproveMasterBondInput;
}>;


export type ApproveMasterBondMutation = (
  { __typename?: 'Mutation' }
  & { approveMasterBond?: Maybe<(
    { __typename?: 'MasterBond' }
    & MasterBondFragment
  )> }
);

export type CreateMasterNoteByUserMutationVariables = Exact<{
  input?: Maybe<CreateMasterNoteByUserInput>;
}>;


export type CreateMasterNoteByUserMutation = (
  { __typename?: 'Mutation' }
  & { createMasterNoteByUser?: Maybe<(
    { __typename?: 'MasterNote' }
    & MasterNoteFragment
  )> }
);

export type ApproveNoteMutationVariables = Exact<{
  input?: Maybe<ApproveNoteInput>;
}>;


export type ApproveNoteMutation = (
  { __typename?: 'Mutation' }
  & { approveNote?: Maybe<(
    { __typename?: 'Note' }
    & NoteFragment
  )> }
);

export type DeclineNoteMutationVariables = Exact<{
  input?: Maybe<DeclineNoteInput>;
}>;


export type DeclineNoteMutation = (
  { __typename?: 'Mutation' }
  & { declineNote?: Maybe<(
    { __typename?: 'Note' }
    & NoteFragment
  )> }
);

export type RequestMoreInfoMutationVariables = Exact<{
  input?: Maybe<RequestMoreInfoInput>;
}>;


export type RequestMoreInfoMutation = (
  { __typename?: 'Mutation' }
  & { requestMoreInfo?: Maybe<(
    { __typename?: 'Note' }
    & NoteFragment
  )> }
);

export type CreateInternalCommentMutationVariables = Exact<{
  input?: Maybe<CreateInternalCommentInput>;
}>;


export type CreateInternalCommentMutation = (
  { __typename?: 'Mutation' }
  & { createInternalComment?: Maybe<(
    { __typename?: 'Comment' }
    & Pick<Comment, 'documentId' | 'message'>
  )> }
);

export type UpdateMarketValueMutationVariables = Exact<{
  input?: Maybe<MarketValueInput>;
}>;


export type UpdateMarketValueMutation = (
  { __typename?: 'Mutation' }
  & { updateMarketValue?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type ChangeStatusMutationVariables = Exact<{
  input?: Maybe<ChangeStatusInput>;
}>;


export type ChangeStatusMutation = (
  { __typename?: 'Mutation' }
  & { changeStatus?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type ArchiveNotificationMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type ArchiveNotificationMutation = (
  { __typename?: 'Mutation' }
  & { archiveNotification?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type OnboardingMutationVariables = Exact<{
  input?: Maybe<OnboardingInput>;
  companyInformation?: Maybe<OnboardingCompanyInput>;
}>;


export type OnboardingMutation = (
  { __typename?: 'Mutation' }
  & { onboarding?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & UserFragment
  )> }
);

export type SendPayoutByUserMutationVariables = Exact<{
  input?: Maybe<SendPayoutByUserInput>;
}>;


export type SendPayoutByUserMutation = (
  { __typename?: 'Mutation' }
  & { sendPayoutByUser?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type SendInterestMutationVariables = Exact<{
  input?: Maybe<SendInterestInput>;
}>;


export type SendInterestMutation = (
  { __typename?: 'Mutation' }
  & { sendInterest?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateRealEstateAssetMutationVariables = Exact<{
  input?: Maybe<CreateRealEstateAssetBaseInput>;
}>;


export type CreateRealEstateAssetMutation = (
  { __typename?: 'Mutation' }
  & { createRealEstateAssetBase?: Maybe<(
    { __typename?: 'RealEstateAsset' }
    & RealEstateAssetFragment
  )> }
);

export type UpdateRealEstateAssetMutationVariables = Exact<{
  input?: Maybe<UpdateRealEstateAssetDetailsInput>;
}>;


export type UpdateRealEstateAssetMutation = (
  { __typename?: 'Mutation' }
  & { updateRealEstateAssetDetails?: Maybe<(
    { __typename?: 'RealEstateAsset' }
    & RealEstateAssetFragment
  )> }
);

export type SubmitRealEstateAssetMutationVariables = Exact<{
  input?: Maybe<SubmitRealEstateAssetInput>;
}>;


export type SubmitRealEstateAssetMutation = (
  { __typename?: 'Mutation' }
  & { submitRealEstateAsset?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type ReviewRealEstateAssetMutationVariables = Exact<{
  input: ReviewRealEstateAssetInput;
}>;


export type ReviewRealEstateAssetMutation = (
  { __typename?: 'Mutation' }
  & { reviewRealEstateAsset?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateRealEstatePriceLogMutationVariables = Exact<{
  input: CreateRealEstatePriceLogInput;
}>;


export type CreateRealEstatePriceLogMutation = (
  { __typename?: 'Mutation' }
  & { createMyRealEstatePriceLog?: Maybe<(
    { __typename?: 'RealEstatePriceLog' }
    & Pick<RealEstatePriceLog, 'documentId' | 'value' | 'logStatus' | 'approvedAt' | 'createdAt'>
    & { realEstateAsset?: Maybe<(
      { __typename?: 'RealEstateAsset' }
      & Pick<RealEstateAsset, 'documentId' | 'title'>
    )> }
  )> }
);

export type PurchaseRealEstateAssetMutationVariables = Exact<{
  input: PurchaseRealEstateAssetInput;
}>;


export type PurchaseRealEstateAssetMutation = (
  { __typename?: 'Mutation' }
  & { purchaseRealEstateAsset?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateRealEstateSellMutationVariables = Exact<{
  input: CreateRealEstateSellInput;
}>;


export type CreateRealEstateSellMutation = (
  { __typename?: 'Mutation' }
  & { createRealEstateSell?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type MintTokensMutationVariables = Exact<{
  input: MintRealEstateAssetTokensInput;
}>;


export type MintTokensMutation = (
  { __typename?: 'Mutation' }
  & { mintRealEstateAssetTokens?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type CreateRealEstatePayoutRequestMutationVariables = Exact<{
  input: CreatePayoutRequestInput;
}>;


export type CreateRealEstatePayoutRequestMutation = (
  { __typename?: 'Mutation' }
  & { createRealEstatePayoutRequest?: Maybe<(
    { __typename?: 'RealEstatePayout' }
    & Pick<RealEstatePayout, 'documentId' | 'isYield' | 'amount' | 'payoutStatus'>
    & { realEstateAsset?: Maybe<(
      { __typename?: 'RealEstateAsset' }
      & Pick<RealEstateAsset, 'documentId' | 'title'>
    )> }
  )> }
);

export type RequestCompanyUpdateMutationVariables = Exact<{
  input?: Maybe<RequestCompanyUpdateInput>;
}>;


export type RequestCompanyUpdateMutation = (
  { __typename?: 'Mutation' }
  & { requestCompanyUpdate?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type RequestMasterNoteUpdateMutationVariables = Exact<{
  input?: Maybe<RequestMasterNoteUpdateInput>;
  type?: Maybe<Enum_Updaterequest_Updatetype>;
}>;


export type RequestMasterNoteUpdateMutation = (
  { __typename?: 'Mutation' }
  & { requestMasterNoteUpdate?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type RequestProfileUpdateMutationVariables = Exact<{
  input?: Maybe<RequestProfileUpdateInput>;
}>;


export type RequestProfileUpdateMutation = (
  { __typename?: 'Mutation' }
  & { requestProfileUpdate?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type SubmitNoteMutationVariables = Exact<{
  input?: Maybe<SubmitNoteInput>;
}>;


export type SubmitNoteMutation = (
  { __typename?: 'Mutation' }
  & { submitNote?: Maybe<(
    { __typename?: 'Note' }
    & NoteFragment
  )> }
);

export type UpdateCompanyDocumentsMutationVariables = Exact<{
  input?: Maybe<CompanyDocumentsInput>;
}>;


export type UpdateCompanyDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { updateCompanyDocuments?: Maybe<(
    { __typename?: 'Company' }
    & CompanyFragment
  )> }
);

export type UpdateOfcreateBankingDetailsMutationVariables = Exact<{
  input?: Maybe<UpdateOrCreateMyBankingInput>;
}>;


export type UpdateOfcreateBankingDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateOrCreateMyBankingInformation?: Maybe<(
    { __typename?: 'BankingInformation' }
    & Pick<BankingInformation, 'documentId' | 'bankName' | 'accountHolder' | 'typeOfAccount' | 'accountNumber'>
  )> }
);

export type UpdateOrCreateMyFinancialSummaryMutationVariables = Exact<{
  input?: Maybe<UpdateOrCreateMyFinancialSummaryInput>;
}>;


export type UpdateOrCreateMyFinancialSummaryMutation = (
  { __typename?: 'Mutation' }
  & { updateOrCreateMyFinancialSummary?: Maybe<(
    { __typename?: 'FinancialSummary' }
    & FinancialSummaryFragment
  )> }
);

export type UpdateRegulatoryProfileMutationVariables = Exact<{
  input?: Maybe<UpdateRegulatoryProfileInput>;
}>;


export type UpdateRegulatoryProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateRegulatoryProfile?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & UserFragment
  )> }
);

export type TopupMyWalletMutationVariables = Exact<{
  input?: Maybe<TopupMyWalletInput>;
}>;


export type TopupMyWalletMutation = (
  { __typename?: 'Mutation' }
  & { topupMyWallet?: Maybe<(
    { __typename?: 'Transaction' }
    & Pick<Transaction, 'documentId' | 'merchantRequestID'>
  )> }
);

export type SubmitTopupRequestMutationVariables = Exact<{
  input?: Maybe<SubmitTopupRequestInput>;
}>;


export type SubmitTopupRequestMutation = (
  { __typename?: 'Mutation' }
  & { submitTopupRequest?: Maybe<(
    { __typename?: 'OkResponse' }
    & Pick<OkResponse, 'ok'>
  )> }
);

export type GetAvailableBondsQueryVariables = Exact<{
  input?: Maybe<AvailableBondsInput>;
}>;


export type GetAvailableBondsQuery = (
  { __typename?: 'Query' }
  & { getAvailableBonds?: Maybe<(
    { __typename?: 'GetAvailableBondsPayload' }
    & Pick<GetAvailableBondsPayload, 'pages' | 'page' | 'count'>
    & { bonds?: Maybe<Array<Maybe<(
      { __typename?: 'BondForInvestorPayload' }
      & BondForInvestorFragment
    )>>> }
  )> }
);

export type GetBondForInvestorQueryVariables = Exact<{
  bondId: Scalars['String'];
}>;


export type GetBondForInvestorQuery = (
  { __typename?: 'Query' }
  & { getBondForInvestor?: Maybe<(
    { __typename?: 'BondForInvestorPayload' }
    & BondForInvestorFragment
  )> }
);

export type GetMyBondsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  bondType?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetMyBondsQuery = (
  { __typename?: 'Query' }
  & { getMyBonds?: Maybe<(
    { __typename?: 'GetMyBondsPayload' }
    & Pick<GetMyBondsPayload, 'pages' | 'page' | 'count'>
    & { bonds?: Maybe<Array<Maybe<(
      { __typename?: 'Bond' }
      & BondFragment
    )>>> }
  )> }
);

export type GetBondsByMasterBondQueryVariables = Exact<{
  masterBondId: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  bondType?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetBondsByMasterBondQuery = (
  { __typename?: 'Query' }
  & { getBondsByMasterBond?: Maybe<(
    { __typename?: 'GetBondsByMasterBondPayload' }
    & Pick<GetBondsByMasterBondPayload, 'pages' | 'page' | 'count'>
    & { bonds?: Maybe<Array<Maybe<(
      { __typename?: 'Bond' }
      & BondFragment
    )>>> }
  )> }
);

export type GetBondByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBondByIdQuery = (
  { __typename?: 'Query' }
  & { getBondById?: Maybe<(
    { __typename?: 'Bond' }
    & BondFragment
  )> }
);

export type GetBondsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetBondsQuery = (
  { __typename?: 'Query' }
  & { getBonds?: Maybe<(
    { __typename?: 'GetBondsPayload' }
    & Pick<GetBondsPayload, 'pages' | 'page' | 'count'>
    & { bonds?: Maybe<Array<Maybe<(
      { __typename?: 'Bond' }
      & BondFragment
    )>>> }
  )> }
);

export type GetMySuccessfulBondHoldingsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
}>;


export type GetMySuccessfulBondHoldingsQuery = (
  { __typename?: 'Query' }
  & { getMySuccessfulBondHoldings?: Maybe<Array<Maybe<(
    { __typename?: 'BondHoldingPayload' }
    & Pick<BondHoldingPayload, 'documentId' | 'quantity' | 'avgCostBasis' | 'currency' | 'holdingStatus' | 'createdAt' | 'updatedAt'>
    & { bond?: Maybe<(
      { __typename?: 'BondForInvestorPayload' }
      & BondForInvestorFragment
    )> }
  )>>> }
);

export type GetBondPriceLogsQueryVariables = Exact<{
  masterBondId: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetBondPriceLogsQuery = (
  { __typename?: 'Query' }
  & { getBondPriceLogs?: Maybe<(
    { __typename?: 'BondPriceLogsPayload' }
    & Pick<BondPriceLogsPayload, 'page' | 'pages' | 'total'>
    & { logs: Array<Maybe<(
      { __typename?: 'BondPriceLogEntry' }
      & Pick<BondPriceLogEntry, 'documentId' | 'newPrice' | 'previousPrice' | 'logStatus' | 'approvedAt' | 'submittedBy' | 'createdAt'>
    )>> }
  )> }
);

export type CountMyActiveNotesQueryVariables = Exact<{
  currency?: Maybe<Enum_Note_Currency>;
}>;


export type CountMyActiveNotesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'countMyActivePapers'>
);

export type GetAvailableNotesQueryVariables = Exact<{
  input?: Maybe<AvailableNotesInput>;
}>;


export type GetAvailableNotesQuery = (
  { __typename?: 'Query' }
  & { getAvailableNotes?: Maybe<(
    { __typename?: 'GetAvailableNotesPayload' }
    & Pick<GetAvailableNotesPayload, 'page' | 'pages'>
    & { notes?: Maybe<Array<Maybe<(
      { __typename?: 'NoteForInvestorPayload' }
      & Pick<NoteForInvestorPayload, 'amountInvested' | 'isAnInvestorOfCP'>
      & { note?: Maybe<(
        { __typename?: 'Note' }
        & NoteFragment
      )> }
    )>>> }
  )> }
);

export type GetAvailableRealEstateAssetsQueryVariables = Exact<{
  input?: Maybe<AvailableRealEstateAssetsInput>;
}>;


export type GetAvailableRealEstateAssetsQuery = (
  { __typename?: 'Query' }
  & { getAvailableRealEstateAssets?: Maybe<(
    { __typename?: 'GetAvailableRealEstateAssetsPayload' }
    & Pick<GetAvailableRealEstateAssetsPayload, 'pages' | 'page'>
    & { realEstateAssets?: Maybe<Array<Maybe<(
      { __typename?: 'RealEstateAssetForInvestorPayload' }
      & Pick<RealEstateAssetForInvestorPayload, 'isAnInvestorOfAsset' | 'investorCount' | 'fundingPercentage' | 'unitsHeld'>
      & { asset?: Maybe<(
        { __typename?: 'RealEstateAsset' }
        & Pick<RealEstateAsset, 'documentId' | 'title' | 'propertyName' | 'location' | 'tokenPrice' | 'purchaseFee' | 'soldSupply' | 'currency' | 'propertyType' | 'value' | 'totalSupply' | 'expectedYield' | 'expectedRent' | 'assetStatus' | 'investedSupply'>
        & { company?: Maybe<(
          { __typename?: 'Company' }
          & Pick<Company, 'documentId' | 'name'>
          & { logo?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'documentId' | 'url'>
          )> }
        )>, images: Array<Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url' | 'alternativeText' | 'name'>
        )>> }
      )> }
    )>>> }
  )> }
);

export type GetBondCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBondCountsQuery = (
  { __typename?: 'Query' }
  & { getBondCounts?: Maybe<(
    { __typename?: 'BondCountsPayload' }
    & Pick<BondCountsPayload, 'listedCount' | 'submittedCount' | 'approvedCount'>
  )> }
);

export type GetNoteForInvestorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetNoteForInvestorQuery = (
  { __typename?: 'Query' }
  & { getNoteForInvestor?: Maybe<(
    { __typename?: 'NoteForInvestorPayload' }
    & Pick<NoteForInvestorPayload, 'isAnInvestorOfCP' | 'amountInvested' | 'investedAt' | 'interest'>
    & { note?: Maybe<(
      { __typename?: 'Note' }
      & Pick<Note, 'lengthOfCP'>
      & NoteFragment
    )> }
  )> }
);

export type GetManagerMetricsQueryVariables = Exact<{
  startDate?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
}>;


export type GetManagerMetricsQuery = (
  { __typename?: 'Query' }
  & { getManagerMetrics?: Maybe<(
    { __typename?: 'ManagerMetricsPayload' }
    & { investors: Array<Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'documentId' | 'type' | 'createdAt'>
      & { role?: Maybe<(
        { __typename?: 'UsersPermissionsRole' }
        & Pick<UsersPermissionsRole, 'type'>
      )> }
    )>>, transactions: Array<Maybe<(
      { __typename?: 'Transaction' }
      & Pick<Transaction, 'documentId' | 'createdAt' | 'updatedAt' | 'payoutDate' | 'transactionNumber' | 'amount' | 'transactionStatus' | 'description' | 'transactionType'>
      & { note?: Maybe<(
        { __typename?: 'Note' }
        & Pick<Note, 'type'>
      )> }
    )>>, closedNotes: Array<Maybe<(
      { __typename?: 'Note' }
      & NoteFragment
    )>>, createdNotes: Array<Maybe<(
      { __typename?: 'Note' }
      & NoteFragment
    )>>, fundingNotes: Array<Maybe<(
      { __typename?: 'Note' }
      & NoteFragment
    )>>, fundCommercialPapers: Array<Maybe<(
      { __typename?: 'Note' }
      & Pick<Note, 'documentId' | 'title' | 'amount'>
      & { investments: Array<Maybe<(
        { __typename?: 'Investment' }
        & Pick<Investment, 'amount'>
        & { user?: Maybe<(
          { __typename?: 'UsersPermissionsUser' }
          & Pick<UsersPermissionsUser, 'firstName' | 'lastName' | 'documentId' | 'idNumber'>
        )> }
      )>> }
    )>>, fundedNotes: Array<Maybe<(
      { __typename?: 'Note' }
      & NoteFragment
    )>> }
  )> }
);

export type GetMasterBondCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterBondCountsQuery = (
  { __typename?: 'Query' }
  & { getMasterBondCounts?: Maybe<(
    { __typename?: 'MasterBondCountsPayload' }
    & Pick<MasterBondCountsPayload, 'listedCount' | 'submittedCount' | 'approvedCount'>
  )> }
);

export type GetMasterBondsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetMasterBondsQuery = (
  { __typename?: 'Query' }
  & { getMasterBonds?: Maybe<(
    { __typename?: 'GetMyMasterBondsPayload' }
    & Pick<GetMyMasterBondsPayload, 'pages' | 'page' | 'count'>
    & { masterBonds?: Maybe<Array<Maybe<(
      { __typename?: 'MasterBond' }
      & MasterBondFragment
    )>>> }
  )> }
);

export type GetMyBankingInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyBankingInformationQuery = (
  { __typename?: 'Query' }
  & { getMyBankingInformation?: Maybe<(
    { __typename?: 'BankingInformation' }
    & Pick<BankingInformation, 'documentId' | 'bankName' | 'accountHolder' | 'typeOfAccount' | 'accountNumber'>
  )> }
);

export type GetMyFinancialSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyFinancialSummaryQuery = (
  { __typename?: 'Query' }
  & { getMyFinancialSummary?: Maybe<(
    { __typename?: 'FinancialSummary' }
    & FinancialSummaryFragment
  )> }
);

export type GetMyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyProfileQuery = (
  { __typename?: 'Query' }
  & { getMyProfile?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'investmentHorizon' | 'country' | 'investmentKnowledge' | 'investmentReaction' | 'mapUrl'>
    & UserFragment
  )> }
);

export type MyWalletBalanceQueryVariables = Exact<{
  currency?: Maybe<Scalars['String']>;
}>;


export type MyWalletBalanceQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'myWalletBalance'>
);

export type FindNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindNotificationsQuery = (
  { __typename?: 'Query' }
  & { notifications: Array<Maybe<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'documentId' | 'message' | 'isRead' | 'title' | 'category'>
  )>> }
);

export type GetRealEstateAssetCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRealEstateAssetCountsQuery = (
  { __typename?: 'Query' }
  & { getRealEstateAssetCounts?: Maybe<(
    { __typename?: 'RealEstateAssetCountsPayload' }
    & Pick<RealEstateAssetCountsPayload, 'listedCount' | 'submittedCount' | 'approvedCount'>
  )> }
);

export type GetRealEstateAssetsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
}>;


export type GetRealEstateAssetsQuery = (
  { __typename?: 'Query' }
  & { getRealEstateAssets?: Maybe<(
    { __typename?: 'GetMyRealEstateAssetsPayload' }
    & Pick<GetMyRealEstateAssetsPayload, 'page' | 'pages' | 'count'>
    & { realEstateAssets?: Maybe<Array<Maybe<(
      { __typename?: 'RealEstateAsset' }
      & RealEstateAssetFragment
    )>>> }
  )> }
);

export type GetSiteDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSiteDataQuery = (
  { __typename?: 'Query' }
  & { jamiipesa?: Maybe<(
    { __typename?: 'Jamiipesa' }
    & Pick<Jamiipesa, 'privacyPolicy' | 'termsAndConditions'>
  )> }
);

export type GetInvestmentsQueryVariables = Exact<{
  filters?: Maybe<InvestmentFilter>;
  currency: Scalars['String'];
}>;


export type GetInvestmentsQuery = (
  { __typename?: 'Query' }
  & { getInvestments?: Maybe<(
    { __typename?: 'GetInvestmentsPayload' }
    & { investments?: Maybe<Array<Maybe<(
      { __typename?: 'Investment' }
      & Pick<Investment, 'documentId' | 'amount' | 'totalReturn' | 'interest' | 'lastPayInterestDate' | 'approvedAt' | 'investmentStatus'>
      & { note?: Maybe<(
        { __typename?: 'Note' }
        & Pick<Note, 'documentId' | 'title' | 'interestFrequency' | 'proposedDateOfIssue' | 'nextInterestPayment' | 'serviceInterestRate' | 'type' | 'payoutDate'>
        & { masterNote?: Maybe<(
          { __typename?: 'MasterNote' }
          & Pick<MasterNote, 'title'>
        )> }
      )>, company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'name' | 'industryType'>
        & { logo?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )> }
    )>>> }
  )> }
);

export type MyTotalInvestedAmountByNoteQueryVariables = Exact<{
  noteId: Scalars['ID'];
}>;


export type MyTotalInvestedAmountByNoteQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'myTotalInvestedAmountByNote'>
);

export type GetAcceptedSellRequestsQueryVariables = Exact<{
  currency: Scalars['String'];
}>;


export type GetAcceptedSellRequestsQuery = (
  { __typename?: 'Query' }
  & { getAcceptedSellRequests?: Maybe<(
    { __typename?: 'GetAcceptedSellRequestsResponse' }
    & { sellRequestLosses?: Maybe<Array<Maybe<(
      { __typename?: 'SellRequestLoss' }
      & Pick<SellRequestLoss, 'loss' | 'time'>
    )>>> }
  )> }
);

export type GetInvestmentsByNoteIdQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  noteId: Scalars['ID'];
}>;


export type GetInvestmentsByNoteIdQuery = (
  { __typename?: 'Query' }
  & { getInvestmentsByNoteId?: Maybe<(
    { __typename?: 'GetInvestmentsByNoteIdPayload' }
    & Pick<GetInvestmentsByNoteIdPayload, 'pages' | 'page'>
    & { investments?: Maybe<Array<Maybe<(
      { __typename?: 'Investment' }
      & Pick<Investment, 'amount'>
      & { user?: Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'firstName' | 'lastName' | 'documentId' | 'idNumber'>
      )> }
    )>>> }
  )> }
);

export type GetInvestorDashboardStatsQueryVariables = Exact<{
  currency: Scalars['String'];
}>;


export type GetInvestorDashboardStatsQuery = (
  { __typename?: 'Query' }
  & { getInvestorDashboardStats?: Maybe<(
    { __typename?: 'InvestorDashboardStatsPayload' }
    & Pick<InvestorDashboardStatsPayload, 'totalInvested' | 'totalInterestEarned' | 'notesInvested' | 'realEstateInvested' | 'bondsInvested' | 'notesInterest' | 'realEstateInterest'>
  )> }
);

export type GetMarketValueLogQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  masterNoteId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetMarketValueLogQuery = (
  { __typename?: 'Query' }
  & { getMarketValueLog?: Maybe<(
    { __typename?: 'MarketValueLogPayload' }
    & Pick<MarketValueLogPayload, 'page' | 'pages'>
    & { marketValueLog?: Maybe<Array<Maybe<(
      { __typename?: 'MarketValueLog' }
      & Pick<MarketValueLog, 'approvedAt' | 'value' | 'interest'>
    )>>> }
  )> }
);

export type GetMyMasterBondsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetMyMasterBondsQuery = (
  { __typename?: 'Query' }
  & { getMyMasterBonds?: Maybe<(
    { __typename?: 'GetMyMasterBondsPayload' }
    & Pick<GetMyMasterBondsPayload, 'pages' | 'page' | 'count'>
    & { masterBonds?: Maybe<Array<Maybe<(
      { __typename?: 'MasterBond' }
      & MasterBondFragment
    )>>> }
  )> }
);

export type GetMasterBondByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMasterBondByIdQuery = (
  { __typename?: 'Query' }
  & { getMasterBondById?: Maybe<(
    { __typename?: 'MasterBond' }
    & MasterBondFragment
  )> }
);

export type GetMasterBondBondsQueryVariables = Exact<{
  masterBondId: Scalars['String'];
}>;


export type GetMasterBondBondsQuery = (
  { __typename?: 'Query' }
  & { getMasterBondBonds?: Maybe<(
    { __typename?: 'MasterBondBondsPayload' }
    & Pick<MasterBondBondsPayload, 'total'>
    & { bonds: Array<Maybe<(
      { __typename?: 'MasterBondBondEntry' }
      & Pick<MasterBondBondEntry, 'documentId' | 'title' | 'numberOfTokens' | 'investorCount' | 'bondFaceValue' | 'bondStatus' | 'purchasePrice' | 'investedTokens'>
    )>> }
  )> }
);

export type GetMasterBondInvestorsQueryVariables = Exact<{
  masterBondId: Scalars['String'];
}>;


export type GetMasterBondInvestorsQuery = (
  { __typename?: 'Query' }
  & { getMasterBondInvestors?: Maybe<(
    { __typename?: 'MasterBondInvestorsPayload' }
    & Pick<MasterBondInvestorsPayload, 'total'>
    & { investors: Array<Maybe<(
      { __typename?: 'MasterBondInvestorEntry' }
      & Pick<MasterBondInvestorEntry, 'documentId' | 'platformId' | 'name' | 'kestrelAccountNumber' | 'bondsInvested' | 'totalLots' | 'totalFaceValue' | 'totalAmountInvested'>
    )>> }
  )> }
);

export type GetMyMasterNoteByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMyMasterNoteByIdQuery = (
  { __typename?: 'Query' }
  & { getMyMasterNoteById?: Maybe<(
    { __typename?: 'MasterNote' }
    & MasterNoteFragment
  )> }
);

export type GetAllMyMasterNotesQueryVariables = Exact<{
  filters?: Maybe<MasterNoteFilter>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
}>;


export type GetAllMyMasterNotesQuery = (
  { __typename?: 'Query' }
  & { getAllMyMasterNotes?: Maybe<(
    { __typename?: 'GetAllMyMasterNotesPayload' }
    & Pick<GetAllMyMasterNotesPayload, 'page' | 'pages' | 'count'>
    & { masterNotes?: Maybe<Array<Maybe<(
      { __typename?: 'MasterNote' }
      & MasterNoteFragment
    )>>> }
  )> }
);

export type GetMasterNoteInvestorsQueryVariables = Exact<{
  masterNoteId?: Maybe<Scalars['ID']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetMasterNoteInvestorsQuery = (
  { __typename?: 'Query' }
  & { getMasterNoteInvestors?: Maybe<(
    { __typename?: 'GetMasterNoteInvestorsResult' }
    & Pick<GetMasterNoteInvestorsResult, 'page' | 'pages' | 'count'>
    & { investors?: Maybe<Array<Maybe<(
      { __typename?: 'GetMasterNoteInvestorsPayload' }
      & Pick<GetMasterNoteInvestorsPayload, 'id' | 'name' | 'kestrelAccountNumber' | 'totalAmountInvested' | 'notes' | 'totalFaceValue'>
    )>>> }
  )> }
);

export type GetAssociatedNotesQueryVariables = Exact<{
  masterNoteId?: Maybe<Scalars['ID']>;
}>;


export type GetAssociatedNotesQuery = (
  { __typename?: 'Query' }
  & { getAssociatedNotes?: Maybe<Array<Maybe<(
    { __typename?: 'AssociatedNotePayload' }
    & Pick<AssociatedNotePayload, 'id' | 'amount' | 'dateFunded' | 'faceValue' | 'purchasePrice' | 'status' | 'title'>
  )>>> }
);

export type ExportMasterNoteInvestorsCsvQueryVariables = Exact<{
  masterNoteId?: Maybe<Scalars['ID']>;
}>;


export type ExportMasterNoteInvestorsCsvQuery = (
  { __typename?: 'Query' }
  & { exportMasterNoteInvestorsCsv?: Maybe<(
    { __typename?: 'ExportFilePayload' }
    & Pick<ExportFilePayload, 'url' | 'fileId' | 'fileName'>
  )> }
);

export type GetNotesQueryVariables = Exact<{
  filters?: Maybe<NoteFilter>;
  page?: Maybe<Scalars['Int']>;
  sort?: Maybe<Cp_Sort_By>;
  limit?: Maybe<Scalars['Int']>;
  showClosed?: Maybe<Scalars['Boolean']>;
}>;


export type GetNotesQuery = (
  { __typename?: 'Query' }
  & { getNotes?: Maybe<(
    { __typename?: 'GetNotesPayload' }
    & Pick<GetNotesPayload, 'pages' | 'page'>
    & { notes?: Maybe<Array<Maybe<(
      { __typename?: 'Note' }
      & NoteFragment
    )>>> }
  )> }
);

export type GetNotesCountQueryVariables = Exact<{
  filters?: Maybe<NoteFilter>;
}>;


export type GetNotesCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getNotesCount'>
);

export type GetNoteByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetNoteByIdQuery = (
  { __typename?: 'Query' }
  & { getNoteById?: Maybe<(
    { __typename?: 'Note' }
    & Pick<Note, 'documentId' | 'submittedAt' | 'amount' | 'amountNeeded' | 'noteMarketValue' | 'masterNoteMarketValue' | 'purchasePrice' | 'lockDown' | 'title' | 'sellFee' | 'shortHoldFeeDuration' | 'interestFrequency' | 'purchaseFee' | 'shortHoldFee' | 'shortHoldDescription' | 'compoundingFrequency' | 'followup' | 'fundManager' | 'assetType' | 'managementFee' | 'interestFrequencyDescription' | 'type' | 'numberOfPaidInterest' | 'potentialRisks' | 'description' | 'payoutDate' | 'interestRate' | 'noteStatus' | 'proposedDateOfIssue' | 'conditions' | 'purposeOfIssue' | 'noteType' | 'lengthOfCP'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & CompanyFragment
    )>, memorandum: Array<Maybe<(
      { __typename?: 'UploadFile' }
      & UploadFileFragment
    )>>, comments: Array<Maybe<(
      { __typename?: 'Comment' }
      & Pick<Comment, 'documentId' | 'message' | 'noteType' | 'createdAt'>
      & { user?: Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'firstName'>
        & { profilePicture?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )> }
    )>> }
  )> }
);

export type DownloadNoteSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DownloadNoteSummaryQuery = (
  { __typename?: 'Query' }
  & { downloadNoteSummary?: Maybe<(
    { __typename?: 'DownloadNoteSummaryPayload' }
    & Pick<DownloadNoteSummaryPayload, 'url'>
  )> }
);

export type GetMyNotificationsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
}>;


export type GetMyNotificationsQuery = (
  { __typename?: 'Query' }
  & { getMyNotifications?: Maybe<Array<Maybe<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'documentId' | 'title' | 'message' | 'category' | 'additionalInformation'>
  )>>> }
);

export type GetMyPortfolioValueLogsQueryVariables = Exact<{
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetMyPortfolioValueLogsQuery = (
  { __typename?: 'Query' }
  & { getMyPortfolioValueLogs?: Maybe<(
    { __typename?: 'GetPortfolioValueLogsPayload' }
    & Pick<GetPortfolioValueLogsPayload, 'total'>
    & { logs: Array<(
      { __typename?: 'PortfolioValueLogPayload' }
      & Pick<PortfolioValueLogPayload, 'id' | 'amountUSD' | 'amountKES' | 'createdAt' | 'updatedAt'>
    )> }
  )> }
);

export type GetMyRealEstateAssetsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
}>;


export type GetMyRealEstateAssetsQuery = (
  { __typename?: 'Query' }
  & { getMyRealEstateAssets?: Maybe<(
    { __typename?: 'GetMyRealEstateAssetsPayload' }
    & Pick<GetMyRealEstateAssetsPayload, 'page' | 'pages' | 'count'>
    & { realEstateAssets?: Maybe<Array<Maybe<(
      { __typename?: 'RealEstateAsset' }
      & RealEstateAssetFragment
    )>>> }
  )> }
);

export type GetRealEstateAssetByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRealEstateAssetByIdQuery = (
  { __typename?: 'Query' }
  & { getRealEstateAssetById?: Maybe<(
    { __typename?: 'RealEstateAsset' }
    & RealEstateAssetFragment
  )> }
);

export type GetRealEstateAssetForInvestorQueryVariables = Exact<{
  input: GetRealEstateAssetForInvestorInput;
}>;


export type GetRealEstateAssetForInvestorQuery = (
  { __typename?: 'Query' }
  & { getRealEstateAssetForInvestor?: Maybe<(
    { __typename?: 'RealEstateAssetForInvestorPayload' }
    & Pick<RealEstateAssetForInvestorPayload, 'isAnInvestorOfAsset' | 'unitsHeld' | 'investorCount' | 'fundingPercentage' | 'tokensOwned' | 'tokensPosted' | 'tokensAvailable'>
    & { asset?: Maybe<(
      { __typename?: 'RealEstateAsset' }
      & Pick<RealEstateAsset, 'mapUrl' | 'additionalInfo'>
      & RealEstateAssetFragment
    )> }
  )> }
);

export type GetMySuccessfulRealEstateHoldingsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
}>;


export type GetMySuccessfulRealEstateHoldingsQuery = (
  { __typename?: 'Query' }
  & { getMySuccessfulRealEstateHoldings?: Maybe<Array<Maybe<(
    { __typename?: 'RealEstateHolding' }
    & Pick<RealEstateHolding, 'documentId' | 'quantity' | 'avgCostBasis' | 'currency' | 'holdingStatus' | 'createdAt' | 'updatedAt'>
    & { realEstateAsset?: Maybe<(
      { __typename?: 'RealEstateAsset' }
      & Pick<RealEstateAsset, 'documentId' | 'title' | 'tokenPrice' | 'expectedYield' | 'location' | 'propertyName' | 'value' | 'currency' | 'assetStatus'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'name'>
      )>, images: Array<Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'url' | 'name'>
      )>> }
    )> }
  )>>> }
);

export type GetRealEstatePriceLogsQueryVariables = Exact<{
  realEstateAssetId: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetRealEstatePriceLogsQuery = (
  { __typename?: 'Query' }
  & { getRealEstatePriceLogs?: Maybe<(
    { __typename?: 'GetRealEstatePriceLogsPayload' }
    & Pick<GetRealEstatePriceLogsPayload, 'page' | 'pages'>
    & { realEstatePriceLogs?: Maybe<Array<Maybe<(
      { __typename?: 'RealEstatePriceLog' }
      & Pick<RealEstatePriceLog, 'documentId' | 'value' | 'logStatus' | 'approvedAt' | 'createdAt'>
      & { realEstateAsset?: Maybe<(
        { __typename?: 'RealEstateAsset' }
        & Pick<RealEstateAsset, 'documentId' | 'title' | 'value'>
      )> }
    )>>> }
  )> }
);

export type GetTransactionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTransactionByIdQuery = (
  { __typename?: 'Query' }
  & { getTransactionById?: Maybe<(
    { __typename?: 'Transaction' }
    & TransactionFragment
  )> }
);

export type GetMyTransactionsQueryVariables = Exact<{
  currency: Scalars['String'];
}>;


export type GetMyTransactionsQuery = (
  { __typename?: 'Query' }
  & { getMyTransactions?: Maybe<Array<Maybe<(
    { __typename?: 'Transaction' }
    & { note?: Maybe<(
      { __typename?: 'Note' }
      & Pick<Note, 'title'>
      & { company?: Maybe<(
        { __typename?: 'Company' }
        & Pick<Company, 'name'>
        & { logo?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )> }
    )> }
    & TransactionFragment
  )>>> }
);

export type DownloadReceiptQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DownloadReceiptQuery = (
  { __typename?: 'Query' }
  & { downloadReceipt?: Maybe<(
    { __typename?: 'DownloadTransactionReceiptPayload' }
    & Pick<DownloadTransactionReceiptPayload, 'url'>
  )> }
);

export const UploadFileFragmentDoc = gql`
    fragment uploadFile on UploadFile {
  documentId
  name
  alternativeText
  caption
  width
  height
  formats
  hash
  ext
  mime
  size
  url
  previewUrl
  provider
  provider_metadata
}
    `;
export const CompanyFragmentDoc = gql`
    fragment company on Company {
  documentId
  name
  companyType
  industryType
  logo {
    url
  }
  activeSince
  briefDescription
  platformUseReason
  registrationNumber
  registeredAt
  countryOfRegistration
  vatNumber
  taxNumber
  formattedAddress
  netWorth
  grossIncome
  totalDebt
  bankingInformation {
    documentId
    bankName
    accountHolder
    typeOfAccount
    accountNumber
  }
  informationMemorandum {
    ...uploadFile
  }
  certificateOfIncorporation {
    ...uploadFile
  }
  memorandumAndArticlesOfAssociation {
    ...uploadFile
  }
  boardOfDirectorsApproval {
    ...uploadFile
  }
  reportingAccountsReport {
    ...uploadFile
  }
  financialStatements {
    ...uploadFile
  }
  companyTAXCertificate {
    ...uploadFile
  }
  relevantCompanyDocuments {
    ...uploadFile
  }
  companyConsent {
    ...uploadFile
  }
}
    ${UploadFileFragmentDoc}`;
export const MasterNoteFragmentDoc = gql`
    fragment masterNote on MasterNote {
  documentId
  title
  type
  interestFrequency
  assetType
  fundManager
  compoundingFrequency
  interestRate
  currentStep
  currency
  maturityDate
  description
  potentialRisks
  marketValue
  masterNoteStatus
  memorandum {
    ...uploadFile
  }
}
    ${UploadFileFragmentDoc}`;
export const NoteFragmentDoc = gql`
    fragment note on Note {
  documentId
  submittedAt
  company {
    ...company
  }
  title
  interestFrequency
  masterNote {
    ...masterNote
  }
  purchaseFee
  shortHoldFee
  shortHoldDescription
  compoundingFrequency
  assetType
  fundManager
  followup
  lockDown
  purchasePrice
  managementFee
  interestFrequencyDescription
  memorandum {
    url
  }
  type
  numberOfPaidInterest
  potentialRisks
  masterNoteMarketValue
  noteMarketValue
  payoutDate
  nextInterestPayment
  sellFee
  shortHoldFeeDuration
  description
  amount
  amountNeeded
  payoutDate
  interestRate
  minInvestment
  serviceInterestRate
  noteStatus
  currency
  proposedDateOfIssue
  purposeOfIssue
  noteType
  currentStep
  comments {
    documentId
    user {
      firstName
      lastName
      profilePicture {
        url
      }
    }
    createdAt
    message
    noteType
  }
  investments {
    amount
    investmentStatus
  }
}
    ${CompanyFragmentDoc}
${MasterNoteFragmentDoc}`;
export const BondFragmentDoc = gql`
    fragment bond on Bond {
  documentId
  title
  numberOfTokens
  interestRate
  purchasePrice
  yieldToMaturity
  bondType
  bondStatus
  proposedDateOfIssue
  purchaseFee
  sellFee
  shortHoldFee
  shortHoldDuration
  managementFee
  contractAddress
  investedTokens
  masterBond {
    documentId
    title
    interestFrequency
    bondPrice
    maturityDate
    interestRate
    interestFrequency
    faceValuePerToken
    supportDocuments {
      ...uploadFile
    }
    currency
    MasterBondStatus
    contractAddress
  }
}
    ${UploadFileFragmentDoc}`;
export const BondForInvestorFragmentDoc = gql`
    fragment bondForInvestor on BondForInvestorPayload {
  documentId
  title
  numberOfTokens
  investedTokens
  interestRate
  purchasePrice
  yieldToMaturity
  estimatedYTM
  bondType
  bondStatus
  proposedDateOfIssue
  purchaseFee
  sellFee
  shortHoldFee
  shortHoldDuration
  managementFee
  contractAddress
  tokenPrice
  bondTokenPrice
  createdAt
  updatedAt
  masterBond {
    documentId
    title
    maturityDate
    interestRate
    faceValuePerToken
    currency
    MasterBondStatus
    interestFrequency
    bondPrice
    nextInterestPayment
    contractAddress
    description
    potentialRisks
  }
}
    `;
export const FinancialSummaryFragmentDoc = gql`
    fragment financialSummary on FinancialSummary {
  documentId
  netWorth
  totalDeptOutstanding
  totalDeptOutstandingOther
  grossIncome
  grossProfit
  operatingProfit
  netProfit
  detailsOfDefaultCP
  detailsOfDefaultDelay
}
    `;
export const MasterBondFragmentDoc = gql`
    fragment masterBond on MasterBond {
  documentId
  title
  interestRate
  interestFrequency
  maturityDate
  bondPrice
  faceValue: faceValuePerToken
  faceValuePerToken
  initialFaceValuePerToken
  marketValue: bondPrice
  totalTokens
  currency
  MasterBondStatus
  contractAddress
  description
  potentialRisks
  supportDocuments {
    ...uploadFile
  }
  nextInterestPayment
  bonds {
    documentId
    investedTokens
    holdings {
      documentId
      user {
        documentId
      }
    }
  }
  investors {
    documentId
  }
  user {
    documentId
    firstName
    lastName
  }
}
    ${UploadFileFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment user on UsersPermissionsUser {
  documentId
  email
  confirmed
  blocked
  phoneNumber
  role {
    type
  }
  phoneNumber
  profilePicture {
    ...uploadFile
  }
  firstName
  lastName
  type
  dateOfBirth
  idNumber
  nationalId {
    ...uploadFile
  }
  selfie {
    ...uploadFile
  }
  mobileNumber
  officeNumber
  currency
  taxNumber
  citizenship
  taxPinCertificate {
    ...uploadFile
  }
  company {
    ...company
  }
  residentialAddress
  certifiedId {
    ...uploadFile
  }
  reasonForInvesting
  agreedToInvestTerms
  onboardingStatus
  investorOnboardingSteps
  smileVerificationStatus
  employmentStatus
  businessName
  occupation
  positionHeld
  yearsAtCurrentOccupation
  businessActivity
  physicalAddress
  postalCode
  postalAddress
  investmentSources
  annualNetIncome
  additionalInfo
  factaApplies
  isPep
  bankName
  accountName
  accountNumber
  swiftCode
  streetName
  streetNumber
  city
  apartmentNumber
  residencyStatus
  dateOfOccupancy
  routingNumber
  branch
  expectedFundingFrequency
  proofOfAccount {
    ...uploadFile
  }
}
    ${UploadFileFragmentDoc}
${CompanyFragmentDoc}`;
export const RealEstateAssetFragmentDoc = gql`
    fragment realEstateAsset on RealEstateAsset {
  documentId
  address
  assetStatus
  images {
    ...uploadFile
  }
  documents {
    ...uploadFile
  }
  title
  currency
  tokenPrice
  purchaseFee
  sellFee
  user {
    ...user
  }
  propertyName
  location
  propertyType
  dateBuilt
  soldSupply
  sqft
  beds
  bathrooms
  symbol
  decimals
  totalSupply
  investedSupply
  lockDownMonths
  value
  expectedRent
  expectedExpenses
  expectedYield
  propertyDescription
  marketDescription
  expensesInfo
}
    ${UploadFileFragmentDoc}
${UserFragmentDoc}`;
export const TransactionFragmentDoc = gql`
    fragment transaction on Transaction {
  documentId
  createdAt
  updatedAt
  transactionNumber
  amount
  invoice {
    url
  }
  transactionStatus
  description
  mpesaNumber
  merchantRequestID
  checkoutRequestID
  mpesaReceiptNumber
  transactionType
}
    `;
export const SubmitBankWithdrawRequestDocument = gql`
    mutation submitBankWithdrawRequest($input: SubmitBankWithdrawRequestInput) {
  submitBankWithdrawRequest(input: $input) {
    ok
  }
}
    `;
export type SubmitBankWithdrawRequestMutationFn = Apollo.MutationFunction<SubmitBankWithdrawRequestMutation, SubmitBankWithdrawRequestMutationVariables>;

/**
 * __useSubmitBankWithdrawRequestMutation__
 *
 * To run a mutation, you first call `useSubmitBankWithdrawRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBankWithdrawRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBankWithdrawRequestMutation, { data, loading, error }] = useSubmitBankWithdrawRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitBankWithdrawRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBankWithdrawRequestMutation, SubmitBankWithdrawRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitBankWithdrawRequestMutation, SubmitBankWithdrawRequestMutationVariables>(SubmitBankWithdrawRequestDocument, options);
      }
export type SubmitBankWithdrawRequestMutationHookResult = ReturnType<typeof useSubmitBankWithdrawRequestMutation>;
export type SubmitBankWithdrawRequestMutationResult = Apollo.MutationResult<SubmitBankWithdrawRequestMutation>;
export type SubmitBankWithdrawRequestMutationOptions = Apollo.BaseMutationOptions<SubmitBankWithdrawRequestMutation, SubmitBankWithdrawRequestMutationVariables>;
export const CreateBondDocument = gql`
    mutation CreateBond($input: CreateBondInput!) {
  createBond(input: $input) {
    ...bond
  }
}
    ${BondFragmentDoc}`;
export type CreateBondMutationFn = Apollo.MutationFunction<CreateBondMutation, CreateBondMutationVariables>;

/**
 * __useCreateBondMutation__
 *
 * To run a mutation, you first call `useCreateBondMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBondMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBondMutation, { data, loading, error }] = useCreateBondMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBondMutation(baseOptions?: Apollo.MutationHookOptions<CreateBondMutation, CreateBondMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBondMutation, CreateBondMutationVariables>(CreateBondDocument, options);
      }
export type CreateBondMutationHookResult = ReturnType<typeof useCreateBondMutation>;
export type CreateBondMutationResult = Apollo.MutationResult<CreateBondMutation>;
export type CreateBondMutationOptions = Apollo.BaseMutationOptions<CreateBondMutation, CreateBondMutationVariables>;
export const ReviewBondDocument = gql`
    mutation ReviewBond($input: ReviewBondInput!) {
  reviewBond(input: $input) {
    ok
  }
}
    `;
export type ReviewBondMutationFn = Apollo.MutationFunction<ReviewBondMutation, ReviewBondMutationVariables>;

/**
 * __useReviewBondMutation__
 *
 * To run a mutation, you first call `useReviewBondMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewBondMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewBondMutation, { data, loading, error }] = useReviewBondMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewBondMutation(baseOptions?: Apollo.MutationHookOptions<ReviewBondMutation, ReviewBondMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewBondMutation, ReviewBondMutationVariables>(ReviewBondDocument, options);
      }
export type ReviewBondMutationHookResult = ReturnType<typeof useReviewBondMutation>;
export type ReviewBondMutationResult = Apollo.MutationResult<ReviewBondMutation>;
export type ReviewBondMutationOptions = Apollo.BaseMutationOptions<ReviewBondMutation, ReviewBondMutationVariables>;
export const PurchaseBondTokensDocument = gql`
    mutation PurchaseBondTokens($input: PurchaseBondTokensInput!) {
  purchaseBondTokens(input: $input) {
    ok
  }
}
    `;
export type PurchaseBondTokensMutationFn = Apollo.MutationFunction<PurchaseBondTokensMutation, PurchaseBondTokensMutationVariables>;

/**
 * __usePurchaseBondTokensMutation__
 *
 * To run a mutation, you first call `usePurchaseBondTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseBondTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseBondTokensMutation, { data, loading, error }] = usePurchaseBondTokensMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseBondTokensMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseBondTokensMutation, PurchaseBondTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseBondTokensMutation, PurchaseBondTokensMutationVariables>(PurchaseBondTokensDocument, options);
      }
export type PurchaseBondTokensMutationHookResult = ReturnType<typeof usePurchaseBondTokensMutation>;
export type PurchaseBondTokensMutationResult = Apollo.MutationResult<PurchaseBondTokensMutation>;
export type PurchaseBondTokensMutationOptions = Apollo.BaseMutationOptions<PurchaseBondTokensMutation, PurchaseBondTokensMutationVariables>;
export const CreateBondSellRequestDocument = gql`
    mutation CreateBondSellRequest($input: CreateBondSellRequestInput!) {
  createBondSellRequest(input: $input) {
    ok
  }
}
    `;
export type CreateBondSellRequestMutationFn = Apollo.MutationFunction<CreateBondSellRequestMutation, CreateBondSellRequestMutationVariables>;

/**
 * __useCreateBondSellRequestMutation__
 *
 * To run a mutation, you first call `useCreateBondSellRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBondSellRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBondSellRequestMutation, { data, loading, error }] = useCreateBondSellRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBondSellRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateBondSellRequestMutation, CreateBondSellRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBondSellRequestMutation, CreateBondSellRequestMutationVariables>(CreateBondSellRequestDocument, options);
      }
export type CreateBondSellRequestMutationHookResult = ReturnType<typeof useCreateBondSellRequestMutation>;
export type CreateBondSellRequestMutationResult = Apollo.MutationResult<CreateBondSellRequestMutation>;
export type CreateBondSellRequestMutationOptions = Apollo.BaseMutationOptions<CreateBondSellRequestMutation, CreateBondSellRequestMutationVariables>;
export const CreateBondPayoutRequestDocument = gql`
    mutation CreateBondPayoutRequest($input: CreateBondPayoutRequestInput!) {
  createBondPayoutRequest(input: $input) {
    ok
  }
}
    `;
export type CreateBondPayoutRequestMutationFn = Apollo.MutationFunction<CreateBondPayoutRequestMutation, CreateBondPayoutRequestMutationVariables>;

/**
 * __useCreateBondPayoutRequestMutation__
 *
 * To run a mutation, you first call `useCreateBondPayoutRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBondPayoutRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBondPayoutRequestMutation, { data, loading, error }] = useCreateBondPayoutRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBondPayoutRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateBondPayoutRequestMutation, CreateBondPayoutRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBondPayoutRequestMutation, CreateBondPayoutRequestMutationVariables>(CreateBondPayoutRequestDocument, options);
      }
export type CreateBondPayoutRequestMutationHookResult = ReturnType<typeof useCreateBondPayoutRequestMutation>;
export type CreateBondPayoutRequestMutationResult = Apollo.MutationResult<CreateBondPayoutRequestMutation>;
export type CreateBondPayoutRequestMutationOptions = Apollo.BaseMutationOptions<CreateBondPayoutRequestMutation, CreateBondPayoutRequestMutationVariables>;
export const CreateBondMaturityPayoutRequestDocument = gql`
    mutation CreateBondMaturityPayoutRequest($input: CreateBondMaturityPayoutRequestInput!) {
  createBondMaturityPayoutRequest(input: $input) {
    ok
  }
}
    `;
export type CreateBondMaturityPayoutRequestMutationFn = Apollo.MutationFunction<CreateBondMaturityPayoutRequestMutation, CreateBondMaturityPayoutRequestMutationVariables>;

/**
 * __useCreateBondMaturityPayoutRequestMutation__
 *
 * To run a mutation, you first call `useCreateBondMaturityPayoutRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBondMaturityPayoutRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBondMaturityPayoutRequestMutation, { data, loading, error }] = useCreateBondMaturityPayoutRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBondMaturityPayoutRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateBondMaturityPayoutRequestMutation, CreateBondMaturityPayoutRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBondMaturityPayoutRequestMutation, CreateBondMaturityPayoutRequestMutationVariables>(CreateBondMaturityPayoutRequestDocument, options);
      }
export type CreateBondMaturityPayoutRequestMutationHookResult = ReturnType<typeof useCreateBondMaturityPayoutRequestMutation>;
export type CreateBondMaturityPayoutRequestMutationResult = Apollo.MutationResult<CreateBondMaturityPayoutRequestMutation>;
export type CreateBondMaturityPayoutRequestMutationOptions = Apollo.BaseMutationOptions<CreateBondMaturityPayoutRequestMutation, CreateBondMaturityPayoutRequestMutationVariables>;
export const UpdateBondPriceDocument = gql`
    mutation UpdateBondPrice($input: UpdateBondPriceInput!) {
  updateBondPrice(input: $input) {
    ok
  }
}
    `;
export type UpdateBondPriceMutationFn = Apollo.MutationFunction<UpdateBondPriceMutation, UpdateBondPriceMutationVariables>;

/**
 * __useUpdateBondPriceMutation__
 *
 * To run a mutation, you first call `useUpdateBondPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBondPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBondPriceMutation, { data, loading, error }] = useUpdateBondPriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBondPriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBondPriceMutation, UpdateBondPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBondPriceMutation, UpdateBondPriceMutationVariables>(UpdateBondPriceDocument, options);
      }
export type UpdateBondPriceMutationHookResult = ReturnType<typeof useUpdateBondPriceMutation>;
export type UpdateBondPriceMutationResult = Apollo.MutationResult<UpdateBondPriceMutation>;
export type UpdateBondPriceMutationOptions = Apollo.BaseMutationOptions<UpdateBondPriceMutation, UpdateBondPriceMutationVariables>;
export const CalculateInvestmentDocument = gql`
    mutation calculateInvestment($input: CalculateInvestmentInput) {
  calculateInvestment(input: $input) {
    interestRate
    investmentTerm
    investmentDate
    dueDate
    purchasePrice
    investorTotalReturn
  }
}
    `;
export type CalculateInvestmentMutationFn = Apollo.MutationFunction<CalculateInvestmentMutation, CalculateInvestmentMutationVariables>;

/**
 * __useCalculateInvestmentMutation__
 *
 * To run a mutation, you first call `useCalculateInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateInvestmentMutation, { data, loading, error }] = useCalculateInvestmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<CalculateInvestmentMutation, CalculateInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateInvestmentMutation, CalculateInvestmentMutationVariables>(CalculateInvestmentDocument, options);
      }
export type CalculateInvestmentMutationHookResult = ReturnType<typeof useCalculateInvestmentMutation>;
export type CalculateInvestmentMutationResult = Apollo.MutationResult<CalculateInvestmentMutation>;
export type CalculateInvestmentMutationOptions = Apollo.BaseMutationOptions<CalculateInvestmentMutation, CalculateInvestmentMutationVariables>;
export const ChangeAppUseDocument = gql`
    mutation ChangeAppUse($input: ChangeAppUseInput) {
  changeAppUse(input: $input) {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type ChangeAppUseMutationFn = Apollo.MutationFunction<ChangeAppUseMutation, ChangeAppUseMutationVariables>;

/**
 * __useChangeAppUseMutation__
 *
 * To run a mutation, you first call `useChangeAppUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAppUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAppUseMutation, { data, loading, error }] = useChangeAppUseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeAppUseMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAppUseMutation, ChangeAppUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeAppUseMutation, ChangeAppUseMutationVariables>(ChangeAppUseDocument, options);
      }
export type ChangeAppUseMutationHookResult = ReturnType<typeof useChangeAppUseMutation>;
export type ChangeAppUseMutationResult = Apollo.MutationResult<ChangeAppUseMutation>;
export type ChangeAppUseMutationOptions = Apollo.BaseMutationOptions<ChangeAppUseMutation, ChangeAppUseMutationVariables>;
export const ChangeCurrencyDocument = gql`
    mutation changeCurrency($input: ChangeCurrencyInput) {
  changeCurrency(input: $input) {
    currency
  }
}
    `;
export type ChangeCurrencyMutationFn = Apollo.MutationFunction<ChangeCurrencyMutation, ChangeCurrencyMutationVariables>;

/**
 * __useChangeCurrencyMutation__
 *
 * To run a mutation, you first call `useChangeCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCurrencyMutation, { data, loading, error }] = useChangeCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCurrencyMutation, ChangeCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCurrencyMutation, ChangeCurrencyMutationVariables>(ChangeCurrencyDocument, options);
      }
export type ChangeCurrencyMutationHookResult = ReturnType<typeof useChangeCurrencyMutation>;
export type ChangeCurrencyMutationResult = Apollo.MutationResult<ChangeCurrencyMutation>;
export type ChangeCurrencyMutationOptions = Apollo.BaseMutationOptions<ChangeCurrencyMutation, ChangeCurrencyMutationVariables>;
export const ChangeMyPasswordDocument = gql`
    mutation ChangeMyPassword($input: ChangePasswordInput) {
  changeMyPassword(input: $input) {
    ok
  }
}
    `;
export type ChangeMyPasswordMutationFn = Apollo.MutationFunction<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>;

/**
 * __useChangeMyPasswordMutation__
 *
 * To run a mutation, you first call `useChangeMyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMyPasswordMutation, { data, loading, error }] = useChangeMyPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeMyPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>(ChangeMyPasswordDocument, options);
      }
export type ChangeMyPasswordMutationHookResult = ReturnType<typeof useChangeMyPasswordMutation>;
export type ChangeMyPasswordMutationResult = Apollo.MutationResult<ChangeMyPasswordMutation>;
export type ChangeMyPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>;
export const CreateMyNoteDocument = gql`
    mutation createMyNote($input: CreateMyNoteInput) {
  createMyNote(input: $input) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export type CreateMyNoteMutationFn = Apollo.MutationFunction<CreateMyNoteMutation, CreateMyNoteMutationVariables>;

/**
 * __useCreateMyNoteMutation__
 *
 * To run a mutation, you first call `useCreateMyNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyNoteMutation, { data, loading, error }] = useCreateMyNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyNoteMutation, CreateMyNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyNoteMutation, CreateMyNoteMutationVariables>(CreateMyNoteDocument, options);
      }
export type CreateMyNoteMutationHookResult = ReturnType<typeof useCreateMyNoteMutation>;
export type CreateMyNoteMutationResult = Apollo.MutationResult<CreateMyNoteMutation>;
export type CreateMyNoteMutationOptions = Apollo.BaseMutationOptions<CreateMyNoteMutation, CreateMyNoteMutationVariables>;
export const HelpAndSupportDocument = gql`
    mutation helpAndSupport($input: SupportRequestInput) {
  helpAndSupport(input: $input) {
    ok
  }
}
    `;
export type HelpAndSupportMutationFn = Apollo.MutationFunction<HelpAndSupportMutation, HelpAndSupportMutationVariables>;

/**
 * __useHelpAndSupportMutation__
 *
 * To run a mutation, you first call `useHelpAndSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHelpAndSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [helpAndSupportMutation, { data, loading, error }] = useHelpAndSupportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHelpAndSupportMutation(baseOptions?: Apollo.MutationHookOptions<HelpAndSupportMutation, HelpAndSupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HelpAndSupportMutation, HelpAndSupportMutationVariables>(HelpAndSupportDocument, options);
      }
export type HelpAndSupportMutationHookResult = ReturnType<typeof useHelpAndSupportMutation>;
export type HelpAndSupportMutationResult = Apollo.MutationResult<HelpAndSupportMutation>;
export type HelpAndSupportMutationOptions = Apollo.BaseMutationOptions<HelpAndSupportMutation, HelpAndSupportMutationVariables>;
export const BuyInvestmentDocument = gql`
    mutation buyInvestment($input: BuyInvestmentInput) {
  buyInvestment(input: $input) {
    documentId
    amount
  }
}
    `;
export type BuyInvestmentMutationFn = Apollo.MutationFunction<BuyInvestmentMutation, BuyInvestmentMutationVariables>;

/**
 * __useBuyInvestmentMutation__
 *
 * To run a mutation, you first call `useBuyInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyInvestmentMutation, { data, loading, error }] = useBuyInvestmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuyInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<BuyInvestmentMutation, BuyInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyInvestmentMutation, BuyInvestmentMutationVariables>(BuyInvestmentDocument, options);
      }
export type BuyInvestmentMutationHookResult = ReturnType<typeof useBuyInvestmentMutation>;
export type BuyInvestmentMutationResult = Apollo.MutationResult<BuyInvestmentMutation>;
export type BuyInvestmentMutationOptions = Apollo.BaseMutationOptions<BuyInvestmentMutation, BuyInvestmentMutationVariables>;
export const CalculateSellDocument = gql`
    mutation calculateSell($input: CalculateSellInput) {
  calculateSell(input: $input) {
    customerAmount
    deadline
    sellAmount
    shortHoldFeeAmount
    sellFeeAmount
  }
}
    `;
export type CalculateSellMutationFn = Apollo.MutationFunction<CalculateSellMutation, CalculateSellMutationVariables>;

/**
 * __useCalculateSellMutation__
 *
 * To run a mutation, you first call `useCalculateSellMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateSellMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateSellMutation, { data, loading, error }] = useCalculateSellMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateSellMutation(baseOptions?: Apollo.MutationHookOptions<CalculateSellMutation, CalculateSellMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateSellMutation, CalculateSellMutationVariables>(CalculateSellDocument, options);
      }
export type CalculateSellMutationHookResult = ReturnType<typeof useCalculateSellMutation>;
export type CalculateSellMutationResult = Apollo.MutationResult<CalculateSellMutation>;
export type CalculateSellMutationOptions = Apollo.BaseMutationOptions<CalculateSellMutation, CalculateSellMutationVariables>;
export const CreateSellDocument = gql`
    mutation createSell($input: CreateSellInput) {
  createSell(input: $input) {
    ok
  }
}
    `;
export type CreateSellMutationFn = Apollo.MutationFunction<CreateSellMutation, CreateSellMutationVariables>;

/**
 * __useCreateSellMutation__
 *
 * To run a mutation, you first call `useCreateSellMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSellMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSellMutation, { data, loading, error }] = useCreateSellMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSellMutation(baseOptions?: Apollo.MutationHookOptions<CreateSellMutation, CreateSellMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSellMutation, CreateSellMutationVariables>(CreateSellDocument, options);
      }
export type CreateSellMutationHookResult = ReturnType<typeof useCreateSellMutation>;
export type CreateSellMutationResult = Apollo.MutationResult<CreateSellMutation>;
export type CreateSellMutationOptions = Apollo.BaseMutationOptions<CreateSellMutation, CreateSellMutationVariables>;
export const InvestorOnboardingDocument = gql`
    mutation investorOnboarding($input: InvestorOnboardingInput) {
  investorOnboarding(input: $input) {
    documentId
  }
}
    `;
export type InvestorOnboardingMutationFn = Apollo.MutationFunction<InvestorOnboardingMutation, InvestorOnboardingMutationVariables>;

/**
 * __useInvestorOnboardingMutation__
 *
 * To run a mutation, you first call `useInvestorOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorOnboardingMutation, { data, loading, error }] = useInvestorOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<InvestorOnboardingMutation, InvestorOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvestorOnboardingMutation, InvestorOnboardingMutationVariables>(InvestorOnboardingDocument, options);
      }
export type InvestorOnboardingMutationHookResult = ReturnType<typeof useInvestorOnboardingMutation>;
export type InvestorOnboardingMutationResult = Apollo.MutationResult<InvestorOnboardingMutation>;
export type InvestorOnboardingMutationOptions = Apollo.BaseMutationOptions<InvestorOnboardingMutation, InvestorOnboardingMutationVariables>;
export const CreateBaseMasterBondDocument = gql`
    mutation CreateBaseMasterBond($input: CreateBaseMasterBondInput!) {
  createBaseMasterBond(input: $input) {
    ...masterBond
  }
}
    ${MasterBondFragmentDoc}`;
export type CreateBaseMasterBondMutationFn = Apollo.MutationFunction<CreateBaseMasterBondMutation, CreateBaseMasterBondMutationVariables>;

/**
 * __useCreateBaseMasterBondMutation__
 *
 * To run a mutation, you first call `useCreateBaseMasterBondMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBaseMasterBondMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBaseMasterBondMutation, { data, loading, error }] = useCreateBaseMasterBondMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBaseMasterBondMutation(baseOptions?: Apollo.MutationHookOptions<CreateBaseMasterBondMutation, CreateBaseMasterBondMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBaseMasterBondMutation, CreateBaseMasterBondMutationVariables>(CreateBaseMasterBondDocument, options);
      }
export type CreateBaseMasterBondMutationHookResult = ReturnType<typeof useCreateBaseMasterBondMutation>;
export type CreateBaseMasterBondMutationResult = Apollo.MutationResult<CreateBaseMasterBondMutation>;
export type CreateBaseMasterBondMutationOptions = Apollo.BaseMutationOptions<CreateBaseMasterBondMutation, CreateBaseMasterBondMutationVariables>;
export const UpdateMasterBondDocument = gql`
    mutation UpdateMasterBond($input: UpdateMasterBondInput!) {
  updateMasterBond(input: $input) {
    ...masterBond
  }
}
    ${MasterBondFragmentDoc}`;
export type UpdateMasterBondMutationFn = Apollo.MutationFunction<UpdateMasterBondMutation, UpdateMasterBondMutationVariables>;

/**
 * __useUpdateMasterBondMutation__
 *
 * To run a mutation, you first call `useUpdateMasterBondMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterBondMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterBondMutation, { data, loading, error }] = useUpdateMasterBondMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMasterBondMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterBondMutation, UpdateMasterBondMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterBondMutation, UpdateMasterBondMutationVariables>(UpdateMasterBondDocument, options);
      }
export type UpdateMasterBondMutationHookResult = ReturnType<typeof useUpdateMasterBondMutation>;
export type UpdateMasterBondMutationResult = Apollo.MutationResult<UpdateMasterBondMutation>;
export type UpdateMasterBondMutationOptions = Apollo.BaseMutationOptions<UpdateMasterBondMutation, UpdateMasterBondMutationVariables>;
export const ReviewMasterBondDocument = gql`
    mutation ReviewMasterBond($input: ReviewMasterBondInput!) {
  reviewMasterBond(input: $input) {
    ok
  }
}
    `;
export type ReviewMasterBondMutationFn = Apollo.MutationFunction<ReviewMasterBondMutation, ReviewMasterBondMutationVariables>;

/**
 * __useReviewMasterBondMutation__
 *
 * To run a mutation, you first call `useReviewMasterBondMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMasterBondMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMasterBondMutation, { data, loading, error }] = useReviewMasterBondMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMasterBondMutation(baseOptions?: Apollo.MutationHookOptions<ReviewMasterBondMutation, ReviewMasterBondMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewMasterBondMutation, ReviewMasterBondMutationVariables>(ReviewMasterBondDocument, options);
      }
export type ReviewMasterBondMutationHookResult = ReturnType<typeof useReviewMasterBondMutation>;
export type ReviewMasterBondMutationResult = Apollo.MutationResult<ReviewMasterBondMutation>;
export type ReviewMasterBondMutationOptions = Apollo.BaseMutationOptions<ReviewMasterBondMutation, ReviewMasterBondMutationVariables>;
export const ApproveMasterBondDocument = gql`
    mutation ApproveMasterBond($input: ApproveMasterBondInput!) {
  approveMasterBond(input: $input) {
    ...masterBond
  }
}
    ${MasterBondFragmentDoc}`;
export type ApproveMasterBondMutationFn = Apollo.MutationFunction<ApproveMasterBondMutation, ApproveMasterBondMutationVariables>;

/**
 * __useApproveMasterBondMutation__
 *
 * To run a mutation, you first call `useApproveMasterBondMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMasterBondMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMasterBondMutation, { data, loading, error }] = useApproveMasterBondMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveMasterBondMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMasterBondMutation, ApproveMasterBondMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMasterBondMutation, ApproveMasterBondMutationVariables>(ApproveMasterBondDocument, options);
      }
export type ApproveMasterBondMutationHookResult = ReturnType<typeof useApproveMasterBondMutation>;
export type ApproveMasterBondMutationResult = Apollo.MutationResult<ApproveMasterBondMutation>;
export type ApproveMasterBondMutationOptions = Apollo.BaseMutationOptions<ApproveMasterBondMutation, ApproveMasterBondMutationVariables>;
export const CreateMasterNoteByUserDocument = gql`
    mutation createMasterNoteByUser($input: CreateMasterNoteByUserInput) {
  createMasterNoteByUser(input: $input) {
    ...masterNote
  }
}
    ${MasterNoteFragmentDoc}`;
export type CreateMasterNoteByUserMutationFn = Apollo.MutationFunction<CreateMasterNoteByUserMutation, CreateMasterNoteByUserMutationVariables>;

/**
 * __useCreateMasterNoteByUserMutation__
 *
 * To run a mutation, you first call `useCreateMasterNoteByUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterNoteByUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterNoteByUserMutation, { data, loading, error }] = useCreateMasterNoteByUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterNoteByUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterNoteByUserMutation, CreateMasterNoteByUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterNoteByUserMutation, CreateMasterNoteByUserMutationVariables>(CreateMasterNoteByUserDocument, options);
      }
export type CreateMasterNoteByUserMutationHookResult = ReturnType<typeof useCreateMasterNoteByUserMutation>;
export type CreateMasterNoteByUserMutationResult = Apollo.MutationResult<CreateMasterNoteByUserMutation>;
export type CreateMasterNoteByUserMutationOptions = Apollo.BaseMutationOptions<CreateMasterNoteByUserMutation, CreateMasterNoteByUserMutationVariables>;
export const ApproveNoteDocument = gql`
    mutation approveNote($input: ApproveNoteInput) {
  approveNote(input: $input) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export type ApproveNoteMutationFn = Apollo.MutationFunction<ApproveNoteMutation, ApproveNoteMutationVariables>;

/**
 * __useApproveNoteMutation__
 *
 * To run a mutation, you first call `useApproveNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveNoteMutation, { data, loading, error }] = useApproveNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveNoteMutation(baseOptions?: Apollo.MutationHookOptions<ApproveNoteMutation, ApproveNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveNoteMutation, ApproveNoteMutationVariables>(ApproveNoteDocument, options);
      }
export type ApproveNoteMutationHookResult = ReturnType<typeof useApproveNoteMutation>;
export type ApproveNoteMutationResult = Apollo.MutationResult<ApproveNoteMutation>;
export type ApproveNoteMutationOptions = Apollo.BaseMutationOptions<ApproveNoteMutation, ApproveNoteMutationVariables>;
export const DeclineNoteDocument = gql`
    mutation declineNote($input: DeclineNoteInput) {
  declineNote(input: $input) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export type DeclineNoteMutationFn = Apollo.MutationFunction<DeclineNoteMutation, DeclineNoteMutationVariables>;

/**
 * __useDeclineNoteMutation__
 *
 * To run a mutation, you first call `useDeclineNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineNoteMutation, { data, loading, error }] = useDeclineNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeclineNoteMutation, DeclineNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineNoteMutation, DeclineNoteMutationVariables>(DeclineNoteDocument, options);
      }
export type DeclineNoteMutationHookResult = ReturnType<typeof useDeclineNoteMutation>;
export type DeclineNoteMutationResult = Apollo.MutationResult<DeclineNoteMutation>;
export type DeclineNoteMutationOptions = Apollo.BaseMutationOptions<DeclineNoteMutation, DeclineNoteMutationVariables>;
export const RequestMoreInfoDocument = gql`
    mutation requestMoreInfo($input: RequestMoreInfoInput) {
  requestMoreInfo(input: $input) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export type RequestMoreInfoMutationFn = Apollo.MutationFunction<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>;

/**
 * __useRequestMoreInfoMutation__
 *
 * To run a mutation, you first call `useRequestMoreInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMoreInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMoreInfoMutation, { data, loading, error }] = useRequestMoreInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMoreInfoMutation(baseOptions?: Apollo.MutationHookOptions<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>(RequestMoreInfoDocument, options);
      }
export type RequestMoreInfoMutationHookResult = ReturnType<typeof useRequestMoreInfoMutation>;
export type RequestMoreInfoMutationResult = Apollo.MutationResult<RequestMoreInfoMutation>;
export type RequestMoreInfoMutationOptions = Apollo.BaseMutationOptions<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>;
export const CreateInternalCommentDocument = gql`
    mutation createInternalComment($input: CreateInternalCommentInput) {
  createInternalComment(input: $input) {
    documentId
    message
  }
}
    `;
export type CreateInternalCommentMutationFn = Apollo.MutationFunction<CreateInternalCommentMutation, CreateInternalCommentMutationVariables>;

/**
 * __useCreateInternalCommentMutation__
 *
 * To run a mutation, you first call `useCreateInternalCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalCommentMutation, { data, loading, error }] = useCreateInternalCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInternalCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateInternalCommentMutation, CreateInternalCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInternalCommentMutation, CreateInternalCommentMutationVariables>(CreateInternalCommentDocument, options);
      }
export type CreateInternalCommentMutationHookResult = ReturnType<typeof useCreateInternalCommentMutation>;
export type CreateInternalCommentMutationResult = Apollo.MutationResult<CreateInternalCommentMutation>;
export type CreateInternalCommentMutationOptions = Apollo.BaseMutationOptions<CreateInternalCommentMutation, CreateInternalCommentMutationVariables>;
export const UpdateMarketValueDocument = gql`
    mutation updateMarketValue($input: MarketValueInput) {
  updateMarketValue(input: $input) {
    ok
  }
}
    `;
export type UpdateMarketValueMutationFn = Apollo.MutationFunction<UpdateMarketValueMutation, UpdateMarketValueMutationVariables>;

/**
 * __useUpdateMarketValueMutation__
 *
 * To run a mutation, you first call `useUpdateMarketValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketValueMutation, { data, loading, error }] = useUpdateMarketValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketValueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketValueMutation, UpdateMarketValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketValueMutation, UpdateMarketValueMutationVariables>(UpdateMarketValueDocument, options);
      }
export type UpdateMarketValueMutationHookResult = ReturnType<typeof useUpdateMarketValueMutation>;
export type UpdateMarketValueMutationResult = Apollo.MutationResult<UpdateMarketValueMutation>;
export type UpdateMarketValueMutationOptions = Apollo.BaseMutationOptions<UpdateMarketValueMutation, UpdateMarketValueMutationVariables>;
export const ChangeStatusDocument = gql`
    mutation changeStatus($input: ChangeStatusInput) {
  changeStatus(input: $input) {
    ok
  }
}
    `;
export type ChangeStatusMutationFn = Apollo.MutationFunction<ChangeStatusMutation, ChangeStatusMutationVariables>;

/**
 * __useChangeStatusMutation__
 *
 * To run a mutation, you first call `useChangeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeStatusMutation, { data, loading, error }] = useChangeStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeStatusMutation, ChangeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeStatusMutation, ChangeStatusMutationVariables>(ChangeStatusDocument, options);
      }
export type ChangeStatusMutationHookResult = ReturnType<typeof useChangeStatusMutation>;
export type ChangeStatusMutationResult = Apollo.MutationResult<ChangeStatusMutation>;
export type ChangeStatusMutationOptions = Apollo.BaseMutationOptions<ChangeStatusMutation, ChangeStatusMutationVariables>;
export const ArchiveNotificationDocument = gql`
    mutation archiveNotification($id: ID) {
  archiveNotification(id: $id) {
    ok
  }
}
    `;
export type ArchiveNotificationMutationFn = Apollo.MutationFunction<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>;

/**
 * __useArchiveNotificationMutation__
 *
 * To run a mutation, you first call `useArchiveNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNotificationMutation, { data, loading, error }] = useArchiveNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>(ArchiveNotificationDocument, options);
      }
export type ArchiveNotificationMutationHookResult = ReturnType<typeof useArchiveNotificationMutation>;
export type ArchiveNotificationMutationResult = Apollo.MutationResult<ArchiveNotificationMutation>;
export type ArchiveNotificationMutationOptions = Apollo.BaseMutationOptions<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>;
export const OnboardingDocument = gql`
    mutation onboarding($input: OnboardingInput, $companyInformation: OnboardingCompanyInput) {
  onboarding(input: $input, companyInformation: $companyInformation) {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type OnboardingMutationFn = Apollo.MutationFunction<OnboardingMutation, OnboardingMutationVariables>;

/**
 * __useOnboardingMutation__
 *
 * To run a mutation, you first call `useOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingMutation, { data, loading, error }] = useOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyInformation: // value for 'companyInformation'
 *   },
 * });
 */
export function useOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingMutation, OnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingMutation, OnboardingMutationVariables>(OnboardingDocument, options);
      }
export type OnboardingMutationHookResult = ReturnType<typeof useOnboardingMutation>;
export type OnboardingMutationResult = Apollo.MutationResult<OnboardingMutation>;
export type OnboardingMutationOptions = Apollo.BaseMutationOptions<OnboardingMutation, OnboardingMutationVariables>;
export const SendPayoutByUserDocument = gql`
    mutation sendPayoutByUser($input: SendPayoutByUserInput) {
  sendPayoutByUser(input: $input) {
    ok
  }
}
    `;
export type SendPayoutByUserMutationFn = Apollo.MutationFunction<SendPayoutByUserMutation, SendPayoutByUserMutationVariables>;

/**
 * __useSendPayoutByUserMutation__
 *
 * To run a mutation, you first call `useSendPayoutByUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPayoutByUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPayoutByUserMutation, { data, loading, error }] = useSendPayoutByUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPayoutByUserMutation(baseOptions?: Apollo.MutationHookOptions<SendPayoutByUserMutation, SendPayoutByUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPayoutByUserMutation, SendPayoutByUserMutationVariables>(SendPayoutByUserDocument, options);
      }
export type SendPayoutByUserMutationHookResult = ReturnType<typeof useSendPayoutByUserMutation>;
export type SendPayoutByUserMutationResult = Apollo.MutationResult<SendPayoutByUserMutation>;
export type SendPayoutByUserMutationOptions = Apollo.BaseMutationOptions<SendPayoutByUserMutation, SendPayoutByUserMutationVariables>;
export const SendInterestDocument = gql`
    mutation sendInterest($input: SendInterestInput) {
  sendInterest(input: $input) {
    ok
  }
}
    `;
export type SendInterestMutationFn = Apollo.MutationFunction<SendInterestMutation, SendInterestMutationVariables>;

/**
 * __useSendInterestMutation__
 *
 * To run a mutation, you first call `useSendInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInterestMutation, { data, loading, error }] = useSendInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInterestMutation(baseOptions?: Apollo.MutationHookOptions<SendInterestMutation, SendInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInterestMutation, SendInterestMutationVariables>(SendInterestDocument, options);
      }
export type SendInterestMutationHookResult = ReturnType<typeof useSendInterestMutation>;
export type SendInterestMutationResult = Apollo.MutationResult<SendInterestMutation>;
export type SendInterestMutationOptions = Apollo.BaseMutationOptions<SendInterestMutation, SendInterestMutationVariables>;
export const CreateRealEstateAssetDocument = gql`
    mutation createRealEstateAsset($input: CreateRealEstateAssetBaseInput) {
  createRealEstateAssetBase(input: $input) {
    ...realEstateAsset
  }
}
    ${RealEstateAssetFragmentDoc}`;
export type CreateRealEstateAssetMutationFn = Apollo.MutationFunction<CreateRealEstateAssetMutation, CreateRealEstateAssetMutationVariables>;

/**
 * __useCreateRealEstateAssetMutation__
 *
 * To run a mutation, you first call `useCreateRealEstateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRealEstateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRealEstateAssetMutation, { data, loading, error }] = useCreateRealEstateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRealEstateAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateRealEstateAssetMutation, CreateRealEstateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRealEstateAssetMutation, CreateRealEstateAssetMutationVariables>(CreateRealEstateAssetDocument, options);
      }
export type CreateRealEstateAssetMutationHookResult = ReturnType<typeof useCreateRealEstateAssetMutation>;
export type CreateRealEstateAssetMutationResult = Apollo.MutationResult<CreateRealEstateAssetMutation>;
export type CreateRealEstateAssetMutationOptions = Apollo.BaseMutationOptions<CreateRealEstateAssetMutation, CreateRealEstateAssetMutationVariables>;
export const UpdateRealEstateAssetDocument = gql`
    mutation updateRealEstateAsset($input: UpdateRealEstateAssetDetailsInput) {
  updateRealEstateAssetDetails(input: $input) {
    ...realEstateAsset
  }
}
    ${RealEstateAssetFragmentDoc}`;
export type UpdateRealEstateAssetMutationFn = Apollo.MutationFunction<UpdateRealEstateAssetMutation, UpdateRealEstateAssetMutationVariables>;

/**
 * __useUpdateRealEstateAssetMutation__
 *
 * To run a mutation, you first call `useUpdateRealEstateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRealEstateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRealEstateAssetMutation, { data, loading, error }] = useUpdateRealEstateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRealEstateAssetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRealEstateAssetMutation, UpdateRealEstateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRealEstateAssetMutation, UpdateRealEstateAssetMutationVariables>(UpdateRealEstateAssetDocument, options);
      }
export type UpdateRealEstateAssetMutationHookResult = ReturnType<typeof useUpdateRealEstateAssetMutation>;
export type UpdateRealEstateAssetMutationResult = Apollo.MutationResult<UpdateRealEstateAssetMutation>;
export type UpdateRealEstateAssetMutationOptions = Apollo.BaseMutationOptions<UpdateRealEstateAssetMutation, UpdateRealEstateAssetMutationVariables>;
export const SubmitRealEstateAssetDocument = gql`
    mutation submitRealEstateAsset($input: SubmitRealEstateAssetInput) {
  submitRealEstateAsset(input: $input) {
    ok
  }
}
    `;
export type SubmitRealEstateAssetMutationFn = Apollo.MutationFunction<SubmitRealEstateAssetMutation, SubmitRealEstateAssetMutationVariables>;

/**
 * __useSubmitRealEstateAssetMutation__
 *
 * To run a mutation, you first call `useSubmitRealEstateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRealEstateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRealEstateAssetMutation, { data, loading, error }] = useSubmitRealEstateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitRealEstateAssetMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRealEstateAssetMutation, SubmitRealEstateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRealEstateAssetMutation, SubmitRealEstateAssetMutationVariables>(SubmitRealEstateAssetDocument, options);
      }
export type SubmitRealEstateAssetMutationHookResult = ReturnType<typeof useSubmitRealEstateAssetMutation>;
export type SubmitRealEstateAssetMutationResult = Apollo.MutationResult<SubmitRealEstateAssetMutation>;
export type SubmitRealEstateAssetMutationOptions = Apollo.BaseMutationOptions<SubmitRealEstateAssetMutation, SubmitRealEstateAssetMutationVariables>;
export const ReviewRealEstateAssetDocument = gql`
    mutation ReviewRealEstateAsset($input: ReviewRealEstateAssetInput!) {
  reviewRealEstateAsset(input: $input) {
    ok
  }
}
    `;
export type ReviewRealEstateAssetMutationFn = Apollo.MutationFunction<ReviewRealEstateAssetMutation, ReviewRealEstateAssetMutationVariables>;

/**
 * __useReviewRealEstateAssetMutation__
 *
 * To run a mutation, you first call `useReviewRealEstateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewRealEstateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewRealEstateAssetMutation, { data, loading, error }] = useReviewRealEstateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewRealEstateAssetMutation(baseOptions?: Apollo.MutationHookOptions<ReviewRealEstateAssetMutation, ReviewRealEstateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewRealEstateAssetMutation, ReviewRealEstateAssetMutationVariables>(ReviewRealEstateAssetDocument, options);
      }
export type ReviewRealEstateAssetMutationHookResult = ReturnType<typeof useReviewRealEstateAssetMutation>;
export type ReviewRealEstateAssetMutationResult = Apollo.MutationResult<ReviewRealEstateAssetMutation>;
export type ReviewRealEstateAssetMutationOptions = Apollo.BaseMutationOptions<ReviewRealEstateAssetMutation, ReviewRealEstateAssetMutationVariables>;
export const CreateRealEstatePriceLogDocument = gql`
    mutation createRealEstatePriceLog($input: CreateRealEstatePriceLogInput!) {
  createMyRealEstatePriceLog(input: $input) {
    documentId
    value
    logStatus
    approvedAt
    createdAt
    realEstateAsset {
      documentId
      title
    }
  }
}
    `;
export type CreateRealEstatePriceLogMutationFn = Apollo.MutationFunction<CreateRealEstatePriceLogMutation, CreateRealEstatePriceLogMutationVariables>;

/**
 * __useCreateRealEstatePriceLogMutation__
 *
 * To run a mutation, you first call `useCreateRealEstatePriceLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRealEstatePriceLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRealEstatePriceLogMutation, { data, loading, error }] = useCreateRealEstatePriceLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRealEstatePriceLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateRealEstatePriceLogMutation, CreateRealEstatePriceLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRealEstatePriceLogMutation, CreateRealEstatePriceLogMutationVariables>(CreateRealEstatePriceLogDocument, options);
      }
export type CreateRealEstatePriceLogMutationHookResult = ReturnType<typeof useCreateRealEstatePriceLogMutation>;
export type CreateRealEstatePriceLogMutationResult = Apollo.MutationResult<CreateRealEstatePriceLogMutation>;
export type CreateRealEstatePriceLogMutationOptions = Apollo.BaseMutationOptions<CreateRealEstatePriceLogMutation, CreateRealEstatePriceLogMutationVariables>;
export const PurchaseRealEstateAssetDocument = gql`
    mutation purchaseRealEstateAsset($input: PurchaseRealEstateAssetInput!) {
  purchaseRealEstateAsset(input: $input) {
    ok
  }
}
    `;
export type PurchaseRealEstateAssetMutationFn = Apollo.MutationFunction<PurchaseRealEstateAssetMutation, PurchaseRealEstateAssetMutationVariables>;

/**
 * __usePurchaseRealEstateAssetMutation__
 *
 * To run a mutation, you first call `usePurchaseRealEstateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseRealEstateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseRealEstateAssetMutation, { data, loading, error }] = usePurchaseRealEstateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseRealEstateAssetMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseRealEstateAssetMutation, PurchaseRealEstateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseRealEstateAssetMutation, PurchaseRealEstateAssetMutationVariables>(PurchaseRealEstateAssetDocument, options);
      }
export type PurchaseRealEstateAssetMutationHookResult = ReturnType<typeof usePurchaseRealEstateAssetMutation>;
export type PurchaseRealEstateAssetMutationResult = Apollo.MutationResult<PurchaseRealEstateAssetMutation>;
export type PurchaseRealEstateAssetMutationOptions = Apollo.BaseMutationOptions<PurchaseRealEstateAssetMutation, PurchaseRealEstateAssetMutationVariables>;
export const CreateRealEstateSellDocument = gql`
    mutation createRealEstateSell($input: CreateRealEstateSellInput!) {
  createRealEstateSell(input: $input) {
    ok
  }
}
    `;
export type CreateRealEstateSellMutationFn = Apollo.MutationFunction<CreateRealEstateSellMutation, CreateRealEstateSellMutationVariables>;

/**
 * __useCreateRealEstateSellMutation__
 *
 * To run a mutation, you first call `useCreateRealEstateSellMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRealEstateSellMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRealEstateSellMutation, { data, loading, error }] = useCreateRealEstateSellMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRealEstateSellMutation(baseOptions?: Apollo.MutationHookOptions<CreateRealEstateSellMutation, CreateRealEstateSellMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRealEstateSellMutation, CreateRealEstateSellMutationVariables>(CreateRealEstateSellDocument, options);
      }
export type CreateRealEstateSellMutationHookResult = ReturnType<typeof useCreateRealEstateSellMutation>;
export type CreateRealEstateSellMutationResult = Apollo.MutationResult<CreateRealEstateSellMutation>;
export type CreateRealEstateSellMutationOptions = Apollo.BaseMutationOptions<CreateRealEstateSellMutation, CreateRealEstateSellMutationVariables>;
export const MintTokensDocument = gql`
    mutation mintTokens($input: MintRealEstateAssetTokensInput!) {
  mintRealEstateAssetTokens(input: $input) {
    ok
  }
}
    `;
export type MintTokensMutationFn = Apollo.MutationFunction<MintTokensMutation, MintTokensMutationVariables>;

/**
 * __useMintTokensMutation__
 *
 * To run a mutation, you first call `useMintTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMintTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mintTokensMutation, { data, loading, error }] = useMintTokensMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMintTokensMutation(baseOptions?: Apollo.MutationHookOptions<MintTokensMutation, MintTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MintTokensMutation, MintTokensMutationVariables>(MintTokensDocument, options);
      }
export type MintTokensMutationHookResult = ReturnType<typeof useMintTokensMutation>;
export type MintTokensMutationResult = Apollo.MutationResult<MintTokensMutation>;
export type MintTokensMutationOptions = Apollo.BaseMutationOptions<MintTokensMutation, MintTokensMutationVariables>;
export const CreateRealEstatePayoutRequestDocument = gql`
    mutation createRealEstatePayoutRequest($input: CreatePayoutRequestInput!) {
  createRealEstatePayoutRequest(input: $input) {
    documentId
    isYield
    amount
    payoutStatus
    realEstateAsset {
      documentId
      title
    }
  }
}
    `;
export type CreateRealEstatePayoutRequestMutationFn = Apollo.MutationFunction<CreateRealEstatePayoutRequestMutation, CreateRealEstatePayoutRequestMutationVariables>;

/**
 * __useCreateRealEstatePayoutRequestMutation__
 *
 * To run a mutation, you first call `useCreateRealEstatePayoutRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRealEstatePayoutRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRealEstatePayoutRequestMutation, { data, loading, error }] = useCreateRealEstatePayoutRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRealEstatePayoutRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateRealEstatePayoutRequestMutation, CreateRealEstatePayoutRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRealEstatePayoutRequestMutation, CreateRealEstatePayoutRequestMutationVariables>(CreateRealEstatePayoutRequestDocument, options);
      }
export type CreateRealEstatePayoutRequestMutationHookResult = ReturnType<typeof useCreateRealEstatePayoutRequestMutation>;
export type CreateRealEstatePayoutRequestMutationResult = Apollo.MutationResult<CreateRealEstatePayoutRequestMutation>;
export type CreateRealEstatePayoutRequestMutationOptions = Apollo.BaseMutationOptions<CreateRealEstatePayoutRequestMutation, CreateRealEstatePayoutRequestMutationVariables>;
export const RequestCompanyUpdateDocument = gql`
    mutation requestCompanyUpdate($input: RequestCompanyUpdateInput) {
  requestCompanyUpdate(input: $input) {
    ok
  }
}
    `;
export type RequestCompanyUpdateMutationFn = Apollo.MutationFunction<RequestCompanyUpdateMutation, RequestCompanyUpdateMutationVariables>;

/**
 * __useRequestCompanyUpdateMutation__
 *
 * To run a mutation, you first call `useRequestCompanyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCompanyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCompanyUpdateMutation, { data, loading, error }] = useRequestCompanyUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCompanyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RequestCompanyUpdateMutation, RequestCompanyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCompanyUpdateMutation, RequestCompanyUpdateMutationVariables>(RequestCompanyUpdateDocument, options);
      }
export type RequestCompanyUpdateMutationHookResult = ReturnType<typeof useRequestCompanyUpdateMutation>;
export type RequestCompanyUpdateMutationResult = Apollo.MutationResult<RequestCompanyUpdateMutation>;
export type RequestCompanyUpdateMutationOptions = Apollo.BaseMutationOptions<RequestCompanyUpdateMutation, RequestCompanyUpdateMutationVariables>;
export const RequestMasterNoteUpdateDocument = gql`
    mutation requestMasterNoteUpdate($input: RequestMasterNoteUpdateInput, $type: ENUM_UPDATEREQUEST_UPDATETYPE) {
  requestMasterNoteUpdate(input: $input, type: $type) {
    ok
  }
}
    `;
export type RequestMasterNoteUpdateMutationFn = Apollo.MutationFunction<RequestMasterNoteUpdateMutation, RequestMasterNoteUpdateMutationVariables>;

/**
 * __useRequestMasterNoteUpdateMutation__
 *
 * To run a mutation, you first call `useRequestMasterNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMasterNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMasterNoteUpdateMutation, { data, loading, error }] = useRequestMasterNoteUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRequestMasterNoteUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RequestMasterNoteUpdateMutation, RequestMasterNoteUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMasterNoteUpdateMutation, RequestMasterNoteUpdateMutationVariables>(RequestMasterNoteUpdateDocument, options);
      }
export type RequestMasterNoteUpdateMutationHookResult = ReturnType<typeof useRequestMasterNoteUpdateMutation>;
export type RequestMasterNoteUpdateMutationResult = Apollo.MutationResult<RequestMasterNoteUpdateMutation>;
export type RequestMasterNoteUpdateMutationOptions = Apollo.BaseMutationOptions<RequestMasterNoteUpdateMutation, RequestMasterNoteUpdateMutationVariables>;
export const RequestProfileUpdateDocument = gql`
    mutation requestProfileUpdate($input: RequestProfileUpdateInput) {
  requestProfileUpdate(input: $input) {
    ok
  }
}
    `;
export type RequestProfileUpdateMutationFn = Apollo.MutationFunction<RequestProfileUpdateMutation, RequestProfileUpdateMutationVariables>;

/**
 * __useRequestProfileUpdateMutation__
 *
 * To run a mutation, you first call `useRequestProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestProfileUpdateMutation, { data, loading, error }] = useRequestProfileUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RequestProfileUpdateMutation, RequestProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestProfileUpdateMutation, RequestProfileUpdateMutationVariables>(RequestProfileUpdateDocument, options);
      }
export type RequestProfileUpdateMutationHookResult = ReturnType<typeof useRequestProfileUpdateMutation>;
export type RequestProfileUpdateMutationResult = Apollo.MutationResult<RequestProfileUpdateMutation>;
export type RequestProfileUpdateMutationOptions = Apollo.BaseMutationOptions<RequestProfileUpdateMutation, RequestProfileUpdateMutationVariables>;
export const SubmitNoteDocument = gql`
    mutation submitNote($input: SubmitNoteInput) {
  submitNote(input: $input) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export type SubmitNoteMutationFn = Apollo.MutationFunction<SubmitNoteMutation, SubmitNoteMutationVariables>;

/**
 * __useSubmitNoteMutation__
 *
 * To run a mutation, you first call `useSubmitNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitNoteMutation, { data, loading, error }] = useSubmitNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitNoteMutation(baseOptions?: Apollo.MutationHookOptions<SubmitNoteMutation, SubmitNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitNoteMutation, SubmitNoteMutationVariables>(SubmitNoteDocument, options);
      }
export type SubmitNoteMutationHookResult = ReturnType<typeof useSubmitNoteMutation>;
export type SubmitNoteMutationResult = Apollo.MutationResult<SubmitNoteMutation>;
export type SubmitNoteMutationOptions = Apollo.BaseMutationOptions<SubmitNoteMutation, SubmitNoteMutationVariables>;
export const UpdateCompanyDocumentsDocument = gql`
    mutation updateCompanyDocuments($input: CompanyDocumentsInput) {
  updateCompanyDocuments(input: $input) {
    ...company
  }
}
    ${CompanyFragmentDoc}`;
export type UpdateCompanyDocumentsMutationFn = Apollo.MutationFunction<UpdateCompanyDocumentsMutation, UpdateCompanyDocumentsMutationVariables>;

/**
 * __useUpdateCompanyDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyDocumentsMutation, { data, loading, error }] = useUpdateCompanyDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyDocumentsMutation, UpdateCompanyDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyDocumentsMutation, UpdateCompanyDocumentsMutationVariables>(UpdateCompanyDocumentsDocument, options);
      }
export type UpdateCompanyDocumentsMutationHookResult = ReturnType<typeof useUpdateCompanyDocumentsMutation>;
export type UpdateCompanyDocumentsMutationResult = Apollo.MutationResult<UpdateCompanyDocumentsMutation>;
export type UpdateCompanyDocumentsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyDocumentsMutation, UpdateCompanyDocumentsMutationVariables>;
export const UpdateOfcreateBankingDetailsDocument = gql`
    mutation updateOfcreateBankingDetails($input: UpdateOrCreateMyBankingInput) {
  updateOrCreateMyBankingInformation(input: $input) {
    documentId
    bankName
    accountHolder
    typeOfAccount
    accountNumber
  }
}
    `;
export type UpdateOfcreateBankingDetailsMutationFn = Apollo.MutationFunction<UpdateOfcreateBankingDetailsMutation, UpdateOfcreateBankingDetailsMutationVariables>;

/**
 * __useUpdateOfcreateBankingDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateOfcreateBankingDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfcreateBankingDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfcreateBankingDetailsMutation, { data, loading, error }] = useUpdateOfcreateBankingDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfcreateBankingDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfcreateBankingDetailsMutation, UpdateOfcreateBankingDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfcreateBankingDetailsMutation, UpdateOfcreateBankingDetailsMutationVariables>(UpdateOfcreateBankingDetailsDocument, options);
      }
export type UpdateOfcreateBankingDetailsMutationHookResult = ReturnType<typeof useUpdateOfcreateBankingDetailsMutation>;
export type UpdateOfcreateBankingDetailsMutationResult = Apollo.MutationResult<UpdateOfcreateBankingDetailsMutation>;
export type UpdateOfcreateBankingDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateOfcreateBankingDetailsMutation, UpdateOfcreateBankingDetailsMutationVariables>;
export const UpdateOrCreateMyFinancialSummaryDocument = gql`
    mutation updateOrCreateMyFinancialSummary($input: UpdateOrCreateMyFinancialSummaryInput) {
  updateOrCreateMyFinancialSummary(input: $input) {
    ...financialSummary
  }
}
    ${FinancialSummaryFragmentDoc}`;
export type UpdateOrCreateMyFinancialSummaryMutationFn = Apollo.MutationFunction<UpdateOrCreateMyFinancialSummaryMutation, UpdateOrCreateMyFinancialSummaryMutationVariables>;

/**
 * __useUpdateOrCreateMyFinancialSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateMyFinancialSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateMyFinancialSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateMyFinancialSummaryMutation, { data, loading, error }] = useUpdateOrCreateMyFinancialSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrCreateMyFinancialSummaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrCreateMyFinancialSummaryMutation, UpdateOrCreateMyFinancialSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrCreateMyFinancialSummaryMutation, UpdateOrCreateMyFinancialSummaryMutationVariables>(UpdateOrCreateMyFinancialSummaryDocument, options);
      }
export type UpdateOrCreateMyFinancialSummaryMutationHookResult = ReturnType<typeof useUpdateOrCreateMyFinancialSummaryMutation>;
export type UpdateOrCreateMyFinancialSummaryMutationResult = Apollo.MutationResult<UpdateOrCreateMyFinancialSummaryMutation>;
export type UpdateOrCreateMyFinancialSummaryMutationOptions = Apollo.BaseMutationOptions<UpdateOrCreateMyFinancialSummaryMutation, UpdateOrCreateMyFinancialSummaryMutationVariables>;
export const UpdateRegulatoryProfileDocument = gql`
    mutation updateRegulatoryProfile($input: UpdateRegulatoryProfileInput) {
  updateRegulatoryProfile(input: $input) {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type UpdateRegulatoryProfileMutationFn = Apollo.MutationFunction<UpdateRegulatoryProfileMutation, UpdateRegulatoryProfileMutationVariables>;

/**
 * __useUpdateRegulatoryProfileMutation__
 *
 * To run a mutation, you first call `useUpdateRegulatoryProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegulatoryProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegulatoryProfileMutation, { data, loading, error }] = useUpdateRegulatoryProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegulatoryProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegulatoryProfileMutation, UpdateRegulatoryProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegulatoryProfileMutation, UpdateRegulatoryProfileMutationVariables>(UpdateRegulatoryProfileDocument, options);
      }
export type UpdateRegulatoryProfileMutationHookResult = ReturnType<typeof useUpdateRegulatoryProfileMutation>;
export type UpdateRegulatoryProfileMutationResult = Apollo.MutationResult<UpdateRegulatoryProfileMutation>;
export type UpdateRegulatoryProfileMutationOptions = Apollo.BaseMutationOptions<UpdateRegulatoryProfileMutation, UpdateRegulatoryProfileMutationVariables>;
export const TopupMyWalletDocument = gql`
    mutation topupMyWallet($input: TopupMyWalletInput) {
  topupMyWallet(input: $input) {
    documentId
    merchantRequestID
  }
}
    `;
export type TopupMyWalletMutationFn = Apollo.MutationFunction<TopupMyWalletMutation, TopupMyWalletMutationVariables>;

/**
 * __useTopupMyWalletMutation__
 *
 * To run a mutation, you first call `useTopupMyWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTopupMyWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [topupMyWalletMutation, { data, loading, error }] = useTopupMyWalletMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTopupMyWalletMutation(baseOptions?: Apollo.MutationHookOptions<TopupMyWalletMutation, TopupMyWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TopupMyWalletMutation, TopupMyWalletMutationVariables>(TopupMyWalletDocument, options);
      }
export type TopupMyWalletMutationHookResult = ReturnType<typeof useTopupMyWalletMutation>;
export type TopupMyWalletMutationResult = Apollo.MutationResult<TopupMyWalletMutation>;
export type TopupMyWalletMutationOptions = Apollo.BaseMutationOptions<TopupMyWalletMutation, TopupMyWalletMutationVariables>;
export const SubmitTopupRequestDocument = gql`
    mutation submitTopupRequest($input: SubmitTopupRequestInput) {
  submitTopupRequest(input: $input) {
    ok
  }
}
    `;
export type SubmitTopupRequestMutationFn = Apollo.MutationFunction<SubmitTopupRequestMutation, SubmitTopupRequestMutationVariables>;

/**
 * __useSubmitTopupRequestMutation__
 *
 * To run a mutation, you first call `useSubmitTopupRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTopupRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTopupRequestMutation, { data, loading, error }] = useSubmitTopupRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTopupRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTopupRequestMutation, SubmitTopupRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitTopupRequestMutation, SubmitTopupRequestMutationVariables>(SubmitTopupRequestDocument, options);
      }
export type SubmitTopupRequestMutationHookResult = ReturnType<typeof useSubmitTopupRequestMutation>;
export type SubmitTopupRequestMutationResult = Apollo.MutationResult<SubmitTopupRequestMutation>;
export type SubmitTopupRequestMutationOptions = Apollo.BaseMutationOptions<SubmitTopupRequestMutation, SubmitTopupRequestMutationVariables>;
export const GetAvailableBondsDocument = gql`
    query GetAvailableBonds($input: AvailableBondsInput) {
  getAvailableBonds(input: $input) {
    bonds {
      ...bondForInvestor
    }
    pages
    page
    count
  }
}
    ${BondForInvestorFragmentDoc}`;

/**
 * __useGetAvailableBondsQuery__
 *
 * To run a query within a React component, call `useGetAvailableBondsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableBondsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableBondsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAvailableBondsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableBondsQuery, GetAvailableBondsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableBondsQuery, GetAvailableBondsQueryVariables>(GetAvailableBondsDocument, options);
      }
export function useGetAvailableBondsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableBondsQuery, GetAvailableBondsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableBondsQuery, GetAvailableBondsQueryVariables>(GetAvailableBondsDocument, options);
        }
export type GetAvailableBondsQueryHookResult = ReturnType<typeof useGetAvailableBondsQuery>;
export type GetAvailableBondsLazyQueryHookResult = ReturnType<typeof useGetAvailableBondsLazyQuery>;
export type GetAvailableBondsQueryResult = Apollo.QueryResult<GetAvailableBondsQuery, GetAvailableBondsQueryVariables>;
export const GetBondForInvestorDocument = gql`
    query GetBondForInvestor($bondId: String!) {
  getBondForInvestor(bondId: $bondId) {
    ...bondForInvestor
  }
}
    ${BondForInvestorFragmentDoc}`;

/**
 * __useGetBondForInvestorQuery__
 *
 * To run a query within a React component, call `useGetBondForInvestorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBondForInvestorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBondForInvestorQuery({
 *   variables: {
 *      bondId: // value for 'bondId'
 *   },
 * });
 */
export function useGetBondForInvestorQuery(baseOptions: Apollo.QueryHookOptions<GetBondForInvestorQuery, GetBondForInvestorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBondForInvestorQuery, GetBondForInvestorQueryVariables>(GetBondForInvestorDocument, options);
      }
export function useGetBondForInvestorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBondForInvestorQuery, GetBondForInvestorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBondForInvestorQuery, GetBondForInvestorQueryVariables>(GetBondForInvestorDocument, options);
        }
export type GetBondForInvestorQueryHookResult = ReturnType<typeof useGetBondForInvestorQuery>;
export type GetBondForInvestorLazyQueryHookResult = ReturnType<typeof useGetBondForInvestorLazyQuery>;
export type GetBondForInvestorQueryResult = Apollo.QueryResult<GetBondForInvestorQuery, GetBondForInvestorQueryVariables>;
export const GetMyBondsDocument = gql`
    query GetMyBonds($search: String, $status: String, $bondType: String, $sort: String, $page: Int, $limit: Int) {
  getMyBonds(search: $search, status: $status, bondType: $bondType, sort: $sort, page: $page, limit: $limit) {
    bonds {
      ...bond
    }
    pages
    page
    count
  }
}
    ${BondFragmentDoc}`;

/**
 * __useGetMyBondsQuery__
 *
 * To run a query within a React component, call `useGetMyBondsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBondsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBondsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      bondType: // value for 'bondType'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMyBondsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyBondsQuery, GetMyBondsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyBondsQuery, GetMyBondsQueryVariables>(GetMyBondsDocument, options);
      }
export function useGetMyBondsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyBondsQuery, GetMyBondsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyBondsQuery, GetMyBondsQueryVariables>(GetMyBondsDocument, options);
        }
export type GetMyBondsQueryHookResult = ReturnType<typeof useGetMyBondsQuery>;
export type GetMyBondsLazyQueryHookResult = ReturnType<typeof useGetMyBondsLazyQuery>;
export type GetMyBondsQueryResult = Apollo.QueryResult<GetMyBondsQuery, GetMyBondsQueryVariables>;
export const GetBondsByMasterBondDocument = gql`
    query GetBondsByMasterBond($masterBondId: String!, $search: String, $status: String, $bondType: String, $sort: String, $page: Int, $limit: Int) {
  getBondsByMasterBond(masterBondId: $masterBondId, search: $search, status: $status, bondType: $bondType, sort: $sort, page: $page, limit: $limit) {
    bonds {
      ...bond
    }
    pages
    page
    count
  }
}
    ${BondFragmentDoc}`;

/**
 * __useGetBondsByMasterBondQuery__
 *
 * To run a query within a React component, call `useGetBondsByMasterBondQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBondsByMasterBondQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBondsByMasterBondQuery({
 *   variables: {
 *      masterBondId: // value for 'masterBondId'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      bondType: // value for 'bondType'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBondsByMasterBondQuery(baseOptions: Apollo.QueryHookOptions<GetBondsByMasterBondQuery, GetBondsByMasterBondQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBondsByMasterBondQuery, GetBondsByMasterBondQueryVariables>(GetBondsByMasterBondDocument, options);
      }
export function useGetBondsByMasterBondLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBondsByMasterBondQuery, GetBondsByMasterBondQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBondsByMasterBondQuery, GetBondsByMasterBondQueryVariables>(GetBondsByMasterBondDocument, options);
        }
export type GetBondsByMasterBondQueryHookResult = ReturnType<typeof useGetBondsByMasterBondQuery>;
export type GetBondsByMasterBondLazyQueryHookResult = ReturnType<typeof useGetBondsByMasterBondLazyQuery>;
export type GetBondsByMasterBondQueryResult = Apollo.QueryResult<GetBondsByMasterBondQuery, GetBondsByMasterBondQueryVariables>;
export const GetBondByIdDocument = gql`
    query GetBondById($id: String!) {
  getBondById(id: $id) {
    ...bond
  }
}
    ${BondFragmentDoc}`;

/**
 * __useGetBondByIdQuery__
 *
 * To run a query within a React component, call `useGetBondByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBondByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBondByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBondByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBondByIdQuery, GetBondByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBondByIdQuery, GetBondByIdQueryVariables>(GetBondByIdDocument, options);
      }
export function useGetBondByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBondByIdQuery, GetBondByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBondByIdQuery, GetBondByIdQueryVariables>(GetBondByIdDocument, options);
        }
export type GetBondByIdQueryHookResult = ReturnType<typeof useGetBondByIdQuery>;
export type GetBondByIdLazyQueryHookResult = ReturnType<typeof useGetBondByIdLazyQuery>;
export type GetBondByIdQueryResult = Apollo.QueryResult<GetBondByIdQuery, GetBondByIdQueryVariables>;
export const GetBondsDocument = gql`
    query GetBonds($search: String, $status: String, $sort: String, $page: Int, $limit: Int) {
  getBonds(search: $search, status: $status, sort: $sort, page: $page, limit: $limit) {
    bonds {
      ...bond
    }
    pages
    page
    count
  }
}
    ${BondFragmentDoc}`;

/**
 * __useGetBondsQuery__
 *
 * To run a query within a React component, call `useGetBondsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBondsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBondsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBondsQuery(baseOptions?: Apollo.QueryHookOptions<GetBondsQuery, GetBondsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBondsQuery, GetBondsQueryVariables>(GetBondsDocument, options);
      }
export function useGetBondsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBondsQuery, GetBondsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBondsQuery, GetBondsQueryVariables>(GetBondsDocument, options);
        }
export type GetBondsQueryHookResult = ReturnType<typeof useGetBondsQuery>;
export type GetBondsLazyQueryHookResult = ReturnType<typeof useGetBondsLazyQuery>;
export type GetBondsQueryResult = Apollo.QueryResult<GetBondsQuery, GetBondsQueryVariables>;
export const GetMySuccessfulBondHoldingsDocument = gql`
    query GetMySuccessfulBondHoldings($search: String) {
  getMySuccessfulBondHoldings(search: $search) {
    documentId
    quantity
    avgCostBasis
    currency
    holdingStatus
    createdAt
    updatedAt
    bond {
      ...bondForInvestor
    }
  }
}
    ${BondForInvestorFragmentDoc}`;

/**
 * __useGetMySuccessfulBondHoldingsQuery__
 *
 * To run a query within a React component, call `useGetMySuccessfulBondHoldingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySuccessfulBondHoldingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySuccessfulBondHoldingsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMySuccessfulBondHoldingsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySuccessfulBondHoldingsQuery, GetMySuccessfulBondHoldingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySuccessfulBondHoldingsQuery, GetMySuccessfulBondHoldingsQueryVariables>(GetMySuccessfulBondHoldingsDocument, options);
      }
export function useGetMySuccessfulBondHoldingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySuccessfulBondHoldingsQuery, GetMySuccessfulBondHoldingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySuccessfulBondHoldingsQuery, GetMySuccessfulBondHoldingsQueryVariables>(GetMySuccessfulBondHoldingsDocument, options);
        }
export type GetMySuccessfulBondHoldingsQueryHookResult = ReturnType<typeof useGetMySuccessfulBondHoldingsQuery>;
export type GetMySuccessfulBondHoldingsLazyQueryHookResult = ReturnType<typeof useGetMySuccessfulBondHoldingsLazyQuery>;
export type GetMySuccessfulBondHoldingsQueryResult = Apollo.QueryResult<GetMySuccessfulBondHoldingsQuery, GetMySuccessfulBondHoldingsQueryVariables>;
export const GetBondPriceLogsDocument = gql`
    query GetBondPriceLogs($masterBondId: String!, $page: Int, $limit: Int) {
  getBondPriceLogs(masterBondId: $masterBondId, page: $page, limit: $limit) {
    logs {
      documentId
      newPrice
      previousPrice
      logStatus
      approvedAt
      submittedBy
      createdAt
    }
    page
    pages
    total
  }
}
    `;

/**
 * __useGetBondPriceLogsQuery__
 *
 * To run a query within a React component, call `useGetBondPriceLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBondPriceLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBondPriceLogsQuery({
 *   variables: {
 *      masterBondId: // value for 'masterBondId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBondPriceLogsQuery(baseOptions: Apollo.QueryHookOptions<GetBondPriceLogsQuery, GetBondPriceLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBondPriceLogsQuery, GetBondPriceLogsQueryVariables>(GetBondPriceLogsDocument, options);
      }
export function useGetBondPriceLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBondPriceLogsQuery, GetBondPriceLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBondPriceLogsQuery, GetBondPriceLogsQueryVariables>(GetBondPriceLogsDocument, options);
        }
export type GetBondPriceLogsQueryHookResult = ReturnType<typeof useGetBondPriceLogsQuery>;
export type GetBondPriceLogsLazyQueryHookResult = ReturnType<typeof useGetBondPriceLogsLazyQuery>;
export type GetBondPriceLogsQueryResult = Apollo.QueryResult<GetBondPriceLogsQuery, GetBondPriceLogsQueryVariables>;
export const CountMyActiveNotesDocument = gql`
    query countMyActiveNotes($currency: ENUM_NOTE_CURRENCY) {
  countMyActivePapers(currency: $currency)
}
    `;

/**
 * __useCountMyActiveNotesQuery__
 *
 * To run a query within a React component, call `useCountMyActiveNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountMyActiveNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountMyActiveNotesQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useCountMyActiveNotesQuery(baseOptions?: Apollo.QueryHookOptions<CountMyActiveNotesQuery, CountMyActiveNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountMyActiveNotesQuery, CountMyActiveNotesQueryVariables>(CountMyActiveNotesDocument, options);
      }
export function useCountMyActiveNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountMyActiveNotesQuery, CountMyActiveNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountMyActiveNotesQuery, CountMyActiveNotesQueryVariables>(CountMyActiveNotesDocument, options);
        }
export type CountMyActiveNotesQueryHookResult = ReturnType<typeof useCountMyActiveNotesQuery>;
export type CountMyActiveNotesLazyQueryHookResult = ReturnType<typeof useCountMyActiveNotesLazyQuery>;
export type CountMyActiveNotesQueryResult = Apollo.QueryResult<CountMyActiveNotesQuery, CountMyActiveNotesQueryVariables>;
export const GetAvailableNotesDocument = gql`
    query getAvailableNotes($input: AvailableNotesInput) {
  getAvailableNotes(input: $input) {
    page
    pages
    notes {
      note {
        ...note
      }
      amountInvested
      isAnInvestorOfCP
    }
  }
}
    ${NoteFragmentDoc}`;

/**
 * __useGetAvailableNotesQuery__
 *
 * To run a query within a React component, call `useGetAvailableNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableNotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAvailableNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableNotesQuery, GetAvailableNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableNotesQuery, GetAvailableNotesQueryVariables>(GetAvailableNotesDocument, options);
      }
export function useGetAvailableNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableNotesQuery, GetAvailableNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableNotesQuery, GetAvailableNotesQueryVariables>(GetAvailableNotesDocument, options);
        }
export type GetAvailableNotesQueryHookResult = ReturnType<typeof useGetAvailableNotesQuery>;
export type GetAvailableNotesLazyQueryHookResult = ReturnType<typeof useGetAvailableNotesLazyQuery>;
export type GetAvailableNotesQueryResult = Apollo.QueryResult<GetAvailableNotesQuery, GetAvailableNotesQueryVariables>;
export const GetAvailableRealEstateAssetsDocument = gql`
    query GetAvailableRealEstateAssets($input: AvailableRealEstateAssetsInput) {
  getAvailableRealEstateAssets(input: $input) {
    realEstateAssets {
      asset {
        documentId
        title
        propertyName
        location
        tokenPrice
        purchaseFee
        soldSupply
        currency
        propertyType
        value
        totalSupply
        expectedYield
        expectedRent
        assetStatus
        investedSupply
        company {
          documentId
          name
          logo {
            documentId
            url
          }
        }
        images {
          documentId
          url
          alternativeText
          name
        }
      }
      isAnInvestorOfAsset
      investorCount
      fundingPercentage
      unitsHeld
    }
    pages
    page
  }
}
    `;

/**
 * __useGetAvailableRealEstateAssetsQuery__
 *
 * To run a query within a React component, call `useGetAvailableRealEstateAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableRealEstateAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableRealEstateAssetsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAvailableRealEstateAssetsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableRealEstateAssetsQuery, GetAvailableRealEstateAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableRealEstateAssetsQuery, GetAvailableRealEstateAssetsQueryVariables>(GetAvailableRealEstateAssetsDocument, options);
      }
export function useGetAvailableRealEstateAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableRealEstateAssetsQuery, GetAvailableRealEstateAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableRealEstateAssetsQuery, GetAvailableRealEstateAssetsQueryVariables>(GetAvailableRealEstateAssetsDocument, options);
        }
export type GetAvailableRealEstateAssetsQueryHookResult = ReturnType<typeof useGetAvailableRealEstateAssetsQuery>;
export type GetAvailableRealEstateAssetsLazyQueryHookResult = ReturnType<typeof useGetAvailableRealEstateAssetsLazyQuery>;
export type GetAvailableRealEstateAssetsQueryResult = Apollo.QueryResult<GetAvailableRealEstateAssetsQuery, GetAvailableRealEstateAssetsQueryVariables>;
export const GetBondCountsDocument = gql`
    query GetBondCounts {
  getBondCounts {
    listedCount
    submittedCount
    approvedCount
  }
}
    `;

/**
 * __useGetBondCountsQuery__
 *
 * To run a query within a React component, call `useGetBondCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBondCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBondCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBondCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetBondCountsQuery, GetBondCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBondCountsQuery, GetBondCountsQueryVariables>(GetBondCountsDocument, options);
      }
export function useGetBondCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBondCountsQuery, GetBondCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBondCountsQuery, GetBondCountsQueryVariables>(GetBondCountsDocument, options);
        }
export type GetBondCountsQueryHookResult = ReturnType<typeof useGetBondCountsQuery>;
export type GetBondCountsLazyQueryHookResult = ReturnType<typeof useGetBondCountsLazyQuery>;
export type GetBondCountsQueryResult = Apollo.QueryResult<GetBondCountsQuery, GetBondCountsQueryVariables>;
export const GetNoteForInvestorDocument = gql`
    query getNoteForInvestor($id: ID!) {
  getNoteForInvestor(id: $id) {
    note {
      ...note
      lengthOfCP
    }
    isAnInvestorOfCP
    amountInvested
    investedAt
    interest
  }
}
    ${NoteFragmentDoc}`;

/**
 * __useGetNoteForInvestorQuery__
 *
 * To run a query within a React component, call `useGetNoteForInvestorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteForInvestorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteForInvestorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNoteForInvestorQuery(baseOptions: Apollo.QueryHookOptions<GetNoteForInvestorQuery, GetNoteForInvestorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoteForInvestorQuery, GetNoteForInvestorQueryVariables>(GetNoteForInvestorDocument, options);
      }
export function useGetNoteForInvestorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoteForInvestorQuery, GetNoteForInvestorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoteForInvestorQuery, GetNoteForInvestorQueryVariables>(GetNoteForInvestorDocument, options);
        }
export type GetNoteForInvestorQueryHookResult = ReturnType<typeof useGetNoteForInvestorQuery>;
export type GetNoteForInvestorLazyQueryHookResult = ReturnType<typeof useGetNoteForInvestorLazyQuery>;
export type GetNoteForInvestorQueryResult = Apollo.QueryResult<GetNoteForInvestorQuery, GetNoteForInvestorQueryVariables>;
export const GetManagerMetricsDocument = gql`
    query GetManagerMetrics($startDate: Date, $currency: String) {
  getManagerMetrics(startDate: $startDate, currency: $currency) {
    investors {
      documentId
      type
      role {
        type
      }
      createdAt
    }
    transactions {
      documentId
      createdAt
      note {
        type
      }
      updatedAt
      payoutDate
      transactionNumber
      amount
      transactionStatus
      description
      transactionType
    }
    closedNotes {
      ...note
    }
    createdNotes {
      ...note
    }
    fundingNotes {
      ...note
    }
    fundCommercialPapers {
      documentId
      title
      amount
      investments {
        amount
        user {
          firstName
          lastName
          documentId
          idNumber
        }
      }
    }
    fundedNotes {
      ...note
    }
  }
}
    ${NoteFragmentDoc}`;

/**
 * __useGetManagerMetricsQuery__
 *
 * To run a query within a React component, call `useGetManagerMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerMetricsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetManagerMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerMetricsQuery, GetManagerMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagerMetricsQuery, GetManagerMetricsQueryVariables>(GetManagerMetricsDocument, options);
      }
export function useGetManagerMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerMetricsQuery, GetManagerMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagerMetricsQuery, GetManagerMetricsQueryVariables>(GetManagerMetricsDocument, options);
        }
export type GetManagerMetricsQueryHookResult = ReturnType<typeof useGetManagerMetricsQuery>;
export type GetManagerMetricsLazyQueryHookResult = ReturnType<typeof useGetManagerMetricsLazyQuery>;
export type GetManagerMetricsQueryResult = Apollo.QueryResult<GetManagerMetricsQuery, GetManagerMetricsQueryVariables>;
export const GetMasterBondCountsDocument = gql`
    query GetMasterBondCounts {
  getMasterBondCounts {
    listedCount
    submittedCount
    approvedCount
  }
}
    `;

/**
 * __useGetMasterBondCountsQuery__
 *
 * To run a query within a React component, call `useGetMasterBondCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterBondCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterBondCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMasterBondCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterBondCountsQuery, GetMasterBondCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterBondCountsQuery, GetMasterBondCountsQueryVariables>(GetMasterBondCountsDocument, options);
      }
export function useGetMasterBondCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterBondCountsQuery, GetMasterBondCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterBondCountsQuery, GetMasterBondCountsQueryVariables>(GetMasterBondCountsDocument, options);
        }
export type GetMasterBondCountsQueryHookResult = ReturnType<typeof useGetMasterBondCountsQuery>;
export type GetMasterBondCountsLazyQueryHookResult = ReturnType<typeof useGetMasterBondCountsLazyQuery>;
export type GetMasterBondCountsQueryResult = Apollo.QueryResult<GetMasterBondCountsQuery, GetMasterBondCountsQueryVariables>;
export const GetMasterBondsDocument = gql`
    query GetMasterBonds($search: String, $status: String, $currency: String, $sort: String, $page: Int, $limit: Int) {
  getMasterBonds(search: $search, status: $status, currency: $currency, sort: $sort, page: $page, limit: $limit) {
    masterBonds {
      ...masterBond
    }
    pages
    page
    count
  }
}
    ${MasterBondFragmentDoc}`;

/**
 * __useGetMasterBondsQuery__
 *
 * To run a query within a React component, call `useGetMasterBondsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterBondsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterBondsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      currency: // value for 'currency'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMasterBondsQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterBondsQuery, GetMasterBondsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterBondsQuery, GetMasterBondsQueryVariables>(GetMasterBondsDocument, options);
      }
export function useGetMasterBondsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterBondsQuery, GetMasterBondsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterBondsQuery, GetMasterBondsQueryVariables>(GetMasterBondsDocument, options);
        }
export type GetMasterBondsQueryHookResult = ReturnType<typeof useGetMasterBondsQuery>;
export type GetMasterBondsLazyQueryHookResult = ReturnType<typeof useGetMasterBondsLazyQuery>;
export type GetMasterBondsQueryResult = Apollo.QueryResult<GetMasterBondsQuery, GetMasterBondsQueryVariables>;
export const GetMyBankingInformationDocument = gql`
    query getMyBankingInformation {
  getMyBankingInformation {
    documentId
    bankName
    accountHolder
    typeOfAccount
    accountNumber
  }
}
    `;

/**
 * __useGetMyBankingInformationQuery__
 *
 * To run a query within a React component, call `useGetMyBankingInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBankingInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBankingInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyBankingInformationQuery(baseOptions?: Apollo.QueryHookOptions<GetMyBankingInformationQuery, GetMyBankingInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyBankingInformationQuery, GetMyBankingInformationQueryVariables>(GetMyBankingInformationDocument, options);
      }
export function useGetMyBankingInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyBankingInformationQuery, GetMyBankingInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyBankingInformationQuery, GetMyBankingInformationQueryVariables>(GetMyBankingInformationDocument, options);
        }
export type GetMyBankingInformationQueryHookResult = ReturnType<typeof useGetMyBankingInformationQuery>;
export type GetMyBankingInformationLazyQueryHookResult = ReturnType<typeof useGetMyBankingInformationLazyQuery>;
export type GetMyBankingInformationQueryResult = Apollo.QueryResult<GetMyBankingInformationQuery, GetMyBankingInformationQueryVariables>;
export const GetMyFinancialSummaryDocument = gql`
    query getMyFinancialSummary {
  getMyFinancialSummary {
    ...financialSummary
  }
}
    ${FinancialSummaryFragmentDoc}`;

/**
 * __useGetMyFinancialSummaryQuery__
 *
 * To run a query within a React component, call `useGetMyFinancialSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyFinancialSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyFinancialSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyFinancialSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetMyFinancialSummaryQuery, GetMyFinancialSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyFinancialSummaryQuery, GetMyFinancialSummaryQueryVariables>(GetMyFinancialSummaryDocument, options);
      }
export function useGetMyFinancialSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyFinancialSummaryQuery, GetMyFinancialSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyFinancialSummaryQuery, GetMyFinancialSummaryQueryVariables>(GetMyFinancialSummaryDocument, options);
        }
export type GetMyFinancialSummaryQueryHookResult = ReturnType<typeof useGetMyFinancialSummaryQuery>;
export type GetMyFinancialSummaryLazyQueryHookResult = ReturnType<typeof useGetMyFinancialSummaryLazyQuery>;
export type GetMyFinancialSummaryQueryResult = Apollo.QueryResult<GetMyFinancialSummaryQuery, GetMyFinancialSummaryQueryVariables>;
export const GetMyProfileDocument = gql`
    query getMyProfile {
  getMyProfile {
    ...user
    investmentHorizon
    country
    investmentKnowledge
    investmentReaction
    mapUrl
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetMyProfileQuery__
 *
 * To run a query within a React component, call `useGetMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetMyProfileQuery, GetMyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProfileQuery, GetMyProfileQueryVariables>(GetMyProfileDocument, options);
      }
export function useGetMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProfileQuery, GetMyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProfileQuery, GetMyProfileQueryVariables>(GetMyProfileDocument, options);
        }
export type GetMyProfileQueryHookResult = ReturnType<typeof useGetMyProfileQuery>;
export type GetMyProfileLazyQueryHookResult = ReturnType<typeof useGetMyProfileLazyQuery>;
export type GetMyProfileQueryResult = Apollo.QueryResult<GetMyProfileQuery, GetMyProfileQueryVariables>;
export const MyWalletBalanceDocument = gql`
    query myWalletBalance($currency: String) {
  myWalletBalance(currency: $currency)
}
    `;

/**
 * __useMyWalletBalanceQuery__
 *
 * To run a query within a React component, call `useMyWalletBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWalletBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWalletBalanceQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useMyWalletBalanceQuery(baseOptions?: Apollo.QueryHookOptions<MyWalletBalanceQuery, MyWalletBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyWalletBalanceQuery, MyWalletBalanceQueryVariables>(MyWalletBalanceDocument, options);
      }
export function useMyWalletBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyWalletBalanceQuery, MyWalletBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyWalletBalanceQuery, MyWalletBalanceQueryVariables>(MyWalletBalanceDocument, options);
        }
export type MyWalletBalanceQueryHookResult = ReturnType<typeof useMyWalletBalanceQuery>;
export type MyWalletBalanceLazyQueryHookResult = ReturnType<typeof useMyWalletBalanceLazyQuery>;
export type MyWalletBalanceQueryResult = Apollo.QueryResult<MyWalletBalanceQuery, MyWalletBalanceQueryVariables>;
export const FindNotificationsDocument = gql`
    query findNotifications {
  notifications {
    documentId
    message
    isRead
    title
    category
  }
}
    `;

/**
 * __useFindNotificationsQuery__
 *
 * To run a query within a React component, call `useFindNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<FindNotificationsQuery, FindNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindNotificationsQuery, FindNotificationsQueryVariables>(FindNotificationsDocument, options);
      }
export function useFindNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindNotificationsQuery, FindNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindNotificationsQuery, FindNotificationsQueryVariables>(FindNotificationsDocument, options);
        }
export type FindNotificationsQueryHookResult = ReturnType<typeof useFindNotificationsQuery>;
export type FindNotificationsLazyQueryHookResult = ReturnType<typeof useFindNotificationsLazyQuery>;
export type FindNotificationsQueryResult = Apollo.QueryResult<FindNotificationsQuery, FindNotificationsQueryVariables>;
export const GetRealEstateAssetCountsDocument = gql`
    query GetRealEstateAssetCounts {
  getRealEstateAssetCounts {
    listedCount
    submittedCount
    approvedCount
  }
}
    `;

/**
 * __useGetRealEstateAssetCountsQuery__
 *
 * To run a query within a React component, call `useGetRealEstateAssetCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRealEstateAssetCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealEstateAssetCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRealEstateAssetCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetRealEstateAssetCountsQuery, GetRealEstateAssetCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRealEstateAssetCountsQuery, GetRealEstateAssetCountsQueryVariables>(GetRealEstateAssetCountsDocument, options);
      }
export function useGetRealEstateAssetCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRealEstateAssetCountsQuery, GetRealEstateAssetCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRealEstateAssetCountsQuery, GetRealEstateAssetCountsQueryVariables>(GetRealEstateAssetCountsDocument, options);
        }
export type GetRealEstateAssetCountsQueryHookResult = ReturnType<typeof useGetRealEstateAssetCountsQuery>;
export type GetRealEstateAssetCountsLazyQueryHookResult = ReturnType<typeof useGetRealEstateAssetCountsLazyQuery>;
export type GetRealEstateAssetCountsQueryResult = Apollo.QueryResult<GetRealEstateAssetCountsQuery, GetRealEstateAssetCountsQueryVariables>;
export const GetRealEstateAssetsDocument = gql`
    query GetRealEstateAssets($page: Int, $limit: Int, $search: String, $status: String, $currency: String, $sort: String) {
  getRealEstateAssets(page: $page, limit: $limit, search: $search, status: $status, currency: $currency, sort: $sort) {
    realEstateAssets {
      ...realEstateAsset
    }
    page
    pages
    count
  }
}
    ${RealEstateAssetFragmentDoc}`;

/**
 * __useGetRealEstateAssetsQuery__
 *
 * To run a query within a React component, call `useGetRealEstateAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRealEstateAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealEstateAssetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      currency: // value for 'currency'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetRealEstateAssetsQuery(baseOptions?: Apollo.QueryHookOptions<GetRealEstateAssetsQuery, GetRealEstateAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRealEstateAssetsQuery, GetRealEstateAssetsQueryVariables>(GetRealEstateAssetsDocument, options);
      }
export function useGetRealEstateAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRealEstateAssetsQuery, GetRealEstateAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRealEstateAssetsQuery, GetRealEstateAssetsQueryVariables>(GetRealEstateAssetsDocument, options);
        }
export type GetRealEstateAssetsQueryHookResult = ReturnType<typeof useGetRealEstateAssetsQuery>;
export type GetRealEstateAssetsLazyQueryHookResult = ReturnType<typeof useGetRealEstateAssetsLazyQuery>;
export type GetRealEstateAssetsQueryResult = Apollo.QueryResult<GetRealEstateAssetsQuery, GetRealEstateAssetsQueryVariables>;
export const GetSiteDataDocument = gql`
    query getSiteData {
  jamiipesa {
    privacyPolicy
    termsAndConditions
  }
}
    `;

/**
 * __useGetSiteDataQuery__
 *
 * To run a query within a React component, call `useGetSiteDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSiteDataQuery(baseOptions?: Apollo.QueryHookOptions<GetSiteDataQuery, GetSiteDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteDataQuery, GetSiteDataQueryVariables>(GetSiteDataDocument, options);
      }
export function useGetSiteDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteDataQuery, GetSiteDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteDataQuery, GetSiteDataQueryVariables>(GetSiteDataDocument, options);
        }
export type GetSiteDataQueryHookResult = ReturnType<typeof useGetSiteDataQuery>;
export type GetSiteDataLazyQueryHookResult = ReturnType<typeof useGetSiteDataLazyQuery>;
export type GetSiteDataQueryResult = Apollo.QueryResult<GetSiteDataQuery, GetSiteDataQueryVariables>;
export const GetInvestmentsDocument = gql`
    query getInvestments($filters: InvestmentFilter, $currency: String!) {
  getInvestments(filters: $filters, currency: $currency) {
    investments {
      documentId
      amount
      totalReturn
      interest
      lastPayInterestDate
      approvedAt
      investmentStatus
      note {
        documentId
        title
        interestFrequency
        masterNote {
          title
        }
        proposedDateOfIssue
        nextInterestPayment
        serviceInterestRate
        type
        payoutDate
      }
      company {
        name
        industryType
        logo {
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetInvestmentsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetInvestmentsQuery(baseOptions: Apollo.QueryHookOptions<GetInvestmentsQuery, GetInvestmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvestmentsQuery, GetInvestmentsQueryVariables>(GetInvestmentsDocument, options);
      }
export function useGetInvestmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvestmentsQuery, GetInvestmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvestmentsQuery, GetInvestmentsQueryVariables>(GetInvestmentsDocument, options);
        }
export type GetInvestmentsQueryHookResult = ReturnType<typeof useGetInvestmentsQuery>;
export type GetInvestmentsLazyQueryHookResult = ReturnType<typeof useGetInvestmentsLazyQuery>;
export type GetInvestmentsQueryResult = Apollo.QueryResult<GetInvestmentsQuery, GetInvestmentsQueryVariables>;
export const MyTotalInvestedAmountByNoteDocument = gql`
    query myTotalInvestedAmountByNote($noteId: ID!) {
  myTotalInvestedAmountByNote(noteId: $noteId)
}
    `;

/**
 * __useMyTotalInvestedAmountByNoteQuery__
 *
 * To run a query within a React component, call `useMyTotalInvestedAmountByNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTotalInvestedAmountByNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTotalInvestedAmountByNoteQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useMyTotalInvestedAmountByNoteQuery(baseOptions: Apollo.QueryHookOptions<MyTotalInvestedAmountByNoteQuery, MyTotalInvestedAmountByNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTotalInvestedAmountByNoteQuery, MyTotalInvestedAmountByNoteQueryVariables>(MyTotalInvestedAmountByNoteDocument, options);
      }
export function useMyTotalInvestedAmountByNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTotalInvestedAmountByNoteQuery, MyTotalInvestedAmountByNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTotalInvestedAmountByNoteQuery, MyTotalInvestedAmountByNoteQueryVariables>(MyTotalInvestedAmountByNoteDocument, options);
        }
export type MyTotalInvestedAmountByNoteQueryHookResult = ReturnType<typeof useMyTotalInvestedAmountByNoteQuery>;
export type MyTotalInvestedAmountByNoteLazyQueryHookResult = ReturnType<typeof useMyTotalInvestedAmountByNoteLazyQuery>;
export type MyTotalInvestedAmountByNoteQueryResult = Apollo.QueryResult<MyTotalInvestedAmountByNoteQuery, MyTotalInvestedAmountByNoteQueryVariables>;
export const GetAcceptedSellRequestsDocument = gql`
    query getAcceptedSellRequests($currency: String!) {
  getAcceptedSellRequests(currency: $currency) {
    sellRequestLosses {
      loss
      time
    }
  }
}
    `;

/**
 * __useGetAcceptedSellRequestsQuery__
 *
 * To run a query within a React component, call `useGetAcceptedSellRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcceptedSellRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcceptedSellRequestsQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetAcceptedSellRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetAcceptedSellRequestsQuery, GetAcceptedSellRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcceptedSellRequestsQuery, GetAcceptedSellRequestsQueryVariables>(GetAcceptedSellRequestsDocument, options);
      }
export function useGetAcceptedSellRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcceptedSellRequestsQuery, GetAcceptedSellRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcceptedSellRequestsQuery, GetAcceptedSellRequestsQueryVariables>(GetAcceptedSellRequestsDocument, options);
        }
export type GetAcceptedSellRequestsQueryHookResult = ReturnType<typeof useGetAcceptedSellRequestsQuery>;
export type GetAcceptedSellRequestsLazyQueryHookResult = ReturnType<typeof useGetAcceptedSellRequestsLazyQuery>;
export type GetAcceptedSellRequestsQueryResult = Apollo.QueryResult<GetAcceptedSellRequestsQuery, GetAcceptedSellRequestsQueryVariables>;
export const GetInvestmentsByNoteIdDocument = gql`
    query getInvestmentsByNoteId($page: Int, $limit: Int, $noteId: ID!) {
  getInvestmentsByNoteId(page: $page, limit: $limit, noteId: $noteId) {
    investments {
      amount
      user {
        firstName
        lastName
        documentId
        idNumber
      }
    }
    pages
    page
  }
}
    `;

/**
 * __useGetInvestmentsByNoteIdQuery__
 *
 * To run a query within a React component, call `useGetInvestmentsByNoteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentsByNoteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentsByNoteIdQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useGetInvestmentsByNoteIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvestmentsByNoteIdQuery, GetInvestmentsByNoteIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvestmentsByNoteIdQuery, GetInvestmentsByNoteIdQueryVariables>(GetInvestmentsByNoteIdDocument, options);
      }
export function useGetInvestmentsByNoteIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvestmentsByNoteIdQuery, GetInvestmentsByNoteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvestmentsByNoteIdQuery, GetInvestmentsByNoteIdQueryVariables>(GetInvestmentsByNoteIdDocument, options);
        }
export type GetInvestmentsByNoteIdQueryHookResult = ReturnType<typeof useGetInvestmentsByNoteIdQuery>;
export type GetInvestmentsByNoteIdLazyQueryHookResult = ReturnType<typeof useGetInvestmentsByNoteIdLazyQuery>;
export type GetInvestmentsByNoteIdQueryResult = Apollo.QueryResult<GetInvestmentsByNoteIdQuery, GetInvestmentsByNoteIdQueryVariables>;
export const GetInvestorDashboardStatsDocument = gql`
    query getInvestorDashboardStats($currency: String!) {
  getInvestorDashboardStats(currency: $currency) {
    totalInvested
    totalInterestEarned
    notesInvested
    realEstateInvested
    bondsInvested
    notesInterest
    realEstateInterest
  }
}
    `;

/**
 * __useGetInvestorDashboardStatsQuery__
 *
 * To run a query within a React component, call `useGetInvestorDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestorDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestorDashboardStatsQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetInvestorDashboardStatsQuery(baseOptions: Apollo.QueryHookOptions<GetInvestorDashboardStatsQuery, GetInvestorDashboardStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvestorDashboardStatsQuery, GetInvestorDashboardStatsQueryVariables>(GetInvestorDashboardStatsDocument, options);
      }
export function useGetInvestorDashboardStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvestorDashboardStatsQuery, GetInvestorDashboardStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvestorDashboardStatsQuery, GetInvestorDashboardStatsQueryVariables>(GetInvestorDashboardStatsDocument, options);
        }
export type GetInvestorDashboardStatsQueryHookResult = ReturnType<typeof useGetInvestorDashboardStatsQuery>;
export type GetInvestorDashboardStatsLazyQueryHookResult = ReturnType<typeof useGetInvestorDashboardStatsLazyQuery>;
export type GetInvestorDashboardStatsQueryResult = Apollo.QueryResult<GetInvestorDashboardStatsQuery, GetInvestorDashboardStatsQueryVariables>;
export const GetMarketValueLogDocument = gql`
    query getMarketValueLog($page: Int, $masterNoteId: ID, $limit: Int) {
  getMarketValueLog(page: $page, masterNoteId: $masterNoteId, limit: $limit) {
    marketValueLog {
      approvedAt
      value
      interest
    }
    page
    pages
  }
}
    `;

/**
 * __useGetMarketValueLogQuery__
 *
 * To run a query within a React component, call `useGetMarketValueLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketValueLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketValueLogQuery({
 *   variables: {
 *      page: // value for 'page'
 *      masterNoteId: // value for 'masterNoteId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMarketValueLogQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketValueLogQuery, GetMarketValueLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketValueLogQuery, GetMarketValueLogQueryVariables>(GetMarketValueLogDocument, options);
      }
export function useGetMarketValueLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketValueLogQuery, GetMarketValueLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketValueLogQuery, GetMarketValueLogQueryVariables>(GetMarketValueLogDocument, options);
        }
export type GetMarketValueLogQueryHookResult = ReturnType<typeof useGetMarketValueLogQuery>;
export type GetMarketValueLogLazyQueryHookResult = ReturnType<typeof useGetMarketValueLogLazyQuery>;
export type GetMarketValueLogQueryResult = Apollo.QueryResult<GetMarketValueLogQuery, GetMarketValueLogQueryVariables>;
export const GetMyMasterBondsDocument = gql`
    query GetMyMasterBonds($search: String, $status: String, $currency: String, $sort: String, $page: Int, $limit: Int) {
  getMyMasterBonds(search: $search, status: $status, currency: $currency, sort: $sort, page: $page, limit: $limit) {
    masterBonds {
      ...masterBond
    }
    pages
    page
    count
  }
}
    ${MasterBondFragmentDoc}`;

/**
 * __useGetMyMasterBondsQuery__
 *
 * To run a query within a React component, call `useGetMyMasterBondsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMasterBondsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMasterBondsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      currency: // value for 'currency'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMyMasterBondsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyMasterBondsQuery, GetMyMasterBondsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyMasterBondsQuery, GetMyMasterBondsQueryVariables>(GetMyMasterBondsDocument, options);
      }
export function useGetMyMasterBondsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMasterBondsQuery, GetMyMasterBondsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyMasterBondsQuery, GetMyMasterBondsQueryVariables>(GetMyMasterBondsDocument, options);
        }
export type GetMyMasterBondsQueryHookResult = ReturnType<typeof useGetMyMasterBondsQuery>;
export type GetMyMasterBondsLazyQueryHookResult = ReturnType<typeof useGetMyMasterBondsLazyQuery>;
export type GetMyMasterBondsQueryResult = Apollo.QueryResult<GetMyMasterBondsQuery, GetMyMasterBondsQueryVariables>;
export const GetMasterBondByIdDocument = gql`
    query GetMasterBondById($id: String!) {
  getMasterBondById(id: $id) {
    ...masterBond
  }
}
    ${MasterBondFragmentDoc}`;

/**
 * __useGetMasterBondByIdQuery__
 *
 * To run a query within a React component, call `useGetMasterBondByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterBondByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterBondByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMasterBondByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMasterBondByIdQuery, GetMasterBondByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterBondByIdQuery, GetMasterBondByIdQueryVariables>(GetMasterBondByIdDocument, options);
      }
export function useGetMasterBondByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterBondByIdQuery, GetMasterBondByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterBondByIdQuery, GetMasterBondByIdQueryVariables>(GetMasterBondByIdDocument, options);
        }
export type GetMasterBondByIdQueryHookResult = ReturnType<typeof useGetMasterBondByIdQuery>;
export type GetMasterBondByIdLazyQueryHookResult = ReturnType<typeof useGetMasterBondByIdLazyQuery>;
export type GetMasterBondByIdQueryResult = Apollo.QueryResult<GetMasterBondByIdQuery, GetMasterBondByIdQueryVariables>;
export const GetMasterBondBondsDocument = gql`
    query GetMasterBondBonds($masterBondId: String!) {
  getMasterBondBonds(masterBondId: $masterBondId) {
    bonds {
      documentId
      title
      numberOfTokens
      investorCount
      bondFaceValue
      bondStatus
      purchasePrice
      investedTokens
    }
    total
  }
}
    `;

/**
 * __useGetMasterBondBondsQuery__
 *
 * To run a query within a React component, call `useGetMasterBondBondsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterBondBondsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterBondBondsQuery({
 *   variables: {
 *      masterBondId: // value for 'masterBondId'
 *   },
 * });
 */
export function useGetMasterBondBondsQuery(baseOptions: Apollo.QueryHookOptions<GetMasterBondBondsQuery, GetMasterBondBondsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterBondBondsQuery, GetMasterBondBondsQueryVariables>(GetMasterBondBondsDocument, options);
      }
export function useGetMasterBondBondsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterBondBondsQuery, GetMasterBondBondsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterBondBondsQuery, GetMasterBondBondsQueryVariables>(GetMasterBondBondsDocument, options);
        }
export type GetMasterBondBondsQueryHookResult = ReturnType<typeof useGetMasterBondBondsQuery>;
export type GetMasterBondBondsLazyQueryHookResult = ReturnType<typeof useGetMasterBondBondsLazyQuery>;
export type GetMasterBondBondsQueryResult = Apollo.QueryResult<GetMasterBondBondsQuery, GetMasterBondBondsQueryVariables>;
export const GetMasterBondInvestorsDocument = gql`
    query GetMasterBondInvestors($masterBondId: String!) {
  getMasterBondInvestors(masterBondId: $masterBondId) {
    investors {
      documentId
      platformId
      name
      kestrelAccountNumber
      bondsInvested
      totalLots
      totalFaceValue
      totalAmountInvested
    }
    total
  }
}
    `;

/**
 * __useGetMasterBondInvestorsQuery__
 *
 * To run a query within a React component, call `useGetMasterBondInvestorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterBondInvestorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterBondInvestorsQuery({
 *   variables: {
 *      masterBondId: // value for 'masterBondId'
 *   },
 * });
 */
export function useGetMasterBondInvestorsQuery(baseOptions: Apollo.QueryHookOptions<GetMasterBondInvestorsQuery, GetMasterBondInvestorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterBondInvestorsQuery, GetMasterBondInvestorsQueryVariables>(GetMasterBondInvestorsDocument, options);
      }
export function useGetMasterBondInvestorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterBondInvestorsQuery, GetMasterBondInvestorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterBondInvestorsQuery, GetMasterBondInvestorsQueryVariables>(GetMasterBondInvestorsDocument, options);
        }
export type GetMasterBondInvestorsQueryHookResult = ReturnType<typeof useGetMasterBondInvestorsQuery>;
export type GetMasterBondInvestorsLazyQueryHookResult = ReturnType<typeof useGetMasterBondInvestorsLazyQuery>;
export type GetMasterBondInvestorsQueryResult = Apollo.QueryResult<GetMasterBondInvestorsQuery, GetMasterBondInvestorsQueryVariables>;
export const GetMyMasterNoteByIdDocument = gql`
    query getMyMasterNoteById($id: ID!) {
  getMyMasterNoteById(id: $id) {
    ...masterNote
  }
}
    ${MasterNoteFragmentDoc}`;

/**
 * __useGetMyMasterNoteByIdQuery__
 *
 * To run a query within a React component, call `useGetMyMasterNoteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMasterNoteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMasterNoteByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyMasterNoteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMyMasterNoteByIdQuery, GetMyMasterNoteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyMasterNoteByIdQuery, GetMyMasterNoteByIdQueryVariables>(GetMyMasterNoteByIdDocument, options);
      }
export function useGetMyMasterNoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMasterNoteByIdQuery, GetMyMasterNoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyMasterNoteByIdQuery, GetMyMasterNoteByIdQueryVariables>(GetMyMasterNoteByIdDocument, options);
        }
export type GetMyMasterNoteByIdQueryHookResult = ReturnType<typeof useGetMyMasterNoteByIdQuery>;
export type GetMyMasterNoteByIdLazyQueryHookResult = ReturnType<typeof useGetMyMasterNoteByIdLazyQuery>;
export type GetMyMasterNoteByIdQueryResult = Apollo.QueryResult<GetMyMasterNoteByIdQuery, GetMyMasterNoteByIdQueryVariables>;
export const GetAllMyMasterNotesDocument = gql`
    query getAllMyMasterNotes($filters: MasterNoteFilter, $limit: Int, $page: Int) {
  getAllMyMasterNotes(filters: $filters, limit: $limit, page: $page) {
    masterNotes {
      ...masterNote
    }
    page
    pages
    count
  }
}
    ${MasterNoteFragmentDoc}`;

/**
 * __useGetAllMyMasterNotesQuery__
 *
 * To run a query within a React component, call `useGetAllMyMasterNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyMasterNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyMasterNotesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetAllMyMasterNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMyMasterNotesQuery, GetAllMyMasterNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMyMasterNotesQuery, GetAllMyMasterNotesQueryVariables>(GetAllMyMasterNotesDocument, options);
      }
export function useGetAllMyMasterNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMyMasterNotesQuery, GetAllMyMasterNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMyMasterNotesQuery, GetAllMyMasterNotesQueryVariables>(GetAllMyMasterNotesDocument, options);
        }
export type GetAllMyMasterNotesQueryHookResult = ReturnType<typeof useGetAllMyMasterNotesQuery>;
export type GetAllMyMasterNotesLazyQueryHookResult = ReturnType<typeof useGetAllMyMasterNotesLazyQuery>;
export type GetAllMyMasterNotesQueryResult = Apollo.QueryResult<GetAllMyMasterNotesQuery, GetAllMyMasterNotesQueryVariables>;
export const GetMasterNoteInvestorsDocument = gql`
    query getMasterNoteInvestors($masterNoteId: ID, $page: Int, $limit: Int) {
  getMasterNoteInvestors(masterNoteId: $masterNoteId, page: $page, limit: $limit) {
    investors {
      id
      name
      kestrelAccountNumber
      totalAmountInvested
      notes
      totalFaceValue
    }
    page
    pages
    count
  }
}
    `;

/**
 * __useGetMasterNoteInvestorsQuery__
 *
 * To run a query within a React component, call `useGetMasterNoteInvestorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterNoteInvestorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterNoteInvestorsQuery({
 *   variables: {
 *      masterNoteId: // value for 'masterNoteId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMasterNoteInvestorsQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterNoteInvestorsQuery, GetMasterNoteInvestorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterNoteInvestorsQuery, GetMasterNoteInvestorsQueryVariables>(GetMasterNoteInvestorsDocument, options);
      }
export function useGetMasterNoteInvestorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterNoteInvestorsQuery, GetMasterNoteInvestorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterNoteInvestorsQuery, GetMasterNoteInvestorsQueryVariables>(GetMasterNoteInvestorsDocument, options);
        }
export type GetMasterNoteInvestorsQueryHookResult = ReturnType<typeof useGetMasterNoteInvestorsQuery>;
export type GetMasterNoteInvestorsLazyQueryHookResult = ReturnType<typeof useGetMasterNoteInvestorsLazyQuery>;
export type GetMasterNoteInvestorsQueryResult = Apollo.QueryResult<GetMasterNoteInvestorsQuery, GetMasterNoteInvestorsQueryVariables>;
export const GetAssociatedNotesDocument = gql`
    query getAssociatedNotes($masterNoteId: ID) {
  getAssociatedNotes(masterNoteId: $masterNoteId) {
    id
    amount
    dateFunded
    faceValue
    purchasePrice
    status
    title
  }
}
    `;

/**
 * __useGetAssociatedNotesQuery__
 *
 * To run a query within a React component, call `useGetAssociatedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssociatedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssociatedNotesQuery({
 *   variables: {
 *      masterNoteId: // value for 'masterNoteId'
 *   },
 * });
 */
export function useGetAssociatedNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetAssociatedNotesQuery, GetAssociatedNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssociatedNotesQuery, GetAssociatedNotesQueryVariables>(GetAssociatedNotesDocument, options);
      }
export function useGetAssociatedNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssociatedNotesQuery, GetAssociatedNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssociatedNotesQuery, GetAssociatedNotesQueryVariables>(GetAssociatedNotesDocument, options);
        }
export type GetAssociatedNotesQueryHookResult = ReturnType<typeof useGetAssociatedNotesQuery>;
export type GetAssociatedNotesLazyQueryHookResult = ReturnType<typeof useGetAssociatedNotesLazyQuery>;
export type GetAssociatedNotesQueryResult = Apollo.QueryResult<GetAssociatedNotesQuery, GetAssociatedNotesQueryVariables>;
export const ExportMasterNoteInvestorsCsvDocument = gql`
    query exportMasterNoteInvestorsCsv($masterNoteId: ID) {
  exportMasterNoteInvestorsCsv(masterNoteId: $masterNoteId) {
    url
    fileId
    fileName
  }
}
    `;

/**
 * __useExportMasterNoteInvestorsCsvQuery__
 *
 * To run a query within a React component, call `useExportMasterNoteInvestorsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportMasterNoteInvestorsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportMasterNoteInvestorsCsvQuery({
 *   variables: {
 *      masterNoteId: // value for 'masterNoteId'
 *   },
 * });
 */
export function useExportMasterNoteInvestorsCsvQuery(baseOptions?: Apollo.QueryHookOptions<ExportMasterNoteInvestorsCsvQuery, ExportMasterNoteInvestorsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportMasterNoteInvestorsCsvQuery, ExportMasterNoteInvestorsCsvQueryVariables>(ExportMasterNoteInvestorsCsvDocument, options);
      }
export function useExportMasterNoteInvestorsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportMasterNoteInvestorsCsvQuery, ExportMasterNoteInvestorsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportMasterNoteInvestorsCsvQuery, ExportMasterNoteInvestorsCsvQueryVariables>(ExportMasterNoteInvestorsCsvDocument, options);
        }
export type ExportMasterNoteInvestorsCsvQueryHookResult = ReturnType<typeof useExportMasterNoteInvestorsCsvQuery>;
export type ExportMasterNoteInvestorsCsvLazyQueryHookResult = ReturnType<typeof useExportMasterNoteInvestorsCsvLazyQuery>;
export type ExportMasterNoteInvestorsCsvQueryResult = Apollo.QueryResult<ExportMasterNoteInvestorsCsvQuery, ExportMasterNoteInvestorsCsvQueryVariables>;
export const GetNotesDocument = gql`
    query getNotes($filters: NoteFilter, $page: Int, $sort: CP_SORT_BY, $limit: Int, $showClosed: Boolean) {
  getNotes(filters: $filters, page: $page, sort: $sort, limit: $limit, showClosed: $showClosed) {
    notes {
      ...note
    }
    pages
    page
  }
}
    ${NoteFragmentDoc}`;

/**
 * __useGetNotesQuery__
 *
 * To run a query within a React component, call `useGetNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      showClosed: // value for 'showClosed'
 *   },
 * });
 */
export function useGetNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
      }
export function useGetNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
        }
export type GetNotesQueryHookResult = ReturnType<typeof useGetNotesQuery>;
export type GetNotesLazyQueryHookResult = ReturnType<typeof useGetNotesLazyQuery>;
export type GetNotesQueryResult = Apollo.QueryResult<GetNotesQuery, GetNotesQueryVariables>;
export const GetNotesCountDocument = gql`
    query getNotesCount($filters: NoteFilter) {
  getNotesCount(filters: $filters)
}
    `;

/**
 * __useGetNotesCountQuery__
 *
 * To run a query within a React component, call `useGetNotesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetNotesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetNotesCountQuery, GetNotesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotesCountQuery, GetNotesCountQueryVariables>(GetNotesCountDocument, options);
      }
export function useGetNotesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesCountQuery, GetNotesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotesCountQuery, GetNotesCountQueryVariables>(GetNotesCountDocument, options);
        }
export type GetNotesCountQueryHookResult = ReturnType<typeof useGetNotesCountQuery>;
export type GetNotesCountLazyQueryHookResult = ReturnType<typeof useGetNotesCountLazyQuery>;
export type GetNotesCountQueryResult = Apollo.QueryResult<GetNotesCountQuery, GetNotesCountQueryVariables>;
export const GetNoteByIdDocument = gql`
    query getNoteById($id: ID!) {
  getNoteById(id: $id) {
    documentId
    submittedAt
    company {
      ...company
    }
    amount
    amountNeeded
    noteMarketValue
    masterNoteMarketValue
    purchasePrice
    lockDown
    title
    sellFee
    shortHoldFeeDuration
    interestFrequency
    purchaseFee
    shortHoldFee
    shortHoldDescription
    compoundingFrequency
    followup
    fundManager
    assetType
    managementFee
    interestFrequencyDescription
    type
    numberOfPaidInterest
    potentialRisks
    description
    payoutDate
    interestRate
    noteStatus
    proposedDateOfIssue
    conditions
    purposeOfIssue
    noteType
    memorandum {
      ...uploadFile
    }
    lengthOfCP
    comments {
      documentId
      message
      noteType
      createdAt
      user {
        firstName
        profilePicture {
          url
        }
      }
    }
  }
}
    ${CompanyFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetNoteByIdQuery__
 *
 * To run a query within a React component, call `useGetNoteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNoteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetNoteByIdQuery, GetNoteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoteByIdQuery, GetNoteByIdQueryVariables>(GetNoteByIdDocument, options);
      }
export function useGetNoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoteByIdQuery, GetNoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoteByIdQuery, GetNoteByIdQueryVariables>(GetNoteByIdDocument, options);
        }
export type GetNoteByIdQueryHookResult = ReturnType<typeof useGetNoteByIdQuery>;
export type GetNoteByIdLazyQueryHookResult = ReturnType<typeof useGetNoteByIdLazyQuery>;
export type GetNoteByIdQueryResult = Apollo.QueryResult<GetNoteByIdQuery, GetNoteByIdQueryVariables>;
export const DownloadNoteSummaryDocument = gql`
    query downloadNoteSummary($id: ID!) {
  downloadNoteSummary(id: $id) {
    url
  }
}
    `;

/**
 * __useDownloadNoteSummaryQuery__
 *
 * To run a query within a React component, call `useDownloadNoteSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadNoteSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadNoteSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadNoteSummaryQuery(baseOptions: Apollo.QueryHookOptions<DownloadNoteSummaryQuery, DownloadNoteSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadNoteSummaryQuery, DownloadNoteSummaryQueryVariables>(DownloadNoteSummaryDocument, options);
      }
export function useDownloadNoteSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadNoteSummaryQuery, DownloadNoteSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadNoteSummaryQuery, DownloadNoteSummaryQueryVariables>(DownloadNoteSummaryDocument, options);
        }
export type DownloadNoteSummaryQueryHookResult = ReturnType<typeof useDownloadNoteSummaryQuery>;
export type DownloadNoteSummaryLazyQueryHookResult = ReturnType<typeof useDownloadNoteSummaryLazyQuery>;
export type DownloadNoteSummaryQueryResult = Apollo.QueryResult<DownloadNoteSummaryQuery, DownloadNoteSummaryQueryVariables>;
export const GetMyNotificationsDocument = gql`
    query getMyNotifications($sort: String) {
  getMyNotifications(sort: $sort) {
    documentId
    title
    message
    category
    additionalInformation
  }
}
    `;

/**
 * __useGetMyNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMyNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
      }
export function useGetMyNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
        }
export type GetMyNotificationsQueryHookResult = ReturnType<typeof useGetMyNotificationsQuery>;
export type GetMyNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyNotificationsLazyQuery>;
export type GetMyNotificationsQueryResult = Apollo.QueryResult<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>;
export const GetMyPortfolioValueLogsDocument = gql`
    query getMyPortfolioValueLogs($startDate: DateTime, $endDate: DateTime, $limit: Int) {
  getMyPortfolioValueLogs(startDate: $startDate, endDate: $endDate, limit: $limit) {
    logs {
      id
      amountUSD
      amountKES
      createdAt
      updatedAt
    }
    total
  }
}
    `;

/**
 * __useGetMyPortfolioValueLogsQuery__
 *
 * To run a query within a React component, call `useGetMyPortfolioValueLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPortfolioValueLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPortfolioValueLogsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMyPortfolioValueLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyPortfolioValueLogsQuery, GetMyPortfolioValueLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPortfolioValueLogsQuery, GetMyPortfolioValueLogsQueryVariables>(GetMyPortfolioValueLogsDocument, options);
      }
export function useGetMyPortfolioValueLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPortfolioValueLogsQuery, GetMyPortfolioValueLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPortfolioValueLogsQuery, GetMyPortfolioValueLogsQueryVariables>(GetMyPortfolioValueLogsDocument, options);
        }
export type GetMyPortfolioValueLogsQueryHookResult = ReturnType<typeof useGetMyPortfolioValueLogsQuery>;
export type GetMyPortfolioValueLogsLazyQueryHookResult = ReturnType<typeof useGetMyPortfolioValueLogsLazyQuery>;
export type GetMyPortfolioValueLogsQueryResult = Apollo.QueryResult<GetMyPortfolioValueLogsQuery, GetMyPortfolioValueLogsQueryVariables>;
export const GetMyRealEstateAssetsDocument = gql`
    query GetMyRealEstateAssets($page: Int, $limit: Int, $sort: String, $search: String, $status: String, $currency: String) {
  getMyRealEstateAssets(page: $page, limit: $limit, sort: $sort, search: $search, status: $status, currency: $currency) {
    realEstateAssets {
      ...realEstateAsset
    }
    page
    pages
    count
  }
}
    ${RealEstateAssetFragmentDoc}`;

/**
 * __useGetMyRealEstateAssetsQuery__
 *
 * To run a query within a React component, call `useGetMyRealEstateAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRealEstateAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRealEstateAssetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetMyRealEstateAssetsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyRealEstateAssetsQuery, GetMyRealEstateAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRealEstateAssetsQuery, GetMyRealEstateAssetsQueryVariables>(GetMyRealEstateAssetsDocument, options);
      }
export function useGetMyRealEstateAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRealEstateAssetsQuery, GetMyRealEstateAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRealEstateAssetsQuery, GetMyRealEstateAssetsQueryVariables>(GetMyRealEstateAssetsDocument, options);
        }
export type GetMyRealEstateAssetsQueryHookResult = ReturnType<typeof useGetMyRealEstateAssetsQuery>;
export type GetMyRealEstateAssetsLazyQueryHookResult = ReturnType<typeof useGetMyRealEstateAssetsLazyQuery>;
export type GetMyRealEstateAssetsQueryResult = Apollo.QueryResult<GetMyRealEstateAssetsQuery, GetMyRealEstateAssetsQueryVariables>;
export const GetRealEstateAssetByIdDocument = gql`
    query GetRealEstateAssetById($id: String!) {
  getRealEstateAssetById(id: $id) {
    ...realEstateAsset
  }
}
    ${RealEstateAssetFragmentDoc}`;

/**
 * __useGetRealEstateAssetByIdQuery__
 *
 * To run a query within a React component, call `useGetRealEstateAssetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRealEstateAssetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealEstateAssetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRealEstateAssetByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRealEstateAssetByIdQuery, GetRealEstateAssetByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRealEstateAssetByIdQuery, GetRealEstateAssetByIdQueryVariables>(GetRealEstateAssetByIdDocument, options);
      }
export function useGetRealEstateAssetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRealEstateAssetByIdQuery, GetRealEstateAssetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRealEstateAssetByIdQuery, GetRealEstateAssetByIdQueryVariables>(GetRealEstateAssetByIdDocument, options);
        }
export type GetRealEstateAssetByIdQueryHookResult = ReturnType<typeof useGetRealEstateAssetByIdQuery>;
export type GetRealEstateAssetByIdLazyQueryHookResult = ReturnType<typeof useGetRealEstateAssetByIdLazyQuery>;
export type GetRealEstateAssetByIdQueryResult = Apollo.QueryResult<GetRealEstateAssetByIdQuery, GetRealEstateAssetByIdQueryVariables>;
export const GetRealEstateAssetForInvestorDocument = gql`
    query getRealEstateAssetForInvestor($input: GetRealEstateAssetForInvestorInput!) {
  getRealEstateAssetForInvestor(input: $input) {
    asset {
      ...realEstateAsset
      mapUrl
      additionalInfo
    }
    isAnInvestorOfAsset
    unitsHeld
    investorCount
    fundingPercentage
    tokensOwned
    tokensPosted
    tokensAvailable
  }
}
    ${RealEstateAssetFragmentDoc}`;

/**
 * __useGetRealEstateAssetForInvestorQuery__
 *
 * To run a query within a React component, call `useGetRealEstateAssetForInvestorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRealEstateAssetForInvestorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealEstateAssetForInvestorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRealEstateAssetForInvestorQuery(baseOptions: Apollo.QueryHookOptions<GetRealEstateAssetForInvestorQuery, GetRealEstateAssetForInvestorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRealEstateAssetForInvestorQuery, GetRealEstateAssetForInvestorQueryVariables>(GetRealEstateAssetForInvestorDocument, options);
      }
export function useGetRealEstateAssetForInvestorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRealEstateAssetForInvestorQuery, GetRealEstateAssetForInvestorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRealEstateAssetForInvestorQuery, GetRealEstateAssetForInvestorQueryVariables>(GetRealEstateAssetForInvestorDocument, options);
        }
export type GetRealEstateAssetForInvestorQueryHookResult = ReturnType<typeof useGetRealEstateAssetForInvestorQuery>;
export type GetRealEstateAssetForInvestorLazyQueryHookResult = ReturnType<typeof useGetRealEstateAssetForInvestorLazyQuery>;
export type GetRealEstateAssetForInvestorQueryResult = Apollo.QueryResult<GetRealEstateAssetForInvestorQuery, GetRealEstateAssetForInvestorQueryVariables>;
export const GetMySuccessfulRealEstateHoldingsDocument = gql`
    query GetMySuccessfulRealEstateHoldings($search: String) {
  getMySuccessfulRealEstateHoldings(search: $search) {
    documentId
    quantity
    avgCostBasis
    currency
    holdingStatus
    createdAt
    updatedAt
    realEstateAsset {
      documentId
      title
      tokenPrice
      expectedYield
      location
      propertyName
      value
      currency
      assetStatus
      company {
        name
      }
      images {
        url
        name
      }
    }
  }
}
    `;

/**
 * __useGetMySuccessfulRealEstateHoldingsQuery__
 *
 * To run a query within a React component, call `useGetMySuccessfulRealEstateHoldingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySuccessfulRealEstateHoldingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySuccessfulRealEstateHoldingsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMySuccessfulRealEstateHoldingsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySuccessfulRealEstateHoldingsQuery, GetMySuccessfulRealEstateHoldingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySuccessfulRealEstateHoldingsQuery, GetMySuccessfulRealEstateHoldingsQueryVariables>(GetMySuccessfulRealEstateHoldingsDocument, options);
      }
export function useGetMySuccessfulRealEstateHoldingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySuccessfulRealEstateHoldingsQuery, GetMySuccessfulRealEstateHoldingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySuccessfulRealEstateHoldingsQuery, GetMySuccessfulRealEstateHoldingsQueryVariables>(GetMySuccessfulRealEstateHoldingsDocument, options);
        }
export type GetMySuccessfulRealEstateHoldingsQueryHookResult = ReturnType<typeof useGetMySuccessfulRealEstateHoldingsQuery>;
export type GetMySuccessfulRealEstateHoldingsLazyQueryHookResult = ReturnType<typeof useGetMySuccessfulRealEstateHoldingsLazyQuery>;
export type GetMySuccessfulRealEstateHoldingsQueryResult = Apollo.QueryResult<GetMySuccessfulRealEstateHoldingsQuery, GetMySuccessfulRealEstateHoldingsQueryVariables>;
export const GetRealEstatePriceLogsDocument = gql`
    query GetRealEstatePriceLogs($realEstateAssetId: String!, $page: Int, $limit: Int) {
  getRealEstatePriceLogs(realEstateAssetId: $realEstateAssetId, page: $page, limit: $limit) {
    realEstatePriceLogs {
      documentId
      value
      logStatus
      approvedAt
      createdAt
      realEstateAsset {
        documentId
        title
        value
      }
    }
    page
    pages
  }
}
    `;

/**
 * __useGetRealEstatePriceLogsQuery__
 *
 * To run a query within a React component, call `useGetRealEstatePriceLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRealEstatePriceLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealEstatePriceLogsQuery({
 *   variables: {
 *      realEstateAssetId: // value for 'realEstateAssetId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRealEstatePriceLogsQuery(baseOptions: Apollo.QueryHookOptions<GetRealEstatePriceLogsQuery, GetRealEstatePriceLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRealEstatePriceLogsQuery, GetRealEstatePriceLogsQueryVariables>(GetRealEstatePriceLogsDocument, options);
      }
export function useGetRealEstatePriceLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRealEstatePriceLogsQuery, GetRealEstatePriceLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRealEstatePriceLogsQuery, GetRealEstatePriceLogsQueryVariables>(GetRealEstatePriceLogsDocument, options);
        }
export type GetRealEstatePriceLogsQueryHookResult = ReturnType<typeof useGetRealEstatePriceLogsQuery>;
export type GetRealEstatePriceLogsLazyQueryHookResult = ReturnType<typeof useGetRealEstatePriceLogsLazyQuery>;
export type GetRealEstatePriceLogsQueryResult = Apollo.QueryResult<GetRealEstatePriceLogsQuery, GetRealEstatePriceLogsQueryVariables>;
export const GetTransactionByIdDocument = gql`
    query getTransactionById($id: ID!) {
  getTransactionById(id: $id) {
    ...transaction
  }
}
    ${TransactionFragmentDoc}`;

/**
 * __useGetTransactionByIdQuery__
 *
 * To run a query within a React component, call `useGetTransactionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransactionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>(GetTransactionByIdDocument, options);
      }
export function useGetTransactionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>(GetTransactionByIdDocument, options);
        }
export type GetTransactionByIdQueryHookResult = ReturnType<typeof useGetTransactionByIdQuery>;
export type GetTransactionByIdLazyQueryHookResult = ReturnType<typeof useGetTransactionByIdLazyQuery>;
export type GetTransactionByIdQueryResult = Apollo.QueryResult<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>;
export const GetMyTransactionsDocument = gql`
    query getMyTransactions($currency: String!) {
  getMyTransactions(currency: $currency) {
    ...transaction
    note {
      title
      company {
        logo {
          url
        }
        name
      }
    }
  }
}
    ${TransactionFragmentDoc}`;

/**
 * __useGetMyTransactionsQuery__
 *
 * To run a query within a React component, call `useGetMyTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTransactionsQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetMyTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>(GetMyTransactionsDocument, options);
      }
export function useGetMyTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>(GetMyTransactionsDocument, options);
        }
export type GetMyTransactionsQueryHookResult = ReturnType<typeof useGetMyTransactionsQuery>;
export type GetMyTransactionsLazyQueryHookResult = ReturnType<typeof useGetMyTransactionsLazyQuery>;
export type GetMyTransactionsQueryResult = Apollo.QueryResult<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>;
export const DownloadReceiptDocument = gql`
    query downloadReceipt($id: ID!) {
  downloadReceipt(id: $id) {
    url
  }
}
    `;

/**
 * __useDownloadReceiptQuery__
 *
 * To run a query within a React component, call `useDownloadReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadReceiptQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadReceiptQuery(baseOptions: Apollo.QueryHookOptions<DownloadReceiptQuery, DownloadReceiptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReceiptQuery, DownloadReceiptQueryVariables>(DownloadReceiptDocument, options);
      }
export function useDownloadReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReceiptQuery, DownloadReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReceiptQuery, DownloadReceiptQueryVariables>(DownloadReceiptDocument, options);
        }
export type DownloadReceiptQueryHookResult = ReturnType<typeof useDownloadReceiptQuery>;
export type DownloadReceiptLazyQueryHookResult = ReturnType<typeof useDownloadReceiptLazyQuery>;
export type DownloadReceiptQueryResult = Apollo.QueryResult<DownloadReceiptQuery, DownloadReceiptQueryVariables>;